function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*! For license information please see default.js.LICENSE.txt */
!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.OktaAuth = t() : e.OktaAuth = t();
}(self, function () {
  return function () {
    var e = {
        9748: function _(e, t, n) {
          "use strict";

          n.d(t, {
            b: function b() {
              return T;
            }
          });
          var r = n(5385),
            o = n(9123),
            i = n(1971);
          function a(e, t) {
            var n = {};
            return Object.assign(n, t), !n.stateToken && e.stateToken && (n.stateToken = e.stateToken), n;
          }
          function u(e, t) {
            return t = a(e, t), (0, r.v_)(e, e.getIssuerOrigin() + "/api/v1/authn", t, {
              withCredentials: !0
            });
          }
          function c(e) {
            return !!f(e);
          }
          function s(e, t, n, o, i) {
            return i = Object.assign({
              withCredentials: !0
            }, i), (0, r.v_)(e, n, o, i).then(function (e) {
              return t.createTransaction(e);
            });
          }
          function f(e) {
            return e.options.storageUtil.storage.get(i.STATE_TOKEN_KEY_NAME);
          }
          var l = n(3144),
            p = n(5671),
            h = n(4942),
            d = n(3193),
            v = n(4771),
            y = n(6718);
          function g(e, t, n, i, u, c) {
            if (Array.isArray(u)) return function (r, a) {
              if (!r) throw new o.Z("Must provide a link name");
              var s = (0, d.sE)(u, {
                name: r
              });
              if (!s) throw new o.Z("No link found for that name");
              return g(e, t, n, i, s, c)(a);
            };
            if (u.hints && u.hints.allow && 1 === u.hints.allow.length) switch (u.hints.allow[0]) {
              case "GET":
                return function () {
                  return (0, r.U2)(e, u.href, {
                    withCredentials: !0
                  });
                };
              case "POST":
                return function (r) {
                  c && c.isPolling && (c.isPolling = !1);
                  var f = a(n, r);
                  "MFA_ENROLL" !== n.status && "FACTOR_ENROLL" !== n.status || Object.assign(f, {
                    factorType: i.factorType,
                    provider: i.provider
                  });
                  var l = {},
                    p = f.autoPush;
                  if (void 0 !== p) {
                    if ("function" == typeof p) try {
                      l.autoPush = !!p();
                    } catch (e) {
                      return Promise.reject(new o.Z("AutoPush resulted in an error."));
                    } else null !== p && (l.autoPush = !!p);
                    f = (0, d.CE)(f, "autoPush");
                  }
                  var h = f.rememberDevice;
                  if (void 0 !== h) {
                    if ("function" == typeof h) try {
                      l.rememberDevice = !!h();
                    } catch (e) {
                      return Promise.reject(new o.Z("RememberDevice resulted in an error."));
                    } else null !== h && (l.rememberDevice = !!h);
                    f = (0, d.CE)(f, "rememberDevice");
                  } else f.profile && void 0 !== f.profile.updatePhone && (f.profile.updatePhone && (l.updatePhone = !0), f.profile = (0, d.CE)(f.profile, "updatePhone"));
                  var v = u.href + (0, y.UK)(l);
                  return s(e, t, v, f);
                };
            }
          }
          var m = n(8750),
            b = n(6573);
          function k(e, t, n) {
            return function (u) {
              var c, s, f, l;
              (0, v.hj)(u) ? c = u : (0, v.Kn)(u) && (c = u.delay, s = u.rememberDevice, f = u.autoPush, l = u.transactionCallBack), c || 0 === c || (c = i.DEFAULT_POLLING_DELAY);
              var p = (0, d.Rg)(t, "next", "poll");
              n.isPolling = !0;
              var h = 0;
              return function i() {
                return n.isPolling ? function () {
                  var n = {};
                  if ("function" == typeof f) try {
                    n.autoPush = !!f();
                  } catch (e) {
                    return Promise.reject(new o.Z("AutoPush resulted in an error."));
                  } else null != f && (n.autoPush = !!f);
                  if ("function" == typeof s) try {
                    n.rememberDevice = !!s();
                  } catch (e) {
                    return Promise.reject(new o.Z("RememberDevice resulted in an error."));
                  } else null != s && (n.rememberDevice = !!s);
                  var i = p.href + (0, y.UK)(n);
                  return (0, r.v_)(e, i, function (e) {
                    return a(e);
                  }(t), {
                    saveAuthnState: !1,
                    withCredentials: !0
                  });
                }().then(function (t) {
                  if (h = 0, t.factorResult && "WAITING" === t.factorResult) {
                    if (!n.isPolling) throw new b.Z();
                    return "function" == typeof l && l(t), (0, m.gw)(c).then(i);
                  }
                  return n.isPolling = !1, e.tx.createTransaction(t);
                })["catch"](function (e) {
                  if (e.xhr && (0 === e.xhr.status || 429 === e.xhr.status) && h <= 4) {
                    var t = 1e3 * Math.pow(2, h);
                    return h++, (0, m.gw)(t).then(i);
                  }
                  throw e;
                }) : Promise.reject(new b.Z());
              }()["catch"](function (e) {
                throw n.isPolling = !1, e;
              });
            };
          }
          function w(e, t, n, r, o) {
            if (r = r || n, r = (0, d.d9)(r), Array.isArray(r)) {
              for (var i = [], a = 0, u = r.length; a < u; a++) i.push(w(e, t, n, r[a], o));
              return i;
            }
            var c = r._embedded || {};
            for (var s in c) Object.prototype.hasOwnProperty.call(c, s) && ((0, v.Kn)(c[s]) || Array.isArray(c[s])) && (c[s] = w(e, t, n, c[s], o));
            var f = function (e, t, n, r, o) {
              var i = {};
              for (var a in r._links) if (Object.prototype.hasOwnProperty.call(r._links, a)) {
                var u = r._links[a];
                if ("next" === a && (a = u.name), u.type) i[a] = u;else if ("poll" === a) i.poll = k(e, n, o);else {
                  var c = g(e, t, n, r, u, o);
                  c && (i[a] = c);
                }
              }
              return i;
            }(e, t, n, r, o);
            return Object.assign(c, f), r = (0, d.CE)(r, "_embedded", "_links"), Object.assign(r, c), r;
          }
          var O = (0, l.Z)(function e(t, n) {
            var r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
            (0, p.Z)(this, e), (0, h.Z)(this, "next", void 0), (0, h.Z)(this, "cancel", void 0), (0, h.Z)(this, "skip", void 0), (0, h.Z)(this, "unlock", void 0), (0, h.Z)(this, "changePassword", void 0), (0, h.Z)(this, "resetPassword", void 0), (0, h.Z)(this, "answer", void 0), (0, h.Z)(this, "recovery", void 0), (0, h.Z)(this, "verify", void 0), (0, h.Z)(this, "resend", void 0), (0, h.Z)(this, "activate", void 0), (0, h.Z)(this, "poll", void 0), (0, h.Z)(this, "prev", void 0), (0, h.Z)(this, "data", void 0), (0, h.Z)(this, "stateToken", void 0), (0, h.Z)(this, "sessionToken", void 0), (0, h.Z)(this, "status", void 0), (0, h.Z)(this, "user", void 0), (0, h.Z)(this, "factor", void 0), (0, h.Z)(this, "factors", void 0), (0, h.Z)(this, "policy", void 0), (0, h.Z)(this, "scopes", void 0), (0, h.Z)(this, "target", void 0), (0, h.Z)(this, "authentication", void 0), this.data = void 0, this.status = void 0, r && (this.data = r, Object.assign(this, w(t, n, r, r, {})), delete this.stateToken, "RECOVERY_CHALLENGE" !== r.status || r._links || (this.cancel = function () {
              return Promise.resolve(n.createTransaction());
            }));
          });
          function T(e) {
            var t = {
              status: u.bind(null, e),
              resume: function resume(n) {
                return function (e, t, n) {
                  if (!n || !n.stateToken) {
                    var r = f(e);
                    if (!r) return Promise.reject(new o.Z("No transaction to resume"));
                    n = {
                      stateToken: r
                    };
                  }
                  return u(e, n).then(function (e) {
                    return t.createTransaction(e);
                  });
                }(e, t, n);
              },
              exists: c.bind(null, e),
              introspect: function introspect(n) {
                return function (e, t, n) {
                  if (!n || !n.stateToken) {
                    var i = f(e);
                    if (!i) return Promise.reject(new o.Z("No transaction to evaluate"));
                    n = {
                      stateToken: i
                    };
                  }
                  return function (e, t) {
                    return t = a(e, t), (0, r.v_)(e, e.getIssuerOrigin() + "/api/v1/authn/introspect", t, {
                      withCredentials: !0
                    });
                  }(e, n).then(function (e) {
                    return t.createTransaction(e);
                  });
                }(e, t, n);
              },
              createTransaction: function createTransaction(n) {
                return new O(e, t, n);
              },
              postToTransaction: function postToTransaction(n, r, o) {
                return s(e, t, n, r, o);
              }
            };
            return t;
          }
        },
        3398: function _(e, t, n) {
          "use strict";

          n.d(t, {
            b: function b() {
              return r.b;
            },
            t: function t() {
              return o.t;
            }
          });
          var r = n(9748),
            o = n(8284);
        },
        8284: function _(e, t, n) {
          "use strict";

          n.d(t, {
            t: function t() {
              return b;
            }
          });
          var r = n(5861),
            o = n(5671),
            i = n(3144),
            a = n(7326),
            u = n(136),
            c = n(2963),
            s = n(1120),
            f = n(4942),
            l = n(4687),
            p = n.n(l),
            h = n(3193),
            d = n(9123),
            v = n(415),
            y = n(4970);
          function g(e, t) {
            return t = t || {}, (0, v.isFingerprintSupported)() ? new Promise(function (i, a) {
              var u;
              (r = document.createElement("iframe")).style.display = "none", o = function o(t) {
                if (t && t.data && t.origin === e.getIssuerOrigin()) {
                  try {
                    var n = JSON.parse(t.data);
                  } catch (e) {
                    return;
                  }
                  if (n) return "FingerprintAvailable" === n.type ? i(n.fingerprint) : void ("FingerprintServiceReady" === n.type && t.source.postMessage(JSON.stringify({
                    type: "GetFingerprint"
                  }), t.origin));
                }
              }, (0, y.NH)(window, "message", o), r.src = e.getIssuerOrigin() + "/auth/services/devicefingerprint", document.body.appendChild(r), n = setTimeout(function () {
                a(new d.Z("Fingerprinting timed out"));
              }, (null === (u = t) || void 0 === u ? void 0 : u.timeout) || 15e3);
            })["finally"](function () {
              clearTimeout(n), (0, y.ys)(window, "message", o), document.body.contains(r) && r.parentElement.removeChild(r);
            }) : Promise.reject(new d.Z("Fingerprinting is not supported on this device"));
            var n, r, o;
          }
          var m = n(9748);
          function b(e) {
            return function (e) {
              (0, u.Z)(y, e);
              var t,
                n,
                l,
                d,
                v = (l = y, d = function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                  } catch (e) {
                    return !1;
                  }
                }(), function () {
                  var e,
                    t = (0, s.Z)(l);
                  if (d) {
                    var n = (0, s.Z)(this).constructor;
                    e = Reflect.construct(t, arguments, n);
                  } else e = t.apply(this, arguments);
                  return (0, c.Z)(this, e);
                });
              function y() {
                var e;
                (0, o.Z)(this, y);
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return e = v.call.apply(v, [this].concat(n)), (0, f.Z)((0, a.Z)(e), "tx", void 0), (0, f.Z)((0, a.Z)(e), "authn", void 0), (0, f.Z)((0, a.Z)(e), "fingerprint", void 0), e.authn = e.tx = (0, m.b)((0, a.Z)(e)), e.fingerprint = g.bind(null, (0, a.Z)(e)), e;
              }
              return (0, i.Z)(y, [{
                key: "signIn",
                value: (n = (0, r.Z)(p().mark(function e(t) {
                  var n,
                    r = this;
                  return p().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        if (t = (0, h.d9)(t || {}), n = function n(e) {
                          return delete t.sendFingerprint, r.tx.postToTransaction("/api/v1/authn", t, e);
                        }, t.sendFingerprint) {
                          e.next = 4;
                          break;
                        }
                        return e.abrupt("return", n());
                      case 4:
                        return e.abrupt("return", this.fingerprint().then(function (e) {
                          return n({
                            headers: {
                              "X-Device-Fingerprint": e
                            }
                          });
                        }));
                      case 5:
                      case "end":
                        return e.stop();
                    }
                  }, e, this);
                })), function (e) {
                  return n.apply(this, arguments);
                })
              }, {
                key: "signInWithCredentials",
                value: (t = (0, r.Z)(p().mark(function e(t) {
                  return p().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        return e.abrupt("return", this.signIn(t));
                      case 1:
                      case "end":
                        return e.stop();
                    }
                  }, e, this);
                })), function (e) {
                  return t.apply(this, arguments);
                })
              }, {
                key: "forgotPassword",
                value: function value(e) {
                  return this.tx.postToTransaction("/api/v1/authn/recovery/password", e);
                }
              }, {
                key: "unlockAccount",
                value: function value(e) {
                  return this.tx.postToTransaction("/api/v1/authn/recovery/unlock", e);
                }
              }, {
                key: "verifyRecoveryToken",
                value: function value(e) {
                  return this.tx.postToTransaction("/api/v1/authn/recovery/token", e);
                }
              }]), y;
            }(e);
          }
        },
        9893: function _(e, t, n) {
          "use strict";

          n.d(t, {
            a: function a() {
              return l;
            }
          });
          var r = n(3144),
            o = n(5671),
            i = n(4942),
            a = n(3193),
            u = n(415),
            c = n(1971),
            s = n(4279),
            f = n.n(s);
          function l(e) {
            var t = (0, r.Z)(function t() {
              (0, o.Z)(this, t), (0, i.Z)(this, "options", void 0), (0, i.Z)(this, "emitter", void 0), (0, i.Z)(this, "features", void 0);
              var n = new e(arguments.length && (arguments.length <= 0 ? void 0 : arguments[0]) || {});
              this.options = (0, a.YY)(n), this.emitter = new (f())(), this.features = u;
            });
            return (0, i.Z)(t, "features", u), (0, i.Z)(t, "constants", c), t.features = t.prototype.features = u, Object.assign(t, {
              constants: c
            }), t;
          }
        },
        3306: function _(e, t, n) {
          "use strict";

          n.d(t, {
            X: function X() {
              return o.X;
            },
            a: function a() {
              return r.a;
            }
          });
          var r = n(9893),
            o = n(5093);
        },
        5093: function _(e, t, n) {
          "use strict";

          n.d(t, {
            X: function X() {
              return a;
            }
          });
          var r = n(3144),
            o = n(5671),
            i = n(4942);
          function a() {
            return (0, r.Z)(function e(t) {
              (0, o.Z)(this, e), (0, i.Z)(this, "devMode", void 0), this.devMode = !!t.devMode;
            });
          }
        },
        4858: function _(e, t, n) {
          "use strict";

          function r(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = arguments[t];
              for (var r in n) e[r] = n[r];
            }
            return e;
          }
          n.d(t, {
            Z: function Z() {
              return f;
            }
          });
          var o = function e(t, n) {
              function o(e, o, i) {
                if ("undefined" != typeof document) {
                  "number" == typeof (i = r({}, n, i)).expires && (i.expires = new Date(Date.now() + 864e5 * i.expires)), i.expires && (i.expires = i.expires.toUTCString()), e = encodeURIComponent(e).replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent).replace(/[()]/g, escape);
                  var a = "";
                  for (var u in i) i[u] && (a += "; " + u, !0 !== i[u] && (a += "=" + i[u].split(";")[0]));
                  return document.cookie = e + "=" + t.write(o, e) + a;
                }
              }
              return Object.create({
                set: o,
                get: function get(e) {
                  if ("undefined" != typeof document && (!arguments.length || e)) {
                    for (var n = document.cookie ? document.cookie.split("; ") : [], r = {}, o = 0; o < n.length; o++) {
                      var i = n[o].split("="),
                        a = i.slice(1).join("=");
                      try {
                        var u = decodeURIComponent(i[0]);
                        if (r[u] = t.read(a, u), e === u) break;
                      } catch (e) {}
                    }
                    return e ? r[e] : r;
                  }
                },
                remove: function remove(e, t) {
                  o(e, "", r({}, t, {
                    expires: -1
                  }));
                },
                withAttributes: function withAttributes(t) {
                  return e(this.converter, r({}, this.attributes, t));
                },
                withConverter: function withConverter(t) {
                  return e(r({}, this.converter, t), this.attributes);
                }
              }, {
                attributes: {
                  value: Object.freeze(n)
                },
                converter: {
                  value: Object.freeze(t)
                }
              });
            }({
              read: function read(e) {
                return '"' === e[0] && (e = e.slice(1, -1)), e.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
              },
              write: function write(e) {
                return encodeURIComponent(e).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
              }
            }, {
              path: "/"
            }),
            i = o,
            a = n(9123),
            u = n(146),
            c = n(415),
            s = {
              browserHasLocalStorage: function browserHasLocalStorage() {
                try {
                  var e = this.getLocalStorage();
                  return this.testStorage(e);
                } catch (e) {
                  return !1;
                }
              },
              browserHasSessionStorage: function browserHasSessionStorage() {
                try {
                  var e = this.getSessionStorage();
                  return this.testStorage(e);
                } catch (e) {
                  return !1;
                }
              },
              testStorageType: function testStorageType(e) {
                var t = !1;
                switch (e) {
                  case "sessionStorage":
                    t = this.browserHasSessionStorage();
                    break;
                  case "localStorage":
                    t = this.browserHasLocalStorage();
                    break;
                  case "cookie":
                  case "memory":
                    t = !0;
                    break;
                  default:
                    t = !1;
                }
                return t;
              },
              getStorageByType: function getStorageByType(e, t) {
                var n;
                switch (e) {
                  case "sessionStorage":
                    n = this.getSessionStorage();
                    break;
                  case "localStorage":
                    n = this.getLocalStorage();
                    break;
                  case "cookie":
                    n = this.getCookieStorage(t);
                    break;
                  case "memory":
                    n = this.getInMemoryStorage();
                    break;
                  default:
                    throw new a.Z("Unrecognized storage option: ".concat(e));
                }
                return n;
              },
              findStorageType: function findStorageType(e) {
                var t, n;
                return t = (e = e.slice()).shift(), (n = e.length ? e[0] : null) ? this.testStorageType(t) ? t : ((0, u.ZK)("This browser doesn't support ".concat(t, ". Switching to ").concat(n, ".")), this.findStorageType(e)) : t;
              },
              getLocalStorage: function getLocalStorage() {
                return (0, c.isIE11OrLess)() && !window.onstorage && (window.onstorage = function () {}), localStorage;
              },
              getSessionStorage: function getSessionStorage() {
                return sessionStorage;
              },
              getCookieStorage: function getCookieStorage(e) {
                var t = this,
                  n = e.secure,
                  r = e.sameSite,
                  o = e.sessionCookie;
                if (void 0 === n || void 0 === r) throw new a.Z('getCookieStorage: "secure" and "sameSite" options must be provided');
                var i = {
                  getItem: this.storage.get,
                  setItem: function setItem(e, i) {
                    var a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : "2200-01-01T00:00:00.000Z";
                    a = o ? null : a, t.storage.set(e, i, a, {
                      secure: n,
                      sameSite: r
                    });
                  },
                  removeItem: function removeItem(e) {
                    t.storage["delete"](e);
                  }
                };
                return e.useSeparateCookies ? {
                  getItem: function getItem(e) {
                    var t = i.getItem(),
                      n = {};
                    return Object.keys(t).forEach(function (r) {
                      0 === r.indexOf(e) && (n[r.replace("".concat(e, "_"), "")] = JSON.parse(t[r]));
                    }), JSON.stringify(n);
                  },
                  setItem: function setItem(e, t) {
                    var n = JSON.parse(this.getItem(e));
                    t = JSON.parse(t), Object.keys(t).forEach(function (r) {
                      var o = e + "_" + r,
                        a = JSON.stringify(t[r]);
                      i.setItem(o, a), delete n[r];
                    }), Object.keys(n).forEach(function (t) {
                      i.removeItem(e + "_" + t);
                    });
                  },
                  removeItem: function removeItem(e) {
                    var t = JSON.parse(this.getItem(e));
                    Object.keys(t).forEach(function (t) {
                      i.removeItem(e + "_" + t);
                    });
                  }
                } : i;
              },
              inMemoryStore: {},
              getInMemoryStorage: function getInMemoryStorage() {
                var e = this;
                return {
                  getItem: function getItem(t) {
                    return e.inMemoryStore[t];
                  },
                  setItem: function setItem(t, n) {
                    e.inMemoryStore[t] = n;
                  }
                };
              },
              testStorage: function testStorage(e) {
                var t = "okta-test-storage";
                try {
                  return e.setItem(t, t), e.removeItem(t), !0;
                } catch (e) {
                  return !1;
                }
              },
              storage: {
                set: function set(e, t, n, r) {
                  var o = r.sameSite,
                    u = r.secure;
                  if (void 0 === u || void 0 === o) throw new a.Z('storage.set: "secure" and "sameSite" options must be provided');
                  var c = {
                    path: r.path || "/",
                    secure: u,
                    sameSite: o
                  };
                  return Date.parse(n) && (c.expires = new Date(n)), i.set(e, t, c), this.get(e);
                },
                get: function get(e) {
                  return arguments.length ? i.get(e) : i.get();
                },
                "delete": function _delete(e) {
                  return i.remove(e, {
                    path: "/"
                  });
                }
              }
            },
            f = s;
        },
        1971: function _(e, t, n) {
          "use strict";

          n.r(t), n.d(t, {
            ACCESS_TOKEN_STORAGE_KEY: function ACCESS_TOKEN_STORAGE_KEY() {
              return d;
            },
            CACHE_STORAGE_NAME: function CACHE_STORAGE_NAME() {
              return c;
            },
            DEFAULT_CACHE_DURATION: function DEFAULT_CACHE_DURATION() {
              return a;
            },
            DEFAULT_CODE_CHALLENGE_METHOD: function DEFAULT_CODE_CHALLENGE_METHOD() {
              return k;
            },
            DEFAULT_MAX_CLOCK_SKEW: function DEFAULT_MAX_CLOCK_SKEW() {
              return i;
            },
            DEFAULT_POLLING_DELAY: function DEFAULT_POLLING_DELAY() {
              return o;
            },
            IDX_API_VERSION: function IDX_API_VERSION() {
              return w;
            },
            IDX_RESPONSE_STORAGE_NAME: function IDX_RESPONSE_STORAGE_NAME() {
              return h;
            },
            ID_TOKEN_STORAGE_KEY: function ID_TOKEN_STORAGE_KEY() {
              return v;
            },
            MAX_VERIFIER_LENGTH: function MAX_VERIFIER_LENGTH() {
              return b;
            },
            MIN_VERIFIER_LENGTH: function MIN_VERIFIER_LENGTH() {
              return m;
            },
            ORIGINAL_URI_STORAGE_NAME: function ORIGINAL_URI_STORAGE_NAME() {
              return p;
            },
            PKCE_STORAGE_NAME: function PKCE_STORAGE_NAME() {
              return s;
            },
            REFERRER_PATH_STORAGE_KEY: function REFERRER_PATH_STORAGE_KEY() {
              return g;
            },
            REFRESH_TOKEN_STORAGE_KEY: function REFRESH_TOKEN_STORAGE_KEY() {
              return y;
            },
            SHARED_TRANSACTION_STORAGE_NAME: function SHARED_TRANSACTION_STORAGE_NAME() {
              return l;
            },
            STATE_TOKEN_KEY_NAME: function STATE_TOKEN_KEY_NAME() {
              return r;
            },
            TOKEN_STORAGE_NAME: function TOKEN_STORAGE_NAME() {
              return u;
            },
            TRANSACTION_STORAGE_NAME: function TRANSACTION_STORAGE_NAME() {
              return f;
            }
          });
          var r = "oktaStateToken",
            o = 500,
            i = 300,
            a = 86400,
            u = "okta-token-storage",
            c = "okta-cache-storage",
            s = "okta-pkce-storage",
            f = "okta-transaction-storage",
            l = "okta-shared-transaction-storage",
            p = "okta-original-uri-storage",
            h = "okta-idx-response-storage",
            d = "accessToken",
            v = "idToken",
            y = "refreshToken",
            g = "referrerPath",
            m = 43,
            b = 128,
            k = "S256",
            w = "1.0.0";
        },
        1018: function _(e, t, n) {
          "use strict";

          n.d(t, {
            E: function E() {
              return k;
            },
            a: function a() {
              return g;
            }
          });
          var r = n(5861),
            o = n(5671),
            i = n(3144),
            a = n(4942),
            u = n(4687),
            c = n.n(u),
            s = n(3615),
            f = n.n(s),
            l = n(9123),
            p = n(7088),
            h = n(3548),
            d = n(146);
          function v(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function y(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? v(Object(n), !0).forEach(function (t) {
                (0, a.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          var g = null,
            m = {
              updateAuthStatePromise: null,
              canceledTimes: 0
            },
            b = "authStateChange",
            k = function () {
              function e(t) {
                var n = this;
                if ((0, o.Z)(this, e), (0, a.Z)(this, "_sdk", void 0), (0, a.Z)(this, "_pending", void 0), (0, a.Z)(this, "_authState", void 0), (0, a.Z)(this, "_prevAuthState", void 0), (0, a.Z)(this, "_logOptions", void 0), (0, a.Z)(this, "_transformQueue", void 0), !t.emitter) throw new l.Z("Emitter should be initialized before AuthStateManager");
                this._sdk = t, this._pending = y({}, m), this._authState = g, this._logOptions = {}, this._prevAuthState = null, this._transformQueue = new h.b({
                  quiet: !0
                }), t.tokenManager.on(p.O3, function (e, t) {
                  n._setLogOptions({
                    event: p.O3,
                    key: e,
                    token: t
                  }), n.updateAuthState();
                }), t.tokenManager.on(p.FT, function (e, t) {
                  n._setLogOptions({
                    event: p.FT,
                    key: e,
                    token: t
                  }), n.updateAuthState();
                });
              }
              var t;
              return (0, i.Z)(e, [{
                key: "_setLogOptions",
                value: function value(e) {
                  this._logOptions = e;
                }
              }, {
                key: "getAuthState",
                value: function value() {
                  return this._authState;
                }
              }, {
                key: "getPreviousAuthState",
                value: function value() {
                  return this._prevAuthState;
                }
              }, {
                key: "updateAuthState",
                value: (t = (0, r.Z)(c().mark(function e() {
                  var t,
                    n,
                    r,
                    o,
                    i,
                    a,
                    u,
                    s = this;
                  return c().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        if (t = this._sdk.options, n = t.transformAuthState, r = t.devMode, o = function o(e) {
                          var t = s._logOptions,
                            n = t.event,
                            r = t.key,
                            o = t.token;
                          (0, d.dr)().group("OKTA-AUTH-JS:updateAuthState: Event:".concat(n, " Status:").concat(e)), (0, d.dr)().log(r, o), (0, d.dr)().log("Current authState", s._authState), (0, d.dr)().groupEnd(), s._logOptions = {};
                        }, i = function i(e) {
                          var t, n;
                          n = e, (t = s._authState) && t.isAuthenticated === n.isAuthenticated && JSON.stringify(t.idToken) === JSON.stringify(n.idToken) && JSON.stringify(t.accessToken) === JSON.stringify(n.accessToken) && t.error === n.error ? r && o("unchanged") : (s._prevAuthState = s._authState, s._authState = e, s._sdk.emitter.emit(b, y({}, e)), r && o("emitted"));
                        }, a = function e(t) {
                          return s._pending.updateAuthStatePromise.then(function () {
                            var n = s._pending.updateAuthStatePromise;
                            return n && n !== t ? e(n) : s.getAuthState();
                          });
                        }, !this._pending.updateAuthStatePromise) {
                          e.next = 11;
                          break;
                        }
                        if (!(this._pending.canceledTimes >= 10)) {
                          e.next = 10;
                          break;
                        }
                        return r && o("terminated"), e.abrupt("return", a(this._pending.updateAuthStatePromise));
                      case 10:
                        this._pending.updateAuthStatePromise.cancel();
                      case 11:
                        return u = new (f())(function (e, t, a) {
                          a.shouldReject = !1, a(function () {
                            s._pending.updateAuthStatePromise = null, s._pending.canceledTimes = s._pending.canceledTimes + 1, r && o("canceled");
                          });
                          var c = function c(t) {
                            u.isCanceled ? e() : (i(t), e(), s._pending = y({}, m));
                          };
                          s._sdk.isAuthenticated().then(function () {
                            if (u.isCanceled) e();else {
                              var t = s._sdk.tokenManager.getTokensSync(),
                                r = t.accessToken,
                                o = t.idToken,
                                i = t.refreshToken,
                                a = {
                                  accessToken: r,
                                  idToken: o,
                                  refreshToken: i,
                                  isAuthenticated: !(!r || !o)
                                };
                              (n ? s._transformQueue.push(n, null, s._sdk, a) : Promise.resolve(a)).then(function (e) {
                                return c(e);
                              })["catch"](function (e) {
                                return c({
                                  accessToken: r,
                                  idToken: o,
                                  refreshToken: i,
                                  isAuthenticated: !1,
                                  error: e
                                });
                              });
                            }
                          });
                        }), this._pending.updateAuthStatePromise = u, e.abrupt("return", a(u));
                      case 14:
                      case "end":
                        return e.stop();
                    }
                  }, e, this);
                })), function () {
                  return t.apply(this, arguments);
                })
              }, {
                key: "subscribe",
                value: function value(e) {
                  this._sdk.emitter.on(b, e);
                }
              }, {
                key: "unsubscribe",
                value: function value(e) {
                  this._sdk.emitter.off(b, e);
                }
              }]), e;
            }();
        },
        2397: function _(e, t, n) {
          "use strict";

          n.d(t, {
            W: function W() {
              return ge;
            }
          });
          var r = n(885),
            o = n(2982),
            i = n(5861),
            a = n(5671),
            u = n(3144),
            c = n(4942),
            s = n(4687),
            f = n.n(s);
          Promise.resolve(!1);
          var l = Promise.resolve(!0),
            p = Promise.resolve();
          function h(e, t) {
            return e || (e = 0), new Promise(function (n) {
              return setTimeout(function () {
                return n(t);
              }, e);
            });
          }
          function d() {
            return Math.random().toString(36).substring(2);
          }
          var v = 0,
            y = 0;
          function g() {
            var e = new Date().getTime();
            return e === v ? 1e3 * e + ++y : (v = e, y = 0, 1e3 * e);
          }
          var m = {
              create: function create(e) {
                var t = {
                  messagesCallback: null,
                  bc: new BroadcastChannel(e),
                  subFns: []
                };
                return t.bc.onmessage = function (e) {
                  t.messagesCallback && t.messagesCallback(e.data);
                }, t;
              },
              close: function close(e) {
                e.bc.close(), e.subFns = [];
              },
              onMessage: function onMessage(e, t) {
                e.messagesCallback = t;
              },
              postMessage: function postMessage(e, t) {
                try {
                  return e.bc.postMessage(t, !1), p;
                } catch (e) {
                  return Promise.reject(e);
                }
              },
              canBeUsed: function canBeUsed() {
                if ("undefined" == typeof window) return !1;
                if ("function" == typeof BroadcastChannel) {
                  if (BroadcastChannel._pubkey) throw new Error("BroadcastChannel: Do not overwrite window.BroadcastChannel with this module, this is not a polyfill");
                  return !0;
                }
                return !1;
              },
              type: "native",
              averageResponseTime: function averageResponseTime() {
                return 150;
              },
              microSeconds: g
            },
            b = function () {
              function e(e) {
                this.ttl = e, this.map = new Map(), this._to = !1;
              }
              return e.prototype.has = function (e) {
                return this.map.has(e);
              }, e.prototype.add = function (e) {
                var t = this;
                this.map.set(e, k()), this._to || (this._to = !0, setTimeout(function () {
                  t._to = !1, function (e) {
                    for (var t = k() - e.ttl, n = e.map[Symbol.iterator]();;) {
                      var r = n.next().value;
                      if (!r) return;
                      var o = r[0];
                      if (!(r[1] < t)) return;
                      e.map["delete"](o);
                    }
                  }(t);
                }, 0));
              }, e.prototype.clear = function () {
                this.map.clear();
              }, e;
            }();
          function k() {
            return new Date().getTime();
          }
          function w() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
              t = JSON.parse(JSON.stringify(e));
            return void 0 === t.webWorkerSupport && (t.webWorkerSupport = !0), t.idb || (t.idb = {}), t.idb.ttl || (t.idb.ttl = 45e3), t.idb.fallbackInterval || (t.idb.fallbackInterval = 150), e.idb && "function" == typeof e.idb.onclose && (t.idb.onclose = e.idb.onclose), t.localstorage || (t.localstorage = {}), t.localstorage.removeTimeout || (t.localstorage.removeTimeout = 6e4), e.methods && (t.methods = e.methods), t.node || (t.node = {}), t.node.ttl || (t.node.ttl = 12e4), t.node.maxParallelWrites || (t.node.maxParallelWrites = 2048), void 0 === t.node.useFastPath && (t.node.useFastPath = !0), t;
          }
          var O = "messages",
            T = {
              durability: "relaxed"
            };
          function Z() {
            if ("undefined" != typeof indexedDB) return indexedDB;
            if ("undefined" != typeof window) {
              if (void 0 !== window.mozIndexedDB) return window.mozIndexedDB;
              if (void 0 !== window.webkitIndexedDB) return window.webkitIndexedDB;
              if (void 0 !== window.msIndexedDB) return window.msIndexedDB;
            }
            return !1;
          }
          function E(e) {
            e.commit && e.commit();
          }
          function S(e) {
            e.closed || x(e).then(function () {
              return h(e.options.idb.fallbackInterval);
            }).then(function () {
              return S(e);
            });
          }
          function x(e) {
            return e.closed ? p : e.messagesCallback ? function (e, t) {
              var n = e.transaction(O, "readonly", T),
                r = n.objectStore(O),
                o = [],
                i = IDBKeyRange.bound(t + 1, 1 / 0);
              if (r.getAll) {
                var a = r.getAll(i);
                return new Promise(function (e, t) {
                  a.onerror = function (e) {
                    return t(e);
                  }, a.onsuccess = function (t) {
                    e(t.target.result);
                  };
                });
              }
              return new Promise(function (e, a) {
                var u = function () {
                  try {
                    return i = IDBKeyRange.bound(t + 1, 1 / 0), r.openCursor(i);
                  } catch (e) {
                    return r.openCursor();
                  }
                }();
                u.onerror = function (e) {
                  return a(e);
                }, u.onsuccess = function (r) {
                  var i = r.target.result;
                  i ? i.value.id < t + 1 ? i["continue"](t + 1) : (o.push(i.value), i["continue"]()) : (E(n), e(o));
                };
              });
            }(e.db, e.lastCursorId).then(function (t) {
              var n = t.filter(function (e) {
                return !!e;
              }).map(function (t) {
                return t.id > e.lastCursorId && (e.lastCursorId = t.id), t;
              }).filter(function (t) {
                return function (e, t) {
                  return !(e.uuid === t.uuid || t.eMIs.has(e.id) || e.data.time < t.messagesCallbackTime);
                }(t, e);
              }).sort(function (e, t) {
                return e.time - t.time;
              });
              return n.forEach(function (t) {
                e.messagesCallback && (e.eMIs.add(t.id), e.messagesCallback(t.data));
              }), p;
            }) : p;
          }
          var P = {
            create: function create(e, t) {
              return t = w(t), function (e) {
                var t = "pubkey.broadcast-channel-0-" + e,
                  n = Z().open(t);
                return n.onupgradeneeded = function (e) {
                  e.target.result.createObjectStore(O, {
                    keyPath: "id",
                    autoIncrement: !0
                  });
                }, new Promise(function (e, t) {
                  n.onerror = function (e) {
                    return t(e);
                  }, n.onsuccess = function () {
                    e(n.result);
                  };
                });
              }(e).then(function (n) {
                var r = {
                  closed: !1,
                  lastCursorId: 0,
                  channelName: e,
                  options: t,
                  uuid: d(),
                  eMIs: new b(2 * t.idb.ttl),
                  writeBlockPromise: p,
                  messagesCallback: null,
                  readQueuePromises: [],
                  db: n
                };
                return n.onclose = function () {
                  r.closed = !0, t.idb.onclose && t.idb.onclose();
                }, S(r), r;
              });
            },
            close: function close(e) {
              e.closed = !0, e.db.close();
            },
            onMessage: function onMessage(e, t, n) {
              e.messagesCallbackTime = n, e.messagesCallback = t, x(e);
            },
            postMessage: function postMessage(e, t) {
              return e.writeBlockPromise = e.writeBlockPromise.then(function () {
                return function (e, t, n) {
                  var r = {
                      uuid: t,
                      time: new Date().getTime(),
                      data: n
                    },
                    o = e.transaction([O], "readwrite", T);
                  return new Promise(function (e, t) {
                    o.oncomplete = function () {
                      return e();
                    }, o.onerror = function (e) {
                      return t(e);
                    }, o.objectStore(O).add(r), E(o);
                  });
                }(e.db, e.uuid, t);
              }).then(function () {
                var t, n;
                0 === (0, 10, Math.floor(11 * Math.random() + 0)) && (t = e.db, n = e.options.idb.ttl, function (e, t) {
                  var n = new Date().getTime() - t,
                    r = e.transaction(O, "readonly", T),
                    o = r.objectStore(O),
                    i = [];
                  return new Promise(function (e) {
                    o.openCursor().onsuccess = function (t) {
                      var o = t.target.result;
                      if (o) {
                        var a = o.value;
                        if (!(a.time < n)) return E(r), void e(i);
                        i.push(a), o["continue"]();
                      } else e(i);
                    };
                  });
                }(t, n).then(function (e) {
                  return function (e, t) {
                    var n = e.transaction([O], "readwrite", T).objectStore(O);
                    return Promise.all(t.map(function (e) {
                      var t = n["delete"](e);
                      return new Promise(function (e) {
                        t.onsuccess = function () {
                          return e();
                        };
                      });
                    }));
                  }(t, e.map(function (e) {
                    return e.id;
                  }));
                }));
              }), e.writeBlockPromise;
            },
            canBeUsed: function canBeUsed() {
              return !!Z();
            },
            type: "idb",
            averageResponseTime: function averageResponseTime(e) {
              return 2 * e.idb.fallbackInterval;
            },
            microSeconds: g
          };
          function A() {
            var e;
            if ("undefined" == typeof window) return null;
            try {
              e = window.localStorage, e = window["ie8-eventlistener/storage"] || window.localStorage;
            } catch (e) {}
            return e;
          }
          function _(e) {
            return "pubkey.broadcastChannel-" + e;
          }
          function R() {
            var e = A();
            if (!e) return !1;
            try {
              var t = "__broadcastchannel_check";
              e.setItem(t, "works"), e.removeItem(t);
            } catch (e) {
              return !1;
            }
            return !0;
          }
          var j = {
              create: function create(e, t) {
                if (t = w(t), !R()) throw new Error("BroadcastChannel: localstorage cannot be used");
                var n = d(),
                  r = new b(t.localstorage.removeTimeout),
                  o = {
                    channelName: e,
                    uuid: n,
                    eMIs: r
                  };
                return o.listener = function (e, t) {
                  var i = _(e),
                    a = function a(e) {
                      var t;
                      e.key === i && (t = JSON.parse(e.newValue), o.messagesCallback && t.uuid !== n && t.token && !r.has(t.token) && (t.data.time && t.data.time < o.messagesCallbackTime || (r.add(t.token), o.messagesCallback(t.data))));
                    };
                  return window.addEventListener("storage", a), a;
                }(e), o;
              },
              close: function close(e) {
                var t;
                t = e.listener, window.removeEventListener("storage", t);
              },
              onMessage: function onMessage(e, t, n) {
                e.messagesCallbackTime = n, e.messagesCallback = t;
              },
              postMessage: function postMessage(e, t) {
                return new Promise(function (n) {
                  h().then(function () {
                    var r = _(e.channelName),
                      o = {
                        token: d(),
                        time: new Date().getTime(),
                        data: t,
                        uuid: e.uuid
                      },
                      i = JSON.stringify(o);
                    A().setItem(r, i);
                    var a = document.createEvent("Event");
                    a.initEvent("storage", !0, !0), a.key = r, a.newValue = i, window.dispatchEvent(a), n();
                  });
                });
              },
              canBeUsed: R,
              type: "localstorage",
              averageResponseTime: function averageResponseTime() {
                var e = navigator.userAgent.toLowerCase();
                return e.includes("safari") && !e.includes("chrome") ? 240 : 120;
              },
              microSeconds: g
            },
            C = g,
            D = new Set(),
            I = {
              create: function create(e) {
                var t = {
                  name: e,
                  messagesCallback: null
                };
                return D.add(t), t;
              },
              close: function close(e) {
                D["delete"](e);
              },
              onMessage: function onMessage(e, t) {
                e.messagesCallback = t;
              },
              postMessage: function postMessage(e, t) {
                return new Promise(function (n) {
                  return setTimeout(function () {
                    Array.from(D).filter(function (t) {
                      return t.name === e.name;
                    }).filter(function (t) {
                      return t !== e;
                    }).filter(function (e) {
                      return !!e.messagesCallback;
                    }).forEach(function (e) {
                      return e.messagesCallback(t);
                    }), n();
                  }, 5);
                });
              },
              canBeUsed: function canBeUsed() {
                return !0;
              },
              type: "simulate",
              averageResponseTime: function averageResponseTime() {
                return 5;
              },
              microSeconds: C
            },
            N = [m, P, j],
            M = new Set(),
            U = 0,
            L = function L(e, t) {
              var n, r, o;
              this.id = U++, M.add(this), this.name = e, this.options = w(t), this.method = function (e) {
                var t = [].concat(e.methods, N).filter(Boolean);
                if (e.type) {
                  if ("simulate" === e.type) return I;
                  var n = t.find(function (t) {
                    return t.type === e.type;
                  });
                  if (n) return n;
                  throw new Error("method-type " + e.type + " not found");
                }
                e.webWorkerSupport || (t = t.filter(function (e) {
                  return "idb" !== e.type;
                }));
                var r = t.find(function (e) {
                  return e.canBeUsed();
                });
                if (r) return r;
                throw new Error("No useable method found in " + JSON.stringify(N.map(function (e) {
                  return e.type;
                })));
              }(this.options), this._iL = !1, this._onML = null, this._addEL = {
                message: [],
                internal: []
              }, this._uMP = new Set(), this._befC = [], this._prepP = null, (o = r = (n = this).method.create(n.name, n.options)) && "function" == typeof o.then ? (n._prepP = r, r.then(function (e) {
                n._state = e;
              })) : n._state = r;
            };
          function F(e, t, n) {
            var r = {
              time: e.method.microSeconds(),
              type: t,
              data: n
            };
            return (e._prepP ? e._prepP : p).then(function () {
              var t = e.method.postMessage(e._state, r);
              return e._uMP.add(t), t["catch"]().then(function () {
                return e._uMP["delete"](t);
              }), t;
            });
          }
          function B(e) {
            return e._addEL.message.length > 0 || e._addEL.internal.length > 0;
          }
          function H(e, t, n) {
            e._addEL[t].push(n), function (e) {
              if (!e._iL && B(e)) {
                var t = function t(_t) {
                    e._addEL[_t.type].forEach(function (e) {
                      var n = e.time - 1e5;
                      _t.time >= n && e.fn(_t.data);
                    });
                  },
                  n = e.method.microSeconds();
                e._prepP ? e._prepP.then(function () {
                  e._iL = !0, e.method.onMessage(e._state, t, n);
                }) : (e._iL = !0, e.method.onMessage(e._state, t, n));
              }
            }(e);
          }
          function K(e, t, n) {
            e._addEL[t] = e._addEL[t].filter(function (e) {
              return e !== n;
            }), function (e) {
              if (e._iL && !B(e)) {
                e._iL = !1;
                var t = e.method.microSeconds();
                e.method.onMessage(e._state, null, t);
              }
            }(e);
          }
          L._pubkey = !0, L.prototype = {
            postMessage: function postMessage(e) {
              if (this.closed) throw new Error("BroadcastChannel.postMessage(): Cannot post message after channel has closed " + JSON.stringify(e));
              return F(this, "message", e);
            },
            postInternal: function postInternal(e) {
              return F(this, "internal", e);
            },
            set onmessage(e) {
              var t = {
                time: this.method.microSeconds(),
                fn: e
              };
              K(this, "message", this._onML), e && "function" == typeof e ? (this._onML = t, H(this, "message", t)) : this._onML = null;
            },
            addEventListener: function addEventListener(e, t) {
              H(this, e, {
                time: this.method.microSeconds(),
                fn: t
              });
            },
            removeEventListener: function removeEventListener(e, t) {
              K(this, e, this._addEL[e].find(function (e) {
                return e.fn === t;
              }));
            },
            close: function close() {
              var e = this;
              if (!this.closed) {
                M["delete"](this), this.closed = !0;
                var t = this._prepP ? this._prepP : p;
                return this._onML = null, this._addEL.message = [], t.then(function () {
                  return Promise.all(Array.from(e._uMP));
                }).then(function () {
                  return Promise.all(e._befC.map(function (e) {
                    return e();
                  }));
                }).then(function () {
                  return e.method.close(e._state);
                });
              }
            },
            get type() {
              return this.method.type;
            },
            get isClosed() {
              return this.closed;
            }
          };
          var G = n(5643),
            V = n.n(G),
            q = {
              add: function add(e) {
                if ("function" == typeof WorkerGlobalScope && self instanceof WorkerGlobalScope) ;else {
                  if ("function" != typeof window.addEventListener) return;
                  window.addEventListener("beforeunload", function () {
                    e();
                  }, !0), window.addEventListener("unload", function () {
                    e();
                  }, !0);
                }
              }
            },
            Y = n(199),
            W = n.n(Y),
            Q = V() ? W() : q,
            z = new Set(),
            X = !1;
          function $() {
            var e = [];
            return z.forEach(function (t) {
              e.push(t()), z["delete"](t);
            }), Promise.all(e);
          }
          var J = function J(e, t) {
            var n = this;
            this.broadcastChannel = e, this._options = t, this.isLeader = !1, this.hasLeader = !1, this.isDead = !1, this.token = d(), this._aplQ = p, this._aplQC = 0, this._unl = [], this._lstns = [], this._dpL = function () {}, this._dpLC = !1;
            var r = function r(e) {
              "leader" === e.context && ("death" === e.action && (n.hasLeader = !1), "tell" === e.action && (n.hasLeader = !0));
            };
            this.broadcastChannel.addEventListener("internal", r), this._lstns.push(r);
          };
          function ee(e, t) {
            var n = {
              context: "leader",
              action: t,
              token: e.token
            };
            return e.broadcastChannel.postInternal(n);
          }
          function te(e, t) {
            if (e._leaderElector) throw new Error("BroadcastChannel already has a leader-elector");
            t = function (e, t) {
              return e || (e = {}), (e = JSON.parse(JSON.stringify(e))).fallbackInterval || (e.fallbackInterval = 3e3), e.responseTime || (e.responseTime = t.method.averageResponseTime(t.options)), e;
            }(t, e);
            var n = new J(e, t);
            return e._befC.push(function () {
              return n.die();
            }), e._leaderElector = n, n;
          }
          J.prototype = {
            applyOnce: function applyOnce(e) {
              var t = this;
              if (this.isLeader) return h(0, !0);
              if (this.isDead) return h(0, !1);
              if (this._aplQC > 1) return this._aplQ;
              var n = function n() {
                if (t.isLeader) return l;
                var n,
                  r = !1,
                  o = new Promise(function (e) {
                    n = function n() {
                      r = !0, e();
                    };
                  }),
                  i = [],
                  a = function a(e) {
                    "leader" === e.context && e.token != t.token && (i.push(e), "apply" === e.action && e.token > t.token && n(), "tell" === e.action && (n(), t.hasLeader = !0));
                  };
                t.broadcastChannel.addEventListener("internal", a);
                var u = e ? 4 * t._options.responseTime : t._options.responseTime;
                return ee(t, "apply").then(function () {
                  return Promise.race([h(u), o.then(function () {
                    return Promise.reject(new Error());
                  })]);
                }).then(function () {
                  return ee(t, "apply");
                }).then(function () {
                  return Promise.race([h(u), o.then(function () {
                    return Promise.reject(new Error());
                  })]);
                })["catch"](function () {}).then(function () {
                  return t.broadcastChannel.removeEventListener("internal", a), !r && function (e) {
                    e.isLeader = !0, e.hasLeader = !0;
                    var t = function (e) {
                      if (X || (X = !0, Q.add($)), "function" != typeof e) throw new Error("Listener is no function");
                      return z.add(e), {
                        remove: function remove() {
                          return z["delete"](e);
                        },
                        run: function run() {
                          return z["delete"](e), e();
                        }
                      };
                    }(function () {
                      return e.die();
                    });
                    e._unl.push(t);
                    var n = function n(t) {
                      "leader" === t.context && "apply" === t.action && ee(e, "tell"), "leader" !== t.context || "tell" !== t.action || e._dpLC || (e._dpLC = !0, e._dpL(), ee(e, "tell"));
                    };
                    return e.broadcastChannel.addEventListener("internal", n), e._lstns.push(n), ee(e, "tell");
                  }(t).then(function () {
                    return !0;
                  });
                });
              };
              return this._aplQC = this._aplQC + 1, this._aplQ = this._aplQ.then(function () {
                return n();
              }).then(function () {
                t._aplQC = t._aplQC - 1;
              }), this._aplQ.then(function () {
                return t.isLeader;
              });
            },
            awaitLeadership: function awaitLeadership() {
              return this._aLP || (this._aLP = (e = this).isLeader ? p : new Promise(function (t) {
                var n = !1;
                function r() {
                  n || (n = !0, e.broadcastChannel.removeEventListener("internal", o), t(!0));
                }
                e.applyOnce().then(function () {
                  e.isLeader && r();
                }), function t() {
                  return h(e._options.fallbackInterval).then(function () {
                    if (!e.isDead && !n) return e.isLeader ? void r() : e.applyOnce(!0).then(function () {
                      e.isLeader ? r() : t();
                    });
                  });
                }();
                var o = function o(t) {
                  "leader" === t.context && "death" === t.action && (e.hasLeader = !1, e.applyOnce().then(function () {
                    e.isLeader && r();
                  }));
                };
                e.broadcastChannel.addEventListener("internal", o), e._lstns.push(o);
              })), this._aLP;
              var e;
            },
            set onduplicate(e) {
              this._dpL = e;
            },
            die: function die() {
              var e = this;
              return this._lstns.forEach(function (t) {
                return e.broadcastChannel.removeEventListener("internal", t);
              }), this._lstns = [], this._unl.forEach(function (e) {
                return e.remove();
              }), this._unl = [], this.isLeader && (this.hasLeader = !1, this.isLeader = !1), this.isDead = !0, ee(this, "death");
            }
          };
          var ne = n(415),
            re = function () {
              function e() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                (0, a.Z)(this, e), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "channel", void 0), (0, c.Z)(this, "elector", void 0), (0, c.Z)(this, "started", !1), this.options = t, this.onLeaderDuplicate = this.onLeaderDuplicate.bind(this), this.onLeader = this.onLeader.bind(this);
              }
              var t, n, r;
              return (0, u.Z)(e, [{
                key: "onLeaderDuplicate",
                value: function value() {}
              }, {
                key: "onLeader",
                value: (r = (0, i.Z)(f().mark(function e() {
                  var t, n;
                  return f().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        return e.next = 2, null === (t = (n = this.options).onLeader) || void 0 === t ? void 0 : t.call(n);
                      case 2:
                      case "end":
                        return e.stop();
                    }
                  }, e, this);
                })), function () {
                  return r.apply(this, arguments);
                })
              }, {
                key: "isLeader",
                value: function value() {
                  var e;
                  return !(null === (e = this.elector) || void 0 === e || !e.isLeader);
                }
              }, {
                key: "hasLeader",
                value: function value() {
                  var e;
                  return !(null === (e = this.elector) || void 0 === e || !e.hasLeader);
                }
              }, {
                key: "start",
                value: (n = (0, i.Z)(f().mark(function e() {
                  var t;
                  return f().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        this.canStart() && (t = this.options.electionChannelName, this.channel = new L(t), this.elector = te(this.channel), this.elector.onduplicate = this.onLeaderDuplicate, this.elector.awaitLeadership().then(this.onLeader), this.started = !0);
                      case 1:
                      case "end":
                        return e.stop();
                    }
                  }, e, this);
                })), function () {
                  return n.apply(this, arguments);
                })
              }, {
                key: "stop",
                value: (t = (0, i.Z)(f().mark(function e() {
                  return f().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        if (!this.started) {
                          e.next = 11;
                          break;
                        }
                        if (!this.elector) {
                          e.next = 5;
                          break;
                        }
                        return e.next = 4, this.elector.die();
                      case 4:
                        this.elector = void 0;
                      case 5:
                        if (!this.channel) {
                          e.next = 10;
                          break;
                        }
                        return this.channel.postInternal = function () {
                          return Promise.resolve();
                        }, e.next = 9, this.channel.close();
                      case 9:
                        this.channel = void 0;
                      case 10:
                        this.started = !1;
                      case 11:
                      case "end":
                        return e.stop();
                    }
                  }, e, this);
                })), function () {
                  return t.apply(this, arguments);
                })
              }, {
                key: "requiresLeadership",
                value: function value() {
                  return !1;
                }
              }, {
                key: "isStarted",
                value: function value() {
                  return this.started;
                }
              }, {
                key: "canStart",
                value: function value() {
                  return (0, ne.isBrowser)() && !this.started;
                }
              }]), e;
            }(),
            oe = n(9123),
            ie = n(6488),
            ae = n(7088),
            ue = function () {
              function e(t) {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                (0, a.Z)(this, e), (0, c.Z)(this, "tokenManager", void 0), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "renewTimeQueue", void 0), (0, c.Z)(this, "started", !1), this.tokenManager = t, this.options = n, this.renewTimeQueue = [], this.onTokenExpiredHandler = this.onTokenExpiredHandler.bind(this);
              }
              var t, n;
              return (0, u.Z)(e, [{
                key: "shouldThrottleRenew",
                value: function value() {
                  var e = !1;
                  if (this.renewTimeQueue.push(Date.now()), this.renewTimeQueue.length >= 10) {
                    var t = this.renewTimeQueue.shift();
                    e = this.renewTimeQueue[this.renewTimeQueue.length - 1] - t < 3e4;
                  }
                  return e;
                }
              }, {
                key: "requiresLeadership",
                value: function value() {
                  return !!this.options.syncStorage && (0, ne.isBrowser)();
                }
              }, {
                key: "processExpiredTokens",
                value: function value() {
                  var e = this,
                    t = this.tokenManager.getStorage().getStorage();
                  Object.keys(t).forEach(function (n) {
                    var r = t[n];
                    !(0, ie.z9)(r) && e.tokenManager.hasExpired(r) && e.onTokenExpiredHandler(n);
                  });
                }
              }, {
                key: "onTokenExpiredHandler",
                value: function value(e) {
                  if (this.options.autoRenew) {
                    if (this.shouldThrottleRenew()) {
                      var t = new oe.Z("Too many token renew requests");
                      this.tokenManager.emitError(t);
                    } else this.tokenManager.renew(e)["catch"](function () {});
                  } else this.options.autoRemove && this.tokenManager.remove(e);
                }
              }, {
                key: "canStart",
                value: function value() {
                  return !(!this.options.autoRenew && !this.options.autoRemove || this.started);
                }
              }, {
                key: "start",
                value: (n = (0, i.Z)(f().mark(function e() {
                  return f().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        this.canStart() && (this.tokenManager.on(ae.$Y, this.onTokenExpiredHandler), this.tokenManager.isStarted() && this.processExpiredTokens(), this.started = !0);
                      case 1:
                      case "end":
                        return e.stop();
                    }
                  }, e, this);
                })), function () {
                  return n.apply(this, arguments);
                })
              }, {
                key: "stop",
                value: (t = (0, i.Z)(f().mark(function e() {
                  return f().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        this.started && (this.tokenManager.off(ae.$Y, this.onTokenExpiredHandler), this.renewTimeQueue = [], this.started = !1);
                      case 1:
                      case "end":
                        return e.stop();
                    }
                  }, e, this);
                })), function () {
                  return t.apply(this, arguments);
                })
              }, {
                key: "isStarted",
                value: function value() {
                  return this.started;
                }
              }]), e;
            }(),
            ce = function () {
              function e(t) {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                (0, a.Z)(this, e), (0, c.Z)(this, "tokenManager", void 0), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "channel", void 0), (0, c.Z)(this, "started", !1), (0, c.Z)(this, "enablePostMessage", !0), this.tokenManager = t, this.options = n, this.onTokenAddedHandler = this.onTokenAddedHandler.bind(this), this.onTokenRemovedHandler = this.onTokenRemovedHandler.bind(this), this.onTokenRenewedHandler = this.onTokenRenewedHandler.bind(this), this.onSetStorageHandler = this.onSetStorageHandler.bind(this), this.onSyncMessageHandler = this.onSyncMessageHandler.bind(this);
              }
              var t, n;
              return (0, u.Z)(e, [{
                key: "requiresLeadership",
                value: function value() {
                  return !1;
                }
              }, {
                key: "isStarted",
                value: function value() {
                  return this.started;
                }
              }, {
                key: "canStart",
                value: function value() {
                  return !!this.options.syncStorage && (0, ne.isBrowser)() && !this.started;
                }
              }, {
                key: "start",
                value: (n = (0, i.Z)(f().mark(function e() {
                  var t;
                  return f().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        if (this.canStart()) {
                          e.next = 2;
                          break;
                        }
                        return e.abrupt("return");
                      case 2:
                        t = this.options.syncChannelName, e.prev = 3, this.channel = new L(t), e.next = 10;
                        break;
                      case 7:
                        throw e.prev = 7, e.t0 = e["catch"](3), new oe.Z("SyncStorageService is not supported in current browser.");
                      case 10:
                        this.tokenManager.on(ae.O3, this.onTokenAddedHandler), this.tokenManager.on(ae.FT, this.onTokenRemovedHandler), this.tokenManager.on(ae.E, this.onTokenRenewedHandler), this.tokenManager.on(ae.zr, this.onSetStorageHandler), this.channel.addEventListener("message", this.onSyncMessageHandler), this.started = !0;
                      case 16:
                      case "end":
                        return e.stop();
                    }
                  }, e, this, [[3, 7]]);
                })), function () {
                  return n.apply(this, arguments);
                })
              }, {
                key: "stop",
                value: (t = (0, i.Z)(f().mark(function e() {
                  var t, n;
                  return f().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        if (!this.started) {
                          e.next = 10;
                          break;
                        }
                        return this.tokenManager.off(ae.O3, this.onTokenAddedHandler), this.tokenManager.off(ae.FT, this.onTokenRemovedHandler), this.tokenManager.off(ae.E, this.onTokenRenewedHandler), this.tokenManager.off(ae.zr, this.onSetStorageHandler), null === (t = this.channel) || void 0 === t || t.removeEventListener("message", this.onSyncMessageHandler), e.next = 8, null === (n = this.channel) || void 0 === n ? void 0 : n.close();
                      case 8:
                        this.channel = void 0, this.started = !1;
                      case 10:
                      case "end":
                        return e.stop();
                    }
                  }, e, this);
                })), function () {
                  return t.apply(this, arguments);
                })
              }, {
                key: "onTokenAddedHandler",
                value: function value(e, t) {
                  var n;
                  this.enablePostMessage && (null === (n = this.channel) || void 0 === n || n.postMessage({
                    type: ae.O3,
                    key: e,
                    token: t
                  }));
                }
              }, {
                key: "onTokenRemovedHandler",
                value: function value(e, t) {
                  var n;
                  this.enablePostMessage && (null === (n = this.channel) || void 0 === n || n.postMessage({
                    type: ae.FT,
                    key: e,
                    token: t
                  }));
                }
              }, {
                key: "onTokenRenewedHandler",
                value: function value(e, t, n) {
                  var r;
                  this.enablePostMessage && (null === (r = this.channel) || void 0 === r || r.postMessage({
                    type: ae.E,
                    key: e,
                    token: t,
                    oldToken: n
                  }));
                }
              }, {
                key: "onSetStorageHandler",
                value: function value(e) {
                  var t;
                  null === (t = this.channel) || void 0 === t || t.postMessage({
                    type: ae.zr,
                    storage: e
                  });
                }
              }, {
                key: "onSyncMessageHandler",
                value: function value(e) {
                  switch (this.enablePostMessage = !1, e.type) {
                    case ae.zr:
                      this.tokenManager.getStorage().setStorage(e.storage);
                      break;
                    case ae.O3:
                      this.tokenManager.emitAdded(e.key, e.token), this.tokenManager.setExpireEventTimeout(e.key, e.token);
                      break;
                    case ae.FT:
                      this.tokenManager.clearExpireEventTimeout(e.key), this.tokenManager.emitRemoved(e.key, e.token);
                      break;
                    case ae.E:
                      this.tokenManager.emitRenewed(e.key, e.token, e.oldToken);
                  }
                  this.enablePostMessage = !0;
                }
              }]), e;
            }(),
            se = n(3193);
          function fe(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function le(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? fe(Object(n), !0).forEach(function (t) {
                (0, c.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : fe(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          function pe(e, t) {
            var _n = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
            if (!_n) {
              if (Array.isArray(e) || (_n = function (e, t) {
                if (e) {
                  if ("string" == typeof e) return he(e, t);
                  var n = Object.prototype.toString.call(e).slice(8, -1);
                  return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? he(e, t) : void 0;
                }
              }(e)) || t && e && "number" == typeof e.length) {
                _n && (e = _n);
                var r = 0,
                  o = function o() {};
                return {
                  s: o,
                  n: function n() {
                    return r >= e.length ? {
                      done: !0
                    } : {
                      done: !1,
                      value: e[r++]
                    };
                  },
                  e: function e(_e2) {
                    throw _e2;
                  },
                  f: o
                };
              }
              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var i,
              a = !0,
              u = !1;
            return {
              s: function s() {
                _n = _n.call(e);
              },
              n: function n() {
                var e = _n.next();
                return a = e.done, e;
              },
              e: function e(_e3) {
                u = !0, i = _e3;
              },
              f: function f() {
                try {
                  a || null == _n["return"] || _n["return"]();
                } finally {
                  if (u) throw i;
                }
              }
            };
          }
          function he(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
            return r;
          }
          var de = "autoRenew",
            ve = "syncStorage",
            ye = "leaderElection",
            ge = function () {
              function e(t) {
                var n = this,
                  r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                (0, a.Z)(this, e), (0, c.Z)(this, "sdk", void 0), (0, c.Z)(this, "options", void 0), (0, c.Z)(this, "services", void 0), (0, c.Z)(this, "started", void 0), this.sdk = t, this.onLeader = this.onLeader.bind(this);
                var o = t.tokenManager.getOptions(),
                  i = o.autoRenew,
                  u = o.autoRemove,
                  s = o.syncStorage;
                r.electionChannelName = r.electionChannelName || r.broadcastChannelName, this.options = Object.assign({}, e.defaultOptions, {
                  autoRenew: i,
                  autoRemove: u,
                  syncStorage: s
                }, {
                  electionChannelName: "".concat(t.options.clientId, "-election"),
                  syncChannelName: "".concat(t.options.clientId, "-sync")
                }, (0, se.YY)(r)), this.started = !1, this.services = new Map(), e.knownServices.forEach(function (e) {
                  var t = n.createService(e);
                  t && n.services.set(e, t);
                });
              }
              var t, n, s, l, p;
              return (0, u.Z)(e, [{
                key: "onLeader",
                value: (p = (0, i.Z)(f().mark(function e() {
                  return f().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        if (!this.started) {
                          e.next = 3;
                          break;
                        }
                        return e.next = 3, this.startServices();
                      case 3:
                      case "end":
                        return e.stop();
                    }
                  }, e, this);
                })), function () {
                  return p.apply(this, arguments);
                })
              }, {
                key: "isLeader",
                value: function value() {
                  var e;
                  return null === (e = this.getService(ye)) || void 0 === e ? void 0 : e.isLeader();
                }
              }, {
                key: "isLeaderRequired",
                value: function value() {
                  return (0, o.Z)(this.services.values()).some(function (e) {
                    return e.canStart() && e.requiresLeadership();
                  });
                }
              }, {
                key: "start",
                value: (l = (0, i.Z)(f().mark(function e() {
                  return f().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        if (!this.started) {
                          e.next = 2;
                          break;
                        }
                        return e.abrupt("return");
                      case 2:
                        return e.next = 4, this.startServices();
                      case 4:
                        this.started = !0;
                      case 5:
                      case "end":
                        return e.stop();
                    }
                  }, e, this);
                })), function () {
                  return l.apply(this, arguments);
                })
              }, {
                key: "stop",
                value: (s = (0, i.Z)(f().mark(function e() {
                  return f().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        return e.next = 2, this.stopServices();
                      case 2:
                        this.started = !1;
                      case 3:
                      case "end":
                        return e.stop();
                    }
                  }, e, this);
                })), function () {
                  return s.apply(this, arguments);
                })
              }, {
                key: "getService",
                value: function value(e) {
                  return this.services.get(e);
                }
              }, {
                key: "startServices",
                value: (n = (0, i.Z)(f().mark(function e() {
                  var t, n, o, i, a;
                  return f().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        t = pe(this.services.entries()), e.prev = 1, t.s();
                      case 3:
                        if ((n = t.n()).done) {
                          e.next = 10;
                          break;
                        }
                        if (o = (0, r.Z)(n.value, 2), i = o[0], a = o[1], !this.canStartService(i, a)) {
                          e.next = 8;
                          break;
                        }
                        return e.next = 8, a.start();
                      case 8:
                        e.next = 3;
                        break;
                      case 10:
                        e.next = 15;
                        break;
                      case 12:
                        e.prev = 12, e.t0 = e["catch"](1), t.e(e.t0);
                      case 15:
                        return e.prev = 15, t.f(), e.finish(15);
                      case 18:
                      case "end":
                        return e.stop();
                    }
                  }, e, this, [[1, 12, 15, 18]]);
                })), function () {
                  return n.apply(this, arguments);
                })
              }, {
                key: "stopServices",
                value: (t = (0, i.Z)(f().mark(function e() {
                  var t, n, r;
                  return f().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        t = pe(this.services.values()), e.prev = 1, t.s();
                      case 3:
                        if ((n = t.n()).done) {
                          e.next = 9;
                          break;
                        }
                        return r = n.value, e.next = 7, r.stop();
                      case 7:
                        e.next = 3;
                        break;
                      case 9:
                        e.next = 14;
                        break;
                      case 11:
                        e.prev = 11, e.t0 = e["catch"](1), t.e(e.t0);
                      case 14:
                        return e.prev = 14, t.f(), e.finish(14);
                      case 17:
                      case "end":
                        return e.stop();
                    }
                  }, e, this, [[1, 11, 14, 17]]);
                })), function () {
                  return t.apply(this, arguments);
                })
              }, {
                key: "canStartService",
                value: function value(e, t) {
                  var n = t.canStart() && !t.isStarted();
                  return e === ye ? n && (n = this.isLeaderRequired()) : t.requiresLeadership() && n && (n = this.isLeader()), n;
                }
              }, {
                key: "createService",
                value: function value(e) {
                  var t,
                    n = this.sdk.tokenManager;
                  switch (e) {
                    case ye:
                      t = new re(le(le({}, this.options), {}, {
                        onLeader: this.onLeader
                      }));
                      break;
                    case de:
                      t = new ue(n, le({}, this.options));
                      break;
                    case ve:
                      t = new ce(n, le({}, this.options));
                      break;
                    default:
                      throw new Error("Unknown service ".concat(e));
                  }
                  return t;
                }
              }]), e;
            }();
          (0, c.Z)(ge, "knownServices", [de, ve, ye]), (0, c.Z)(ge, "defaultOptions", {
            autoRenew: !0,
            autoRemove: !0,
            syncStorage: !0
          });
        },
        6599: function _(e, t, n) {
          "use strict";

          n.d(t, {
            W: function W() {
              return r.W;
            }
          });
          var r = n(2397);
        },
        1578: function _(e, t, n) {
          "use strict";

          n.d(t, {
            K: function K() {
              return s;
            }
          });
          var r = n(9893),
            o = n(265),
            i = n(279),
            a = n(2724),
            u = n(8386),
            c = n(3980);
          function s(e, t, n) {
            var s = (0, r.a)(t),
              f = (0, o.H)(s, e),
              l = (0, i.A)(f),
              p = (0, c.Z)(l),
              h = (0, a.J)(p, n);
            return (0, u.i)(h);
          }
        },
        3961: function _(e, t, n) {
          "use strict";

          n.r(t), n.d(t, {
            AuthStateManager: function AuthStateManager() {
              return r.E;
            },
            INITIAL_AUTH_STATE: function INITIAL_AUTH_STATE() {
              return r.a;
            },
            ServiceManager: function ServiceManager() {
              return l.W;
            },
            createCoreOptionsConstructor: function createCoreOptionsConstructor() {
              return o.n;
            },
            createCoreStorageManager: function createCoreStorageManager() {
              return u.a;
            },
            createOktaAuthCore: function createOktaAuthCore() {
              return i.K;
            },
            mixinCore: function mixinCore() {
              return a.i;
            }
          });
          var r = n(1018),
            o = n(9133),
            i = n(1578),
            a = n(8386),
            u = n(2647),
            c = n(8553),
            s = {};
          for (var f in c) ["default", "AuthStateManager", "INITIAL_AUTH_STATE", "createCoreOptionsConstructor", "createOktaAuthCore", "mixinCore", "createCoreStorageManager"].indexOf(f) < 0 && (s[f] = function (e) {
            return c[e];
          }.bind(0, f));
          n.d(t, s);
          var l = n(6599);
        },
        8386: function _(e, t, n) {
          "use strict";

          n.d(t, {
            i: function i() {
              return y;
            }
          });
          var r = n(5861),
            o = n(5671),
            i = n(3144),
            a = n(7326),
            u = n(136),
            c = n(2963),
            s = n(1120),
            f = n(4942),
            l = n(4687),
            p = n.n(l),
            h = n(5372),
            d = n(1018),
            v = n(2397);
          function y(e) {
            return function (e) {
              (0, u.Z)(k, e);
              var t,
                n,
                l,
                y,
                g,
                m,
                b = (g = k, m = function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                  } catch (e) {
                    return !1;
                  }
                }(), function () {
                  var e,
                    t = (0, s.Z)(g);
                  if (m) {
                    var n = (0, s.Z)(this).constructor;
                    e = Reflect.construct(t, arguments, n);
                  } else e = t.apply(this, arguments);
                  return (0, c.Z)(this, e);
                });
              function k() {
                var e;
                (0, o.Z)(this, k);
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return e = b.call.apply(b, [this].concat(n)), (0, f.Z)((0, a.Z)(e), "authStateManager", void 0), (0, f.Z)((0, a.Z)(e), "serviceManager", void 0), e.authStateManager = new d.E((0, a.Z)(e)), e.serviceManager = new v.W((0, a.Z)(e), e.options.services), e;
              }
              return (0, i.Z)(k, [{
                key: "start",
                value: (y = (0, r.Z)(p().mark(function e() {
                  return p().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        return e.next = 2, this.serviceManager.start();
                      case 2:
                        if (this.tokenManager.start(), this.token.isLoginRedirect()) {
                          e.next = 6;
                          break;
                        }
                        return e.next = 6, this.authStateManager.updateAuthState();
                      case 6:
                      case "end":
                        return e.stop();
                    }
                  }, e, this);
                })), function () {
                  return y.apply(this, arguments);
                })
              }, {
                key: "stop",
                value: (l = (0, r.Z)(p().mark(function e() {
                  return p().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        return this.tokenManager.stop(), e.next = 3, this.serviceManager.stop();
                      case 3:
                      case "end":
                        return e.stop();
                    }
                  }, e, this);
                })), function () {
                  return l.apply(this, arguments);
                })
              }, {
                key: "handleRedirect",
                value: (n = (0, r.Z)(p().mark(function e(t) {
                  return p().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        return e.next = 2, this.handleLoginRedirect(void 0, t);
                      case 2:
                      case "end":
                        return e.stop();
                    }
                  }, e, this);
                })), function (e) {
                  return n.apply(this, arguments);
                })
              }, {
                key: "handleLoginRedirect",
                value: (t = (0, r.Z)(p().mark(function e(t, n) {
                  var r, o, i;
                  return p().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        if (r = this.options.state, !t) {
                          e.next = 6;
                          break;
                        }
                        this.tokenManager.setTokens(t), n = n || this.getOriginalUri(this.options.state), e.next = 25;
                        break;
                      case 6:
                        if (!this.isLoginRedirect()) {
                          e.next = 24;
                          break;
                        }
                        return e.prev = 7, e.next = 10, (0, h.Tp)(this, {});
                      case 10:
                        return o = e.sent, r = o.state, n = n || this.getOriginalUri(r), e.next = 15, this.storeTokensFromRedirect();
                      case 15:
                        e.next = 22;
                        break;
                      case 17:
                        return e.prev = 17, e.t0 = e["catch"](7), e.next = 21, this.authStateManager.updateAuthState();
                      case 21:
                        throw e.t0;
                      case 22:
                        e.next = 25;
                        break;
                      case 24:
                        return e.abrupt("return");
                      case 25:
                        return e.next = 27, this.authStateManager.updateAuthState();
                      case 27:
                        if (this.removeOriginalUri(r), !(i = this.options.restoreOriginalUri)) {
                          e.next = 34;
                          break;
                        }
                        return e.next = 32, i(this, n);
                      case 32:
                        e.next = 35;
                        break;
                      case 34:
                        n && window.location.replace(n);
                      case 35:
                      case "end":
                        return e.stop();
                    }
                  }, e, this, [[7, 17]]);
                })), function (e, n) {
                  return t.apply(this, arguments);
                })
              }]), k;
            }(e);
          }
        },
        9133: function _(e, t, n) {
          "use strict";

          n.d(t, {
            n: function n() {
              return l;
            }
          });
          var r = n(3144),
            o = n(5671),
            i = n(7326),
            a = n(136),
            u = n(2963),
            c = n(1120),
            s = n(4942),
            f = n(9453);
          function l() {
            return function (e) {
              (0, a.Z)(l, e);
              var t,
                n,
                f = (t = l, n = function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                  } catch (e) {
                    return !1;
                  }
                }(), function () {
                  var e,
                    r = (0, c.Z)(t);
                  if (n) {
                    var o = (0, c.Z)(this).constructor;
                    e = Reflect.construct(r, arguments, o);
                  } else e = r.apply(this, arguments);
                  return (0, u.Z)(this, e);
                });
              function l(e) {
                var t;
                return (0, o.Z)(this, l), t = f.call(this, e), (0, s.Z)((0, i.Z)(t), "services", void 0), (0, s.Z)((0, i.Z)(t), "transformAuthState", void 0), t.services = e.services, t.transformAuthState = e.transformAuthState, t;
              }
              return (0, r.Z)(l);
            }((0, f.m)());
          }
        },
        2647: function _(e, t, n) {
          "use strict";

          n.d(t, {
            a: function a() {
              return o;
            }
          });
          var r = n(2333);
          function o() {
            return (0, r.a)();
          }
        },
        5675: function _() {},
        8553: function _(e, t, n) {
          "use strict";

          n.r(t);
          var r = n(5675),
            o = {};
          for (var i in r) "default" !== i && (o[i] = function (e) {
            return r[e];
          }.bind(0, i));
          n.d(t, o);
        },
        7987: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Df: function Df() {
              return u;
            },
            EL: function EL() {
              return f;
            },
            NL: function NL() {
              return i;
            },
            Wy: function Wy() {
              return c;
            },
            aR: function aR() {
              return a;
            },
            dX: function dX() {
              return l;
            },
            k8: function k8() {
              return s;
            },
            kQ: function kQ() {
              return p;
            }
          });
          var r = n(9123),
            o = n(7594);
          function i(e) {
            return a((0, o.r3)(e));
          }
          function a(e) {
            return e.replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
          }
          function u(e) {
            return e.replace(/-/g, "+").replace(/_/g, "/");
          }
          function c(e) {
            var t = u(e);
            switch (t.length % 4) {
              case 0:
                break;
              case 2:
                t += "==";
                break;
              case 3:
                t += "=";
                break;
              default:
                throw new r.Z("Not a valid Base64Url");
            }
            var n = (0, o.ty)(t);
            try {
              return decodeURIComponent(escape(n));
            } catch (e) {
              return n;
            }
          }
          function s(e) {
            for (var t = new Uint8Array(e.length), n = 0; n < e.length; n++) t[n] = e.charCodeAt(n);
            return t;
          }
          function f(e) {
            return (0, o.ty)(u(e));
          }
          function l(e) {
            return Uint8Array.from(f(e), function (e) {
              return e.charCodeAt(0);
            });
          }
          function p(e) {
            return (0, o.r3)(new Uint8Array(e).reduce(function (e, t) {
              return e + String.fromCharCode(t);
            }, ""));
          }
        },
        7594: function _(e, t, n) {
          "use strict";

          n.d(t, {
            KP: function KP() {
              return i;
            },
            r3: function r3() {
              return o;
            },
            ty: function ty() {
              return r;
            }
          });
          var r = function r(e) {
              return atob(e);
            },
            o = function o(e) {
              return btoa(e);
            },
            i = "undefined" == typeof crypto ? null : crypto;
        },
        9718: function _(e, t, n) {
          "use strict";

          n.r(t), n.d(t, {
            atob: function atob() {
              return s.ty;
            },
            base64ToBase64Url: function base64ToBase64Url() {
              return r.aR;
            },
            base64UrlDecode: function base64UrlDecode() {
              return r.EL;
            },
            base64UrlToBase64: function base64UrlToBase64() {
              return r.Df;
            },
            base64UrlToBuffer: function base64UrlToBuffer() {
              return r.dX;
            },
            base64UrlToString: function base64UrlToString() {
              return r.Wy;
            },
            btoa: function btoa() {
              return s.r3;
            },
            bufferToBase64Url: function bufferToBase64Url() {
              return r.kQ;
            },
            getOidcHash: function getOidcHash() {
              return o.X;
            },
            stringToBase64Url: function stringToBase64Url() {
              return r.NL;
            },
            stringToBuffer: function stringToBuffer() {
              return r.k8;
            },
            verifyToken: function verifyToken() {
              return c.W;
            },
            webcrypto: function webcrypto() {
              return s.KP;
            }
          });
          var r = n(7987),
            o = n(5698),
            i = n(6332),
            a = {};
          for (var u in i) ["default", "base64ToBase64Url", "base64UrlDecode", "base64UrlToBase64", "base64UrlToBuffer", "base64UrlToString", "bufferToBase64Url", "stringToBase64Url", "stringToBuffer", "getOidcHash"].indexOf(u) < 0 && (a[u] = function (e) {
            return i[e];
          }.bind(0, u));
          n.d(t, a);
          var c = n(3154),
            s = n(1);
        },
        5698: function _(e, t, n) {
          "use strict";

          n.d(t, {
            X: function X() {
              return i;
            }
          });
          var r = n(7987),
            o = n(7594);
          function i(e) {
            var t = new TextEncoder().encode(e);
            return o.KP.subtle.digest("SHA-256", t).then(function (e) {
              var t = new Uint8Array(e).slice(0, 16),
                n = String.fromCharCode.apply(null, t);
              return (0, r.NL)(n);
            });
          }
        },
        6332: function _() {},
        3154: function _(e, t, n) {
          "use strict";

          n.d(t, {
            W: function W() {
              return a;
            }
          });
          var r = n(3193),
            o = n(7987),
            i = n(7594);
          function a(e, t) {
            t = (0, r.d9)(t);
            var n = {
              name: "RSASSA-PKCS1-v1_5",
              hash: {
                name: "SHA-256"
              }
            };
            return delete t.use, i.KP.subtle.importKey("jwk", t, n, !0, ["verify"]).then(function (t) {
              var r = e.split("."),
                a = (0, o.k8)(r[0] + "." + r[1]),
                u = (0, o.EL)(r[2]),
                c = (0, o.k8)(u);
              return i.KP.subtle.verify(n, t, c, a);
            });
          }
        },
        1: function _(e, t, n) {
          "use strict";

          n.d(t, {
            KP: function KP() {
              return r.KP;
            },
            r3: function r3() {
              return r.r3;
            },
            ty: function ty() {
              return r.ty;
            }
          });
          var r = n(7594);
        },
        3983: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Z: function Z() {
              return f;
            }
          });
          var r = n(3144),
            o = n(5671),
            i = n(7326),
            a = n(136),
            u = n(2963),
            c = n(1120),
            s = n(4942);
          var f = function (e) {
            (0, a.Z)(l, e);
            var t,
              n,
              f = (t = l, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, c.Z)(t);
                if (n) {
                  var o = (0, c.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, u.Z)(this, e);
              });
            function l(e, t, n) {
              var r;
              (0, o.Z)(this, l);
              var a = e.errorSummary;
              return r = f.call(this, a), (0, s.Z)((0, i.Z)(r), "errorSummary", void 0), (0, s.Z)((0, i.Z)(r), "errorCode", void 0), (0, s.Z)((0, i.Z)(r), "errorLink", void 0), (0, s.Z)((0, i.Z)(r), "errorId", void 0), (0, s.Z)((0, i.Z)(r), "errorCauses", void 0), (0, s.Z)((0, i.Z)(r), "xhr", void 0), (0, s.Z)((0, i.Z)(r), "meta", void 0), r.name = "AuthApiError", r.errorSummary = e.errorSummary, r.errorCode = e.errorCode, r.errorLink = e.errorLink, r.errorId = e.errorId, r.errorCauses = e.errorCauses, t && (r.xhr = t), n && (r.meta = n), r;
            }
            return (0, r.Z)(l);
          }(n(6245).Z);
        },
        6573: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Z: function Z() {
              return c;
            }
          });
          var r = n(3144),
            o = n(5671),
            i = n(136),
            a = n(2963),
            u = n(1120);
          var c = function (e) {
            (0, i.Z)(s, e);
            var t,
              n,
              c = (t = s, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, u.Z)(t);
                if (n) {
                  var o = (0, u.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, a.Z)(this, e);
              });
            function s() {
              return (0, o.Z)(this, s), c.call(this, "The poll was stopped by the sdk");
            }
            return (0, r.Z)(s);
          }(n(6245).Z);
        },
        9123: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Z: function Z() {
              return f;
            }
          });
          var r = n(3144),
            o = n(5671),
            i = n(7326),
            a = n(136),
            u = n(2963),
            c = n(1120),
            s = n(4942);
          var f = function (e) {
            (0, a.Z)(l, e);
            var t,
              n,
              f = (t = l, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, c.Z)(t);
                if (n) {
                  var o = (0, c.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, u.Z)(this, e);
              });
            function l(e, t) {
              var n;
              return (0, o.Z)(this, l), n = f.call(this, e), (0, s.Z)((0, i.Z)(n), "errorSummary", void 0), (0, s.Z)((0, i.Z)(n), "errorCode", void 0), (0, s.Z)((0, i.Z)(n), "errorLink", void 0), (0, s.Z)((0, i.Z)(n), "errorId", void 0), (0, s.Z)((0, i.Z)(n), "errorCauses", void 0), (0, s.Z)((0, i.Z)(n), "xhr", void 0), n.name = "AuthSdkError", n.errorCode = "INTERNAL", n.errorSummary = e, n.errorLink = "INTERNAL", n.errorId = "INTERNAL", n.errorCauses = [], t && (n.xhr = t), n;
            }
            return (0, r.Z)(l);
          }(n(6245).Z);
        },
        6245: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Z: function Z() {
              return p;
            }
          });
          var r = n(3144),
            o = n(5671),
            i = n(7326),
            a = n(136),
            u = n(2963),
            c = n(1120),
            s = n(9611);
          function f(e, t, n) {
            return f = function () {
              if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
              if (Reflect.construct.sham) return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
              } catch (e) {
                return !1;
              }
            }() ? Reflect.construct.bind() : function (e, t, n) {
              var r = [null];
              r.push.apply(r, t);
              var o = new (Function.bind.apply(e, r))();
              return n && (0, s.Z)(o, n.prototype), o;
            }, f.apply(null, arguments);
          }
          function l(e) {
            var t = "function" == typeof Map ? new Map() : void 0;
            return l = function l(e) {
              if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
              var n;
              if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
              if (void 0 !== t) {
                if (t.has(e)) return t.get(e);
                t.set(e, r);
              }
              function r() {
                return f(e, arguments, (0, c.Z)(this).constructor);
              }
              return r.prototype = Object.create(e.prototype, {
                constructor: {
                  value: r,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0
                }
              }), (0, s.Z)(r, e);
            }, l(e);
          }
          var p = function (e) {
            (0, a.Z)(f, e);
            var t,
              n,
              s = (t = f, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, c.Z)(t);
                if (n) {
                  var o = (0, c.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, u.Z)(this, e);
              });
            function f(e) {
              var t;
              return (0, o.Z)(this, f), t = s.call(this, e), Object.setPrototypeOf((0, i.Z)(t), (this instanceof f ? this.constructor : void 0).prototype), t;
            }
            return (0, r.Z)(f);
          }(l(Error));
        },
        2886: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Z: function Z() {
              return f;
            }
          });
          var r = n(3144),
            o = n(5671),
            i = n(7326),
            a = n(136),
            u = n(2963),
            c = n(1120),
            s = n(4942);
          var f = function (e) {
            (0, a.Z)(l, e);
            var t,
              n,
              f = (t = l, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, c.Z)(t);
                if (n) {
                  var o = (0, c.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, u.Z)(this, e);
              });
            function l(e, t) {
              var n;
              return (0, o.Z)(this, l), n = f.call(this, t), (0, s.Z)((0, i.Z)(n), "errorCode", void 0), (0, s.Z)((0, i.Z)(n), "errorSummary", void 0), (0, s.Z)((0, i.Z)(n), "error", void 0), (0, s.Z)((0, i.Z)(n), "error_description", void 0), n.name = "OAuthError", n.errorCode = e, n.errorSummary = t, n.error = e, n.error_description = t, n;
            }
            return (0, r.Z)(l);
          }(n(6245).Z);
        },
        5728: function _(e, t, n) {
          "use strict";

          n.r(t), n.d(t, {
            AuthApiError: function AuthApiError() {
              return r.Z;
            },
            AuthPollStopError: function AuthPollStopError() {
              return o.Z;
            },
            AuthSdkError: function AuthSdkError() {
              return i.Z;
            },
            OAuthError: function OAuthError() {
              return a.Z;
            },
            isAuthApiError: function isAuthApiError() {
              return f;
            },
            isOAuthError: function isOAuthError() {
              return l;
            }
          });
          var r = n(3983),
            o = n(6573),
            i = n(9123),
            a = n(2886),
            u = n(1243),
            c = {};
          for (var s in u) ["default", "isAuthApiError", "isOAuthError", "AuthApiError", "AuthPollStopError", "AuthSdkError", "OAuthError"].indexOf(s) < 0 && (c[s] = function (e) {
            return u[e];
          }.bind(0, s));
          function f(e) {
            return e instanceof r.Z;
          }
          function l(e) {
            return e instanceof a.Z;
          }
          n.d(t, c);
        },
        1243: function _() {},
        6736: function _(e, t, n) {
          "use strict";

          n.r(t), n.d(t, {
            ACCESS_TOKEN_STORAGE_KEY: function ACCESS_TOKEN_STORAGE_KEY() {
              return i.ACCESS_TOKEN_STORAGE_KEY;
            },
            BaseStorageManager: function BaseStorageManager() {
              return h.W8;
            },
            CACHE_STORAGE_NAME: function CACHE_STORAGE_NAME() {
              return i.CACHE_STORAGE_NAME;
            },
            DEFAULT_CACHE_DURATION: function DEFAULT_CACHE_DURATION() {
              return i.DEFAULT_CACHE_DURATION;
            },
            DEFAULT_CODE_CHALLENGE_METHOD: function DEFAULT_CODE_CHALLENGE_METHOD() {
              return i.DEFAULT_CODE_CHALLENGE_METHOD;
            },
            DEFAULT_MAX_CLOCK_SKEW: function DEFAULT_MAX_CLOCK_SKEW() {
              return i.DEFAULT_MAX_CLOCK_SKEW;
            },
            DEFAULT_POLLING_DELAY: function DEFAULT_POLLING_DELAY() {
              return i.DEFAULT_POLLING_DELAY;
            },
            IDX_API_VERSION: function IDX_API_VERSION() {
              return i.IDX_API_VERSION;
            },
            IDX_RESPONSE_STORAGE_NAME: function IDX_RESPONSE_STORAGE_NAME() {
              return i.IDX_RESPONSE_STORAGE_NAME;
            },
            ID_TOKEN_STORAGE_KEY: function ID_TOKEN_STORAGE_KEY() {
              return i.ID_TOKEN_STORAGE_KEY;
            },
            MAX_VERIFIER_LENGTH: function MAX_VERIFIER_LENGTH() {
              return i.MAX_VERIFIER_LENGTH;
            },
            MIN_VERIFIER_LENGTH: function MIN_VERIFIER_LENGTH() {
              return i.MIN_VERIFIER_LENGTH;
            },
            ORIGINAL_URI_STORAGE_NAME: function ORIGINAL_URI_STORAGE_NAME() {
              return i.ORIGINAL_URI_STORAGE_NAME;
            },
            OktaUserAgent: function OktaUserAgent() {
              return f.ed;
            },
            PKCE_STORAGE_NAME: function PKCE_STORAGE_NAME() {
              return i.PKCE_STORAGE_NAME;
            },
            PromiseQueue: function PromiseQueue() {
              return d.bo;
            },
            REFERRER_PATH_STORAGE_KEY: function REFERRER_PATH_STORAGE_KEY() {
              return i.REFERRER_PATH_STORAGE_KEY;
            },
            REFRESH_TOKEN_STORAGE_KEY: function REFRESH_TOKEN_STORAGE_KEY() {
              return i.REFRESH_TOKEN_STORAGE_KEY;
            },
            SHARED_TRANSACTION_STORAGE_NAME: function SHARED_TRANSACTION_STORAGE_NAME() {
              return i.SHARED_TRANSACTION_STORAGE_NAME;
            },
            STATE_TOKEN_KEY_NAME: function STATE_TOKEN_KEY_NAME() {
              return i.STATE_TOKEN_KEY_NAME;
            },
            SavedObject: function SavedObject() {
              return h._e;
            },
            TOKEN_STORAGE_NAME: function TOKEN_STORAGE_NAME() {
              return i.TOKEN_STORAGE_NAME;
            },
            TRANSACTION_STORAGE_NAME: function TRANSACTION_STORAGE_NAME() {
              return i.TRANSACTION_STORAGE_NAME;
            },
            bind: function bind() {
              return d.ak;
            },
            clone: function clone() {
              return d.d9;
            },
            closeSession: function closeSession() {
              return p.RJ;
            },
            createBaseOptionsConstructor: function createBaseOptionsConstructor() {
              return o.X;
            },
            createHttpOptionsConstructor: function createHttpOptionsConstructor() {
              return f.ZM;
            },
            createOktaAuthBase: function createOktaAuthBase() {
              return o.a;
            },
            createSessionApi: function createSessionApi() {
              return p.MG;
            },
            createStorageOptionsConstructor: function createStorageOptionsConstructor() {
              return h.Tp;
            },
            crypto: function crypto() {
              return r;
            },
            delay: function delay() {
              return d.gw;
            },
            deprecate: function deprecate() {
              return d.Rn;
            },
            deprecateWrap: function deprecateWrap() {
              return d.VA;
            },
            extend: function extend() {
              return d.l7;
            },
            find: function find() {
              return d.sE;
            },
            genRandomString: function genRandomString() {
              return d.uh;
            },
            get: function get() {
              return f.U2;
            },
            getConsole: function getConsole() {
              return d.dr;
            },
            getLink: function getLink() {
              return d.Rg;
            },
            getNativeConsole: function getNativeConsole() {
              return d.sW;
            },
            getSession: function getSession() {
              return p.Gg;
            },
            httpRequest: function httpRequest() {
              return f.c3;
            },
            isAbsoluteUrl: function isAbsoluteUrl() {
              return d.sD;
            },
            isFunction: function isFunction() {
              return d.mf;
            },
            isNumber: function isNumber() {
              return d.hj;
            },
            isObject: function isObject() {
              return d.Kn;
            },
            isPromise: function isPromise() {
              return d.tI;
            },
            isString: function isString() {
              return d.HD;
            },
            isoToUTCString: function isoToUTCString() {
              return d.ng;
            },
            logServerSideMemoryStorageWarning: function logServerSideMemoryStorageWarning() {
              return h.Vp;
            },
            mixinHttp: function mixinHttp() {
              return f.Am;
            },
            mixinSession: function mixinSession() {
              return p.Zg;
            },
            mixinStorage: function mixinStorage() {
              return h.Ho;
            },
            omit: function omit() {
              return d.CE;
            },
            post: function post() {
              return f.v_;
            },
            refreshSession: function refreshSession() {
              return p.dx;
            },
            removeNils: function removeNils() {
              return d.YY;
            },
            removeTrailingSlash: function removeTrailingSlash() {
              return d.Qj;
            },
            sessionExists: function sessionExists() {
              return p.sH;
            },
            setCookieAndRedirect: function setCookieAndRedirect() {
              return p.OT;
            },
            setRequestHeader: function setRequestHeader() {
              return f.rn;
            },
            split2: function split2() {
              return d.YQ;
            },
            toAbsoluteUrl: function toAbsoluteUrl() {
              return d.BY;
            },
            toQueryString: function toQueryString() {
              return d.UK;
            },
            toRelativeUrl: function toRelativeUrl() {
              return d.QN;
            },
            warn: function warn() {
              return d.ZK;
            }
          });
          var r = n(9718),
            o = n(3306),
            i = n(1971),
            a = n(3961),
            u = {};
          for (var c in a) ["default", "crypto", "createBaseOptionsConstructor", "createOktaAuthBase", "ACCESS_TOKEN_STORAGE_KEY", "CACHE_STORAGE_NAME", "DEFAULT_CACHE_DURATION", "DEFAULT_CODE_CHALLENGE_METHOD", "DEFAULT_MAX_CLOCK_SKEW", "DEFAULT_POLLING_DELAY", "IDX_API_VERSION", "IDX_RESPONSE_STORAGE_NAME", "ID_TOKEN_STORAGE_KEY", "MAX_VERIFIER_LENGTH", "MIN_VERIFIER_LENGTH", "ORIGINAL_URI_STORAGE_NAME", "PKCE_STORAGE_NAME", "REFERRER_PATH_STORAGE_KEY", "REFRESH_TOKEN_STORAGE_KEY", "SHARED_TRANSACTION_STORAGE_NAME", "STATE_TOKEN_KEY_NAME", "TOKEN_STORAGE_NAME", "TRANSACTION_STORAGE_NAME"].indexOf(c) < 0 && (u[c] = function (e) {
            return a[e];
          }.bind(0, c));
          n.d(t, u);
          var s = n(5728);
          for (var c in u = {}, s) ["default", "crypto", "createBaseOptionsConstructor", "createOktaAuthBase", "ACCESS_TOKEN_STORAGE_KEY", "CACHE_STORAGE_NAME", "DEFAULT_CACHE_DURATION", "DEFAULT_CODE_CHALLENGE_METHOD", "DEFAULT_MAX_CLOCK_SKEW", "DEFAULT_POLLING_DELAY", "IDX_API_VERSION", "IDX_RESPONSE_STORAGE_NAME", "ID_TOKEN_STORAGE_KEY", "MAX_VERIFIER_LENGTH", "MIN_VERIFIER_LENGTH", "ORIGINAL_URI_STORAGE_NAME", "PKCE_STORAGE_NAME", "REFERRER_PATH_STORAGE_KEY", "REFRESH_TOKEN_STORAGE_KEY", "SHARED_TRANSACTION_STORAGE_NAME", "STATE_TOKEN_KEY_NAME", "TOKEN_STORAGE_NAME", "TRANSACTION_STORAGE_NAME", "AuthStateManager", "INITIAL_AUTH_STATE", "ServiceManager", "createCoreOptionsConstructor", "createCoreStorageManager", "createOktaAuthCore", "mixinCore"].indexOf(c) < 0 && (u[c] = function (e) {
            return s[e];
          }.bind(0, c));
          n.d(t, u);
          var f = n(4777),
            l = n(9443);
          for (var c in u = {}, l) ["default", "crypto", "createBaseOptionsConstructor", "createOktaAuthBase", "ACCESS_TOKEN_STORAGE_KEY", "CACHE_STORAGE_NAME", "DEFAULT_CACHE_DURATION", "DEFAULT_CODE_CHALLENGE_METHOD", "DEFAULT_MAX_CLOCK_SKEW", "DEFAULT_POLLING_DELAY", "IDX_API_VERSION", "IDX_RESPONSE_STORAGE_NAME", "ID_TOKEN_STORAGE_KEY", "MAX_VERIFIER_LENGTH", "MIN_VERIFIER_LENGTH", "ORIGINAL_URI_STORAGE_NAME", "PKCE_STORAGE_NAME", "REFERRER_PATH_STORAGE_KEY", "REFRESH_TOKEN_STORAGE_KEY", "SHARED_TRANSACTION_STORAGE_NAME", "STATE_TOKEN_KEY_NAME", "TOKEN_STORAGE_NAME", "TRANSACTION_STORAGE_NAME", "AuthStateManager", "INITIAL_AUTH_STATE", "ServiceManager", "createCoreOptionsConstructor", "createCoreStorageManager", "createOktaAuthCore", "mixinCore", "AuthApiError", "AuthPollStopError", "AuthSdkError", "OAuthError", "isAuthApiError", "isOAuthError", "OktaUserAgent", "createHttpOptionsConstructor", "get", "httpRequest", "mixinHttp", "post", "setRequestHeader"].indexOf(c) < 0 && (u[c] = function (e) {
            return l[e];
          }.bind(0, c));
          n.d(t, u);
          var p = n(8041),
            h = n(9927),
            d = n(305);
        },
        415: function _(e, t, n) {
          "use strict";

          n.r(t), n.d(t, {
            getUserAgent: function getUserAgent() {
              return u;
            },
            hasTextEncoder: function hasTextEncoder() {
              return l;
            },
            isBrowser: function isBrowser() {
              return i;
            },
            isFingerprintSupported: function isFingerprintSupported() {
              return c;
            },
            isHTTPS: function isHTTPS() {
              return h;
            },
            isIE11OrLess: function isIE11OrLess() {
              return a;
            },
            isLocalhost: function isLocalhost() {
              return d;
            },
            isPKCESupported: function isPKCESupported() {
              return p;
            },
            isPopupPostMessageSupported: function isPopupPostMessageSupported() {
              return s;
            },
            isTokenVerifySupported: function isTokenVerifySupported() {
              return f;
            }
          });
          var r = n(7594),
            o = /windows phone|iemobile|wpdesktop/i;
          function i() {
            return "undefined" != typeof document && "undefined" != typeof window;
          }
          function a() {
            if (!i()) return !1;
            var e = document.documentMode;
            return !!e && e <= 11;
          }
          function u() {
            return navigator.userAgent;
          }
          function c() {
            var e = u();
            return e && !o.test(e);
          }
          function s() {
            if (!i()) return !1;
            var e = document.documentMode,
              t = e && e < 10;
            return void 0 !== window.postMessage && !t;
          }
          function f() {
            return void 0 !== r.KP && null !== r.KP && void 0 !== r.KP.subtle && "undefined" != typeof Uint8Array;
          }
          function l() {
            return "undefined" != typeof TextEncoder;
          }
          function p() {
            return f() && l();
          }
          function h() {
            return !!i() && "https:" === window.location.protocol;
          }
          function d() {
            return i() && "localhost" === window.location.hostname;
          }
        },
        287: function _(e, t, n) {
          "use strict";

          n.d(t, {
            e: function e() {
              return u;
            }
          });
          var r = n(5671),
            o = n(3144),
            i = n(4942),
            a = n(415),
            u = function () {
              function e() {
                (0, r.Z)(this, e), (0, i.Z)(this, "environments", void 0), this.environments = ["okta-auth-js/".concat("7.4.3")], this.maybeAddNodeEnvironment();
              }
              return (0, o.Z)(e, [{
                key: "addEnvironment",
                value: function value(e) {
                  this.environments.push(e);
                }
              }, {
                key: "getHttpHeader",
                value: function value() {
                  return {
                    "X-Okta-User-Agent-Extended": this.environments.join(" ")
                  };
                }
              }, {
                key: "getVersion",
                value: function value() {
                  return "7.4.3";
                }
              }, {
                key: "maybeAddNodeEnvironment",
                value: function value() {
                  if (!(0, a.isBrowser)() && process && process.versions) {
                    var e = process.versions.node;
                    this.environments.push("nodejs/".concat(e));
                  }
                }
              }]), e;
            }();
        },
        2281: function _(e, t, n) {
          "use strict";

          function _r(e, t, n) {
            e.options.headers = e.options.headers || {}, e.options.headers[t] = n;
          }
          n.d(t, {
            r: function r() {
              return _r;
            }
          });
        },
        4777: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Am: function Am() {
              return a.A;
            },
            U2: function U2() {
              return i.U2;
            },
            ZM: function ZM() {
              return u.Z;
            },
            c3: function c3() {
              return i.c3;
            },
            ed: function ed() {
              return o.e;
            },
            rn: function rn() {
              return r.r;
            },
            v_: function v_() {
              return i.v_;
            }
          });
          var r = n(2281),
            o = n(287),
            i = n(5385),
            a = n(279),
            u = n(8817);
        },
        279: function _(e, t, n) {
          "use strict";

          n.d(t, {
            A: function A() {
              return d;
            }
          });
          var r = n(5671),
            o = n(3144),
            i = n(7326),
            a = n(136),
            u = n(2963),
            c = n(1120),
            s = n(4942),
            f = n(287),
            l = n(2281),
            p = n(6718),
            h = n(5385);
          function d(e) {
            return function (e) {
              (0, a.Z)(v, e);
              var t,
                n,
                d = (t = v, n = function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                  } catch (e) {
                    return !1;
                  }
                }(), function () {
                  var e,
                    r = (0, c.Z)(t);
                  if (n) {
                    var o = (0, c.Z)(this).constructor;
                    e = Reflect.construct(r, arguments, o);
                  } else e = r.apply(this, arguments);
                  return (0, u.Z)(this, e);
                });
              function v() {
                var e;
                (0, r.Z)(this, v);
                for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++) n[o] = arguments[o];
                return e = d.call.apply(d, [this].concat(n)), (0, s.Z)((0, i.Z)(e), "_oktaUserAgent", void 0), (0, s.Z)((0, i.Z)(e), "http", void 0), e._oktaUserAgent = new f.e(), e.http = {
                  setRequestHeader: l.r.bind(null, (0, i.Z)(e))
                }, e;
              }
              return (0, o.Z)(v, [{
                key: "setHeaders",
                value: function value(e) {
                  this.options.headers = Object.assign({}, this.options.headers, e);
                }
              }, {
                key: "getIssuerOrigin",
                value: function value() {
                  return this.options.issuer.split("/oauth2/")[0];
                }
              }, {
                key: "webfinger",
                value: function value(e) {
                  var t = "/.well-known/webfinger" + (0, p.UK)(e);
                  return (0, h.U2)(this, t, {
                    headers: {
                      Accept: "application/jrd+json"
                    }
                  });
                }
              }]), v;
            }(e);
          }
        },
        8817: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Z: function Z() {
              return m;
            }
          });
          var r = n(3144),
            o = n(5671),
            i = n(7326),
            a = n(136),
            u = n(2963),
            c = n(1120),
            s = n(4942),
            f = n(3849),
            l = n(885),
            p = n(1002),
            h = n(4098),
            d = n.n(h);
          function v(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
            return r;
          }
          var y = /application\/\w*\+?json/,
            g = function g(e, t, r) {
              var o = r.data,
                i = r.headers || {},
                a = i["Content-Type"] || i["content-type"] || "";
              o && "string" != typeof o && (y.test(a) ? o = JSON.stringify(o) : "application/x-www-form-urlencoded" === a && (o = Object.entries(o).map(function (e) {
                var t = (0, l.Z)(e, 2),
                  n = t[0],
                  r = t[1];
                return "".concat(n, "=").concat(encodeURIComponent(r));
              }).join("&")));
              var u = (n.g.fetch || d())(t, {
                method: e,
                headers: r.headers,
                body: o,
                credentials: r.withCredentials ? "include" : "omit"
              });
              return u["finally"] || (u = Promise.resolve(u)), u.then(function (e) {
                var t = !e.ok,
                  n = e.status;
                return function (e) {
                  return e.headers.get("Content-Type") && e.headers.get("Content-Type").toLowerCase().indexOf("application/json") >= 0 ? e.json()["catch"](function (e) {
                    return {
                      error: e,
                      errorSummary: "Could not parse server response"
                    };
                  }) : e.text();
                }(e).then(function (t) {
                  return function (e, t, n) {
                    var r,
                      o = "object" === (0, p.Z)(t),
                      i = {},
                      a = function (e, t) {
                        var _n2 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                        if (!_n2) {
                          if (Array.isArray(e) || (_n2 = function (e, t) {
                            if (e) {
                              if ("string" == typeof e) return v(e, t);
                              var n = Object.prototype.toString.call(e).slice(8, -1);
                              return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? v(e, t) : void 0;
                            }
                          }(e)) || t && e && "number" == typeof e.length) {
                            _n2 && (e = _n2);
                            var r = 0,
                              o = function o() {};
                            return {
                              s: o,
                              n: function n() {
                                return r >= e.length ? {
                                  done: !0
                                } : {
                                  done: !1,
                                  value: e[r++]
                                };
                              },
                              e: function e(_e4) {
                                throw _e4;
                              },
                              f: o
                            };
                          }
                          throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                        }
                        var i,
                          a = !0,
                          u = !1;
                        return {
                          s: function s() {
                            _n2 = _n2.call(e);
                          },
                          n: function n() {
                            var e = _n2.next();
                            return a = e.done, e;
                          },
                          e: function e(_e5) {
                            u = !0, i = _e5;
                          },
                          f: function f() {
                            try {
                              a || null == _n2["return"] || _n2["return"]();
                            } finally {
                              if (u) throw i;
                            }
                          }
                        };
                      }(n.headers.entries());
                    try {
                      for (a.s(); !(r = a.n()).done;) {
                        var u = r.value;
                        i[u[0]] = u[1];
                      }
                    } catch (e) {
                      a.e(e);
                    } finally {
                      a.f();
                    }
                    var c = {
                      responseText: o ? JSON.stringify(t) : t,
                      status: e,
                      headers: i
                    };
                    return o && (c.responseType = "json", c.responseJSON = t), c;
                  }(n, t, e);
                }).then(function (e) {
                  var n;
                  if (t || null !== (n = e.responseJSON) && void 0 !== n && n.error) throw e;
                  return e;
                });
              });
            };
          function m() {
            return function (e) {
              (0, a.Z)(l, e);
              var t,
                n,
                f = (t = l, n = function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                  } catch (e) {
                    return !1;
                  }
                }(), function () {
                  var e,
                    r = (0, c.Z)(t);
                  if (n) {
                    var o = (0, c.Z)(this).constructor;
                    e = Reflect.construct(r, arguments, o);
                  } else e = r.apply(this, arguments);
                  return (0, u.Z)(this, e);
                });
              function l(e) {
                var t;
                return (0, o.Z)(this, l), t = f.call(this, e), (0, s.Z)((0, i.Z)(t), "issuer", void 0), (0, s.Z)((0, i.Z)(t), "transformErrorXHR", void 0), (0, s.Z)((0, i.Z)(t), "headers", void 0), (0, s.Z)((0, i.Z)(t), "httpRequestClient", void 0), (0, s.Z)((0, i.Z)(t), "httpRequestInterceptors", void 0), t.issuer = e.issuer, t.transformErrorXHR = e.transformErrorXHR, t.headers = e.headers, t.httpRequestClient = e.httpRequestClient || g, t.httpRequestInterceptors = e.httpRequestInterceptors, t;
              }
              return (0, r.Z)(l);
            }((0, f.T)());
          }
        },
        5385: function _(e, t, n) {
          "use strict";

          n.d(t, {
            U2: function U2() {
              return g;
            },
            c3: function c3() {
              return y;
            },
            v_: function v_() {
              return m;
            }
          });
          var r = n(1002),
            o = n(4942),
            i = n(4771),
            a = n(3193),
            u = n(6718),
            c = n(1971),
            s = n(9123),
            f = n(2886),
            l = n(3983);
          function p(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
            return r;
          }
          function h(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function d(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? h(Object(n), !0).forEach(function (t) {
                (0, o.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          var v = function v(e, t) {
            var n,
              r,
              o,
              u,
              c = {};
            if (t.responseText && (0, i.HD)(t.responseText)) try {
              c = JSON.parse(t.responseText);
            } catch (e) {
              c = {
                errorSummary: "Unknown error"
              };
            }
            if (t.status >= 500 && (c.errorSummary = "Unknown error"), e.options.transformErrorXHR && (t = e.options.transformErrorXHR((0, a.d9)(t))), u = c.error && c.error_description ? new f.Z(c.error, c.error_description) : new l.Z(c, t), 403 === (null === (n = t) || void 0 === n ? void 0 : n.status) && null !== (r = t) && void 0 !== r && null !== (o = r.headers) && void 0 !== o && o["www-authenticate"]) {
              var p,
                h,
                v = function (e) {
                  if (!e) throw new s.Z("Missing header string");
                  return e.split(",").map(function (e) {
                    return e.trim();
                  }).map(function (e) {
                    return e.split("=");
                  }).reduce(function (e, t) {
                    return e[t[0]] = t[1].replace(/^"(.*)"$/, "$1"), e;
                  }, {});
                }(null === (p = t) || void 0 === p || null === (h = p.headers) || void 0 === h ? void 0 : h["www-authenticate"]),
                y = v.error,
                g = v.error_description,
                m = v.max_age,
                b = v.acr_values;
              "insufficient_authentication_context" === y && (u = new l.Z({
                errorSummary: y,
                errorCauses: [{
                  errorSummary: g
                }]
              }, t, d({
                max_age: +m
              }, b && {
                acr_values: b
              })));
            }
            return u;
          };
          function y(e, t) {
            if (t = t || {}, e.options.httpRequestInterceptors) {
              var n,
                o = function (e, t) {
                  var _n3 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                  if (!_n3) {
                    if (Array.isArray(e) || (_n3 = function (e, t) {
                      if (e) {
                        if ("string" == typeof e) return p(e, t);
                        var n = Object.prototype.toString.call(e).slice(8, -1);
                        return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? p(e, t) : void 0;
                      }
                    }(e)) || t && e && "number" == typeof e.length) {
                      _n3 && (e = _n3);
                      var r = 0,
                        o = function o() {};
                      return {
                        s: o,
                        n: function n() {
                          return r >= e.length ? {
                            done: !0
                          } : {
                            done: !1,
                            value: e[r++]
                          };
                        },
                        e: function e(_e6) {
                          throw _e6;
                        },
                        f: o
                      };
                    }
                    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                  }
                  var i,
                    a = !0,
                    u = !1;
                  return {
                    s: function s() {
                      _n3 = _n3.call(e);
                    },
                    n: function n() {
                      var e = _n3.next();
                      return a = e.done, e;
                    },
                    e: function e(_e7) {
                      u = !0, i = _e7;
                    },
                    f: function f() {
                      try {
                        a || null == _n3["return"] || _n3["return"]();
                      } finally {
                        if (u) throw i;
                      }
                    }
                  };
                }(e.options.httpRequestInterceptors);
              try {
                for (o.s(); !(n = o.n()).done;) (0, n.value)(t);
              } catch (w) {
                o.e(w);
              } finally {
                o.f();
              }
            }
            var u = t.url,
              s = t.method,
              f = t.args,
              l = t.saveAuthnState,
              h = t.accessToken,
              y = !0 === t.withCredentials,
              g = e.options.storageUtil.storage,
              m = e.storageManager.getHttpCache(e.options.cookies);
            if (t.cacheResponse) {
              var b = m.getStorage()[u];
              if (b && Date.now() / 1e3 < b.expiresAt) return Promise.resolve(b.response);
            }
            var k = d({
              Accept: "application/json",
              "Content-Type": "application/json"
            }, e._oktaUserAgent.getHttpHeader());
            Object.assign(k, e.options.headers, t.headers), k = (0, a.YY)(k), h && (0, i.HD)(h) && (k.Authorization = "Bearer " + h);
            var w,
              O,
              T = {
                headers: k,
                data: f || void 0,
                withCredentials: y
              };
            return e.options.httpRequestClient(s, u, T).then(function (n) {
              return (O = n.responseText) && (0, i.HD)(O) && (O = JSON.parse(O)) && "object" === (0, r.Z)(O) && !O.headers && (Array.isArray(O) ? O.forEach(function (e) {
                e.headers = n.headers;
              }) : O.headers = n.headers), l && (O.stateToken || g["delete"](c.STATE_TOKEN_KEY_NAME)), O && O.stateToken && O.expiresAt && g.set(c.STATE_TOKEN_KEY_NAME, O.stateToken, O.expiresAt, e.options.cookies), O && t.cacheResponse && m.updateStorage(u, {
                expiresAt: Math.floor(Date.now() / 1e3) + c.DEFAULT_CACHE_DURATION,
                response: O
              }), O;
            })["catch"](function (t) {
              throw "E0000011" === (w = v(e, t)).errorCode && g["delete"](c.STATE_TOKEN_KEY_NAME), w;
            });
          }
          function g(e, t, n) {
            var r = {
              url: t = (0, u.sD)(t) ? t : e.getIssuerOrigin() + t,
              method: "GET"
            };
            return Object.assign(r, n), y(e, r);
          }
          function m(e, t, n, r) {
            var o = {
              url: t = (0, u.sD)(t) ? t : e.getIssuerOrigin() + t,
              method: "POST",
              args: n,
              saveAuthnState: !0
            };
            return Object.assign(o, r), y(e, o);
          }
        },
        3334: function _(e, t, n) {
          "use strict";

          n.d(t, {
            v: function v() {
              return l;
            }
          });
          var r = n(5671),
            o = n(3144),
            i = n(1752),
            a = n(136),
            u = n(2963),
            c = n(1120),
            s = n(1646),
            f = n(480);
          function l() {
            return function (e) {
              (0, a.Z)(l, e);
              var t,
                n,
                s = (t = l, n = function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                  } catch (e) {
                    return !1;
                  }
                }(), function () {
                  var e,
                    r = (0, c.Z)(t);
                  if (n) {
                    var o = (0, c.Z)(this).constructor;
                    e = Reflect.construct(r, arguments, o);
                  } else e = r.apply(this, arguments);
                  return (0, u.Z)(this, e);
                });
              function l(e) {
                return (0, r.Z)(this, l), s.call(this, e);
              }
              return (0, o.Z)(l, [{
                key: "clear",
                value: function value() {
                  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  (0, i.Z)((0, c.Z)(l.prototype), "clear", this).call(this, e), !1 !== e.clearIdxResponse && this.clearIdxResponse();
                }
              }, {
                key: "saveIdxResponse",
                value: function value(e) {
                  if (this.saveLastResponse) {
                    var t = this.storageManager.getIdxResponseStorage();
                    t && t.setStorage(e);
                  }
                }
              }, {
                key: "loadIdxResponse",
                value: function value(e) {
                  if (!this.saveLastResponse) return null;
                  var t = this.storageManager.getIdxResponseStorage();
                  if (!t) return null;
                  var n = t.getStorage();
                  if (!n || !(0, f.P)(n.rawIdxResponse)) return null;
                  if (e) {
                    var r = e.interactionHandle;
                    if (r && n.interactionHandle !== r) return null;
                  }
                  return n;
                }
              }, {
                key: "clearIdxResponse",
                value: function value() {
                  if (this.saveLastResponse) {
                    var e = this.storageManager.getIdxResponseStorage();
                    null == e || e.clearStorage();
                  }
                }
              }]), l;
            }((0, s.P)());
          }
        },
        1286: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Y: function Y() {
              return l;
            }
          });
          var r = n(4942),
            o = n(5861),
            i = n(4687),
            a = n.n(i),
            u = n(7595),
            c = n(5832);
          function s(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function f(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? s(Object(n), !0).forEach(function (t) {
                (0, r.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          function l(e) {
            return p.apply(this, arguments);
          }
          function p() {
            return p = (0, o.Z)(a().mark(function e(t) {
              var n,
                r = arguments;
              return a().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return (n = r.length > 1 && void 0 !== r[1] ? r[1] : {}).password && !n.authenticator && (n.authenticator = u.pc.OKTA_PASSWORD), e.abrupt("return", (0, c.K)(t, f(f({}, n), {}, {
                      flow: "authenticate"
                    })));
                  case 3:
                  case "end":
                    return e.stop();
                }
              }, e);
            })), p.apply(this, arguments);
          }
        },
        7644: function _(e, t, n) {
          "use strict";

          n.d(t, {
            _: function _() {
              return a;
            }
          });
          var r = n(3144),
            o = n(5671),
            i = n(4942),
            a = (0, r.Z)(function e(t) {
              (0, o.Z)(this, e), (0, i.Z)(this, "meta", void 0), this.meta = t;
            });
        },
        9582: function _(e, t, n) {
          "use strict";

          n.d(t, {
            a: function a() {
              return l;
            }
          });
          var r = n(4942),
            o = n(5671),
            i = n(3144),
            a = n(136),
            u = n(2963),
            c = n(1120);
          function s(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function f(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? s(Object(n), !0).forEach(function (t) {
                (0, r.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          var l = function (e) {
            (0, a.Z)(s, e);
            var t,
              n,
              r = (t = s, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, c.Z)(t);
                if (n) {
                  var o = (0, c.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, u.Z)(this, e);
              });
            function s() {
              return (0, o.Z)(this, s), r.apply(this, arguments);
            }
            return (0, i.Z)(s, [{
              key: "canVerify",
              value: function value(e) {
                return !!(e.credentials || e.password || e.passcode);
              }
            }, {
              key: "mapCredentials",
              value: function value(e) {
                var t = e.credentials,
                  n = e.password,
                  r = e.passcode;
                if (t || n || r) return t || {
                  passcode: r || n
                };
              }
            }, {
              key: "getInputs",
              value: function value(e) {
                var t;
                return f(f({}, null === (t = e.form) || void 0 === t ? void 0 : t.value[0]), {}, {
                  name: "password",
                  type: "string",
                  required: e.required
                });
              }
            }]), s;
          }(n(7644)._);
        },
        9344: function _(e, t, n) {
          "use strict";

          n.d(t, {
            LL: function LL() {
              return i;
            },
            PN: function PN() {
              return a;
            },
            h_: function h_() {
              return u;
            }
          });
          var r = n(7595);
          function o(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
            return r;
          }
          function i(e) {
            var t;
            if ((0, r.H)(e)) t = e;else {
              if ("string" != typeof e) throw new Error("Invalid format for authenticator");
              t = {
                key: e
              };
            }
            return t;
          }
          function a(e, t) {
            return !!(e && t && (e.id && t.id ? e.id === t.id : e.key && t.key && e.key === t.key));
          }
          function u(e, t) {
            var n,
              r,
              i = function (e, t) {
                var _n4 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (!_n4) {
                  if (Array.isArray(e) || (_n4 = function (e, t) {
                    if (e) {
                      if ("string" == typeof e) return o(e, t);
                      var n = Object.prototype.toString.call(e).slice(8, -1);
                      return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? o(e, t) : void 0;
                    }
                  }(e)) || t && e && "number" == typeof e.length) {
                    _n4 && (e = _n4);
                    var r = 0,
                      i = function i() {};
                    return {
                      s: i,
                      n: function n() {
                        return r >= e.length ? {
                          done: !0
                        } : {
                          done: !1,
                          value: e[r++]
                        };
                      },
                      e: function e(_e8) {
                        throw _e8;
                      },
                      f: i
                    };
                  }
                  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                }
                var a,
                  u = !0,
                  c = !1;
                return {
                  s: function s() {
                    _n4 = _n4.call(e);
                  },
                  n: function n() {
                    var e = _n4.next();
                    return u = e.done, e;
                  },
                  e: function e(_e9) {
                    c = !0, a = _e9;
                  },
                  f: function f() {
                    try {
                      u || null == _n4["return"] || _n4["return"]();
                    } finally {
                      if (c) throw a;
                    }
                  }
                };
              }(e);
            try {
              var a = function a() {
                var e = r.value;
                if (n = t.find(function (t) {
                  var n = t.relatesTo;
                  return n.key && n.key === e.key;
                })) return "break";
              };
              for (i.s(); !(r = i.n()).done && "break" !== a(););
            } catch (e) {
              i.e(e);
            } finally {
              i.f();
            }
            return n;
          }
        },
        9192: function _(e, t, n) {
          "use strict";

          n.d(t, {
            a: function a() {
              return l;
            }
          });
          var r = n(4942),
            o = n(5861),
            i = n(4687),
            a = n.n(i),
            u = n(5832),
            c = n(7738);
          function s(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function f(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? s(Object(n), !0).forEach(function (t) {
                (0, r.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          function l(e, t) {
            return p.apply(this, arguments);
          }
          function p() {
            return (p = (0, o.Z)(a().mark(function e(t, n) {
              var r, o;
              return a().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return r = t.transactionManager.load(), o = (0, c.s)(t, r.flow), e.abrupt("return", (0, u.K)(t, f(f(f({}, n), o), {}, {
                      actions: ["cancel"]
                    })));
                  case 3:
                  case "end":
                    return e.stop();
                }
              }, e);
            }))).apply(this, arguments);
          }
        },
        7985: function _(e, t, n) {
          "use strict";

          n.d(t, {
            GA: function GA() {
              return g;
            },
            Jn: function Jn() {
              return b;
            },
            gc: function gc() {
              return y;
            },
            mo: function mo() {
              return m;
            }
          });
          var r = n(5861),
            o = n(3144),
            i = n(5671),
            a = n(7326),
            u = n(136),
            c = n(2963),
            s = n(1120),
            f = n(4942),
            l = n(4687),
            p = n.n(l),
            h = n(6245),
            d = n(1969);
          var v = function (e) {
            (0, u.Z)(l, e);
            var t,
              n,
              r = (t = l, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, s.Z)(t);
                if (n) {
                  var o = (0, s.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, c.Z)(this, e);
              });
            function l(e, t) {
              var n;
              return (0, i.Z)(this, l), n = r.call(this, "Enter the OTP code in the originating client: ".concat(t)), (0, f.Z)((0, a.Z)(n), "state", void 0), (0, f.Z)((0, a.Z)(n), "otp", void 0), n.name = "EmailVerifyCallbackError", n.state = e, n.otp = t, n;
            }
            return (0, o.Z)(l);
          }(h.Z);
          function y(e) {
            return "EmailVerifyCallbackError" === e.name;
          }
          function g(e) {
            return /(otp=)/i.test(e) && /(state=)/i.test(e);
          }
          function m(e) {
            return (0, d.v)(e);
          }
          function b(e, t) {
            return k.apply(this, arguments);
          }
          function k() {
            return (k = (0, r.Z)(p().mark(function e(t, n) {
              var r, o, i;
              return p().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if (!g(n)) {
                      e.next = 9;
                      break;
                    }
                    if (r = m(n), o = r.state, i = r.otp, !t.idx.canProceed({
                      state: o
                    })) {
                      e.next = 8;
                      break;
                    }
                    return e.next = 5, t.idx.proceed({
                      state: o,
                      otp: i
                    });
                  case 5:
                    return e.abrupt("return", e.sent);
                  case 8:
                    throw new v(o, i);
                  case 9:
                  case "end":
                    return e.stop();
                }
              }, e);
            }))).apply(this, arguments);
          }
        },
        2144: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Y: function Y() {
              return i;
            }
          });
          var r = n(1578),
            o = n(9284);
          function i(e, t, n) {
            var i = (0, r.K)(e, t, n);
            return (0, o.B)(i);
          }
        },
        9727: function _(e, t, n) {
          "use strict";

          n.d(t, {
            F: function F() {
              return b;
            }
          });
          var r = n(8221),
            o = n(9912),
            i = n(1286),
            a = n(9192),
            u = n(7985),
            c = n(5021),
            s = n(6799),
            f = n(6131),
            l = n(2660),
            p = n(9310),
            h = n(2845),
            d = n(9214),
            v = n(8826),
            y = n(2473),
            g = n(2620),
            m = n(8277);
          function b(e) {
            var t = y.Y.bind(null, e);
            return {
              interact: f.E.bind(null, e),
              introspect: l.L.bind(null, e),
              makeIdxResponse: s._T.bind(null, e),
              authenticate: i.Y.bind(null, e),
              register: v.z.bind(null, e),
              start: t,
              startTransaction: t,
              poll: p.$.bind(null, e),
              proceed: h.x.bind(null, e),
              cancel: a.a.bind(null, e),
              recoverPassword: d.M.bind(null, e),
              handleInteractionCodeRedirect: c.X.bind(null, e),
              isInteractionRequired: r.wc.bind(null, e),
              isInteractionRequiredError: o.Cf,
              handleEmailVerifyCallback: u.Jn.bind(null, e),
              isEmailVerifyCallback: u.GA,
              parseEmailVerifyCallback: u.mo,
              isEmailVerifyCallbackError: u.gc,
              getSavedTransactionMeta: g.uN.bind(null, e),
              createTransactionMeta: g.Xc.bind(null, e),
              getTransactionMeta: g.Co.bind(null, e),
              saveTransactionMeta: g.r0.bind(null, e),
              clearTransactionMeta: g.Jm.bind(null, e),
              isTransactionMetaValid: g.Wf,
              setFlow: function setFlow(t) {
                e.options.flow = t;
              },
              getFlow: function getFlow() {
                return e.options.flow;
              },
              canProceed: h.C.bind(null, e),
              unlockAccount: m.l.bind(null, e)
            };
          }
        },
        7738: function _(e, t, n) {
          "use strict";

          n.d(t, {
            s: function s() {
              return E;
            }
          });
          var r = n(8628),
            o = n(7311),
            i = n(9865),
            a = n(2541),
            u = n(5278),
            c = n(3857),
            s = n(4560),
            f = n(1104),
            l = n(9024),
            p = n(2288),
            h = n(3403),
            d = n(3679),
            v = n(8490),
            y = n(8443),
            g = {
              identify: r.h,
              "select-authenticator-authenticate": o.X,
              "select-authenticator-enroll": i.j,
              "authenticator-enrollment-data": a.q,
              "authenticator-verification-data": u.q,
              "enroll-authenticator": c.q,
              "challenge-authenticator": s.J,
              "challenge-poll": f.U,
              "reenroll-authenticator": l.j,
              "enroll-poll": p.T,
              "select-enrollment-channel": h.V,
              "enrollment-channel-data": d.t,
              "redirect-idp": v.O,
              skip: y.h
            },
            m = n(1019),
            b = {
              identify: r.h,
              "identify-recovery": r.h,
              "select-authenticator-authenticate": o.X,
              "select-authenticator-enroll": i.j,
              "challenge-authenticator": s.J,
              "authenticator-verification-data": u.q,
              "authenticator-enrollment-data": a.q,
              "reset-authenticator": m.G,
              "reenroll-authenticator": l.j,
              "enroll-poll": p.T
            },
            k = n(4713),
            w = n(7522),
            O = {
              "select-enroll-profile": k.j,
              "enroll-profile": w.w,
              "authenticator-enrollment-data": a.q,
              "select-authenticator-enroll": i.j,
              "enroll-poll": p.T,
              "select-enrollment-channel": h.V,
              "enrollment-channel-data": d.t,
              "enroll-authenticator": c.q,
              skip: y.h
            },
            T = n(5272),
            Z = {
              identify: r.h,
              "select-authenticator-unlock-account": T.G,
              "select-authenticator-authenticate": o.X,
              "challenge-authenticator": s.J,
              "challenge-poll": f.U,
              "authenticator-verification-data": u.q
            };
          function E(e) {
            var t,
              n,
              r = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "default",
              o = !0;
            switch (r) {
              case "register":
              case "signup":
              case "enrollProfile":
                t = O, o = !1;
                break;
              case "recoverPassword":
              case "resetPassword":
                t = b, n = ["currentAuthenticator-recover", "currentAuthenticatorEnrollment-recover"], o = !1;
                break;
              case "unlockAccount":
                t = Z, o = !1, n = ["unlock-account"];
                break;
              default:
                t = g;
            }
            return {
              flow: r,
              remediators: t,
              actions: n,
              withCredentials: o
            };
          }
        },
        5021: function _(e, t, n) {
          "use strict";

          n.d(t, {
            X: function X() {
              return c;
            }
          });
          var r = n(5861),
            o = n(4687),
            i = n.n(o),
            a = n(9123),
            u = n(2886);
          function c(e, t) {
            return s.apply(this, arguments);
          }
          function s() {
            return (s = (0, r.Z)(i().mark(function e(t, n) {
              var r, o, c, s, f, l, p, h, d, v;
              return i().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if (r = t.transactionManager.load()) {
                      e.next = 3;
                      break;
                    }
                    throw new a.Z("No transaction data was found in storage");
                  case 3:
                    if (o = r.codeVerifier, c = r.state, s = new URL(n), f = s.searchParams, l = f.get("state"), p = f.get("interaction_code"), !(h = f.get("error"))) {
                      e.next = 10;
                      break;
                    }
                    throw new u.Z(h, f.get("error_description"));
                  case 10:
                    if (l === c) {
                      e.next = 12;
                      break;
                    }
                    throw new a.Z("State in redirect uri does not match with transaction state");
                  case 12:
                    if (p) {
                      e.next = 14;
                      break;
                    }
                    throw new a.Z("Unable to parse interaction_code from the url");
                  case 14:
                    return e.next = 16, t.token.exchangeCodeForTokens({
                      interactionCode: p,
                      codeVerifier: o
                    });
                  case 16:
                    d = e.sent, v = d.tokens, t.tokenManager.setTokens(v);
                  case 19:
                  case "end":
                    return e.stop();
                }
              }, e);
            }))).apply(this, arguments);
          }
        },
        6799: function _(e, t, n) {
          "use strict";

          n.d(t, {
            _T: function _T() {
              return Y;
            },
            A0: function A0() {
              return q;
            }
          });
          var r = n(1971),
            o = n(5861),
            i = n(2982),
            a = n(4687),
            u = n.n(a),
            c = n(885),
            s = n(4942),
            f = n(4925),
            l = n(1002),
            p = n(5385);
          function h(e, t) {
            var _n5 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
            if (!_n5) {
              if (Array.isArray(e) || (_n5 = function (e, t) {
                if (e) {
                  if ("string" == typeof e) return d(e, t);
                  var n = Object.prototype.toString.call(e).slice(8, -1);
                  return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? d(e, t) : void 0;
                }
              }(e)) || t && e && "number" == typeof e.length) {
                _n5 && (e = _n5);
                var r = 0,
                  o = function o() {};
                return {
                  s: o,
                  n: function n() {
                    return r >= e.length ? {
                      done: !0
                    } : {
                      done: !1,
                      value: e[r++]
                    };
                  },
                  e: function e(_e10) {
                    throw _e10;
                  },
                  f: o
                };
              }
              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var i,
              a = !0,
              u = !1;
            return {
              s: function s() {
                _n5 = _n5.call(e);
              },
              n: function n() {
                var e = _n5.next();
                return a = e.done, e;
              },
              e: function e(_e11) {
                u = !0, i = _e11;
              },
              f: function f() {
                try {
                  a || null == _n5["return"] || _n5["return"]();
                } finally {
                  if (u) throw i;
                }
              }
            };
          }
          function d(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
            return r;
          }
          var v = function v(e) {
              return !1 !== e.mutable;
            },
            y = function y(e) {
              var t = {},
                n = [],
                r = {};
              if (!e.value) return n.push(e), {
                defaultParamsForAction: t,
                neededParamsForAction: n,
                immutableParamsForAction: r
              };
              var o,
                i = h(e.value);
              try {
                for (i.s(); !(o = i.n()).done;) {
                  var a,
                    u,
                    c = o.value;
                  v(c) ? (n.push(c), null !== (a = c.value) && void 0 !== a && a && (t[c.name] = c.value)) : r[c.name] = null !== (u = c.value) && void 0 !== u ? u : "";
                }
              } catch (e) {
                i.e(e);
              } finally {
                i.f();
              }
              return {
                defaultParamsForAction: t,
                neededParamsForAction: n,
                immutableParamsForAction: r
              };
            },
            g = n(3983);
          function m(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function b(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? m(Object(n), !0).forEach(function (t) {
                (0, s.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          var k = function k(e, t) {
              var n = t.actionDefinition,
                r = t.defaultParamsForAction,
                i = void 0 === r ? {} : r,
                a = t.immutableParamsForAction,
                c = void 0 === a ? {} : a,
                s = t.toPersist,
                f = void 0 === s ? {} : s,
                l = n.href;
              return (0, o.Z)(u().mark(function t() {
                var r,
                  o,
                  a,
                  s,
                  h,
                  d,
                  v,
                  y,
                  m,
                  k = arguments;
                return u().wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      return r = k.length > 0 && void 0 !== k[0] ? k[0] : {}, o = {
                        "Content-Type": "application/json",
                        Accept: n.accepts || "application/ion+json"
                      }, a = JSON.stringify(b(b(b({}, i), r), c)), t.prev = 3, t.next = 6, (0, p.c3)(e, {
                        url: l,
                        method: n.method,
                        headers: o,
                        args: a,
                        withCredentials: null === (s = null == f ? void 0 : f.withCredentials) || void 0 === s || s
                      });
                    case 6:
                      return h = t.sent, t.abrupt("return", e.idx.makeIdxResponse(b({}, h), f, !0));
                    case 10:
                      if (t.prev = 10, t.t0 = t["catch"](3), t.t0 instanceof g.Z && null !== t.t0 && void 0 !== t.t0 && t.t0.xhr) {
                        t.next = 14;
                        break;
                      }
                      throw t.t0;
                    case 14:
                      return d = t.t0.xhr, v = d.responseJSON || JSON.parse(d.responseText), y = d.headers["WWW-Authenticate"] || d.headers["www-authenticate"], m = e.idx.makeIdxResponse(b({}, v), f, !1), 401 === d.status && 'Oktadevicejwt realm="Okta Device"' === y && (m.stepUp = !0), t.abrupt("return", m);
                    case 20:
                    case "end":
                      return t.stop();
                  }
                }, t, null, [[3, 10]]);
              }));
            },
            w = function w(e, t, n) {
              var r = k,
                o = function (e) {
                  var t,
                    n = [],
                    r = {},
                    o = {},
                    i = h(e = Array.isArray(e) ? e : [e]);
                  try {
                    for (i.s(); !(t = i.n()).done;) {
                      var a = t.value,
                        u = y(a),
                        c = u.defaultParamsForAction,
                        s = u.neededParamsForAction,
                        f = u.immutableParamsForAction;
                      n.push(s), r[a.name] = c, o[a.name] = f;
                    }
                  } catch (e) {
                    i.e(e);
                  } finally {
                    i.f();
                  }
                  return {
                    defaultParams: r,
                    neededParams: n,
                    immutableParams: o
                  };
                }(t),
                i = o.defaultParams,
                a = o.neededParams,
                u = o.immutableParams,
                c = r(e, {
                  actionDefinition: t,
                  defaultParamsForAction: i[t.name],
                  immutableParamsForAction: u[t.name],
                  toPersist: n
                });
              return c.neededParams = a, c;
            };
          function O(e) {
            return O = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
              return _typeof(e);
            } : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
            }, O(e);
          }
          function T(e) {
            return T = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
              return e.__proto__ || Object.getPrototypeOf(e);
            }, T(e);
          }
          function Z(e, t) {
            return Z = Object.setPrototypeOf || function (e, t) {
              return e.__proto__ = t, e;
            }, Z(e, t);
          }
          function E() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }
          function S(e, t, n) {
            return S = E() ? Reflect.construct : function (e, t, n) {
              var r = [null];
              r.push.apply(r, t);
              var o = new (Function.bind.apply(e, r))();
              return n && Z(o, n.prototype), o;
            }, S.apply(null, arguments);
          }
          function x(e) {
            var t = "function" == typeof Map ? new Map() : void 0;
            return x = function x(e) {
              if (null === e || (n = e, -1 === Function.toString.call(n).indexOf("[native code]"))) return e;
              var n;
              if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
              if (void 0 !== t) {
                if (t.has(e)) return t.get(e);
                t.set(e, r);
              }
              function r() {
                return S(e, arguments, T(this).constructor);
              }
              return r.prototype = Object.create(e.prototype, {
                constructor: {
                  value: r,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0
                }
              }), Z(r, e);
            }, x(e);
          }
          function P(e) {
            return function (e) {
              if (Array.isArray(e)) return _(e);
            }(e) || function (e) {
              if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
            }(e) || A(e) || function () {
              throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }
          function A(e, t) {
            if (e) {
              if ("string" == typeof e) return _(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? _(e, t) : void 0;
            }
          }
          function _(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
            return r;
          }
          var R = Object.prototype.hasOwnProperty;
          function j(e, t) {
            return (e = e.slice()).push(t), e;
          }
          function C(e, t) {
            return (t = t.slice()).unshift(e), t;
          }
          var D = function (e) {
            !function (e, t) {
              if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
              e.prototype = Object.create(t && t.prototype, {
                constructor: {
                  value: e,
                  writable: !0,
                  configurable: !0
                }
              }), t && Z(e, t);
            }(o, e);
            var t,
              n,
              r = (t = o, n = E(), function () {
                var e,
                  r = T(t);
                if (n) {
                  var o = T(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return function (e, t) {
                  return !t || "object" != _typeof(t) && "function" != typeof t ? function (e) {
                    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                    return e;
                  }(e) : t;
                }(this, e);
              });
            function o(e) {
              var t;
              return function (e, t) {
                if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
              }(this, o), (t = r.call(this, 'JSONPath should not be called with "new" (it prevents return of (unwrapped) scalar values)')).avoidNew = !0, t.value = e, t.name = "NewError", t;
            }
            return o;
          }(x(Error));
          function I(e, t, n, r, o) {
            if (!(this instanceof I)) try {
              return new I(e, t, n, r, o);
            } catch (e) {
              if (!e.avoidNew) throw e;
              return e.value;
            }
            "string" == typeof e && (o = r, r = n, n = t, t = e, e = null);
            var i = e && "object" === O(e);
            if (e = e || {}, this.json = e.json || n, this.path = e.path || t, this.resultType = e.resultType || "value", this.flatten = e.flatten || !1, this.wrap = !R.call(e, "wrap") || e.wrap, this.sandbox = e.sandbox || {}, this.preventEval = e.preventEval || !1, this.parent = e.parent || null, this.parentProperty = e.parentProperty || null, this.callback = e.callback || r || null, this.otherTypeCallback = e.otherTypeCallback || o || function () {
              throw new TypeError("You must supply an otherTypeCallback callback option with the @other() operator.");
            }, !1 !== e.autostart) {
              var a = {
                path: i ? e.path : t
              };
              i ? "json" in e && (a.json = e.json) : a.json = n;
              var u = this.evaluate(a);
              if (!u || "object" !== O(u)) throw new D(u);
              return u;
            }
          }
          function N(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          I.prototype.evaluate = function (e, t, n, r) {
            var o = this,
              i = this.parent,
              a = this.parentProperty,
              u = this.flatten,
              c = this.wrap;
            if (this.currResultType = this.resultType, this.currPreventEval = this.preventEval, this.currSandbox = this.sandbox, n = n || this.callback, this.currOtherTypeCallback = r || this.otherTypeCallback, t = t || this.json, (e = e || this.path) && "object" === O(e) && !Array.isArray(e)) {
              if (!e.path && "" !== e.path) throw new TypeError('You must supply a "path" property when providing an object argument to JSONPath.evaluate().');
              if (!R.call(e, "json")) throw new TypeError('You must supply a "json" property when providing an object argument to JSONPath.evaluate().');
              t = e.json, u = R.call(e, "flatten") ? e.flatten : u, this.currResultType = R.call(e, "resultType") ? e.resultType : this.currResultType, this.currSandbox = R.call(e, "sandbox") ? e.sandbox : this.currSandbox, c = R.call(e, "wrap") ? e.wrap : c, this.currPreventEval = R.call(e, "preventEval") ? e.preventEval : this.currPreventEval, n = R.call(e, "callback") ? e.callback : n, this.currOtherTypeCallback = R.call(e, "otherTypeCallback") ? e.otherTypeCallback : this.currOtherTypeCallback, i = R.call(e, "parent") ? e.parent : i, a = R.call(e, "parentProperty") ? e.parentProperty : a, e = e.path;
            }
            if (i = i || null, a = a || null, Array.isArray(e) && (e = I.toPathString(e)), (e || "" === e) && t) {
              var s = I.toPathArray(e);
              "$" === s[0] && s.length > 1 && s.shift(), this._hasParentSelector = null;
              var f = this._trace(s, t, ["$"], i, a, n).filter(function (e) {
                return e && !e.isParentSelector;
              });
              return f.length ? c || 1 !== f.length || f[0].hasArrExpr ? f.reduce(function (e, t) {
                var n = o._getPreferredOutput(t);
                return u && Array.isArray(n) ? e = e.concat(n) : e.push(n), e;
              }, []) : this._getPreferredOutput(f[0]) : c ? [] : void 0;
            }
          }, I.prototype._getPreferredOutput = function (e) {
            var t = this.currResultType;
            switch (t) {
              case "all":
                var n = Array.isArray(e.path) ? e.path : I.toPathArray(e.path);
                return e.pointer = I.toPointer(n), e.path = "string" == typeof e.path ? e.path : I.toPathString(e.path), e;
              case "value":
              case "parent":
              case "parentProperty":
                return e[t];
              case "path":
                return I.toPathString(e[t]);
              case "pointer":
                return I.toPointer(e.path);
              default:
                throw new TypeError("Unknown result type");
            }
          }, I.prototype._handleCallback = function (e, t, n) {
            if (t) {
              var r = this._getPreferredOutput(e);
              e.path = "string" == typeof e.path ? e.path : I.toPathString(e.path), t(r, n, e);
            }
          }, I.prototype._trace = function (e, t, n, r, o, i, a, u) {
            var c,
              s = this;
            if (!e.length) return c = {
              path: n,
              value: t,
              parent: r,
              parentProperty: o,
              hasArrExpr: a
            }, this._handleCallback(c, i, "value"), c;
            var f = e[0],
              l = e.slice(1),
              p = [];
            function h(e) {
              Array.isArray(e) ? e.forEach(function (e) {
                p.push(e);
              }) : p.push(e);
            }
            if (("string" != typeof f || u) && t && R.call(t, f)) h(this._trace(l, t[f], j(n, f), t, f, i, a));else if ("*" === f) this._walk(f, l, t, n, r, o, i, function (e, t, n, r, o, i, a, u) {
              h(s._trace(C(e, n), r, o, i, a, u, !0, !0));
            });else if (".." === f) h(this._trace(l, t, n, r, o, i, a)), this._walk(f, l, t, n, r, o, i, function (e, t, n, r, o, i, a, u) {
              "object" === O(r[e]) && h(s._trace(C(t, n), r[e], j(o, e), r, e, u, !0));
            });else {
              if ("^" === f) return this._hasParentSelector = !0, {
                path: n.slice(0, -1),
                expr: l,
                isParentSelector: !0
              };
              if ("~" === f) return c = {
                path: j(n, f),
                value: o,
                parent: r,
                parentProperty: null
              }, this._handleCallback(c, i, "property"), c;
              if ("$" === f) h(this._trace(l, t, n, null, null, i, a));else if (/^(\x2D?[0-9]*):(\x2D?[0-9]*):?([0-9]*)$/.test(f)) h(this._slice(f, l, t, n, r, o, i));else if (0 === f.indexOf("?(")) {
                if (this.currPreventEval) throw new Error("Eval [?(expr)] prevented in JSONPath expression.");
                this._walk(f, l, t, n, r, o, i, function (e, t, n, r, o, i, a, u) {
                  s._eval(t.replace(/^\?\(((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?)\)$/, "$1"), r[e], e, o, i, a) && h(s._trace(C(e, n), r, o, i, a, u, !0));
                });
              } else if ("(" === f[0]) {
                if (this.currPreventEval) throw new Error("Eval [(expr)] prevented in JSONPath expression.");
                h(this._trace(C(this._eval(f, t, n[n.length - 1], n.slice(0, -1), r, o), l), t, n, r, o, i, a));
              } else if ("@" === f[0]) {
                var d = !1,
                  v = f.slice(1, -2);
                switch (v) {
                  case "scalar":
                    t && ["object", "function"].includes(O(t)) || (d = !0);
                    break;
                  case "boolean":
                  case "string":
                  case "undefined":
                  case "function":
                    O(t) === v && (d = !0);
                    break;
                  case "integer":
                    !Number.isFinite(t) || t % 1 || (d = !0);
                    break;
                  case "number":
                    Number.isFinite(t) && (d = !0);
                    break;
                  case "nonFinite":
                    "number" != typeof t || Number.isFinite(t) || (d = !0);
                    break;
                  case "object":
                    t && O(t) === v && (d = !0);
                    break;
                  case "array":
                    Array.isArray(t) && (d = !0);
                    break;
                  case "other":
                    d = this.currOtherTypeCallback(t, n, r, o);
                    break;
                  case "null":
                    null === t && (d = !0);
                    break;
                  default:
                    throw new TypeError("Unknown value type " + v);
                }
                if (d) return c = {
                  path: n,
                  value: t,
                  parent: r,
                  parentProperty: o
                }, this._handleCallback(c, i, "value"), c;
              } else if ("`" === f[0] && t && R.call(t, f.slice(1))) {
                var y = f.slice(1);
                h(this._trace(l, t[y], j(n, y), t, y, i, a, !0));
              } else if (f.includes(",")) {
                var g,
                  m = function (e, t) {
                    var _n6 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (!_n6) {
                      if (Array.isArray(e) || (_n6 = A(e))) {
                        _n6 && (e = _n6);
                        var r = 0,
                          o = function o() {};
                        return {
                          s: o,
                          n: function n() {
                            return r >= e.length ? {
                              done: !0
                            } : {
                              done: !1,
                              value: e[r++]
                            };
                          },
                          e: function e(_e12) {
                            throw _e12;
                          },
                          f: o
                        };
                      }
                      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i,
                      a = !0,
                      u = !1;
                    return {
                      s: function s() {
                        _n6 = _n6.call(e);
                      },
                      n: function n() {
                        var e = _n6.next();
                        return a = e.done, e;
                      },
                      e: function e(_e13) {
                        u = !0, i = _e13;
                      },
                      f: function f() {
                        try {
                          a || null == _n6["return"] || _n6["return"]();
                        } finally {
                          if (u) throw i;
                        }
                      }
                    };
                  }(f.split(","));
                try {
                  for (m.s(); !(g = m.n()).done;) {
                    var b = g.value;
                    h(this._trace(C(b, l), t, n, r, o, i, !0));
                  }
                } catch (e) {
                  m.e(e);
                } finally {
                  m.f();
                }
              } else !u && t && R.call(t, f) && h(this._trace(l, t[f], j(n, f), t, f, i, a, !0));
            }
            if (this._hasParentSelector) for (var k = 0; k < p.length; k++) {
              var w = p[k];
              if (w && w.isParentSelector) {
                var T = this._trace(w.expr, t, w.path, r, o, i, a);
                if (Array.isArray(T)) {
                  p[k] = T[0];
                  for (var Z = T.length, E = 1; E < Z; E++) k++, p.splice(k, 0, T[E]);
                } else p[k] = T;
              }
            }
            return p;
          }, I.prototype._walk = function (e, t, n, r, o, i, a, u) {
            if (Array.isArray(n)) for (var c = n.length, s = 0; s < c; s++) u(s, e, t, n, r, o, i, a);else n && "object" === O(n) && Object.keys(n).forEach(function (c) {
              u(c, e, t, n, r, o, i, a);
            });
          }, I.prototype._slice = function (e, t, n, r, o, i, a) {
            if (Array.isArray(n)) {
              var u = n.length,
                c = e.split(":"),
                s = c[2] && Number.parseInt(c[2]) || 1,
                f = c[0] && Number.parseInt(c[0]) || 0,
                l = c[1] && Number.parseInt(c[1]) || u;
              f = f < 0 ? Math.max(0, f + u) : Math.min(u, f), l = l < 0 ? Math.max(0, l + u) : Math.min(u, l);
              for (var p = [], h = f; h < l; h += s) this._trace(C(h, t), n, r, o, i, a, !0).forEach(function (e) {
                p.push(e);
              });
              return p;
            }
          }, I.prototype._eval = function (e, t, n, r, o, i) {
            e.includes("@parentProperty") && (this.currSandbox._$_parentProperty = i, e = e.replace(/@parentProperty/g, "_$_parentProperty")), e.includes("@parent") && (this.currSandbox._$_parent = o, e = e.replace(/@parent/g, "_$_parent")), e.includes("@property") && (this.currSandbox._$_property = n, e = e.replace(/@property/g, "_$_property")), e.includes("@path") && (this.currSandbox._$_path = I.toPathString(r.concat([n])), e = e.replace(/@path/g, "_$_path")), e.includes("@root") && (this.currSandbox._$_root = this.json, e = e.replace(/@root/g, "_$_root")), /@([\t-\r \)\.\[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])/.test(e) && (this.currSandbox._$_v = t, e = e.replace(/@([\t-\r \)\.\[\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF])/g, "_$_v$1"));
            try {
              return this.vm.runInNewContext(e, this.currSandbox);
            } catch (t) {
              throw console.log(t), new Error("jsonPath: " + t.message + ": " + e);
            }
          }, I.cache = {}, I.toPathString = function (e) {
            for (var t = e, n = t.length, r = "$", o = 1; o < n; o++) /^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(t[o]) || (r += /^[\*0-9]+$/.test(t[o]) ? "[" + t[o] + "]" : "['" + t[o] + "']");
            return r;
          }, I.toPointer = function (e) {
            for (var t = e, n = t.length, r = "", o = 1; o < n; o++) /^(~|\^|@(?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\(\))$/.test(t[o]) || (r += "/" + t[o].toString().replace(/~/g, "~0").replace(/\//g, "~1"));
            return r;
          }, I.toPathArray = function (e) {
            var t = I.cache;
            if (t[e]) return t[e].concat();
            var n = [],
              r = e.replace(/@(?:null|boolean|number|string|integer|undefined|nonFinite|scalar|array|object|function|other)\(\)/g, ";$&;").replace(/['\[](\??\((?:[\0-\t\x0B\f\x0E-\u2027\u202A-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])*?\))['\]]/g, function (e, t) {
                return "[#" + (n.push(t) - 1) + "]";
              }).replace(/\[["']((?:(?!['\]])[\s\S])*)["']\]/g, function (e, t) {
                return "['" + t.replace(/\./g, "%@%").replace(/~/g, "%%@@%%") + "']";
              }).replace(/~/g, ";~;").replace(/["']?\.["']?(?!(?:(?!\[)[\s\S])*\])|\[["']?/g, ";").replace(/%@%/g, ".").replace(/%%@@%%/g, "~").replace(/(?:;)?(\^+)(?:;)?/g, function (e, t) {
                return ";" + t.split("").join(";") + ";";
              }).replace(/;;;|;;/g, ";..;").replace(/;$|'?\]|'$/g, "").split(";").map(function (e) {
                var t = e.match(/#([0-9]+)/);
                return t && t[1] ? n[t[1]] : e;
              });
            return t[e] = r, t[e].concat();
          }, I.prototype.vm = {
            runInNewContext: function runInNewContext(e, t) {
              var n = Object.keys(t),
                r = [];
              !function (e, n, r) {
                for (var o = e.length, i = 0; i < o; i++) a = e[i], "function" == typeof t[a] && n.push(e.splice(i--, 1)[0]);
                var a;
              }(n, r);
              var o = n.map(function (e, n) {
                  return t[e];
                }),
                i = r.reduce(function (e, n) {
                  var r = t[n].toString();
                  return /function/.test(r) || (r = "function " + r), "var " + n + "=" + r + ";" + e;
                }, "");
              /(["'])use strict\1/.test(e = i + e) || n.includes("arguments") || (e = "var arguments = undefined;" + e);
              var a = (e = e.replace(/;[\t-\r \xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]*$/, "")).lastIndexOf(";"),
                u = a > -1 ? e.slice(0, a + 1) + " return " + e.slice(a + 1) : " return " + e;
              return S(Function, P(n).concat([u])).apply(void 0, P(o));
            }
          };
          var M = n(9123),
            U = ["value", "type"];
          function L(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function F(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? L(Object(n), !0).forEach(function (t) {
                (0, s.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : L(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          var B = Object.fromEntries(["remediation", "context"].map(function (e) {
              return [e, !0];
            })),
            H = function e(t, n) {
              Object.keys(n).forEach(function (r) {
                if ("relatesTo" === r) {
                  var o = Array.isArray(n[r]) ? n[r][0] : n[r];
                  if ("string" == typeof o) {
                    var i = (a = {
                      path: o,
                      json: t
                    }, I(function (e) {
                      for (var t = 1; t < arguments.length; t++) {
                        var n = null != arguments[t] ? arguments[t] : {};
                        t % 2 ? N(Object(n), !0).forEach(function (t) {
                          (0, s.Z)(e, t, n[t]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : N(Object(n)).forEach(function (t) {
                          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                        });
                      }
                      return e;
                    }({
                      preventEval: !0
                    }, a)))[0];
                    if (i) return void (n[r] = i);
                    throw new M.Z("Cannot resolve relatesTo: ".concat(o));
                  }
                }
                var a;
                Array.isArray(n[r]) && n[r].forEach(function (n) {
                  return e(t, n);
                });
              });
            },
            K = function K(e, t) {
              var n,
                r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                o = (null === (n = t.remediation) || void 0 === n ? void 0 : n.value) || [];
              o.forEach(function (e) {
                var n;
                if ("launch-authenticator" !== e.name || "authenticatorChallenge" !== (null == e || null === (n = e.relatesTo) || void 0 === n ? void 0 : n[0]) || null != t && t.authenticatorChallenge) return H(t, e);
                delete e.relatesTo;
              });
              var i = o.map(function (t) {
                  return function (e, t, n) {
                    if (t.rel) {
                      var r = function (e, t) {
                          var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                          return Object.fromEntries(t.map(function (t) {
                            return [t.name, w(e, t, n)];
                          }));
                        }(e, [t], n),
                        o = r[t.name];
                      return F(F({}, t), {}, {
                        action: o
                      });
                    }
                    return t;
                  }(e, t, r);
                }),
                a = function (e, t) {
                  var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
                    r = {},
                    o = {};
                  return Object.keys(t).filter(function (e) {
                    return !B[e];
                  }).forEach(function (i) {
                    if ("object" === (0, l.Z)(t[i]) && t[i]) {
                      if (t[i].rel) r[t[i].name] = w(e, t[i], n);else {
                        var a = t[i],
                          u = a.value,
                          s = a.type,
                          p = (0, f.Z)(a, U);
                        o[i] = F({
                          type: s
                        }, p), "object" === s ? (o[i].value = {}, Object.entries(u).forEach(function (t) {
                          var a = (0, c.Z)(t, 2),
                            u = a[0],
                            s = a[1];
                          s.rel ? r["".concat(i, "-").concat(u.name || u)] = w(e, s, n) : o[i].value[u] = s;
                        })) : o[i].value = u;
                      }
                    } else o[i] = t[i];
                  }), {
                    context: o,
                    actions: r
                  };
                }(e, t, r);
              return {
                remediations: i,
                context: a.context,
                actions: a.actions
              };
            },
            G = {
              makeIdxState: function makeIdxState(e, t, n, r) {
                var a,
                  c,
                  s,
                  f,
                  l = t,
                  p = K(e, t, n),
                  h = p.remediations,
                  d = p.context,
                  v = p.actions,
                  y = (0, i.Z)(h),
                  g = (f = (0, o.Z)(u().mark(function e(t) {
                    var n,
                      r,
                      o = arguments;
                    return u().wrap(function (e) {
                      for (;;) switch (e.prev = e.next) {
                        case 0:
                          if (n = o.length > 1 && void 0 !== o[1] ? o[1] : {}, r = h.find(function (e) {
                            return e.name === t;
                          })) {
                            e.next = 4;
                            break;
                          }
                          return e.abrupt("return", Promise.reject("Unknown remediation choice: [".concat(t, "]")));
                        case 4:
                          if ("function" == typeof r.action) {
                            e.next = 7;
                            break;
                          }
                          return e.abrupt("return", Promise.reject("Current remediation cannot make form submit action: [".concat(t, "]")));
                        case 7:
                          return e.abrupt("return", r.action(n));
                        case 8:
                        case "end":
                          return e.stop();
                      }
                    }, e);
                  })), function (e) {
                    return f.apply(this, arguments);
                  });
                return {
                  proceed: g,
                  neededToProceed: y,
                  actions: v,
                  context: d,
                  rawIdxState: l,
                  interactionCode: null === (a = l.successWithInteractionCode) || void 0 === a || null === (c = a.value) || void 0 === c || null === (s = c.find(function (e) {
                    return "interaction_code" === e.name;
                  })) || void 0 === s ? void 0 : s.value,
                  toPersist: n,
                  requestDidSucceed: r
                };
              }
            },
            V = function V(e) {
              switch (e) {
                case "1.0.0":
                  return G;
                case void 0:
                case null:
                  throw new Error("Api version is required");
                default:
                  throw new Error("Unknown api version: ".concat(e, ".  Use an exact semver version."));
              }
            };
          function q(e) {
            if (!e) throw new Error("version is required");
            if ((null != e ? e : "").replace(/[^0-9a-zA-Z._-]/, "") !== e || !e) throw new Error("invalid version supplied - version is required and uses semver syntax");
            V(e);
          }
          function Y(e, t, n, o) {
            var i,
              a = null !== (i = null == t ? void 0 : t.version) && void 0 !== i ? i : r.IDX_API_VERSION;
            return q(a), (0, V(a).makeIdxState)(e, t, n, o);
          }
        },
        683: function _(e, t, n) {
          "use strict";

          n.d(t, {
            pc: function pc() {
              return w.pc;
            },
            Fw: function Fw() {
              return w.Fw;
            },
            Qd: function Qd() {
              return w.Qd;
            },
            YR: function YR() {
              return r.Y;
            },
            Ch: function Ch() {
              return s.C;
            },
            al: function al() {
              return o.a;
            },
            Jm: function Jm() {
              return v.Jm;
            },
            F4: function F4() {
              return y.F;
            },
            SL: function SL() {
              return b.S;
            },
            aT: function aT() {
              return k.a;
            },
            vK: function vK() {
              return O.v;
            },
            Yn: function Yn() {
              return g.Y;
            },
            Xc: function Xc() {
              return v.Xc;
            },
            uN: function uN() {
              return v.uN;
            },
            Co: function Co() {
              return v.Co;
            },
            Jn: function Jn() {
              return i.Jn;
            },
            Xx: function Xx() {
              return p.X;
            },
            $0: function $0() {
              return v.$0;
            },
            EW: function EW() {
              return a.E;
            },
            L8: function L8() {
              return u.L;
            },
            H: function H() {
              return w.H;
            },
            GA: function GA() {
              return i.GA;
            },
            gc: function gc() {
              return i.gc;
            },
            Wf: function Wf() {
              return v.Wf;
            },
            bl: function bl() {
              return v.bl;
            },
            UC: function UC() {
              return v.UC;
            },
            B_: function B_() {
              return m.B;
            },
            mo: function mo() {
              return i.mo;
            },
            $l: function $l() {
              return c.$;
            },
            xc: function xc() {
              return s.x;
            },
            M4: function M4() {
              return l.M;
            },
            z2: function z2() {
              return f.z;
            },
            r0: function r0() {
              return v.r0;
            },
            Yr: function Yr() {
              return h.Y;
            },
            le: function le() {
              return d.l;
            }
          });
          var r = n(1286),
            o = n(9192),
            i = n(7985),
            a = n(6131),
            u = n(2660),
            c = n(9310),
            s = n(2845),
            f = n(8826),
            l = n(9214),
            p = n(5021),
            h = n(2473),
            d = n(8277),
            v = n(2620),
            y = n(9727),
            g = n(2144),
            m = n(9284),
            b = n(4602),
            k = n(4143),
            w = n(7595),
            O = n(3334);
        },
        6131: function _(e, t, n) {
          "use strict";

          n.d(t, {
            E: function E() {
              return d;
            }
          });
          var r = n(4942),
            o = n(5861),
            i = n(4687),
            a = n.n(i),
            u = n(2620),
            c = n(7599),
            s = n(3193),
            f = n(5385);
          function l(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function p(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? l(Object(n), !0).forEach(function (t) {
                (0, r.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          function h(e) {
            return {
              meta: e,
              interactionHandle: e.interactionHandle,
              state: e.state
            };
          }
          function d(e) {
            return v.apply(this, arguments);
          }
          function v() {
            return v = (0, o.Z)(a().mark(function e(t) {
              var n,
                r,
                o,
                i,
                l,
                d,
                v,
                y,
                g,
                m,
                b,
                k,
                w,
                O,
                T,
                Z,
                E,
                S,
                x,
                P,
                A,
                _,
                R,
                j,
                C,
                D = arguments;
              return a().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if (o = D.length > 1 && void 0 !== D[1] ? D[1] : {}, o = (0, s.YY)(o), i = (0, u.uN)(t, o), null === (n = i) || void 0 === n || !n.interactionHandle) {
                      e.next = 5;
                      break;
                    }
                    return e.abrupt("return", h(i));
                  case 5:
                    return e.next = 7, (0, u.Xc)(t, p(p({}, i), o));
                  case 7:
                    return i = e.sent, l = (0, c.zf)(t), v = (d = i).clientId, y = d.redirectUri, g = d.state, m = d.scopes, b = d.withCredentials, k = d.codeChallenge, w = d.codeChallengeMethod, O = d.activationToken, T = d.recoveryToken, Z = d.maxAge, E = d.acrValues, S = d.nonce, x = o.clientSecret || t.options.clientSecret, b = null === (r = b) || void 0 === r || r, P = "".concat(l, "/v1/interact"), A = p(p(p(p(p(p({
                      client_id: v,
                      scope: m.join(" "),
                      redirect_uri: y,
                      code_challenge: k,
                      code_challenge_method: w,
                      state: g
                    }, O && {
                      activation_token: O
                    }), T && {
                      recovery_token: T
                    }), x && {
                      client_secret: x
                    }), Z && {
                      max_age: Z
                    }), E && {
                      acr_values: E
                    }), S && {
                      nonce: S
                    }), _ = {
                      "Content-Type": "application/x-www-form-urlencoded"
                    }, e.next = 17, (0, f.c3)(t, {
                      method: "POST",
                      url: P,
                      headers: _,
                      withCredentials: b,
                      args: A
                    });
                  case 17:
                    return R = e.sent, j = R.interaction_handle, C = p(p({}, i), {}, {
                      interactionHandle: j,
                      withCredentials: b,
                      state: g,
                      scopes: m,
                      recoveryToken: T,
                      activationToken: O
                    }), (0, u.r0)(t, C), e.abrupt("return", h(C));
                  case 22:
                  case "end":
                    return e.stop();
                }
              }, e);
            })), v.apply(this, arguments);
          }
        },
        2660: function _(e, t, n) {
          "use strict";

          n.d(t, {
            L: function L() {
              return p;
            }
          });
          var r = n(5861),
            o = n(4687),
            i = n.n(o),
            a = n(6799),
            u = n(480),
            c = n(7599),
            s = n(1971),
            f = n(5385),
            l = n(5728);
          function p(e) {
            return h.apply(this, arguments);
          }
          function h() {
            return h = (0, r.Z)(i().mark(function e(t) {
              var n,
                r,
                o,
                p,
                h,
                d,
                v,
                y,
                g,
                m,
                b,
                k,
                w,
                O,
                T = arguments;
              return i().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if (n = T.length > 1 && void 0 !== T[1] ? T[1] : {}, (p = t.transactionManager.loadIdxResponse(n)) && (r = p.rawIdxResponse, o = p.requestDidSucceed), r) {
                      e.next = 27;
                      break;
                    }
                    return d = n.version || s.IDX_API_VERSION, v = (0, c.Xp)(t), y = n.interactionHandle, g = n.stateHandle, m = null === (h = n.withCredentials) || void 0 === h || h, e.prev = 8, o = !0, (0, a.A0)(d), b = "".concat(v, "/idp/idx/introspect"), k = g ? {
                      stateToken: g
                    } : {
                      interactionHandle: y
                    }, w = {
                      "Content-Type": "application/ion+json; okta-version=".concat(d),
                      Accept: "application/ion+json; okta-version=".concat(d)
                    }, e.next = 16, (0, f.c3)(t, {
                      method: "POST",
                      url: b,
                      headers: w,
                      withCredentials: m,
                      args: k
                    });
                  case 16:
                    r = e.sent, e.next = 27;
                    break;
                  case 19:
                    if (e.prev = 19, e.t0 = e["catch"](8), !((0, l.isAuthApiError)(e.t0) && e.t0.xhr && (0, u.P)(e.t0.xhr.responseJSON))) {
                      e.next = 26;
                      break;
                    }
                    r = e.t0.xhr.responseJSON, o = !1, e.next = 27;
                    break;
                  case 26:
                    throw e.t0;
                  case 27:
                    return O = n.withCredentials, e.abrupt("return", (0, a._T)(t, r, {
                      withCredentials: O
                    }, o));
                  case 29:
                  case "end":
                    return e.stop();
                }
              }, e, null, [[8, 19]]);
            })), h.apply(this, arguments);
          }
        },
        9284: function _(e, t, n) {
          "use strict";

          n.d(t, {
            B: function B() {
              return m;
            }
          });
          var r = {};
          n.r(r), n.d(r, {
            buildCredentialCreationOptions: function buildCredentialCreationOptions() {
              return d;
            },
            buildCredentialRequestOptions: function buildCredentialRequestOptions() {
              return v;
            },
            getAssertion: function getAssertion() {
              return g;
            },
            getAttestation: function getAttestation() {
              return y;
            }
          });
          var o = n(3144),
            i = n(5671),
            a = n(7326),
            u = n(136),
            c = n(2963),
            s = n(1120),
            f = n(4942),
            l = n(9727),
            p = n(7987),
            h = function h() {
              var e = [];
              return (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : []).forEach(function (t) {
                "webauthn" === t.key && e.push({
                  type: "public-key",
                  id: (0, p.dX)(t.credentialId)
                });
              }), e;
            },
            d = function d(e, t) {
              return {
                publicKey: {
                  rp: e.rp,
                  user: {
                    id: (0, p.dX)(e.user.id),
                    name: e.user.name,
                    displayName: e.user.displayName
                  },
                  challenge: (0, p.dX)(e.challenge),
                  pubKeyCredParams: e.pubKeyCredParams,
                  attestation: e.attestation,
                  authenticatorSelection: e.authenticatorSelection,
                  excludeCredentials: h(t)
                }
              };
            },
            v = function v(e, t) {
              return {
                publicKey: {
                  challenge: (0, p.dX)(e.challenge),
                  userVerification: e.userVerification,
                  allowCredentials: h(t)
                }
              };
            },
            y = function y(e) {
              var t = e.response;
              return {
                id: e.id,
                clientData: (0, p.kQ)(t.clientDataJSON),
                attestation: (0, p.kQ)(t.attestationObject)
              };
            },
            g = function g(e) {
              var t = e.response;
              return {
                id: e.id,
                clientData: (0, p.kQ)(t.clientDataJSON),
                authenticatorData: (0, p.kQ)(t.authenticatorData),
                signatureData: (0, p.kQ)(t.signature)
              };
            };
          function m(e) {
            var t;
            return t = function (e) {
              (0, u.Z)(p, e);
              var t,
                n,
                r = (t = p, n = function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                  } catch (e) {
                    return !1;
                  }
                }(), function () {
                  var e,
                    r = (0, s.Z)(t);
                  if (n) {
                    var o = (0, s.Z)(this).constructor;
                    e = Reflect.construct(r, arguments, o);
                  } else e = r.apply(this, arguments);
                  return (0, c.Z)(this, e);
                });
              function p() {
                var e;
                (0, i.Z)(this, p);
                for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++) n[o] = arguments[o];
                return e = r.call.apply(r, [this].concat(n)), (0, f.Z)((0, a.Z)(e), "idx", void 0), e.idx = (0, l.F)((0, a.Z)(e)), e;
              }
              return (0, o.Z)(p);
            }(e), (0, f.Z)(t, "webauthn", r), t;
          }
        },
        4602: function _(e, t, n) {
          "use strict";

          n.d(t, {
            S: function S() {
              return l;
            }
          });
          var r = n(3144),
            o = n(5671),
            i = n(7326),
            a = n(136),
            u = n(2963),
            c = n(1120),
            s = n(4942),
            f = n(9133);
          function l() {
            return function (e) {
              (0, a.Z)(l, e);
              var t,
                n,
                f = (t = l, n = function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                  } catch (e) {
                    return !1;
                  }
                }(), function () {
                  var e,
                    r = (0, c.Z)(t);
                  if (n) {
                    var o = (0, c.Z)(this).constructor;
                    e = Reflect.construct(r, arguments, o);
                  } else e = r.apply(this, arguments);
                  return (0, u.Z)(this, e);
                });
              function l(e) {
                var t;
                return (0, o.Z)(this, l), t = f.call(this, e), (0, s.Z)((0, i.Z)(t), "flow", void 0), (0, s.Z)((0, i.Z)(t), "activationToken", void 0), (0, s.Z)((0, i.Z)(t), "recoveryToken", void 0), (0, s.Z)((0, i.Z)(t), "idx", void 0), t.flow = e.flow, t.activationToken = e.activationToken, t.recoveryToken = e.recoveryToken, t.idx = e.idx, t;
              }
              return (0, r.Z)(l);
            }((0, f.n)());
          }
        },
        9310: function _(e, t, n) {
          "use strict";

          n.d(t, {
            $: function $() {
              return s;
            }
          });
          var r = n(5861),
            o = n(4687),
            i = n.n(o),
            a = n(2845),
            u = n(2620),
            c = n(146);
          function s(e) {
            return f.apply(this, arguments);
          }
          function f() {
            return f = (0, r.Z)(i().mark(function e(t) {
              var n,
                o,
                f,
                l,
                p,
                h = arguments;
              return i().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return o = h.length > 1 && void 0 !== h[1] ? h[1] : {}, e.next = 3, (0, a.x)(t, {
                      startPolling: !0
                    });
                  case 3:
                    if (f = e.sent, l = (0, u.uN)(t), null != (p = null == l || null === (n = l.remediations) || void 0 === n ? void 0 : n.find(function (e) {
                      return e.includes("poll");
                    })) && p.length || (0, c.ZK)("No polling remediations available at the current IDX flow stage"), !Number.isInteger(o.refresh)) {
                      e.next = 9;
                      break;
                    }
                    return e.abrupt("return", new Promise(function (e, n) {
                      setTimeout((0, r.Z)(i().mark(function r() {
                        var o, a, u;
                        return i().wrap(function (r) {
                          for (;;) switch (r.prev = r.next) {
                            case 0:
                              try {
                                u = null === (o = f.nextStep) || void 0 === o || null === (a = o.poll) || void 0 === a ? void 0 : a.refresh, e(u ? s(t, {
                                  refresh: u
                                }) : f);
                              } catch (e) {
                                n(e);
                              }
                            case 1:
                            case "end":
                              return r.stop();
                          }
                        }, r);
                      })), o.refresh);
                    }));
                  case 9:
                    return e.abrupt("return", f);
                  case 10:
                  case "end":
                    return e.stop();
                }
              }, e);
            })), f.apply(this, arguments);
          }
        },
        2845: function _(e, t, n) {
          "use strict";

          n.d(t, {
            C: function C() {
              return p;
            },
            x: function x() {
              return h;
            }
          });
          var r = n(4942),
            o = n(5861),
            i = n(4687),
            a = n.n(i),
            u = n(5832),
            c = n(2620),
            s = n(9123);
          function f(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function l(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? f(Object(n), !0).forEach(function (t) {
                (0, r.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          function p(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return !(!(0, c.uN)(e, t) && !t.stateHandle);
          }
          function h(e) {
            return d.apply(this, arguments);
          }
          function d() {
            return d = (0, o.Z)(a().mark(function e(t) {
              var n,
                r,
                o,
                i,
                f = arguments;
              return a().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if (p(t, n = f.length > 1 && void 0 !== f[1] ? f[1] : {})) {
                      e.next = 3;
                      break;
                    }
                    throw new s.Z("Unable to proceed: saved transaction could not be loaded");
                  case 3:
                    return r = n.flow, o = n.state, r || (i = (0, c.uN)(t, {
                      state: o
                    }), r = null == i ? void 0 : i.flow), e.abrupt("return", (0, u.K)(t, l(l({}, n), {}, {
                      flow: r
                    })));
                  case 6:
                  case "end":
                    return e.stop();
                }
              }, e);
            })), d.apply(this, arguments);
          }
        },
        9214: function _(e, t, n) {
          "use strict";

          n.d(t, {
            M: function M() {
              return l;
            }
          });
          var r = n(4942),
            o = n(5861),
            i = n(4687),
            a = n.n(i),
            u = n(5832),
            c = n(7738);
          function s(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function f(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? s(Object(n), !0).forEach(function (t) {
                (0, r.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          function l(e) {
            return p.apply(this, arguments);
          }
          function p() {
            return p = (0, o.Z)(a().mark(function e(t) {
              var n,
                r,
                o = arguments;
              return a().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return n = o.length > 1 && void 0 !== o[1] ? o[1] : {}, r = (0, c.s)(t, "recoverPassword"), e.abrupt("return", (0, u.K)(t, f(f({}, n), r)));
                  case 3:
                  case "end":
                    return e.stop();
                }
              }, e);
            })), p.apply(this, arguments);
          }
        },
        8826: function _(e, t, n) {
          "use strict";

          n.d(t, {
            z: function z() {
              return d;
            }
          });
          var r = n(4942),
            o = n(5861),
            i = n(4687),
            a = n.n(i),
            u = n(5832),
            c = n(2620),
            s = n(2473),
            f = n(9123),
            l = n(7595);
          function p(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function h(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? p(Object(n), !0).forEach(function (t) {
                (0, r.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          function d(e) {
            return v.apply(this, arguments);
          }
          function v() {
            return v = (0, o.Z)(a().mark(function e(t) {
              var n,
                r,
                o,
                i = arguments;
              return a().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if (n = i.length > 1 && void 0 !== i[1] ? i[1] : {}, (0, c.$0)(t)) {
                      e.next = 8;
                      break;
                    }
                    return e.next = 4, (0, s.Y)(t, h(h({}, n), {}, {
                      flow: "register",
                      autoRemediate: !1
                    }));
                  case 4:
                    if (r = e.sent, o = r.enabledFeatures, n.activationToken || !o || o.includes(l.Fw.REGISTRATION)) {
                      e.next = 8;
                      break;
                    }
                    throw new f.Z("Registration is not supported based on your current org configuration.");
                  case 8:
                    return e.abrupt("return", (0, u.K)(t, h(h({}, n), {}, {
                      flow: "register"
                    })));
                  case 9:
                  case "end":
                    return e.stop();
                }
              }, e);
            })), v.apply(this, arguments);
          }
        },
        2541: function _(e, t, n) {
          "use strict";

          n.d(t, {
            q: function q() {
              return d;
            }
          });
          var r = n(5671),
            o = n(3144),
            i = n(1752),
            a = n(136),
            u = n(2963),
            c = n(1120),
            s = n(4942),
            f = n(4794),
            l = n(6064);
          function p(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function h(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? p(Object(n), !0).forEach(function (t) {
                (0, s.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          var d = function (e) {
            (0, a.Z)(f, e);
            var t,
              n,
              s = (t = f, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, c.Z)(t);
                if (n) {
                  var o = (0, c.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, u.Z)(this, e);
              });
            function f() {
              return (0, r.Z)(this, f), s.apply(this, arguments);
            }
            return (0, o.Z)(f, [{
              key: "mapAuthenticator",
              value: function value() {
                var e = this.getAuthenticatorData();
                return {
                  id: (0, l.zg)(this.remediation).form.value.find(function (e) {
                    return "id" === e.name;
                  }).value,
                  methodType: e.methodType,
                  phoneNumber: e.phoneNumber
                };
              }
            }, {
              key: "getInputAuthenticator",
              value: function value(e) {
                return [{
                  name: "methodType",
                  type: "string"
                }, {
                  name: "phoneNumber",
                  label: "Phone Number",
                  type: "string"
                }].map(function (t) {
                  return h(h({}, e.form.value.find(function (e) {
                    return e.name === t.name;
                  })), t);
                });
              }
            }, {
              key: "mapAuthenticatorDataFromValues",
              value: function value(e) {
                e = (0, i.Z)((0, c.Z)(f.prototype), "mapAuthenticatorDataFromValues", this).call(this, e);
                var t = this.values.phoneNumber;
                if (e || t) return h(h({}, e && e), t && {
                  phoneNumber: t
                });
              }
            }]), f;
          }(f.a);
          (0, s.Z)(d, "remediationName", "authenticator-enrollment-data");
        },
        5278: function _(e, t, n) {
          "use strict";

          n.d(t, {
            q: function q() {
              return h;
            }
          });
          var r = n(2982),
            o = n(5671),
            i = n(3144),
            a = n(1752),
            u = n(136),
            c = n(2963),
            s = n(1120),
            f = n(4942);
          function l(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function p(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? l(Object(n), !0).forEach(function (t) {
                (0, f.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          var h = function (e) {
            (0, u.Z)(h, e);
            var t,
              n,
              l = (t = h, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, s.Z)(t);
                if (n) {
                  var o = (0, s.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, c.Z)(this, e);
              });
            function h() {
              return (0, o.Z)(this, h), l.apply(this, arguments);
            }
            return (0, i.Z)(h, [{
              key: "mapAuthenticator",
              value: function value() {
                return this.getAuthenticatorData();
              }
            }, {
              key: "getInputAuthenticator",
              value: function value() {
                var e = this.getAuthenticatorFromRemediation(),
                  t = e.form.value.find(function (e) {
                    return "methodType" === e.name;
                  });
                return t && t.options ? {
                  name: "methodType",
                  type: "string",
                  required: !0,
                  options: t.options
                } : (0, r.Z)(e.form.value);
              }
            }, {
              key: "getValuesAfterProceed",
              value: function value() {
                var e = this;
                return this.values = (0, a.Z)((0, s.Z)(h.prototype), "getValuesAfterProceed", this).call(this), Object.keys(this.values).filter(function (e) {
                  return "authenticator" !== e;
                }).reduce(function (t, n) {
                  return p(p({}, t), {}, (0, f.Z)({}, n, e.values[n]));
                }, {});
              }
            }]), h;
          }(n(4794).a);
          (0, f.Z)(h, "remediationName", "authenticator-verification-data");
        },
        4794: function _(e, t, n) {
          "use strict";

          n.d(t, {
            a: function a() {
              return y;
            }
          });
          var r = n(5671),
            o = n(3144),
            i = n(7326),
            a = n(1752),
            u = n(136),
            c = n(2963),
            s = n(1120),
            f = n(4942),
            l = n(3118),
            p = n(7595),
            h = n(9344);
          function d(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function v(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? d(Object(n), !0).forEach(function (t) {
                (0, f.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : d(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          var y = function (e) {
            (0, u.Z)(d, e);
            var t,
              n,
              l = (t = d, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, s.Z)(t);
                if (n) {
                  var o = (0, s.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, c.Z)(this, e);
              });
            function d(e) {
              var t,
                n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return (0, r.Z)(this, d), t = l.call(this, e, n), (0, f.Z)((0, i.Z)(t), "authenticator", void 0), t.authenticator = t.getAuthenticator(), t.formatAuthenticatorData(), t;
            }
            return (0, o.Z)(d, [{
              key: "formatAuthenticatorData",
              value: function value() {
                var e = this;
                if (this.getAuthenticatorData()) this.values.authenticatorsData = this.values.authenticatorsData.map(function (t) {
                  return (0, h.PN)(e.authenticator, t) ? e.mapAuthenticatorDataFromValues(t) : t;
                });else {
                  var t = this.mapAuthenticatorDataFromValues();
                  t && this.values.authenticatorsData.push(t);
                }
              }
            }, {
              key: "getAuthenticatorData",
              value: function value() {
                var e = this;
                return this.values.authenticatorsData.find(function (t) {
                  return (0, h.PN)(e.authenticator, t);
                });
              }
            }, {
              key: "canRemediate",
              value: function value() {
                var e = this;
                return this.values.authenticatorsData.some(function (t) {
                  return (0, h.PN)(e.authenticator, t);
                });
              }
            }, {
              key: "mapAuthenticatorDataFromValues",
              value: function value(e) {
                var t = this.values,
                  n = t.methodType,
                  r = t.authenticator;
                !n && (0, p.H)(r) && (n = null == r ? void 0 : r.methodType);
                var o = this.authenticator,
                  i = v(v({
                    id: o.id,
                    enrollmentId: o.enrollmentId
                  }, e && e), n && {
                    methodType: n
                  });
                return i.methodType ? i : null;
              }
            }, {
              key: "getAuthenticatorFromRemediation",
              value: function value() {
                return this.remediation.value.find(function (e) {
                  return "authenticator" === e.name;
                });
              }
            }, {
              key: "getValuesAfterProceed",
              value: function value() {
                var e = this;
                this.values = (0, a.Z)((0, s.Z)(d.prototype), "getValuesAfterProceed", this).call(this);
                var t = this.values.authenticatorsData.filter(function (t) {
                  return !0 !== (0, h.PN)(e.authenticator, t);
                });
                return v(v({}, this.values), {}, {
                  authenticatorsData: t
                });
              }
            }]), d;
          }(l.n);
        },
        3118: function _(e, t, n) {
          "use strict";

          n.d(t, {
            n: function n() {
              return h;
            }
          });
          var r = n(2982),
            o = n(1002),
            i = n(5671),
            a = n(3144),
            u = n(4942),
            c = n(6064),
            s = n(9344);
          function f(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
            return r;
          }
          function l(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function p(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? l(Object(n), !0).forEach(function (t) {
                (0, u.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          var h = function () {
            function e(t) {
              var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              (0, i.Z)(this, e), (0, u.Z)(this, "remediation", void 0), (0, u.Z)(this, "values", void 0), (0, u.Z)(this, "options", void 0), (0, u.Z)(this, "map", void 0), this.values = p({}, n), this.options = p({}, r), this.formatAuthenticators(), this.remediation = t;
            }
            return (0, a.Z)(e, [{
              key: "formatAuthenticators",
              value: function value() {
                if (this.values.authenticators = this.values.authenticators || [], this.values.authenticators = this.values.authenticators.map(function (e) {
                  return (0, s.LL)(e);
                }), this.values.authenticator) {
                  var e = (0, s.LL)(this.values.authenticator);
                  this.values.authenticators.some(function (t) {
                    return (0, s.PN)(e, t);
                  }) || this.values.authenticators.push(e);
                }
                this.values.authenticatorsData = this.values.authenticators.reduce(function (e, t) {
                  return "object" === (0, o.Z)(t) && Object.keys(t).length > 1 && e.push(t), e;
                }, this.values.authenticatorsData || []);
              }
            }, {
              key: "getName",
              value: function value() {
                return this.remediation.name;
              }
            }, {
              key: "canRemediate",
              value: function value(e) {
                var t = this;
                return !(0, c.QG)(this.remediation).find(function (e) {
                  return !t.hasData(e);
                });
              }
            }, {
              key: "getData",
              value: function value(e) {
                var t = this;
                if (!e) {
                  var n = (0, c.ix)(this.remediation).reduce(function (e, n) {
                    return e[n] = t.getData(n), e;
                  }, {});
                  return n;
                }
                if ("function" == typeof this["map".concat((0, c.Qs)(e))]) {
                  var r = this["map".concat((0, c.Qs)(e))](this.remediation.value.find(function (t) {
                    return t.name === e;
                  }));
                  if (r) return r;
                }
                if (this.map && this.map[e]) for (var o = this.map[e], i = 0; i < o.length; i++) {
                  var a = this.values[o[i]];
                  if (a) return a;
                }
                return this.values[e];
              }
            }, {
              key: "hasData",
              value: function value(e) {
                return !!this.getData(e);
              }
            }, {
              key: "getNextStep",
              value: function value(e, t) {
                var n = this.getName(),
                  r = this.getInputs(),
                  o = this.getAuthenticator(),
                  i = null == o ? void 0 : o.type;
                return p(p({
                  name: n,
                  inputs: r
                }, i && {
                  type: i
                }), o && {
                  authenticator: o
                });
              }
            }, {
              key: "getInputs",
              value: function value() {
                var e = this,
                  t = [];
                return (this.remediation.value || []).forEach(function (n) {
                  var r,
                    o = n.name,
                    i = n.type,
                    a = n.visible,
                    u = n.messages;
                  if (!1 !== a) {
                    if ("function" == typeof e["getInput".concat((0, c.Qs)(o))]) r = e["getInput".concat((0, c.Qs)(o))](n);else if ("object" !== i) {
                      var s,
                        f = (e.map ? e.map[o] : null) || [];
                      s = 1 === f.length ? f[0] : f.find(function (t) {
                        return Object.keys(e.values).includes(t);
                      }), s && (r = p(p({}, n), {}, {
                        name: s
                      }));
                    }
                    r || (r = n), Array.isArray(r) ? r.forEach(function (e) {
                      return t.push(e);
                    }) : (u && (r.messages = u), t.push(r));
                  }
                }), t;
              }
            }, {
              key: "getValuesAfterProceed",
              value: function value() {
                var e,
                  t = this.remediation.value || [],
                  n = this.getInputs(),
                  o = function (e, t) {
                    var _n7 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (!_n7) {
                      if (Array.isArray(e) || (_n7 = function (e, t) {
                        if (e) {
                          if ("string" == typeof e) return f(e, t);
                          var n = Object.prototype.toString.call(e).slice(8, -1);
                          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? f(e, t) : void 0;
                        }
                      }(e)) || t && e && "number" == typeof e.length) {
                        _n7 && (e = _n7);
                        var r = 0,
                          o = function o() {};
                        return {
                          s: o,
                          n: function n() {
                            return r >= e.length ? {
                              done: !0
                            } : {
                              done: !1,
                              value: e[r++]
                            };
                          },
                          e: function e(_e14) {
                            throw _e14;
                          },
                          f: o
                        };
                      }
                      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i,
                      a = !0,
                      u = !1;
                    return {
                      s: function s() {
                        _n7 = _n7.call(e);
                      },
                      n: function n() {
                        var e = _n7.next();
                        return a = e.done, e;
                      },
                      e: function e(_e15) {
                        u = !0, i = _e15;
                      },
                      f: function f() {
                        try {
                          a || null == _n7["return"] || _n7["return"]();
                        } finally {
                          if (u) throw i;
                        }
                      }
                    };
                  }([].concat((0, r.Z)(t), (0, r.Z)(n)));
                try {
                  for (o.s(); !(e = o.n()).done;) {
                    var i = e.value;
                    delete this.values[i.name];
                  }
                } catch (e) {
                  o.e(e);
                } finally {
                  o.f();
                }
                return this.values;
              }
            }, {
              key: "getAuthenticator",
              value: function value() {
                var e,
                  t,
                  n = null === (e = this.remediation.relatesTo) || void 0 === e ? void 0 : e.value;
                if (n) {
                  var r = (0, c.zg)(this.remediation);
                  if (!r) return n;
                  var o = r.form.value.find(function (e) {
                      return "id" === e.name;
                    }).value,
                    i = null === (t = r.form.value.find(function (e) {
                      return "enrollmentId" === e.name;
                    })) || void 0 === t ? void 0 : t.value;
                  return p(p({}, n), {}, {
                    id: o,
                    enrollmentId: i
                  });
                }
              }
            }], [{
              key: "getMessages",
              value: function value(e) {
                var t, n;
                if (e.value) return null === (t = e.value[0]) || void 0 === t || null === (n = t.form) || void 0 === n ? void 0 : n.value.reduce(function (e, t) {
                  return t.messages && (e = [].concat((0, r.Z)(e), (0, r.Z)(t.messages.value))), e;
                }, []);
              }
            }]), e;
          }();
          (0, u.Z)(h, "remediationName", void 0);
        },
        9164: function _(e, t, n) {
          "use strict";

          n.d(t, {
            n: function n() {
              return m;
            }
          });
          var r = n(5671),
            o = n(3144),
            i = n(7326),
            a = n(1752),
            u = n(136),
            c = n(2963),
            s = n(1120),
            f = n(4942),
            l = n(3118),
            p = n(6064),
            h = n(7595),
            d = n(9344);
          function v(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function y(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? v(Object(n), !0).forEach(function (t) {
                (0, f.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          function g(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
            return r;
          }
          var m = function (e) {
            (0, u.Z)(v, e);
            var t,
              n,
              l = (t = v, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, s.Z)(t);
                if (n) {
                  var o = (0, s.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, c.Z)(this, e);
              });
            function v() {
              var e;
              (0, r.Z)(this, v);
              for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++) n[o] = arguments[o];
              return e = l.call.apply(l, [this].concat(n)), (0, f.Z)((0, i.Z)(e), "selectedAuthenticator", void 0), (0, f.Z)((0, i.Z)(e), "selectedOption", void 0), e;
            }
            return (0, o.Z)(v, [{
              key: "findMatchedOption",
              value: function value(e, t) {
                var n,
                  r,
                  o = function (e, t) {
                    var _n8 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                    if (!_n8) {
                      if (Array.isArray(e) || (_n8 = function (e, t) {
                        if (e) {
                          if ("string" == typeof e) return g(e, t);
                          var n = Object.prototype.toString.call(e).slice(8, -1);
                          return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? g(e, t) : void 0;
                        }
                      }(e)) || t && e && "number" == typeof e.length) {
                        _n8 && (e = _n8);
                        var r = 0,
                          o = function o() {};
                        return {
                          s: o,
                          n: function n() {
                            return r >= e.length ? {
                              done: !0
                            } : {
                              done: !1,
                              value: e[r++]
                            };
                          },
                          e: function e(_e16) {
                            throw _e16;
                          },
                          f: o
                        };
                      }
                      throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                    }
                    var i,
                      a = !0,
                      u = !1;
                    return {
                      s: function s() {
                        _n8 = _n8.call(e);
                      },
                      n: function n() {
                        var e = _n8.next();
                        return a = e.done, e;
                      },
                      e: function e(_e17) {
                        u = !0, i = _e17;
                      },
                      f: function f() {
                        try {
                          a || null == _n8["return"] || _n8["return"]();
                        } finally {
                          if (u) throw i;
                        }
                      }
                    };
                  }(e);
                try {
                  var i = function i() {
                    var e = r.value;
                    if (n = t.find(function (t) {
                      var n = t.relatesTo;
                      return n.key && n.key === e.key;
                    })) return "break";
                  };
                  for (o.s(); !(r = o.n()).done && "break" !== i(););
                } catch (e) {
                  o.e(e);
                } finally {
                  o.f();
                }
                return n;
              }
            }, {
              key: "canRemediate",
              value: function value(e) {
                var t = this.values,
                  n = t.authenticators,
                  r = t.authenticator,
                  o = (0, p.zg)(this.remediation).options;
                if (!n || !n.length) return !1;
                if ((0, h.H)(r) && r.id) return !0;
                var i = this.findMatchedOption(n, o);
                if (i) {
                  var a,
                    u,
                    c = (null == e ? void 0 : e.currentAuthenticator) && (null == e ? void 0 : e.currentAuthenticator.value.id) === (null === (a = i.relatesTo) || void 0 === a ? void 0 : a.id),
                    s = (null == e ? void 0 : e.currentAuthenticatorEnrollment) && (null == e ? void 0 : e.currentAuthenticatorEnrollment.value.id) === (null === (u = i.relatesTo) || void 0 === u ? void 0 : u.id);
                  return !c && !s;
                }
                return !1;
              }
            }, {
              key: "mapAuthenticator",
              value: function value(e) {
                var t = this.values,
                  n = t.authenticators,
                  r = t.authenticator;
                if ((0, h.H)(r) && r.id) return this.selectedAuthenticator = r, r;
                var o = e.options,
                  i = (0, d.h_)(n, o);
                return this.selectedAuthenticator = i.relatesTo, this.selectedOption = i, {
                  id: null == i ? void 0 : i.value.form.value.find(function (e) {
                    return "id" === e.name;
                  }).value
                };
              }
            }, {
              key: "getInputAuthenticator",
              value: function value(e) {
                return {
                  name: "authenticator",
                  type: "string",
                  options: e.options.map(function (e) {
                    return {
                      label: e.label,
                      value: e.relatesTo.key
                    };
                  })
                };
              }
            }, {
              key: "getValuesAfterProceed",
              value: function value() {
                var e = this;
                this.values = (0, a.Z)((0, s.Z)(v.prototype), "getValuesAfterProceed", this).call(this);
                var t = this.values.authenticators.filter(function (t) {
                  return !0 !== (0, d.PN)(t, e.selectedAuthenticator);
                });
                return y(y({}, this.values), {}, {
                  authenticators: t
                });
              }
            }]), v;
          }(l.n);
        },
        9883: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Q: function Q() {
              return E;
            }
          });
          var r = n(5671),
            o = n(3144),
            i = n(7326),
            a = n(1752),
            u = n(136),
            c = n(2963),
            s = n(1120),
            f = n(4942),
            l = n(3118),
            p = n(7644);
          function h(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function d(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? h(Object(n), !0).forEach(function (t) {
                (0, f.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          var v = function (e) {
            (0, u.Z)(a, e);
            var t,
              n,
              i = (t = a, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, s.Z)(t);
                if (n) {
                  var o = (0, s.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, c.Z)(this, e);
              });
            function a() {
              return (0, r.Z)(this, a), i.apply(this, arguments);
            }
            return (0, o.Z)(a, [{
              key: "canVerify",
              value: function value(e) {
                return !!(e.credentials || e.verificationCode || e.otp);
              }
            }, {
              key: "mapCredentials",
              value: function value(e) {
                var t = e.credentials,
                  n = e.verificationCode,
                  r = e.otp;
                if (t || n || r) return t || {
                  passcode: n || r
                };
              }
            }, {
              key: "getInputs",
              value: function value(e) {
                var t;
                return d(d({}, null === (t = e.form) || void 0 === t ? void 0 : t.value[0]), {}, {
                  name: "verificationCode",
                  type: "string",
                  required: e.required
                });
              }
            }]), a;
          }(p._);
          var y = function (e) {
              (0, u.Z)(a, e);
              var t,
                n,
                i = (t = a, n = function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                  } catch (e) {
                    return !1;
                  }
                }(), function () {
                  var e,
                    r = (0, s.Z)(t);
                  if (n) {
                    var o = (0, s.Z)(this).constructor;
                    e = Reflect.construct(r, arguments, o);
                  } else e = r.apply(this, arguments);
                  return (0, c.Z)(this, e);
                });
              function a() {
                return (0, r.Z)(this, a), i.apply(this, arguments);
              }
              return (0, o.Z)(a, [{
                key: "mapCredentials",
                value: function value(e) {
                  var t = e.verificationCode;
                  if (t) return {
                    totp: t
                  };
                }
              }]), a;
            }(v),
            g = n(9582);
          var m = function (e) {
            (0, u.Z)(a, e);
            var t,
              n,
              i = (t = a, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, s.Z)(t);
                if (n) {
                  var o = (0, s.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, c.Z)(this, e);
              });
            function a() {
              return (0, r.Z)(this, a), i.apply(this, arguments);
            }
            return (0, o.Z)(a, [{
              key: "canVerify",
              value: function value(e) {
                var t = e.credentials;
                if (t && t.questionKey && t.answer) return !0;
                var n = e.questionKey,
                  r = e.question,
                  o = e.answer;
                return !(!n || !o) || !(!r || !o);
              }
            }, {
              key: "mapCredentials",
              value: function value(e) {
                var t = e.questionKey,
                  n = e.question,
                  r = e.answer;
                if (r && (t || n)) return {
                  questionKey: n ? "custom" : t,
                  question: n,
                  answer: r
                };
              }
            }, {
              key: "getInputs",
              value: function value() {
                return [{
                  name: "questionKey",
                  type: "string",
                  required: !0
                }, {
                  name: "question",
                  type: "string",
                  label: "Create a security question"
                }, {
                  name: "answer",
                  type: "string",
                  label: "Answer",
                  required: !0
                }];
              }
            }]), a;
          }(p._);
          var b = function (e) {
            (0, u.Z)(a, e);
            var t,
              n,
              i = (t = a, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, s.Z)(t);
                if (n) {
                  var o = (0, s.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, c.Z)(this, e);
              });
            function a() {
              return (0, r.Z)(this, a), i.apply(this, arguments);
            }
            return (0, o.Z)(a, [{
              key: "canVerify",
              value: function value(e) {
                var t = e.credentials;
                return !(!t || !t.answer) || !!e.answer;
              }
            }, {
              key: "mapCredentials",
              value: function value(e) {
                var t = e.answer;
                if (t) return {
                  questionKey: this.meta.contextualData.enrolledQuestion.questionKey,
                  answer: t
                };
              }
            }, {
              key: "getInputs",
              value: function value() {
                return [{
                  name: "answer",
                  type: "string",
                  label: "Answer",
                  required: !0
                }];
              }
            }]), a;
          }(p._);
          var k = function (e) {
            (0, u.Z)(a, e);
            var t,
              n,
              i = (t = a, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, s.Z)(t);
                if (n) {
                  var o = (0, s.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, c.Z)(this, e);
              });
            function a() {
              return (0, r.Z)(this, a), i.apply(this, arguments);
            }
            return (0, o.Z)(a, [{
              key: "canVerify",
              value: function value(e) {
                var t = e.credentials || e,
                  n = t.clientData,
                  r = t.attestation;
                return !(!n || !r);
              }
            }, {
              key: "mapCredentials",
              value: function value(e) {
                var t = e.credentials,
                  n = e.clientData,
                  r = e.attestation;
                if (t || n || r) return t || {
                  clientData: n,
                  attestation: r
                };
              }
            }, {
              key: "getInputs",
              value: function value() {
                return [{
                  name: "clientData",
                  type: "string",
                  required: !0,
                  visible: !1,
                  label: "Client Data"
                }, {
                  name: "attestation",
                  type: "string",
                  required: !0,
                  visible: !1,
                  label: "Attestation"
                }];
              }
            }]), a;
          }(p._);
          var w = function (e) {
              (0, u.Z)(a, e);
              var t,
                n,
                i = (t = a, n = function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                  } catch (e) {
                    return !1;
                  }
                }(), function () {
                  var e,
                    r = (0, s.Z)(t);
                  if (n) {
                    var o = (0, s.Z)(this).constructor;
                    e = Reflect.construct(r, arguments, o);
                  } else e = r.apply(this, arguments);
                  return (0, c.Z)(this, e);
                });
              function a() {
                return (0, r.Z)(this, a), i.apply(this, arguments);
              }
              return (0, o.Z)(a, [{
                key: "canVerify",
                value: function value(e) {
                  var t = e.credentials || e,
                    n = t.clientData,
                    r = t.authenticatorData,
                    o = t.signatureData;
                  return !!(n && r && o);
                }
              }, {
                key: "mapCredentials",
                value: function value(e) {
                  var t = e.credentials,
                    n = e.authenticatorData,
                    r = e.clientData,
                    o = e.signatureData;
                  if (t || n || r || o) return t || {
                    authenticatorData: n,
                    clientData: r,
                    signatureData: o
                  };
                }
              }, {
                key: "getInputs",
                value: function value() {
                  return [{
                    name: "authenticatorData",
                    type: "string",
                    label: "Authenticator Data",
                    required: !0,
                    visible: !1
                  }, {
                    name: "clientData",
                    type: "string",
                    label: "Client Data",
                    required: !0,
                    visible: !1
                  }, {
                    name: "signatureData",
                    type: "string",
                    label: "Signature Data",
                    required: !0,
                    visible: !1
                  }];
                }
              }]), a;
            }(p._),
            O = n(7595);
          function T(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function Z(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? T(Object(n), !0).forEach(function (t) {
                (0, f.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : T(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          var E = function (e) {
            (0, u.Z)(p, e);
            var t,
              n,
              l = (t = p, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, s.Z)(t);
                if (n) {
                  var o = (0, s.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, c.Z)(this, e);
              });
            function p(e) {
              var t,
                n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
              return (0, r.Z)(this, p), t = l.call(this, e, n), (0, f.Z)((0, i.Z)(t), "authenticator", void 0), t.authenticator = function (e) {
                var t,
                  n,
                  r = e.relatesTo,
                  o = (null == r ? void 0 : r.value) || {};
                switch (o.key) {
                  case O.pc.OKTA_PASSWORD:
                    return new g.a(o);
                  case O.pc.SECURITY_QUESTION:
                    return null !== (t = o.contextualData) && void 0 !== t && t.enrolledQuestion ? new b(o) : new m(o);
                  case O.pc.OKTA_VERIFY:
                    return new y(o);
                  case O.pc.WEBAUTHN:
                    return null !== (n = o.contextualData) && void 0 !== n && n.challengeData ? new w(o) : new k(o);
                  default:
                    return new v(o);
                }
              }(e), t;
            }
            return (0, o.Z)(p, [{
              key: "getNextStep",
              value: function value(e, t) {
                var n,
                  r = (0, a.Z)((0, s.Z)(p.prototype), "getNextStep", this).call(this, e, t),
                  o = null == t || null === (n = t.authenticatorEnrollments) || void 0 === n ? void 0 : n.value;
                return Z(Z({}, r), {}, {
                  authenticatorEnrollments: o
                });
              }
            }, {
              key: "canRemediate",
              value: function value() {
                return this.authenticator.canVerify(this.values);
              }
            }, {
              key: "mapCredentials",
              value: function value() {
                return this.authenticator.mapCredentials(this.values);
              }
            }, {
              key: "getInputCredentials",
              value: function value(e) {
                return this.authenticator.getInputs(e);
              }
            }, {
              key: "getValuesAfterProceed",
              value: function value() {
                var e = this;
                return this.values = (0, a.Z)((0, s.Z)(p.prototype), "getValuesAfterProceed", this).call(this), Object.keys(this.values).filter(function (e) {
                  return "credentials" !== e;
                }).reduce(function (t, n) {
                  return Z(Z({}, t), {}, (0, f.Z)({}, n, e.values[n]));
                }, {});
              }
            }]), p;
          }(l.n);
        },
        4560: function _(e, t, n) {
          "use strict";

          n.d(t, {
            J: function J() {
              return s;
            }
          });
          var r = n(3144),
            o = n(5671),
            i = n(136),
            a = n(2963),
            u = n(1120),
            c = n(4942);
          var s = function (e) {
            (0, i.Z)(s, e);
            var t,
              n,
              c = (t = s, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, u.Z)(t);
                if (n) {
                  var o = (0, u.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, a.Z)(this, e);
              });
            function s() {
              return (0, o.Z)(this, s), c.apply(this, arguments);
            }
            return (0, r.Z)(s);
          }(n(9883).Q);
          (0, c.Z)(s, "remediationName", "challenge-authenticator");
        },
        1104: function _(e, t, n) {
          "use strict";

          n.d(t, {
            U: function U() {
              return s;
            }
          });
          var r = n(5671),
            o = n(3144),
            i = n(136),
            a = n(2963),
            u = n(1120),
            c = n(4942);
          var s = function (e) {
            (0, i.Z)(s, e);
            var t,
              n,
              c = (t = s, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, u.Z)(t);
                if (n) {
                  var o = (0, u.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, a.Z)(this, e);
              });
            function s() {
              return (0, r.Z)(this, s), c.apply(this, arguments);
            }
            return (0, o.Z)(s, [{
              key: "canRemediate",
              value: function value() {
                return !!this.values.startPolling || "challenge-poll" === this.options.step;
              }
            }]), s;
          }(n(2288).T);
          (0, c.Z)(s, "remediationName", "challenge-poll");
        },
        3857: function _(e, t, n) {
          "use strict";

          n.d(t, {
            q: function q() {
              return s;
            }
          });
          var r = n(3144),
            o = n(5671),
            i = n(136),
            a = n(2963),
            u = n(1120),
            c = n(4942);
          var s = function (e) {
            (0, i.Z)(s, e);
            var t,
              n,
              c = (t = s, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, u.Z)(t);
                if (n) {
                  var o = (0, u.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, a.Z)(this, e);
              });
            function s() {
              return (0, o.Z)(this, s), c.apply(this, arguments);
            }
            return (0, r.Z)(s);
          }(n(9883).Q);
          (0, c.Z)(s, "remediationName", "enroll-authenticator");
        },
        2288: function _(e, t, n) {
          "use strict";

          n.d(t, {
            T: function T() {
              return p;
            }
          });
          var r = n(5671),
            o = n(3144),
            i = n(1752),
            a = n(136),
            u = n(2963),
            c = n(1120),
            s = n(4942);
          function f(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function l(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? f(Object(n), !0).forEach(function (t) {
                (0, s.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          var p = function (e) {
            (0, a.Z)(p, e);
            var t,
              n,
              f = (t = p, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, c.Z)(t);
                if (n) {
                  var o = (0, c.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, u.Z)(this, e);
              });
            function p() {
              return (0, r.Z)(this, p), f.apply(this, arguments);
            }
            return (0, o.Z)(p, [{
              key: "canRemediate",
              value: function value() {
                return !!this.values.startPolling || "enroll-poll" === this.options.step;
              }
            }, {
              key: "getNextStep",
              value: function value(e, t) {
                var n = (0, i.Z)((0, c.Z)(p.prototype), "getNextStep", this).call(this, e, t),
                  r = this.getAuthenticator();
                return !r && null != t && t.currentAuthenticator && (r = t.currentAuthenticator.value), l(l({}, n), {}, {
                  authenticator: r,
                  poll: {
                    required: !0,
                    refresh: this.remediation.refresh
                  }
                });
              }
            }, {
              key: "getValuesAfterProceed",
              value: function value() {
                var e = this;
                return Object.keys(this.values).filter(function (e) {
                  return "startPolling" !== e;
                }).reduce(function (t, n) {
                  return l(l({}, t), {}, (0, s.Z)({}, n, e.values[n]));
                }, {});
              }
            }]), p;
          }(n(3118).n);
          (0, s.Z)(p, "remediationName", "enroll-poll");
        },
        7522: function _(e, t, n) {
          "use strict";

          n.d(t, {
            w: function w() {
              return v;
            }
          });
          var r = n(2982),
            o = n(5671),
            i = n(3144),
            a = n(7326),
            u = n(136),
            c = n(2963),
            s = n(1120),
            f = n(4942),
            l = n(3118),
            p = n(9582);
          function h(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function d(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? h(Object(n), !0).forEach(function (t) {
                (0, f.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : h(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          var v = function (e) {
            (0, u.Z)(h, e);
            var t,
              n,
              l = (t = h, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, s.Z)(t);
                if (n) {
                  var o = (0, s.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, c.Z)(this, e);
              });
            function h(e) {
              var t,
                n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                r = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              return (0, o.Z)(this, h), t = l.call(this, e, n, r), (0, f.Z)((0, a.Z)(t), "authenticator", null), t.getCredentialsFromRemediation() && (t.authenticator = t.authenticator = new p.a({})), t;
            }
            return (0, i.Z)(h, [{
              key: "canRemediate",
              value: function value() {
                if (this.authenticator && !this.authenticator.canVerify(this.values)) return !1;
                var e = this.getData().userProfile;
                return !!e && this.remediation.value.find(function (e) {
                  return "userProfile" === e.name;
                }).form.value.reduce(function (t, n) {
                  return n.required && (t = t && !!e[n.name]), t;
                }, !0);
              }
            }, {
              key: "getCredentialsFromRemediation",
              value: function value() {
                return this.remediation.value.find(function (e) {
                  return "credentials" === e.name;
                });
              }
            }, {
              key: "mapUserProfile",
              value: function value(e) {
                var t = this,
                  n = e.form.value.map(function (e) {
                    return e.name;
                  }).reduce(function (e, n) {
                    return t.values[n] ? d(d({}, e), {}, (0, f.Z)({}, n, t.values[n])) : e;
                  }, {});
                if (0 !== Object.keys(n).length) return n;
              }
            }, {
              key: "mapCredentials",
              value: function value() {
                var e = this.authenticator && this.authenticator.mapCredentials(this.values);
                if (e) return e;
              }
            }, {
              key: "getInputUserProfile",
              value: function value(e) {
                return (0, r.Z)(e.form.value);
              }
            }, {
              key: "getInputCredentials",
              value: function value(e) {
                return (0, r.Z)(e.form.value);
              }
            }, {
              key: "getErrorMessages",
              value: function value(e) {
                return e.value[0].form.value.reduce(function (e, t) {
                  return t.messages && e.push(t.messages.value[0].message), e;
                }, []);
              }
            }]), h;
          }(l.n);
          (0, f.Z)(v, "remediationName", "enroll-profile");
        },
        3679: function _(e, t, n) {
          "use strict";

          n.d(t, {
            t: function t() {
              return p;
            }
          });
          var r = n(5671),
            o = n(3144),
            i = n(1752),
            a = n(136),
            u = n(2963),
            c = n(1120),
            s = n(4942);
          function f(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function l(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? f(Object(n), !0).forEach(function (t) {
                (0, s.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          var p = function (e) {
            (0, a.Z)(p, e);
            var t,
              n,
              f = (t = p, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, c.Z)(t);
                if (n) {
                  var o = (0, c.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, u.Z)(this, e);
              });
            function p() {
              return (0, r.Z)(this, p), f.apply(this, arguments);
            }
            return (0, o.Z)(p, [{
              key: "getInputEmail",
              value: function value() {
                return [{
                  name: "email",
                  type: "string",
                  required: !0,
                  label: "Email"
                }];
              }
            }, {
              key: "getInputPhoneNumber",
              value: function value() {
                return [{
                  name: "phoneNumber",
                  type: "string",
                  required: !0,
                  label: "Phone Number"
                }];
              }
            }, {
              key: "canRemediate",
              value: function value() {
                return Boolean(this.values.email || this.values.phoneNumber);
              }
            }, {
              key: "getNextStep",
              value: function value(e, t) {
                var n = (0, i.Z)((0, c.Z)(p.prototype), "getNextStep", this).call(this, e, t),
                  r = t.currentAuthenticator.value;
                return l(l({}, n), {}, {
                  authenticator: r
                });
              }
            }, {
              key: "getData",
              value: function value() {
                return {
                  stateHandle: this.values.stateHandle,
                  email: this.values.email,
                  phoneNumber: this.values.phoneNumber
                };
              }
            }, {
              key: "getValuesAfterProceed",
              value: function value() {
                var e = this;
                return Object.keys(this.values).filter(function (e) {
                  return !["email", "phoneNumber"].includes(e);
                }).reduce(function (t, n) {
                  return l(l({}, t), {}, (0, s.Z)({}, n, e.values[n]));
                }, {});
              }
            }]), p;
          }(n(3118).n);
          (0, s.Z)(p, "remediationName", "enrollment-channel-data");
        },
        8628: function _(e, t, n) {
          "use strict";

          n.d(t, {
            h: function h() {
              return p;
            }
          });
          var r = n(5671),
            o = n(3144),
            i = n(7326),
            a = n(136),
            u = n(2963),
            c = n(1120),
            s = n(4942);
          function f(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function l(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? f(Object(n), !0).forEach(function (t) {
                (0, s.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          var p = function (e) {
            (0, a.Z)(p, e);
            var t,
              n,
              f = (t = p, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, c.Z)(t);
                if (n) {
                  var o = (0, c.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, u.Z)(this, e);
              });
            function p() {
              var e;
              (0, r.Z)(this, p);
              for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++) n[o] = arguments[o];
              return e = f.call.apply(f, [this].concat(n)), (0, s.Z)((0, i.Z)(e), "map", {
                identifier: ["username"]
              }), e;
            }
            return (0, o.Z)(p, [{
              key: "canRemediate",
              value: function value() {
                return !!this.getData().identifier;
              }
            }, {
              key: "mapCredentials",
              value: function value() {
                var e = this.values,
                  t = e.credentials,
                  n = e.password;
                if (t || n) return t || {
                  passcode: n
                };
              }
            }, {
              key: "getInputCredentials",
              value: function value(e) {
                return l(l({}, e.form.value[0]), {}, {
                  name: "password",
                  required: e.required
                });
              }
            }]), p;
          }(n(3118).n);
          (0, s.Z)(p, "remediationName", "identify");
        },
        9024: function _(e, t, n) {
          "use strict";

          n.d(t, {
            j: function j() {
              return l;
            }
          });
          var r = n(5671),
            o = n(3144),
            i = n(136),
            a = n(2963),
            u = n(1120),
            c = n(4942);
          function s(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function f(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? s(Object(n), !0).forEach(function (t) {
                (0, c.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : s(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          var l = function (e) {
            (0, i.Z)(s, e);
            var t,
              n,
              c = (t = s, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, u.Z)(t);
                if (n) {
                  var o = (0, u.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, a.Z)(this, e);
              });
            function s() {
              return (0, r.Z)(this, s), c.apply(this, arguments);
            }
            return (0, o.Z)(s, [{
              key: "mapCredentials",
              value: function value() {
                var e = this.values.newPassword;
                if (e) return {
                  passcode: e
                };
              }
            }, {
              key: "getInputCredentials",
              value: function value(e) {
                var t = "password" === this.getAuthenticator().type ? "newPassword" : "verificationCode";
                return f(f({}, e.form.value[0]), {}, {
                  name: t
                });
              }
            }]), s;
          }(n(3118).n);
          (0, c.Z)(l, "remediationName", "reenroll-authenticator");
        },
        8490: function _(e, t, n) {
          "use strict";

          n.d(t, {
            O: function O() {
              return s;
            }
          });
          var r = n(5671),
            o = n(3144),
            i = n(136),
            a = n(2963),
            u = n(1120),
            c = n(4942);
          var s = function (e) {
            (0, i.Z)(s, e);
            var t,
              n,
              c = (t = s, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, u.Z)(t);
                if (n) {
                  var o = (0, u.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, a.Z)(this, e);
              });
            function s() {
              return (0, r.Z)(this, s), c.apply(this, arguments);
            }
            return (0, o.Z)(s, [{
              key: "canRemediate",
              value: function value() {
                return !1;
              }
            }, {
              key: "getNextStep",
              value: function value() {
                var e = this.remediation;
                return {
                  name: e.name,
                  type: e.type,
                  idp: e.idp,
                  href: e.href
                };
              }
            }]), s;
          }(n(3118).n);
          (0, c.Z)(s, "remediationName", "redirect-idp");
        },
        1019: function _(e, t, n) {
          "use strict";

          n.d(t, {
            G: function G() {
              return s;
            }
          });
          var r = n(3144),
            o = n(5671),
            i = n(136),
            a = n(2963),
            u = n(1120),
            c = n(4942);
          var s = function (e) {
            (0, i.Z)(s, e);
            var t,
              n,
              c = (t = s, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, u.Z)(t);
                if (n) {
                  var o = (0, u.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, a.Z)(this, e);
              });
            function s() {
              return (0, o.Z)(this, s), c.apply(this, arguments);
            }
            return (0, r.Z)(s);
          }(n(9883).Q);
          (0, c.Z)(s, "remediationName", "reset-authenticator");
        },
        7311: function _(e, t, n) {
          "use strict";

          n.d(t, {
            X: function X() {
              return h;
            }
          });
          var r = n(2982),
            o = n(3144),
            i = n(5671),
            a = n(136),
            u = n(2963),
            c = n(1120),
            s = n(4942),
            f = n(9164),
            l = n(6064),
            p = n(7595);
          var h = function (e) {
            (0, a.Z)(f, e);
            var t,
              n,
              s = (t = f, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, c.Z)(t);
                if (n) {
                  var o = (0, c.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, u.Z)(this, e);
              });
            function f(e) {
              var t,
                n,
                o = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                a = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
              (0, i.Z)(this, f);
              var u = "recoverPassword" === (n = s.call(this, e, o, a)).options.flow;
              return (null === (t = (0, l.zg)(e).options) || void 0 === t ? void 0 : t.some(function (e) {
                var t = e.relatesTo;
                return (null == t ? void 0 : t.key) === p.pc.OKTA_PASSWORD;
              })) && (u || n.values.password) && (n.values.authenticators = [].concat((0, r.Z)(n.values.authenticators || []), [{
                key: p.pc.OKTA_PASSWORD
              }])), n;
            }
            return (0, o.Z)(f);
          }(f.n);
          (0, s.Z)(h, "remediationName", "select-authenticator-authenticate");
        },
        9865: function _(e, t, n) {
          "use strict";

          n.d(t, {
            j: function j() {
              return s;
            }
          });
          var r = n(3144),
            o = n(5671),
            i = n(136),
            a = n(2963),
            u = n(1120),
            c = n(4942);
          var s = function (e) {
            (0, i.Z)(s, e);
            var t,
              n,
              c = (t = s, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, u.Z)(t);
                if (n) {
                  var o = (0, u.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, a.Z)(this, e);
              });
            function s() {
              return (0, o.Z)(this, s), c.apply(this, arguments);
            }
            return (0, r.Z)(s);
          }(n(9164).n);
          (0, c.Z)(s, "remediationName", "select-authenticator-enroll");
        },
        5272: function _(e, t, n) {
          "use strict";

          n.d(t, {
            G: function G() {
              return h;
            }
          });
          var r = n(5671),
            o = n(3144),
            i = n(7326),
            a = n(1752),
            u = n(136),
            c = n(2963),
            s = n(1120),
            f = n(4942);
          function l(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function p(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? l(Object(n), !0).forEach(function (t) {
                (0, f.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          var h = function (e) {
            (0, u.Z)(h, e);
            var t,
              n,
              l = (t = h, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, s.Z)(t);
                if (n) {
                  var o = (0, s.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, c.Z)(this, e);
              });
            function h() {
              var e;
              (0, r.Z)(this, h);
              for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++) n[o] = arguments[o];
              return e = l.call.apply(l, [this].concat(n)), (0, f.Z)((0, i.Z)(e), "authenticator", void 0), (0, f.Z)((0, i.Z)(e), "map", {
                identifier: ["username"]
              }), e;
            }
            return (0, o.Z)(h, [{
              key: "canRemediate",
              value: function value() {
                return !!this.getData("identifier") && (0, a.Z)((0, s.Z)(h.prototype), "canRemediate", this).call(this);
              }
            }, {
              key: "mapAuthenticator",
              value: function value(e) {
                var t,
                  n,
                  r,
                  o = (0, a.Z)((0, s.Z)(h.prototype), "mapAuthenticator", this).call(this, e),
                  i = null === (t = this.selectedOption) || void 0 === t ? void 0 : t.value.form.value.find(function (e) {
                    return "methodType" === e.name;
                  }),
                  u = this.values.methodType || (null == i ? void 0 : i.value) || (null == i || null === (n = i.options) || void 0 === n || null === (r = n[0]) || void 0 === r ? void 0 : r.value);
                return u ? p(p({}, o), {}, {
                  methodType: u
                }) : o;
              }
            }, {
              key: "getInputUsername",
              value: function value() {
                return {
                  name: "username",
                  type: "string"
                };
              }
            }]), h;
          }(n(9164).n);
          (0, f.Z)(h, "remediationName", "select-authenticator-unlock-account");
        },
        4713: function _(e, t, n) {
          "use strict";

          n.d(t, {
            j: function j() {
              return s;
            }
          });
          var r = n(5671),
            o = n(3144),
            i = n(136),
            a = n(2963),
            u = n(1120),
            c = n(4942);
          var s = function (e) {
            (0, i.Z)(s, e);
            var t,
              n,
              c = (t = s, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, u.Z)(t);
                if (n) {
                  var o = (0, u.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, a.Z)(this, e);
              });
            function s() {
              return (0, r.Z)(this, s), c.apply(this, arguments);
            }
            return (0, o.Z)(s, [{
              key: "canRemediate",
              value: function value() {
                return !0;
              }
            }]), s;
          }(n(3118).n);
          (0, c.Z)(s, "remediationName", "select-enroll-profile");
        },
        3403: function _(e, t, n) {
          "use strict";

          n.d(t, {
            V: function V() {
              return p;
            }
          });
          var r = n(5671),
            o = n(3144),
            i = n(1752),
            a = n(136),
            u = n(2963),
            c = n(1120),
            s = n(4942);
          function f(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function l(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? f(Object(n), !0).forEach(function (t) {
                (0, s.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          var p = function (e) {
            (0, a.Z)(p, e);
            var t,
              n,
              f = (t = p, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, c.Z)(t);
                if (n) {
                  var o = (0, c.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, u.Z)(this, e);
              });
            function p() {
              return (0, r.Z)(this, p), f.apply(this, arguments);
            }
            return (0, o.Z)(p, [{
              key: "canRemediate",
              value: function value() {
                if (this.values.channel) return !0;
                if (this.values.authenticator) {
                  var e = this.values.authenticator,
                    t = e.id,
                    n = e.channel;
                  if (t && n) return !0;
                }
                return !1;
              }
            }, {
              key: "getNextStep",
              value: function value(e, t) {
                var n = (0, i.Z)((0, c.Z)(p.prototype), "getNextStep", this).call(this, e, t),
                  r = t.currentAuthenticator.value;
                return l(l({}, n), {}, {
                  authenticator: r
                });
              }
            }, {
              key: "getData",
              value: function value() {
                var e;
                return {
                  authenticator: {
                    id: this.remediation.value[0].value.form.value[0].value,
                    channel: (null === (e = this.values.authenticator) || void 0 === e ? void 0 : e.channel) || this.values.channel
                  },
                  stateHandle: this.values.stateHandle
                };
              }
            }, {
              key: "getValuesAfterProceed",
              value: function value() {
                var e = this;
                this.values = (0, i.Z)((0, c.Z)(p.prototype), "getValuesAfterProceed", this).call(this), delete this.values.authenticators;
                var t = this.values.channel ? "channel" : "authenticator";
                return Object.keys(this.values).filter(function (e) {
                  return e !== t;
                }).reduce(function (t, n) {
                  return l(l({}, t), {}, (0, s.Z)({}, n, e.values[n]));
                }, {});
              }
            }]), p;
          }(n(3118).n);
          (0, s.Z)(p, "remediationName", "select-enrollment-channel");
        },
        8443: function _(e, t, n) {
          "use strict";

          n.d(t, {
            h: function h() {
              return s;
            }
          });
          var r = n(5671),
            o = n(3144),
            i = n(136),
            a = n(2963),
            u = n(1120),
            c = n(4942);
          var s = function (e) {
            (0, i.Z)(s, e);
            var t,
              n,
              c = (t = s, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, u.Z)(t);
                if (n) {
                  var o = (0, u.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, a.Z)(this, e);
              });
            function s() {
              return (0, r.Z)(this, s), c.apply(this, arguments);
            }
            return (0, o.Z)(s, [{
              key: "canRemediate",
              value: function value() {
                return !!this.values.skip || "skip" === this.options.step;
              }
            }]), s;
          }(n(3118).n);
          (0, c.Z)(s, "remediationName", "skip");
        },
        6064: function _(e, t, n) {
          "use strict";

          function r(e) {
            var t;
            return null === (t = e.value) || void 0 === t ? void 0 : t.map(function (e) {
              return e.name;
            });
          }
          function o(e) {
            var t;
            return null === (t = e.value) || void 0 === t ? void 0 : t.reduce(function (e, t) {
              return t.required && e.push(t.name), e;
            }, []);
          }
          function i(e) {
            return e.charAt(0).toUpperCase() + e.substring(1);
          }
          function a(e) {
            return e.value.find(function (e) {
              return "authenticator" === e.name;
            });
          }
          n.d(t, {
            QG: function QG() {
              return o;
            },
            Qs: function Qs() {
              return i;
            },
            ix: function ix() {
              return r;
            },
            zg: function zg() {
              return a;
            }
          });
        },
        5832: function _(e, t, n) {
          "use strict";

          n.d(t, {
            K: function K() {
              return Re;
            }
          });
          var r = {};
          n.r(r), n.d(r, {
            AuthenticatorEnrollmentData: function AuthenticatorEnrollmentData() {
              return D.q;
            },
            AuthenticatorVerificationData: function AuthenticatorVerificationData() {
              return C.q;
            },
            ChallengeAuthenticator: function ChallengeAuthenticator() {
              return O.J;
            },
            ChallengePoll: function ChallengePoll() {
              return T.U;
            },
            EnrollAuthenticator: function EnrollAuthenticator() {
              return m.q;
            },
            EnrollPoll: function EnrollPoll() {
              return b.T;
            },
            EnrollProfile: function EnrollProfile() {
              return E.w;
            },
            EnrollmentChannelData: function EnrollmentChannelData() {
              return w.t;
            },
            GenericRemediator: function GenericRemediator() {
              return V;
            },
            Identify: function Identify() {
              return S.h;
            },
            ReEnrollAuthenticator: function ReEnrollAuthenticator() {
              return x.j;
            },
            RedirectIdp: function RedirectIdp() {
              return P.O;
            },
            Remediator: function Remediator() {
              return g.n;
            },
            ResetAuthenticator: function ResetAuthenticator() {
              return Z.G;
            },
            SelectAuthenticatorAuthenticate: function SelectAuthenticatorAuthenticate() {
              return A.X;
            },
            SelectAuthenticatorEnroll: function SelectAuthenticatorEnroll() {
              return _.j;
            },
            SelectAuthenticatorUnlockAccount: function SelectAuthenticatorUnlockAccount() {
              return R.G;
            },
            SelectEnrollProfile: function SelectEnrollProfile() {
              return j.j;
            },
            SelectEnrollmentChannel: function SelectEnrollmentChannel() {
              return k.V;
            },
            Skip: function Skip() {
              return I.h;
            }
          });
          var o = n(5861),
            i = n(4942),
            a = n(4687),
            u = n.n(a),
            c = n(6131),
            s = n(2660),
            f = n(1002),
            l = n(2982),
            p = n(9123),
            h = n(4925),
            d = n(885),
            v = n(8750),
            y = n(146),
            g = n(3118),
            m = n(3857),
            b = n(2288),
            k = n(3403),
            w = n(3679),
            O = n(4560),
            T = n(1104),
            Z = n(1019),
            E = n(7522),
            S = n(8628),
            x = n(9024),
            P = n(8490),
            A = n(7311),
            _ = n(9865),
            R = n(5272),
            j = n(4713),
            C = n(5278),
            D = n(2541),
            I = n(8443),
            N = n(5671),
            M = n(3144),
            U = n(136),
            L = n(2963),
            F = n(1120);
          function B(e) {
            if (Array.isArray(e)) return e.map(function (e) {
              return "string" == typeof e || "number" == typeof e || "boolean" == typeof e ? e : B(e);
            });
            for (var t = {}, n = 0, r = Object.entries(e); n < r.length; n++) {
              var o = (0, d.Z)(r[n], 2),
                i = o[0],
                a = o[1];
              if (null != a) if ("object" === (0, f.Z)(a)) {
                var u = Object.keys(a);
                if (["value", "form"].includes(i) && 1 === u.length && ["value", "form"].includes(u[0])) {
                  var c = B(a);
                  Object.entries(c).forEach(function (e) {
                    var n = (0, d.Z)(e, 2),
                      r = n[0],
                      o = n[1];
                    t[r] = o;
                  });
                } else t[i] = B(a);
              } else t[i] = a;
            }
            return t;
          }
          var H = ["href", "method", "rel", "accepts", "produces", "value", "action"];
          function K(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function G(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? K(Object(n), !0).forEach(function (t) {
                (0, i.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : K(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          var V = function (e) {
              (0, U.Z)(i, e);
              var t,
                n,
                r = (t = i, n = function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                  } catch (e) {
                    return !1;
                  }
                }(), function () {
                  var e,
                    r = (0, F.Z)(t);
                  if (n) {
                    var o = (0, F.Z)(this).constructor;
                    e = Reflect.construct(r, arguments, o);
                  } else e = r.apply(this, arguments);
                  return (0, L.Z)(this, e);
                });
              function i() {
                return (0, N.Z)(this, i), r.apply(this, arguments);
              }
              return (0, M.Z)(i, [{
                key: "canRemediate",
                value: function value() {
                  return !("function" != typeof this.remediation.action || "poll" !== this.remediation.name && !this.remediation.name.endsWith("-poll") && !this.options.step);
                }
              }, {
                key: "getData",
                value: function value() {
                  var e = this;
                  return this.getInputs().reduce(function (t, n) {
                    var r = n.name;
                    return t[r] = e.values[r], t;
                  }, {});
                }
              }, {
                key: "getNextStep",
                value: function value(e, t) {
                  var n,
                    r = this.getName(),
                    i = this.getInputs(),
                    a = this.remediation,
                    c = (a.href, a.method, a.rel, a.accepts, a.produces, a.value, a.action),
                    s = (0, h.Z)(a, H);
                  return c ? G(G(G({}, s), !!i.length && {
                    inputs: i
                  }), {}, {
                    action: (n = (0, o.Z)(u().mark(function t(n) {
                      return u().wrap(function (t) {
                        for (;;) switch (t.prev = t.next) {
                          case 0:
                            return t.abrupt("return", e.idx.proceed(G({
                              step: r
                            }, n)));
                          case 1:
                          case "end":
                            return t.stop();
                        }
                      }, t);
                    })), function (e) {
                      return n.apply(this, arguments);
                    })
                  }) : G({}, this.remediation);
                }
              }, {
                key: "getInputs",
                value: function value() {
                  return (this.remediation.value || []).filter(function (e) {
                    return "stateHandle" !== e.name;
                  }).map(B).map(function (e) {
                    return e.type = e.type || "string", e;
                  });
                }
              }]), i;
            }(g.n),
            q = n(7595),
            Y = ["href", "method", "rel", "accepts", "produces"];
          function W(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function Q(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? W(Object(n), !0).forEach(function (t) {
                (0, i.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : W(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          function z(e, t) {
            var _n9 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
            if (!_n9) {
              if (Array.isArray(e) || (_n9 = function (e, t) {
                if (e) {
                  if ("string" == typeof e) return X(e, t);
                  var n = Object.prototype.toString.call(e).slice(8, -1);
                  return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? X(e, t) : void 0;
                }
              }(e)) || t && e && "number" == typeof e.length) {
                _n9 && (e = _n9);
                var r = 0,
                  o = function o() {};
                return {
                  s: o,
                  n: function n() {
                    return r >= e.length ? {
                      done: !0
                    } : {
                      done: !1,
                      value: e[r++]
                    };
                  },
                  e: function e(_e18) {
                    throw _e18;
                  },
                  f: o
                };
              }
              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var i,
              a = !0,
              u = !1;
            return {
              s: function s() {
                _n9 = _n9.call(e);
              },
              n: function n() {
                var e = _n9.next();
                return a = e.done, e;
              },
              e: function e(_e19) {
                u = !0, i = _e19;
              },
              f: function f() {
                try {
                  a || null == _n9["return"] || _n9["return"]();
                } finally {
                  if (u) throw i;
                }
              }
            };
          }
          function X(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
            return r;
          }
          function $(e) {
            var t = e.neededToProceed,
              n = e.interactionCode;
            return !t.length && !n;
          }
          function J(e) {
            if (e && Array.isArray(e)) return e.reduce(function (e, t) {
              if (t.messages && (e = [].concat((0, l.Z)(e), (0, l.Z)(t.messages.value))), t.form) {
                var n = J(t.form.value) || [];
                e = [].concat((0, l.Z)(e), (0, l.Z)(n));
              }
              if (t.options) {
                var r = [];
                t.options.forEach(function (e) {
                  e.value && "string" != typeof e.value && (r = [].concat((0, l.Z)(r), [e.value]));
                });
                var o = J(r) || [];
                e = [].concat((0, l.Z)(e), (0, l.Z)(o));
              }
              return e;
            }, []);
          }
          function ee(e, t) {
            var n,
              r = [],
              o = e.rawIdxState,
              i = e.neededToProceed,
              a = null === (n = o.messages) || void 0 === n ? void 0 : n.value.map(function (e) {
                return e;
              });
            if (a && (r = [].concat((0, l.Z)(r), (0, l.Z)(a))), !t.useGenericRemediator) {
              var u,
                c = z(i);
              try {
                for (c.s(); !(u = c.n()).done;) {
                  var s = J(u.value.value);
                  s && (r = [].concat((0, l.Z)(r), (0, l.Z)(s)));
                }
              } catch (e) {
                c.e(e);
              } finally {
                c.f();
              }
            }
            var f = {};
            return r.reduce(function (e, t) {
              var n,
                r = null === (n = t.i18n) || void 0 === n ? void 0 : n.key;
              return r && f[r] && t.message === f[r].message ? e : (f[r] = t, e = [].concat((0, l.Z)(e), [t]));
            }, []);
          }
          function te(e) {
            var t = [],
              n = e.actions,
              r = e.neededToProceed;
            return n["currentAuthenticator-recover"] && t.push(q.Fw.PASSWORD_RECOVERY), r.some(function (e) {
              return "select-enroll-profile" === e.name;
            }) && t.push(q.Fw.REGISTRATION), r.some(function (e) {
              return "redirect-idp" === e.name;
            }) && t.push(q.Fw.SOCIAL_IDP), r.some(function (e) {
              return "unlock-account" === e.name;
            }) && t.push(q.Fw.ACCOUNT_UNLOCK), t;
          }
          function ne(e, t, n) {
            var i,
              a = [],
              c = Object.values(r).reduce(function (e, t) {
                return t.remediationName && (e[t.remediationName] = t), e;
              }, {}),
              s = z(t.neededToProceed);
            try {
              for (s.s(); !(i = s.n()).done;) {
                var f = i.value,
                  l = oe(f, {
                    useGenericRemediator: n,
                    remediators: c
                  });
                if (l) {
                  var p = new l(f);
                  a.push(p.getNextStep(e, t.context));
                }
              }
            } catch (e) {
              s.e(e);
            } finally {
              s.f();
            }
            for (var y = function y() {
                var n,
                  r = (0, d.Z)(m[g], 1)[0],
                  i = {
                    name: r,
                    action: (n = (0, o.Z)(u().mark(function t(n) {
                      return u().wrap(function (t) {
                        for (;;) switch (t.prev = t.next) {
                          case 0:
                            return t.abrupt("return", e.idx.proceed({
                              actions: [{
                                name: r,
                                params: n
                              }]
                            }));
                          case 1:
                          case "end":
                            return t.stop();
                        }
                      }, t);
                    })), function (e) {
                      return n.apply(this, arguments);
                    })
                  };
                if (r.startsWith("currentAuthenticator")) {
                  var c,
                    s = (0, v.YQ)(r, "-"),
                    f = (0, d.Z)(s, 2),
                    l = f[0],
                    p = f[1],
                    y = t.rawIdxState[l].value[p],
                    b = (y.href, y.method, y.rel, y.accepts, y.produces, (0, h.Z)(y, Y)),
                    k = null === (c = y.value) || void 0 === c ? void 0 : c.filter(function (e) {
                      return "stateHandle" !== e.name;
                    });
                  i = Q(Q(Q({}, b), k && {
                    value: k
                  }), i);
                }
                a.push(i);
              }, g = 0, m = Object.entries(t.actions || {}); g < m.length; g++) y();
            return a;
          }
          function re(e, t, n) {
            var r = (e.neededToProceed || []).find(function (e) {
              return e.name === t;
            });
            return r ? r.value.reduce(function (e, t) {
              var r = t.name,
                o = t.value;
              return e[r] = "stateHandle" === r ? o : n[r], e;
            }, {}) : ((0, y.ZK)('filterValuesForRemediation: "'.concat(t, '" did not match any remediations')), n);
          }
          function oe(e, t) {
            var n = t.useGenericRemediator,
              r = t.remediators;
            if (e) return n ? V : r[e.name];
          }
          function ie(e, t, n) {
            var r,
              o = n.remediators,
              i = n.useGenericRemediator,
              a = e.neededToProceed,
              u = e.context;
            if (!n.step) {
              var c = [];
              if (i) c.push(new V(a[0], t, n));else {
                var s,
                  f = z(a);
                try {
                  for (f.s(); !(s = f.n()).done;) {
                    var l = s.value;
                    if (Object.keys(o).includes(l.name)) {
                      if ((r = new (oe(l, n))(l, t, n)).canRemediate(u)) return r;
                      c.push(r);
                    }
                  }
                } catch (e) {
                  f.e(e);
                } finally {
                  f.f();
                }
              }
              return c[0];
            }
            var p = a.find(function (e) {
              return e.name === n.step;
            });
            if (p) {
              var h = oe(p, n);
              return h ? new h(p, t, n) : void 0;
            }
            (0, y.ZK)('step "'.concat(n.step, '" did not match any remediations'));
          }
          function ae(e, t, n) {
            var r = t.getNextStep(e, n.context),
              o = function (e) {
                return e.neededToProceed.some(function (e) {
                  return "skip" === e.name;
                });
              }(n),
              i = function (e) {
                return Object.keys(e.actions).some(function (e) {
                  return e.includes("resend");
                });
              }(n);
            return Q(Q(Q({}, r), o && {
              canSkip: o
            }), i && {
              canResend: i
            });
          }
          function ue(e, t) {
            var n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
              r = $(t),
              o = ee(t, n);
            if (r) return {
              idxResponse: t,
              terminal: r,
              messages: o
            };
            var i = ie(t, {}, n),
              a = i && ae(e, i, t);
            return Q({
              idxResponse: t,
              messages: o
            }, a && {
              nextStep: a
            });
          }
          function ce(e, t) {
            var _n10 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
            if (!_n10) {
              if (Array.isArray(e) || (_n10 = function (e, t) {
                if (e) {
                  if ("string" == typeof e) return se(e, t);
                  var n = Object.prototype.toString.call(e).slice(8, -1);
                  return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? se(e, t) : void 0;
                }
              }(e)) || t && e && "number" == typeof e.length) {
                _n10 && (e = _n10);
                var r = 0,
                  o = function o() {};
                return {
                  s: o,
                  n: function n() {
                    return r >= e.length ? {
                      done: !0
                    } : {
                      done: !1,
                      value: e[r++]
                    };
                  },
                  e: function e(_e20) {
                    throw _e20;
                  },
                  f: o
                };
              }
              throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }
            var i,
              a = !0,
              u = !1;
            return {
              s: function s() {
                _n10 = _n10.call(e);
              },
              n: function n() {
                var e = _n10.next();
                return a = e.done, e;
              },
              e: function e(_e21) {
                u = !0, i = _e21;
              },
              f: function f() {
                try {
                  a || null == _n10["return"] || _n10["return"]();
                } finally {
                  if (u) throw i;
                }
              }
            };
          }
          function se(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
            return r;
          }
          function fe(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function le(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? fe(Object(n), !0).forEach(function (t) {
                (0, i.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : fe(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          function pe(e, t) {
            return Object.keys(t.actions).find(function (t) {
              return !!e.resend && t.includes("-resend");
            });
          }
          function he(e) {
            return le(le({}, e), {}, {
              resend: void 0
            });
          }
          function de(e, t) {
            var n = e.actions || [];
            return n = n.filter(function (e) {
              return "string" == typeof e ? e !== t : e.name !== t;
            }), le(le({}, e), {}, {
              actions: n
            });
          }
          function ve(e, t, n, r) {
            return ye.apply(this, arguments);
          }
          function ye() {
            return (ye = (0, o.Z)(u().mark(function e(t, n, r, o) {
              var i, a, c, s, h, d, v, y, g, m, b, k, w, O, T, Z, E, S;
              return u().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if (a = (i = n).neededToProceed, c = i.interactionCode, s = o.flow, !c) {
                      e.next = 4;
                      break;
                    }
                    return e.abrupt("return", {
                      idxResponse: n
                    });
                  case 4:
                    if (h = ie(n, r, o), d = pe(r, n), v = o.actions || [], !(y = [].concat((0, l.Z)(v), (0, l.Z)(d && [d] || [])))) {
                      e.next = 28;
                      break;
                    }
                    g = ce(y), e.prev = 10, b = u().mark(function e() {
                      var i, c, s, f;
                      return u().wrap(function (e) {
                        for (;;) switch (e.prev = e.next) {
                          case 0:
                            if (i = m.value, c = {}, "string" != typeof i && (c = i.params || {}, i = i.name), s = he(r), f = de(o, i), "function" != typeof n.actions[i]) {
                              e.next = 14;
                              break;
                            }
                            return e.next = 8, n.actions[i](c);
                          case 8:
                            if (!1 !== (n = e.sent).requestDidSucceed) {
                              e.next = 11;
                              break;
                            }
                            return e.abrupt("return", {
                              v: ue(t, n, o)
                            });
                          case 11:
                            if ("cancel" !== i) {
                              e.next = 13;
                              break;
                            }
                            return e.abrupt("return", {
                              v: {
                                idxResponse: n,
                                canceled: !0
                              }
                            });
                          case 13:
                            return e.abrupt("return", {
                              v: ve(t, n, s, f)
                            });
                          case 14:
                            if (!a.find(function (e) {
                              return e.name === i;
                            })) {
                              e.next = 22;
                              break;
                            }
                            return e.next = 18, n.proceed(i, c);
                          case 18:
                            if (!1 !== (n = e.sent).requestDidSucceed) {
                              e.next = 21;
                              break;
                            }
                            return e.abrupt("return", {
                              v: ue(t, n, o)
                            });
                          case 21:
                            return e.abrupt("return", {
                              v: ve(t, n, r, f)
                            });
                          case 22:
                          case "end":
                            return e.stop();
                        }
                      }, e);
                    }), g.s();
                  case 13:
                    if ((m = g.n()).done) {
                      e.next = 20;
                      break;
                    }
                    return e.delegateYield(b(), "t0", 15);
                  case 15:
                    if (k = e.t0, "object" !== (0, f.Z)(k)) {
                      e.next = 18;
                      break;
                    }
                    return e.abrupt("return", k.v);
                  case 18:
                    e.next = 13;
                    break;
                  case 20:
                    e.next = 25;
                    break;
                  case 22:
                    e.prev = 22, e.t1 = e["catch"](10), g.e(e.t1);
                  case 25:
                    return e.prev = 25, g.f(), e.finish(25);
                  case 28:
                    if (!(w = $(n))) {
                      e.next = 31;
                      break;
                    }
                    return e.abrupt("return", {
                      idxResponse: n,
                      terminal: w
                    });
                  case 31:
                    if (h) {
                      e.next = 43;
                      break;
                    }
                    if (!o.step) {
                      e.next = 40;
                      break;
                    }
                    return r = re(n, o.step, r), e.next = 36, n.proceed(o.step, r);
                  case 36:
                    if (!1 !== (n = e.sent).requestDidSucceed) {
                      e.next = 39;
                      break;
                    }
                    return e.abrupt("return", ue(t, n, o));
                  case 39:
                    return e.abrupt("return", {
                      idxResponse: n
                    });
                  case 40:
                    if ("default" !== s) {
                      e.next = 42;
                      break;
                    }
                    return e.abrupt("return", {
                      idxResponse: n
                    });
                  case 42:
                    throw new p.Z("\n      No remediation can match current flow, check policy settings in your org.\n      Remediations: [".concat(a.reduce(function (e, t) {
                      return e ? e + " ," + t.name : t.name;
                    }, ""), "]\n    "));
                  case 43:
                    if (h.canRemediate()) {
                      e.next = 46;
                      break;
                    }
                    return O = ae(t, h, n), e.abrupt("return", {
                      idxResponse: n,
                      nextStep: O
                    });
                  case 46:
                    return T = h.getName(), Z = h.getData(), e.next = 50, n.proceed(T, Z);
                  case 50:
                    if (!1 !== (n = e.sent).requestDidSucceed) {
                      e.next = 53;
                      break;
                    }
                    return e.abrupt("return", ue(t, n, o));
                  case 53:
                    if (r = h.getValuesAfterProceed(), !(o = le(le({}, o), {}, {
                      step: void 0
                    })).useGenericRemediator || n.interactionCode || $(n)) {
                      e.next = 59;
                      break;
                    }
                    return E = ie(n, r, o), S = ae(t, E, n), e.abrupt("return", {
                      idxResponse: n,
                      nextStep: S
                    });
                  case 59:
                    return e.abrupt("return", ve(t, n, r, o));
                  case 60:
                  case "end":
                    return e.stop();
                }
              }, e, null, [[10, 22, 25, 28]]);
            }))).apply(this, arguments);
          }
          var ge = n(7738),
            me = n(2620);
          function be(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function ke(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? be(Object(n), !0).forEach(function (t) {
                (0, i.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : be(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          function we(e) {
            var t = ke({}, e);
            return ["flow", "remediators", "actions", "withCredentials", "step", "useGenericRemediator", "exchangeCodeForTokens"].forEach(function (e) {
              delete t[e];
            }), t;
          }
          function Oe(e, t) {
            var n = t.options,
              r = n = ke(ke({}, e.options.idx), n),
              o = r.flow,
              i = r.withCredentials,
              a = r.remediators,
              u = r.actions,
              c = q.Qd.PENDING;
            if (o = o || e.idx.getFlow() || "default") {
              e.idx.setFlow(o);
              var s = (0, ge.s)(e, o);
              i = void 0 !== i ? i : s.withCredentials, a = a || s.remediators, u = u || s.actions;
            }
            return ke(ke({}, t), {}, {
              options: ke(ke({}, n), {}, {
                flow: o,
                withCredentials: i,
                remediators: a,
                actions: u
              }),
              status: c
            });
          }
          function Te(e, t) {
            return Ze.apply(this, arguments);
          }
          function Ze() {
            return (Ze = (0, o.Z)(u().mark(function e(t, n) {
              var r, o, i, a, f, l, p, h, d, v, y, g, m, b, k, w;
              return u().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if (r = n.options, o = r.stateHandle, i = r.withCredentials, a = r.version, f = r.state, l = r.scopes, p = r.recoveryToken, h = r.activationToken, d = r.maxAge, v = r.acrValues, y = r.nonce, m = (0, me.uN)(t, {
                      state: f,
                      recoveryToken: p,
                      activationToken: h
                    }), !o) {
                      e.next = 9;
                      break;
                    }
                    return e.next = 6, (0, s.L)(t, {
                      withCredentials: i,
                      version: a,
                      stateHandle: o
                    });
                  case 6:
                    g = e.sent, e.next = 20;
                    break;
                  case 9:
                    if (k = null === (b = m) || void 0 === b ? void 0 : b.interactionHandle) {
                      e.next = 17;
                      break;
                    }
                    return t.transactionManager.clear(), e.next = 14, (0, c.E)(t, {
                      withCredentials: i,
                      state: f,
                      scopes: l,
                      activationToken: h,
                      recoveryToken: p,
                      maxAge: d,
                      acrValues: v,
                      nonce: y
                    });
                  case 14:
                    w = e.sent, k = w.interactionHandle, m = w.meta;
                  case 17:
                    return e.next = 19, (0, s.L)(t, {
                      withCredentials: i,
                      version: a,
                      interactionHandle: k
                    });
                  case 19:
                    g = e.sent;
                  case 20:
                    return e.abrupt("return", ke(ke({}, n), {}, {
                      idxResponse: g,
                      meta: m
                    }));
                  case 21:
                  case "end":
                    return e.stop();
                }
              }, e);
            }))).apply(this, arguments);
          }
          function Ee(e, t) {
            return Se.apply(this, arguments);
          }
          function Se() {
            return (Se = (0, o.Z)(u().mark(function e(t, n) {
              var r, o, i, a, c, s, f, l, p, h, d, v, y;
              return u().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if (r = n.idxResponse, o = n.options, i = n.values, a = o.autoRemediate, c = o.remediators, s = o.actions, f = o.flow, l = o.step, p = o.useGenericRemediator, !1 !== a && (c || s || l)) {
                      e.next = 5;
                      break;
                    }
                    return e.abrupt("return", n);
                  case 5:
                    return i = ke(ke({}, i), {}, {
                      stateHandle: r.rawIdxState.stateHandle
                    }), e.next = 8, ve(t, r, i, {
                      remediators: c,
                      actions: s,
                      flow: f,
                      step: l,
                      useGenericRemediator: p
                    });
                  case 8:
                    return h = e.sent, d = h.idxResponse, v = h.nextStep, y = h.canceled, r = d, e.abrupt("return", ke(ke({}, n), {}, {
                      idxResponse: r,
                      nextStep: v,
                      canceled: y
                    }));
                  case 14:
                  case "end":
                    return e.stop();
                }
              }, e);
            }))).apply(this, arguments);
          }
          function xe(e, t) {
            return Pe.apply(this, arguments);
          }
          function Pe() {
            return (Pe = (0, o.Z)(u().mark(function e(t, n) {
              var r, o, i, a, c, s, f, l, p, h, d;
              return u().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return r = n.meta, o = n.idxResponse, i = o.interactionCode, c = (a = r).clientId, s = a.codeVerifier, f = a.ignoreSignature, l = a.redirectUri, p = a.urls, h = a.scopes, e.next = 5, t.token.exchangeCodeForTokens({
                      interactionCode: i,
                      clientId: c,
                      codeVerifier: s,
                      ignoreSignature: f,
                      redirectUri: l,
                      scopes: h
                    }, p);
                  case 5:
                    return d = e.sent, e.abrupt("return", d.tokens);
                  case 7:
                  case "end":
                    return e.stop();
                }
              }, e);
            }))).apply(this, arguments);
          }
          function Ae(e, t) {
            return _e.apply(this, arguments);
          }
          function _e() {
            return (_e = (0, o.Z)(u().mark(function e(t, n) {
              var r, o, i, a, c, s, f, l, p, h, d, v, y, g, m, b;
              return u().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if (r = n.options, o = n.idxResponse, i = n.canceled, a = n.status, c = r.exchangeCodeForTokens, s = !1, f = !1, l = !0, o && (s = !(!o.requestDidSucceed && !o.stepUp), d = te(o), v = ne(t, o, r.useGenericRemediator), y = ee(o, r), g = $(o)), !g) {
                      e.next = 15;
                      break;
                    }
                    a = q.Qd.TERMINAL, m = Object.keys(o.actions).length > 0, b = !!y.find(function (e) {
                      return "ERROR" === e["class"];
                    }), m || b || !0 !== o.requestDidSucceed ? s = !!m : f = !0, l = !1, e.next = 32;
                    break;
                  case 15:
                    if (!i) {
                      e.next = 20;
                      break;
                    }
                    a = q.Qd.CANCELED, f = !0, e.next = 32;
                    break;
                  case 20:
                    if (null == o || !o.interactionCode) {
                      e.next = 32;
                      break;
                    }
                    if (p = o.interactionCode, !1 !== c) {
                      e.next = 27;
                      break;
                    }
                    a = q.Qd.SUCCESS, f = !1, e.next = 32;
                    break;
                  case 27:
                    return e.next = 29, xe(t, n);
                  case 29:
                    h = e.sent, a = q.Qd.SUCCESS, f = !0;
                  case 32:
                    return e.abrupt("return", ke(ke({}, n), {}, {
                      status: a,
                      interactionCode: p,
                      tokens: h,
                      shouldSaveResponse: s,
                      shouldClearTransaction: f,
                      clearSharedStorage: l,
                      enabledFeatures: d,
                      availableSteps: v,
                      messages: y,
                      terminal: g
                    }));
                  case 33:
                  case "end":
                    return e.stop();
                }
              }, e);
            }))).apply(this, arguments);
          }
          function Re(e) {
            return je.apply(this, arguments);
          }
          function je() {
            return je = (0, o.Z)(u().mark(function e(t) {
              var n,
                r,
                o,
                i,
                a,
                c,
                s,
                f,
                l,
                p,
                h,
                d,
                v,
                y,
                g,
                m,
                b,
                k,
                w,
                O,
                T,
                Z,
                E,
                S,
                x,
                P,
                A,
                _,
                R = arguments;
              return u().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return r = {
                      options: n = R.length > 1 && void 0 !== R[1] ? R[1] : {},
                      values: we(n)
                    }, r = Oe(t, r), e.next = 5, Te(t, r);
                  case 5:
                    return r = e.sent, e.next = 8, Ee(t, r);
                  case 8:
                    return r = e.sent, e.next = 11, Ae(t, r);
                  case 11:
                    return r = e.sent, i = (o = r).idxResponse, a = o.meta, c = o.shouldSaveResponse, s = o.shouldClearTransaction, f = o.clearSharedStorage, l = o.status, p = o.enabledFeatures, h = o.availableSteps, d = o.tokens, v = o.nextStep, y = o.messages, g = o.error, m = o.interactionCode, s ? t.transactionManager.clear({
                      clearSharedStorage: f
                    }) : ((0, me.r0)(t, ke({}, a)), c && (w = (k = i).rawIdxState, O = k.requestDidSucceed, t.transactionManager.saveIdxResponse({
                      rawIdxResponse: w,
                      requestDidSucceed: O,
                      stateHandle: null === (b = i.context) || void 0 === b ? void 0 : b.stateHandle,
                      interactionHandle: null == a ? void 0 : a.interactionHandle
                    }))), Z = (T = i || {}).actions, E = T.context, S = T.neededToProceed, x = T.proceed, P = T.rawIdxState, A = T.requestDidSucceed, _ = T.stepUp, e.abrupt("return", ke(ke(ke(ke(ke(ke(ke(ke(ke({
                      status: l
                    }, a && {
                      meta: a
                    }), p && {
                      enabledFeatures: p
                    }), h && {
                      availableSteps: h
                    }), d && {
                      tokens: d
                    }), v && {
                      nextStep: v
                    }), y && y.length && {
                      messages: y
                    }), g && {
                      error: g
                    }), _ && {
                      stepUp: _
                    }), {}, {
                      interactionCode: m,
                      actions: Z,
                      context: E,
                      neededToProceed: S,
                      proceed: x,
                      rawIdxState: P,
                      requestDidSucceed: A
                    }));
                  case 16:
                  case "end":
                    return e.stop();
                }
              }, e);
            })), je.apply(this, arguments);
          }
        },
        2473: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Y: function Y() {
              return f;
            }
          });
          var r = n(4942),
            o = n(5861),
            i = n(4687),
            a = n.n(i),
            u = n(5832);
          function c(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function s(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? c(Object(n), !0).forEach(function (t) {
                (0, r.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          function f(e) {
            return l.apply(this, arguments);
          }
          function l() {
            return l = (0, o.Z)(a().mark(function e(t) {
              var n,
                r = arguments;
              return a().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return n = r.length > 1 && void 0 !== r[1] ? r[1] : {}, t.transactionManager.clear(), e.abrupt("return", (0, u.K)(t, s({
                      exchangeCodeForTokens: !1
                    }, n)));
                  case 3:
                  case "end":
                    return e.stop();
                }
              }, e);
            })), l.apply(this, arguments);
          }
        },
        4143: function _(e, t, n) {
          "use strict";

          n.d(t, {
            a: function a() {
              return d;
            }
          });
          var r = n(5671),
            o = n(3144),
            i = n(136),
            a = n(2963),
            u = n(1120),
            c = n(5763),
            s = n(1971),
            f = n(2647),
            l = n(415),
            p = n(146),
            h = n(9123);
          function d() {
            return function (e) {
              (0, i.Z)(d, e);
              var t,
                n,
                f = (t = d, n = function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                  } catch (e) {
                    return !1;
                  }
                }(), function () {
                  var e,
                    r = (0, u.Z)(t);
                  if (n) {
                    var o = (0, u.Z)(this).constructor;
                    e = Reflect.construct(r, arguments, o);
                  } else e = r.apply(this, arguments);
                  return (0, a.Z)(this, e);
                });
              function d(e, t, n) {
                return (0, r.Z)(this, d), f.call(this, e, t, n);
              }
              return (0, o.Z)(d, [{
                key: "getIdxResponseStorage",
                value: function value(e) {
                  var t;
                  if ((0, l.isBrowser)()) try {
                    t = this.storageUtil.getStorageByType("memory", e);
                  } catch (e) {
                    (0, p.ZK)("No response storage found, you may want to provide custom implementation for intermediate idx responses to optimize the network traffic");
                  } else {
                    var n = this.getTransactionStorage(e);
                    n && (t = {
                      getItem: function getItem(e) {
                        var t = n.getStorage();
                        return t && t[e] ? t[e] : null;
                      },
                      setItem: function setItem(e, t) {
                        var r = n.getStorage();
                        if (!r) throw new h.Z("Transaction has been cleared, failed to save idxState");
                        r[e] = t, n.setStorage(r);
                      },
                      removeItem: function removeItem(e) {
                        var t = n.getStorage();
                        t && (delete t[e], n.setStorage(t));
                      }
                    });
                  }
                  return t ? new c._(t, s.IDX_RESPONSE_STORAGE_NAME) : null;
                }
              }]), d;
            }((0, f.a)());
          }
        },
        2620: function _(e, t, n) {
          "use strict";

          n.d(t, {
            $0: function $0() {
              return d;
            },
            Co: function Co() {
              return y;
            },
            Jm: function Jm() {
              return b;
            },
            UC: function UC() {
              return O;
            },
            Wf: function Wf() {
              return k;
            },
            Xc: function Xc() {
              return p;
            },
            bl: function bl() {
              return w;
            },
            r0: function r0() {
              return m;
            },
            uN: function uN() {
              return v;
            }
          });
          var r = n(4942),
            o = n(5861),
            i = n(4687),
            a = n.n(i),
            u = n(3193),
            c = n(146),
            s = n(2865);
          function f(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function l(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? f(Object(n), !0).forEach(function (t) {
                (0, r.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : f(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          function p(e) {
            return h.apply(this, arguments);
          }
          function h() {
            return h = (0, o.Z)(a().mark(function e(t) {
              var n,
                r,
                o,
                i,
                u,
                c,
                f,
                p,
                h,
                d,
                v,
                y,
                g,
                m,
                b,
                k,
                w,
                O = arguments;
              return a().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return n = O.length > 1 && void 0 !== O[1] ? O[1] : {}, e.next = 3, t.token.prepareTokenParams(n);
                  case 3:
                    return r = e.sent, o = (0, s.H)(t, r), i = l(l({}, t.options), n), u = i.flow, c = void 0 === u ? "default" : u, f = i.withCredentials, p = void 0 === f || f, h = i.activationToken, d = void 0 === h ? void 0 : h, v = i.recoveryToken, y = void 0 === v ? void 0 : v, g = i.maxAge, m = void 0 === g ? void 0 : g, b = i.acrValues, k = void 0 === b ? void 0 : b, w = l(l({}, o), {}, {
                      flow: c,
                      withCredentials: p,
                      activationToken: d,
                      recoveryToken: y,
                      maxAge: m,
                      acrValues: k
                    }), e.abrupt("return", w);
                  case 8:
                  case "end":
                    return e.stop();
                }
              }, e);
            })), h.apply(this, arguments);
          }
          function d(e, t) {
            var n = v(e, t);
            return !(null == n || !n.interactionHandle);
          }
          function v(e, t) {
            var n;
            t = (0, u.YY)(t), t = l(l({}, e.options), t);
            try {
              n = e.transactionManager.load(t);
            } catch (e) {}
            if (n) return k(n, t) ? n : void (0, c.ZK)("Saved transaction meta does not match the current configuration. This may indicate that two apps are sharing a storage key.");
          }
          function y(e, t) {
            return g.apply(this, arguments);
          }
          function g() {
            return (g = (0, o.Z)(a().mark(function e(t, n) {
              var r;
              return a().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if (n = (0, u.YY)(n), n = l(l({}, t.options), n), !(r = v(t, n))) {
                      e.next = 5;
                      break;
                    }
                    return e.abrupt("return", r);
                  case 5:
                    return e.abrupt("return", p(t, n));
                  case 6:
                  case "end":
                    return e.stop();
                }
              }, e);
            }))).apply(this, arguments);
          }
          function m(e, t) {
            e.transactionManager.save(t, {
              muteWarning: !0
            });
          }
          function b(e) {
            e.transactionManager.clear();
          }
          function k(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return !1 !== O(e, t, ["issuer", "clientId", "redirectUri", "state", "codeChallenge", "codeChallengeMethod", "activationToken", "recoveryToken"]) && !1 !== w(e, t.flow);
          }
          function w(e, t) {
            return !(t && "default" !== t && "proceed" !== t) || t === e.flow;
          }
          function O(e, t, n) {
            return !n.some(function (n) {
              var r = t[n];
              if (r && r !== e[n]) return !0;
            });
          }
        },
        7595: function _(e, t, n) {
          "use strict";

          var r, o, i;
          function a(e) {
            return e && (e.key || e.id);
          }
          n.d(t, {
            Fw: function Fw() {
              return i;
            },
            H: function H() {
              return a;
            },
            Qd: function Qd() {
              return r;
            },
            pc: function pc() {
              return o;
            }
          }), function (e) {
            e.SUCCESS = "SUCCESS", e.PENDING = "PENDING", e.FAILURE = "FAILURE", e.TERMINAL = "TERMINAL", e.CANCELED = "CANCELED";
          }(r || (r = {})), function (e) {
            e.OKTA_PASSWORD = "okta_password", e.OKTA_EMAIL = "okta_email", e.PHONE_NUMBER = "phone_number", e.GOOGLE_AUTHENTICATOR = "google_otp", e.SECURITY_QUESTION = "security_question", e.OKTA_VERIFY = "okta_verify", e.WEBAUTHN = "webauthn";
          }(o || (o = {})), function (e) {
            e.PASSWORD_RECOVERY = "recover-password", e.REGISTRATION = "enroll-profile", e.SOCIAL_IDP = "redirect-idp", e.ACCOUNT_UNLOCK = "unlock-account";
          }(i || (i = {}));
        },
        480: function _(e, t, n) {
          "use strict";

          function r(e) {
            return e && e.version;
          }
          n.d(t, {
            P: function P() {
              return r;
            }
          });
        },
        8277: function _(e, t, n) {
          "use strict";

          n.d(t, {
            l: function l() {
              return d;
            }
          });
          var r = n(4942),
            o = n(5861),
            i = n(4687),
            a = n.n(i),
            u = n(5832),
            c = n(2620),
            s = n(2473),
            f = n(9123),
            l = n(7595);
          function p(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function h(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? p(Object(n), !0).forEach(function (t) {
                (0, r.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          function d(e) {
            return v.apply(this, arguments);
          }
          function v() {
            return v = (0, o.Z)(a().mark(function e(t) {
              var n,
                r,
                o,
                i = arguments;
              return a().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if ((n = i.length > 1 && void 0 !== i[1] ? i[1] : {}).flow = "unlockAccount", (0, c.$0)(t)) {
                      e.next = 9;
                      break;
                    }
                    return e.next = 5, (0, s.Y)(t, h(h({}, n), {}, {
                      autoRemediate: !1
                    }));
                  case 5:
                    if (r = e.sent, !(o = r.enabledFeatures) || o.includes(l.Fw.ACCOUNT_UNLOCK)) {
                      e.next = 9;
                      break;
                    }
                    throw new f.Z("Self Service Account Unlock is not supported based on your current org configuration.");
                  case 9:
                    return e.abrupt("return", (0, u.K)(t, h({}, n)));
                  case 10:
                  case "end":
                    return e.stop();
                }
              }, e);
            })), v.apply(this, arguments);
          }
        },
        5878: function _(e, t, n) {
          "use strict";

          n.r(t), n.d(t, {
            addEmail: function addEmail() {
              return b;
            },
            addPhone: function addPhone() {
              return S;
            },
            deleteEmail: function deleteEmail() {
              return k;
            },
            deletePassword: function deletePassword() {
              return C;
            },
            deletePhone: function deletePhone() {
              return x;
            },
            enrollPassword: function enrollPassword() {
              return R;
            },
            getEmail: function getEmail() {
              return m;
            },
            getEmailChallenge: function getEmailChallenge() {
              return O;
            },
            getEmails: function getEmails() {
              return g;
            },
            getPassword: function getPassword() {
              return _;
            },
            getPhone: function getPhone() {
              return E;
            },
            getPhones: function getPhones() {
              return Z;
            },
            getProfile: function getProfile() {
              return d;
            },
            getProfileSchema: function getProfileSchema() {
              return y;
            },
            sendEmailChallenge: function sendEmailChallenge() {
              return w;
            },
            sendPhoneChallenge: function sendPhoneChallenge() {
              return P;
            },
            updatePassword: function updatePassword() {
              return j;
            },
            updateProfile: function updateProfile() {
              return v;
            },
            verifyEmailChallenge: function verifyEmailChallenge() {
              return T;
            },
            verifyPhoneChallenge: function verifyPhoneChallenge() {
              return A;
            }
          });
          var r,
            o,
            i,
            a,
            u,
            c,
            s,
            f = n(5861),
            l = n(4687),
            p = n.n(l),
            h = n(777),
            d = (r = (0, f.Z)(p().mark(function e(t, n) {
              var r;
              return p().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, (0, h.w)(t, {
                      url: "/idp/myaccount/profile",
                      method: "GET",
                      accessToken: null == n ? void 0 : n.accessToken,
                      transactionClassName: "ProfileTransaction"
                    });
                  case 2:
                    return r = e.sent, e.abrupt("return", r);
                  case 4:
                  case "end":
                    return e.stop();
                }
              }, e);
            })), function (e, t) {
              return r.apply(this, arguments);
            }),
            v = (o = (0, f.Z)(p().mark(function e(t, n) {
              var r, o, i, a;
              return p().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return o = (r = n).payload, i = r.accessToken, e.next = 3, (0, h.w)(t, {
                      url: "/idp/myaccount/profile",
                      method: "PUT",
                      payload: o,
                      accessToken: i,
                      transactionClassName: "ProfileTransaction"
                    });
                  case 3:
                    return a = e.sent, e.abrupt("return", a);
                  case 5:
                  case "end":
                    return e.stop();
                }
              }, e);
            })), function (e, t) {
              return o.apply(this, arguments);
            }),
            y = (i = (0, f.Z)(p().mark(function e(t, n) {
              var r;
              return p().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return e.next = 2, (0, h.w)(t, {
                      url: "/idp/myaccount/profile/schema",
                      method: "GET",
                      accessToken: null == n ? void 0 : n.accessToken,
                      transactionClassName: "ProfileSchemaTransaction"
                    });
                  case 2:
                    return r = e.sent, e.abrupt("return", r);
                  case 4:
                  case "end":
                    return e.stop();
                }
              }, e);
            })), function (e, t) {
              return i.apply(this, arguments);
            }),
            g = function () {
              var e = (0, f.Z)(p().mark(function e(t, n) {
                var r;
                return p().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return e.next = 2, (0, h.w)(t, {
                        url: "/idp/myaccount/emails",
                        method: "GET",
                        accessToken: null == n ? void 0 : n.accessToken,
                        transactionClassName: "EmailTransaction"
                      });
                    case 2:
                      return r = e.sent, e.abrupt("return", r);
                    case 4:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }));
              return function (t, n) {
                return e.apply(this, arguments);
              };
            }(),
            m = function () {
              var e = (0, f.Z)(p().mark(function e(t, n) {
                var r, o, i, a;
                return p().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return o = (r = n).id, i = r.accessToken, e.next = 3, (0, h.w)(t, {
                        url: "/idp/myaccount/emails/".concat(o),
                        method: "GET",
                        accessToken: i,
                        transactionClassName: "EmailTransaction"
                      });
                    case 3:
                      return a = e.sent, e.abrupt("return", a);
                    case 5:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }));
              return function (t, n) {
                return e.apply(this, arguments);
              };
            }(),
            b = function () {
              var e = (0, f.Z)(p().mark(function e(t, n) {
                var r, o, i, a;
                return p().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return o = (r = n).accessToken, i = r.payload, e.next = 3, (0, h.w)(t, {
                        url: "/idp/myaccount/emails",
                        method: "POST",
                        payload: i,
                        accessToken: o,
                        transactionClassName: "EmailTransaction"
                      });
                    case 3:
                      return a = e.sent, e.abrupt("return", a);
                    case 5:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }));
              return function (t, n) {
                return e.apply(this, arguments);
              };
            }(),
            k = (a = (0, f.Z)(p().mark(function e(t, n) {
              var r, o, i, a;
              return p().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return o = (r = n).id, i = r.accessToken, e.next = 3, (0, h.w)(t, {
                      url: "/idp/myaccount/emails/".concat(o),
                      method: "DELETE",
                      accessToken: i
                    });
                  case 3:
                    return a = e.sent, e.abrupt("return", a);
                  case 5:
                  case "end":
                    return e.stop();
                }
              }, e);
            })), function (e, t) {
              return a.apply(this, arguments);
            }),
            w = (u = (0, f.Z)(p().mark(function e(t, n) {
              var r, o, i, a;
              return p().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return o = (r = n).id, i = r.accessToken, e.next = 3, (0, h.w)(t, {
                      url: "/idp/myaccount/emails/".concat(o, "/challenge"),
                      method: "POST",
                      accessToken: i,
                      transactionClassName: "EmailChallengeTransaction"
                    });
                  case 3:
                    return a = e.sent, e.abrupt("return", a);
                  case 5:
                  case "end":
                    return e.stop();
                }
              }, e);
            })), function (e, t) {
              return u.apply(this, arguments);
            }),
            O = (c = (0, f.Z)(p().mark(function e(t, n) {
              var r, o, i, a, u;
              return p().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return o = (r = n).emailId, i = r.challengeId, a = r.accessToken, e.next = 3, (0, h.w)(t, {
                      url: "/idp/myaccount/emails/".concat(o, "/challenge/").concat(i),
                      method: "POST",
                      accessToken: a,
                      transactionClassName: "EmailChallengeTransaction"
                    });
                  case 3:
                    return u = e.sent, e.abrupt("return", u);
                  case 5:
                  case "end":
                    return e.stop();
                }
              }, e);
            })), function (e, t) {
              return c.apply(this, arguments);
            }),
            T = (s = (0, f.Z)(p().mark(function e(t, n) {
              var r, o, i, a, u, c;
              return p().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return o = (r = n).emailId, i = r.challengeId, a = r.payload, u = r.accessToken, e.next = 3, (0, h.w)(t, {
                      url: "/idp/myaccount/emails/".concat(o, "/challenge/").concat(i, "/verify"),
                      method: "POST",
                      payload: a,
                      accessToken: u
                    });
                  case 3:
                    return c = e.sent, e.abrupt("return", c);
                  case 5:
                  case "end":
                    return e.stop();
                }
              }, e);
            })), function (e, t) {
              return s.apply(this, arguments);
            }),
            Z = function () {
              var e = (0, f.Z)(p().mark(function e(t, n) {
                var r;
                return p().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return e.next = 2, (0, h.w)(t, {
                        url: "/idp/myaccount/phones",
                        method: "GET",
                        accessToken: null == n ? void 0 : n.accessToken,
                        transactionClassName: "PhoneTransaction"
                      });
                    case 2:
                      return r = e.sent, e.abrupt("return", r);
                    case 4:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }));
              return function (t, n) {
                return e.apply(this, arguments);
              };
            }(),
            E = function () {
              var e = (0, f.Z)(p().mark(function e(t, n) {
                var r, o, i, a;
                return p().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return o = (r = n).accessToken, i = r.id, e.next = 3, (0, h.w)(t, {
                        url: "/idp/myaccount/phones/".concat(i),
                        method: "GET",
                        accessToken: o,
                        transactionClassName: "PhoneTransaction"
                      });
                    case 3:
                      return a = e.sent, e.abrupt("return", a);
                    case 5:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }));
              return function (t, n) {
                return e.apply(this, arguments);
              };
            }(),
            S = function () {
              var e = (0, f.Z)(p().mark(function e(t, n) {
                var r, o, i, a;
                return p().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return o = (r = n).accessToken, i = r.payload, e.next = 3, (0, h.w)(t, {
                        url: "/idp/myaccount/phones",
                        method: "POST",
                        payload: i,
                        accessToken: o,
                        transactionClassName: "PhoneTransaction"
                      });
                    case 3:
                      return a = e.sent, e.abrupt("return", a);
                    case 5:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }));
              return function (t, n) {
                return e.apply(this, arguments);
              };
            }(),
            x = function () {
              var e = (0, f.Z)(p().mark(function e(t, n) {
                var r, o, i, a;
                return p().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return o = (r = n).id, i = r.accessToken, e.next = 3, (0, h.w)(t, {
                        url: "/idp/myaccount/phones/".concat(o),
                        method: "DELETE",
                        accessToken: i
                      });
                    case 3:
                      return a = e.sent, e.abrupt("return", a);
                    case 5:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }));
              return function (t, n) {
                return e.apply(this, arguments);
              };
            }(),
            P = function () {
              var e = (0, f.Z)(p().mark(function e(t, n) {
                var r, o, i, a, u;
                return p().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return o = (r = n).accessToken, i = r.id, a = r.payload, e.next = 3, (0, h.w)(t, {
                        url: "/idp/myaccount/phones/".concat(i, "/challenge"),
                        method: "POST",
                        payload: a,
                        accessToken: o
                      });
                    case 3:
                      return u = e.sent, e.abrupt("return", u);
                    case 5:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }));
              return function (t, n) {
                return e.apply(this, arguments);
              };
            }(),
            A = function () {
              var e = (0, f.Z)(p().mark(function e(t, n) {
                var r, o, i, a, u;
                return p().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return o = (r = n).id, i = r.payload, a = r.accessToken, e.next = 3, (0, h.w)(t, {
                        url: "/idp/myaccount/phones/".concat(o, "/verify"),
                        method: "POST",
                        payload: i,
                        accessToken: a
                      });
                    case 3:
                      return u = e.sent, e.abrupt("return", u);
                    case 5:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }));
              return function (t, n) {
                return e.apply(this, arguments);
              };
            }(),
            _ = function () {
              var e = (0, f.Z)(p().mark(function e(t, n) {
                var r;
                return p().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return e.next = 2, (0, h.w)(t, {
                        url: "/idp/myaccount/password",
                        method: "GET",
                        accessToken: null == n ? void 0 : n.accessToken,
                        transactionClassName: "PasswordTransaction"
                      });
                    case 2:
                      return r = e.sent, e.abrupt("return", r);
                    case 4:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }));
              return function (t, n) {
                return e.apply(this, arguments);
              };
            }(),
            R = function () {
              var e = (0, f.Z)(p().mark(function e(t, n) {
                var r, o, i, a;
                return p().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return o = (r = n).accessToken, i = r.payload, e.next = 3, (0, h.w)(t, {
                        url: "/idp/myaccount/password",
                        method: "POST",
                        payload: i,
                        accessToken: o,
                        transactionClassName: "PasswordTransaction"
                      });
                    case 3:
                      return a = e.sent, e.abrupt("return", a);
                    case 5:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }));
              return function (t, n) {
                return e.apply(this, arguments);
              };
            }(),
            j = function () {
              var e = (0, f.Z)(p().mark(function e(t, n) {
                var r, o, i, a;
                return p().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return o = (r = n).accessToken, i = r.payload, e.next = 3, (0, h.w)(t, {
                        url: "/idp/myaccount/password",
                        method: "PUT",
                        payload: i,
                        accessToken: o,
                        transactionClassName: "PasswordTransaction"
                      });
                    case 3:
                      return a = e.sent, e.abrupt("return", a);
                    case 5:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }));
              return function (t, n) {
                return e.apply(this, arguments);
              };
            }(),
            C = function () {
              var e = (0, f.Z)(p().mark(function e(t, n) {
                var r;
                return p().wrap(function (e) {
                  for (;;) switch (e.prev = e.next) {
                    case 0:
                      return e.next = 2, (0, h.w)(t, {
                        url: "/idp/myaccount/password",
                        method: "DELETE",
                        accessToken: null == n ? void 0 : n.accessToken
                      });
                    case 2:
                      return r = e.sent, e.abrupt("return", r);
                    case 4:
                    case "end":
                      return e.stop();
                  }
                }, e);
              }));
              return function (t, n) {
                return e.apply(this, arguments);
              };
            }();
        },
        1132: function _(e, t, n) {
          "use strict";

          n.d(t, {
            mV: function mV() {
              return u.mV;
            },
            nh: function nh() {
              return u.nh;
            },
            aw: function aw() {
              return u.aw;
            },
            XC: function XC() {
              return u.XC;
            },
            yB: function yB() {
              return u.yB;
            },
            Fn: function Fn() {
              return u.Fn;
            },
            QU: function QU() {
              return u.QU;
            },
            $N: function $N() {
              return u.$N;
            },
            XW: function XW() {
              return u.XW;
            },
            Sx: function Sx() {
              return u.Sx;
            },
            qb: function qb() {
              return u.qb;
            },
            no: function no() {
              return r.addEmail;
            },
            Z1: function Z1() {
              return r.addPhone;
            },
            Xc: function Xc() {
              return a;
            },
            nd: function nd() {
              return r.deleteEmail;
            },
            QN: function QN() {
              return r.deletePassword;
            },
            qj: function qj() {
              return r.deletePhone;
            },
            xg: function xg() {
              return r.enrollPassword;
            },
            OD: function OD() {
              return r.getEmail;
            },
            hG: function hG() {
              return r.getEmailChallenge;
            },
            G5: function G5() {
              return r.getEmails;
            },
            Ij: function Ij() {
              return r.getPassword;
            },
            u_: function u_() {
              return r.getPhone;
            },
            Po: function Po() {
              return r.getPhones;
            },
            Ai: function Ai() {
              return r.getProfile;
            },
            aF: function aF() {
              return r.getProfileSchema;
            },
            HT: function HT() {
              return i.H;
            },
            ME: function ME() {
              return r.sendEmailChallenge;
            },
            dv: function dv() {
              return r.sendPhoneChallenge;
            },
            gQ: function gQ() {
              return r.updatePassword;
            },
            ck: function ck() {
              return r.updateProfile;
            },
            T8: function T8() {
              return r.verifyEmailChallenge;
            },
            Lo: function Lo() {
              return r.verifyPhoneChallenge;
            }
          });
          var r = n(5878),
            o = n(1578),
            i = n(6794);
          function a(e, t, n) {
            var r = (0, o.K)(e, t, n);
            return (0, i.H)(r);
          }
          var u = n(8008);
        },
        6794: function _(e, t, n) {
          "use strict";

          n.d(t, {
            H: function H() {
              return p;
            }
          });
          var r = n(885),
            o = n(3144),
            i = n(5671),
            a = n(7326),
            u = n(136),
            c = n(2963),
            s = n(1120),
            f = n(4942),
            l = n(5878);
          function p(e) {
            return function (e) {
              (0, u.Z)(h, e);
              var t,
                n,
                p = (t = h, n = function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                  } catch (e) {
                    return !1;
                  }
                }(), function () {
                  var e,
                    r = (0, s.Z)(t);
                  if (n) {
                    var o = (0, s.Z)(this).constructor;
                    e = Reflect.construct(r, arguments, o);
                  } else e = r.apply(this, arguments);
                  return (0, c.Z)(this, e);
                });
              function h() {
                var e;
                (0, i.Z)(this, h);
                for (var t = arguments.length, n = new Array(t), o = 0; o < t; o++) n[o] = arguments[o];
                return e = p.call.apply(p, [this].concat(n)), (0, f.Z)((0, a.Z)(e), "myaccount", void 0), e.myaccount = Object.entries(l).filter(function (e) {
                  return "default" !== (0, r.Z)(e, 1)[0];
                }).reduce(function (t, n) {
                  var o = (0, r.Z)(n, 2),
                    i = o[0],
                    u = o[1];
                  return t[i] = u.bind(null, (0, a.Z)(e)), t;
                }, {}), e;
              }
              return (0, o.Z)(h);
            }(e);
          }
        },
        777: function _(e, t, n) {
          "use strict";

          n.d(t, {
            B: function B() {
              return O;
            },
            w: function w() {
              return k;
            }
          });
          var r = n(4942),
            o = n(1002),
            i = n(5861),
            a = n(4687),
            u = n.n(a),
            c = n(8261),
            s = n(9953),
            f = n(4454),
            l = n(5708),
            p = n(8399),
            h = n(3082),
            d = n(3746),
            v = n(3395),
            y = n(5385),
            g = n(9123);
          function m(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function b(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? m(Object(n), !0).forEach(function (t) {
                (0, r.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          function k(e, t) {
            return w.apply(this, arguments);
          }
          function w() {
            return (w = (0, i.Z)(u().mark(function e(t, n) {
              var r, o, i, a, m, k, w, O, T, Z, E;
              return u().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if (r = t.tokenManager.getTokensSync(), o = r.accessToken, i = n.accessToken || (null == o ? void 0 : o.accessToken), a = t.getIssuerOrigin(), m = n.url, k = n.method, w = n.payload, O = m.startsWith(a) ? m : "".concat(a).concat(m), i) {
                      e.next = 7;
                      break;
                    }
                    throw new g.Z("AccessToken is required to request MyAccount API endpoints.");
                  case 7:
                    return e.next = 9, (0, y.c3)(t, b({
                      headers: {
                        Accept: "*/*;okta-version=1.0.0"
                      },
                      accessToken: i,
                      url: O,
                      method: k
                    }, w && {
                      args: w
                    }));
                  case 9:
                    if (T = e.sent, Z = {
                      EmailTransaction: c.Z,
                      EmailStatusTransaction: s.Z,
                      EmailChallengeTransaction: f.Z,
                      ProfileTransaction: l.Z,
                      ProfileSchemaTransaction: p.Z,
                      PhoneTransaction: h.Z,
                      PasswordTransaction: d.Z
                    }, E = Z[n.transactionClassName] || v.Z, !Array.isArray(T)) {
                      e.next = 14;
                      break;
                    }
                    return e.abrupt("return", T.map(function (e) {
                      return new E(t, {
                        res: e,
                        accessToken: i
                      });
                    }));
                  case 14:
                    return e.abrupt("return", new E(t, {
                      res: T,
                      accessToken: i
                    }));
                  case 15:
                  case "end":
                    return e.stop();
                }
              }, e);
            }))).apply(this, arguments);
          }
          function O(e) {
            for (var t = e.oktaAuth, n = e.accessToken, r = e.methodName, a = e.links, c = e.transactionClassName, s = function s() {
                var e,
                  o = l[f];
                if (o.toLowerCase() === r) {
                  var s = a.self;
                  return {
                    v: (e = (0, i.Z)(u().mark(function e(r) {
                      return u().wrap(function (e) {
                        for (;;) switch (e.prev = e.next) {
                          case 0:
                            return e.abrupt("return", k(t, {
                              accessToken: n,
                              url: s.href,
                              method: o,
                              payload: r,
                              transactionClassName: c
                            }));
                          case 1:
                          case "end":
                            return e.stop();
                        }
                      }, e);
                    })), function (t) {
                      return e.apply(this, arguments);
                    })
                  };
                }
              }, f = 0, l = ["GET", "POST", "PUT", "DELETE"]; f < l.length; f++) {
              var p = s();
              if ("object" === (0, o.Z)(p)) return p.v;
            }
            var h,
              d = a[r];
            if (!d) throw new g.Z("No link is found with methodName: ".concat(r));
            return h = (0, i.Z)(u().mark(function e(r) {
              return u().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return e.abrupt("return", k(t, {
                      accessToken: n,
                      url: d.href,
                      method: d.hints.allow[0],
                      payload: r,
                      transactionClassName: c
                    }));
                  case 1:
                  case "end":
                    return e.stop();
                }
              }, e);
            })), function (e) {
              return h.apply(this, arguments);
            };
          }
        },
        3395: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Z: function Z() {
              return c;
            }
          });
          var r = n(4925),
            o = n(3144),
            i = n(5671),
            a = n(4942),
            u = ["headers"],
            c = (0, o.Z)(function e(t, n) {
              var o = this;
              (0, i.Z)(this, e), (0, a.Z)(this, "headers", void 0);
              var c = n.res,
                s = c.headers,
                f = (0, r.Z)(c, u);
              s && (this.headers = s), Object.keys(f).forEach(function (e) {
                "_links" !== e && (o[e] = f[e]);
              });
            });
        },
        4454: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Z: function Z() {
              return v;
            }
          });
          var r = n(5861),
            o = n(3144),
            i = n(5671),
            a = n(7326),
            u = n(136),
            c = n(2963),
            s = n(1120),
            f = n(4942),
            l = n(4687),
            p = n.n(l),
            h = n(3395),
            d = n(777);
          var v = function (e) {
            (0, u.Z)(h, e);
            var t,
              n,
              l = (t = h, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, s.Z)(t);
                if (n) {
                  var o = (0, s.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, c.Z)(this, e);
              });
            function h(e, t) {
              var n;
              (0, i.Z)(this, h), n = l.call(this, e, t), (0, f.Z)((0, a.Z)(n), "id", void 0), (0, f.Z)((0, a.Z)(n), "expiresAt", void 0), (0, f.Z)((0, a.Z)(n), "profile", void 0), (0, f.Z)((0, a.Z)(n), "status", void 0), (0, f.Z)((0, a.Z)(n), "poll", void 0), (0, f.Z)((0, a.Z)(n), "verify", void 0);
              var o,
                u = t.accessToken,
                c = t.res,
                s = c.id,
                v = c.expiresAt,
                y = c.profile,
                g = c.status,
                m = c._links;
              return n.id = s, n.expiresAt = v, n.profile = y, n.status = g, n.poll = (0, r.Z)(p().mark(function t() {
                var n;
                return p().wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      return n = (0, d.B)({
                        oktaAuth: e,
                        accessToken: u,
                        methodName: "poll",
                        links: m,
                        transactionClassName: "EmailStatusTransaction"
                      }), t.next = 3, n();
                    case 3:
                      return t.abrupt("return", t.sent);
                    case 4:
                    case "end":
                      return t.stop();
                  }
                }, t);
              })), n.verify = (o = (0, r.Z)(p().mark(function t(n) {
                var r;
                return p().wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      return r = (0, d.B)({
                        oktaAuth: e,
                        accessToken: u,
                        methodName: "verify",
                        links: m
                      }), t.next = 3, r(n);
                    case 3:
                      return t.abrupt("return", t.sent);
                    case 4:
                    case "end":
                      return t.stop();
                  }
                }, t);
              })), function (e) {
                return o.apply(this, arguments);
              }), n;
            }
            return (0, o.Z)(h);
          }(h.Z);
        },
        9953: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Z: function Z() {
              return f;
            }
          });
          var r = n(3144),
            o = n(5671),
            i = n(7326),
            a = n(136),
            u = n(2963),
            c = n(1120),
            s = n(4942);
          var f = function (e) {
            (0, a.Z)(l, e);
            var t,
              n,
              f = (t = l, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, c.Z)(t);
                if (n) {
                  var o = (0, c.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, u.Z)(this, e);
              });
            function l(e, t) {
              var n;
              (0, o.Z)(this, l), n = f.call(this, e, t), (0, s.Z)((0, i.Z)(n), "id", void 0), (0, s.Z)((0, i.Z)(n), "expiresAt", void 0), (0, s.Z)((0, i.Z)(n), "profile", void 0), (0, s.Z)((0, i.Z)(n), "status", void 0);
              var r = t.res,
                a = r.id,
                u = r.profile,
                c = r.expiresAt,
                p = r.status;
              return n.id = a, n.expiresAt = c, n.profile = u, n.status = p, n;
            }
            return (0, r.Z)(l);
          }(n(3395).Z);
        },
        8261: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Z: function Z() {
              return v;
            }
          });
          var r = n(5861),
            o = n(3144),
            i = n(5671),
            a = n(7326),
            u = n(136),
            c = n(2963),
            s = n(1120),
            f = n(4942),
            l = n(4687),
            p = n.n(l),
            h = n(3395),
            d = n(777);
          var v = function (e) {
            (0, u.Z)(h, e);
            var t,
              n,
              l = (t = h, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, s.Z)(t);
                if (n) {
                  var o = (0, s.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, c.Z)(this, e);
              });
            function h(e, t) {
              var n;
              (0, i.Z)(this, h), n = l.call(this, e, t), (0, f.Z)((0, a.Z)(n), "id", void 0), (0, f.Z)((0, a.Z)(n), "profile", void 0), (0, f.Z)((0, a.Z)(n), "roles", void 0), (0, f.Z)((0, a.Z)(n), "status", void 0), (0, f.Z)((0, a.Z)(n), "get", void 0), (0, f.Z)((0, a.Z)(n), "delete", void 0), (0, f.Z)((0, a.Z)(n), "challenge", void 0), (0, f.Z)((0, a.Z)(n), "poll", void 0), (0, f.Z)((0, a.Z)(n), "verify", void 0);
              var o,
                u = t.accessToken,
                c = t.res,
                s = c.id,
                v = c.profile,
                y = c.roles,
                g = c.status,
                m = c._links;
              return n.id = s, n.profile = v, n.roles = y, n.status = g, n.get = (0, r.Z)(p().mark(function t() {
                var n;
                return p().wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      return n = (0, d.B)({
                        oktaAuth: e,
                        accessToken: u,
                        methodName: "get",
                        links: m,
                        transactionClassName: "EmailTransaction"
                      }), t.next = 3, n();
                    case 3:
                      return t.abrupt("return", t.sent);
                    case 4:
                    case "end":
                      return t.stop();
                  }
                }, t);
              })), n["delete"] = (0, r.Z)(p().mark(function t() {
                var n;
                return p().wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      return n = (0, d.B)({
                        oktaAuth: e,
                        accessToken: u,
                        methodName: "delete",
                        links: m
                      }), t.next = 3, n();
                    case 3:
                      return t.abrupt("return", t.sent);
                    case 4:
                    case "end":
                      return t.stop();
                  }
                }, t);
              })), n.challenge = (0, r.Z)(p().mark(function t() {
                var n;
                return p().wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      return n = (0, d.B)({
                        oktaAuth: e,
                        accessToken: u,
                        methodName: "challenge",
                        links: m,
                        transactionClassName: "EmailChallengeTransaction"
                      }), t.next = 3, n();
                    case 3:
                      return t.abrupt("return", t.sent);
                    case 4:
                    case "end":
                      return t.stop();
                  }
                }, t);
              })), m.poll && (n.poll = (0, r.Z)(p().mark(function t() {
                var n;
                return p().wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      return n = (0, d.B)({
                        oktaAuth: e,
                        accessToken: u,
                        methodName: "poll",
                        links: m,
                        transactionClassName: "EmailStatusTransaction"
                      }), t.next = 3, n();
                    case 3:
                      return t.abrupt("return", t.sent);
                    case 4:
                    case "end":
                      return t.stop();
                  }
                }, t);
              }))), m.verify && (n.verify = (o = (0, r.Z)(p().mark(function t(n) {
                var r;
                return p().wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      return r = (0, d.B)({
                        oktaAuth: e,
                        accessToken: u,
                        methodName: "verify",
                        links: m
                      }), t.next = 3, r(n);
                    case 3:
                      return t.abrupt("return", t.sent);
                    case 4:
                    case "end":
                      return t.stop();
                  }
                }, t);
              })), function (e) {
                return o.apply(this, arguments);
              })), n;
            }
            return (0, o.Z)(h);
          }(h.Z);
        },
        3746: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Z: function Z() {
              return y;
            }
          });
          var r = n(5861),
            o = n(3144),
            i = n(5671),
            a = n(7326),
            u = n(136),
            c = n(2963),
            s = n(1120),
            f = n(4942),
            l = n(4687),
            p = n.n(l),
            h = n(8008),
            d = n(3395),
            v = n(777);
          var y = function (e) {
            (0, u.Z)(d, e);
            var t,
              n,
              l = (t = d, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, s.Z)(t);
                if (n) {
                  var o = (0, s.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, c.Z)(this, e);
              });
            function d(e, t) {
              var n;
              (0, i.Z)(this, d), n = l.call(this, e, t), (0, f.Z)((0, a.Z)(n), "id", void 0), (0, f.Z)((0, a.Z)(n), "created", void 0), (0, f.Z)((0, a.Z)(n), "lastUpdated", void 0), (0, f.Z)((0, a.Z)(n), "status", void 0), (0, f.Z)((0, a.Z)(n), "get", void 0), (0, f.Z)((0, a.Z)(n), "enroll", void 0), (0, f.Z)((0, a.Z)(n), "update", void 0), (0, f.Z)((0, a.Z)(n), "delete", void 0);
              var o,
                u,
                c = t.res,
                s = t.accessToken,
                y = c.id,
                g = c.status,
                m = c.created,
                b = c.lastUpdated,
                k = c._links;
              return n.id = y, n.status = g, n.created = m, n.lastUpdated = b, n.status == h.Fn.NOT_ENROLLED ? n.enroll = (u = (0, r.Z)(p().mark(function t(n) {
                var r;
                return p().wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      return r = (0, v.B)({
                        oktaAuth: e,
                        accessToken: s,
                        methodName: "enroll",
                        links: k,
                        transactionClassName: "PasswordTransaction"
                      }), t.next = 3, r(n);
                    case 3:
                      return t.abrupt("return", t.sent);
                    case 4:
                    case "end":
                      return t.stop();
                  }
                }, t);
              })), function (e) {
                return u.apply(this, arguments);
              }) : (n.get = (0, r.Z)(p().mark(function t() {
                var n;
                return p().wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      return n = (0, v.B)({
                        oktaAuth: e,
                        accessToken: s,
                        methodName: "get",
                        links: k,
                        transactionClassName: "PasswordTransaction"
                      }), t.next = 3, n();
                    case 3:
                      return t.abrupt("return", t.sent);
                    case 4:
                    case "end":
                      return t.stop();
                  }
                }, t);
              })), n.update = (o = (0, r.Z)(p().mark(function t(n) {
                var r;
                return p().wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      return r = (0, v.B)({
                        oktaAuth: e,
                        accessToken: s,
                        methodName: "put",
                        links: k,
                        transactionClassName: "PasswordTransaction"
                      }), t.next = 3, r(n);
                    case 3:
                      return t.abrupt("return", t.sent);
                    case 4:
                    case "end":
                      return t.stop();
                  }
                }, t);
              })), function (e) {
                return o.apply(this, arguments);
              }), n["delete"] = (0, r.Z)(p().mark(function t() {
                var n;
                return p().wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      return n = (0, v.B)({
                        oktaAuth: e,
                        accessToken: s,
                        methodName: "delete",
                        links: k
                      }), t.next = 3, n();
                    case 3:
                      return t.abrupt("return", t.sent);
                    case 4:
                    case "end":
                      return t.stop();
                  }
                }, t);
              }))), n;
            }
            return (0, o.Z)(d);
          }(d.Z);
        },
        3082: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Z: function Z() {
              return v;
            }
          });
          var r = n(5861),
            o = n(3144),
            i = n(5671),
            a = n(7326),
            u = n(136),
            c = n(2963),
            s = n(1120),
            f = n(4942),
            l = n(4687),
            p = n.n(l),
            h = n(3395),
            d = n(777);
          var v = function (e) {
            (0, u.Z)(h, e);
            var t,
              n,
              l = (t = h, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, s.Z)(t);
                if (n) {
                  var o = (0, s.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, c.Z)(this, e);
              });
            function h(e, t) {
              var n;
              (0, i.Z)(this, h), n = l.call(this, e, t), (0, f.Z)((0, a.Z)(n), "id", void 0), (0, f.Z)((0, a.Z)(n), "profile", void 0), (0, f.Z)((0, a.Z)(n), "status", void 0), (0, f.Z)((0, a.Z)(n), "get", void 0), (0, f.Z)((0, a.Z)(n), "delete", void 0), (0, f.Z)((0, a.Z)(n), "challenge", void 0), (0, f.Z)((0, a.Z)(n), "verify", void 0);
              var o,
                u,
                c = t.res,
                s = t.accessToken,
                v = c.id,
                y = c.profile,
                g = c.status,
                m = c._links;
              return n.id = v, n.profile = y, n.status = g, n.get = (0, r.Z)(p().mark(function t() {
                var n;
                return p().wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      return n = (0, d.B)({
                        oktaAuth: e,
                        accessToken: s,
                        methodName: "get",
                        links: m,
                        transactionClassName: "PhoneTransaction"
                      }), t.next = 3, n();
                    case 3:
                      return t.abrupt("return", t.sent);
                    case 4:
                    case "end":
                      return t.stop();
                  }
                }, t);
              })), n["delete"] = (0, r.Z)(p().mark(function t() {
                var n;
                return p().wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      return n = (0, d.B)({
                        oktaAuth: e,
                        accessToken: s,
                        methodName: "delete",
                        links: m
                      }), t.next = 3, n();
                    case 3:
                      return t.abrupt("return", t.sent);
                    case 4:
                    case "end":
                      return t.stop();
                  }
                }, t);
              })), n.challenge = (o = (0, r.Z)(p().mark(function t(n) {
                var r;
                return p().wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      return r = (0, d.B)({
                        oktaAuth: e,
                        accessToken: s,
                        methodName: "challenge",
                        links: m
                      }), t.next = 3, r(n);
                    case 3:
                      return t.abrupt("return", t.sent);
                    case 4:
                    case "end":
                      return t.stop();
                  }
                }, t);
              })), function (e) {
                return o.apply(this, arguments);
              }), m.verify && (n.verify = (u = (0, r.Z)(p().mark(function t(n) {
                var r;
                return p().wrap(function (t) {
                  for (;;) switch (t.prev = t.next) {
                    case 0:
                      return r = (0, d.B)({
                        oktaAuth: e,
                        accessToken: s,
                        methodName: "verify",
                        links: m
                      }), t.next = 3, r(n);
                    case 3:
                      return t.abrupt("return", t.sent);
                    case 4:
                    case "end":
                      return t.stop();
                  }
                }, t);
              })), function (e) {
                return u.apply(this, arguments);
              })), n;
            }
            return (0, o.Z)(h);
          }(h.Z);
        },
        8399: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Z: function Z() {
              return f;
            }
          });
          var r = n(3144),
            o = n(5671),
            i = n(7326),
            a = n(136),
            u = n(2963),
            c = n(1120),
            s = n(4942);
          var f = function (e) {
            (0, a.Z)(l, e);
            var t,
              n,
              f = (t = l, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, c.Z)(t);
                if (n) {
                  var o = (0, c.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, u.Z)(this, e);
              });
            function l(e, t) {
              var n;
              return (0, o.Z)(this, l), n = f.call(this, e, t), (0, s.Z)((0, i.Z)(n), "properties", void 0), n.properties = t.res.properties, n;
            }
            return (0, r.Z)(l);
          }(n(3395).Z);
        },
        5708: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Z: function Z() {
              return f;
            }
          });
          var r = n(3144),
            o = n(5671),
            i = n(7326),
            a = n(136),
            u = n(2963),
            c = n(1120),
            s = n(4942);
          var f = function (e) {
            (0, a.Z)(l, e);
            var t,
              n,
              f = (t = l, n = function () {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                  return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                } catch (e) {
                  return !1;
                }
              }(), function () {
                var e,
                  r = (0, c.Z)(t);
                if (n) {
                  var o = (0, c.Z)(this).constructor;
                  e = Reflect.construct(r, arguments, o);
                } else e = r.apply(this, arguments);
                return (0, u.Z)(this, e);
              });
            function l(e, t) {
              var n;
              (0, o.Z)(this, l), n = f.call(this, e, t), (0, s.Z)((0, i.Z)(n), "createdAt", void 0), (0, s.Z)((0, i.Z)(n), "modifiedAt", void 0), (0, s.Z)((0, i.Z)(n), "profile", void 0);
              var r = t.res,
                a = r.createdAt,
                u = r.modifiedAt,
                c = r.profile;
              return n.createdAt = a, n.modifiedAt = u, n.profile = c, n;
            }
            return (0, r.Z)(l);
          }(n(3395).Z);
        },
        8008: function _(e, t, n) {
          "use strict";

          n.d(t, {
            $N: function $N() {
              return s.Z;
            },
            Fn: function Fn() {
              return i;
            },
            QU: function QU() {
              return p.Z;
            },
            Sx: function Sx() {
              return f.Z;
            },
            XC: function XC() {
              return u.Z;
            },
            XW: function XW() {
              return l.Z;
            },
            aw: function aw() {
              return r;
            },
            mV: function mV() {
              return h.Z;
            },
            nh: function nh() {
              return c.Z;
            },
            qb: function qb() {
              return o;
            },
            yB: function yB() {
              return a.Z;
            }
          });
          var r,
            o,
            i,
            a = n(8261),
            u = n(9953),
            c = n(4454),
            s = n(3082),
            f = n(5708),
            l = n(8399),
            p = n(3746),
            h = n(3395);
          !function (e) {
            e.PRIMARY = "PRIMARY", e.SECONDARY = "SECONDARY";
          }(r || (r = {})), function (e) {
            e.VERIFIED = "VERIFIED", e.UNVERIFIED = "UNVERIFIED";
          }(o || (o = {})), function (e) {
            e.NOT_ENROLLED = "NOT_ENROLLED", e.ACTIVE = "ACTIVE";
          }(i || (i = {}));
        },
        2427: function _(e, t, n) {
          "use strict";

          n.d(t, {
            M: function M() {
              return w;
            }
          });
          var r = n(5861),
            o = n(1002),
            i = n(5671),
            a = n(3144),
            u = n(4942),
            c = n(4687),
            s = n.n(c),
            f = n(3193),
            l = n(9123),
            p = n(2482),
            h = n(415),
            d = function () {
              function e(t) {
                (0, i.Z)(this, e), (0, u.Z)(this, "localOffset", void 0), this.localOffset = parseInt(t || 0);
              }
              return (0, a.Z)(e, [{
                key: "now",
                value: function value() {
                  return (Date.now() + this.localOffset) / 1e3;
                }
              }], [{
                key: "create",
                value: function value() {
                  return new e(0);
                }
              }]), e;
            }(),
            v = n(7088),
            y = n(6488),
            g = n(1971);
          function m(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function b(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? m(Object(n), !0).forEach(function (t) {
                (0, u.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : m(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          var k = {
              autoRenew: !0,
              autoRemove: !0,
              syncStorage: !0,
              clearPendingRemoveTokens: !0,
              storage: void 0,
              expireEarlySeconds: 30,
              storageKey: g.TOKEN_STORAGE_NAME
            },
            w = function () {
              function e(t) {
                var n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                if ((0, i.Z)(this, e), (0, u.Z)(this, "sdk", void 0), (0, u.Z)(this, "clock", void 0), (0, u.Z)(this, "emitter", void 0), (0, u.Z)(this, "storage", void 0), (0, u.Z)(this, "state", void 0), (0, u.Z)(this, "options", void 0), this.sdk = t, this.emitter = t.emitter, !this.emitter) throw new l.Z("Emitter should be initialized before TokenManager");
                n = Object.assign({}, k, (0, f.YY)(n)), (0, h.isLocalhost)() || (n.expireEarlySeconds = k.expireEarlySeconds), this.options = n;
                var r = (0, f.YY)({
                  storageKey: n.storageKey,
                  secure: n.secure
                });
                "object" === (0, o.Z)(n.storage) ? r.storageProvider = n.storage : n.storage && (r.storageType = n.storage), this.storage = t.storageManager.getTokenStorage(b(b({}, r), {}, {
                  useSeparateCookies: !0
                })), this.clock = d.create(), this.state = {
                  expireTimeouts: {},
                  renewPromise: null
                };
              }
              var t, n, c;
              return (0, a.Z)(e, [{
                key: "on",
                value: function value(e, t, n) {
                  n ? this.emitter.on(e, t, n) : this.emitter.on(e, t);
                }
              }, {
                key: "off",
                value: function value(e, t) {
                  t ? this.emitter.off(e, t) : this.emitter.off(e);
                }
              }, {
                key: "start",
                value: function value() {
                  this.options.clearPendingRemoveTokens && this.clearPendingRemoveTokens(), this.setExpireEventTimeoutAll(), this.state.started = !0;
                }
              }, {
                key: "stop",
                value: function value() {
                  this.clearExpireEventTimeoutAll(), this.state.started = !1;
                }
              }, {
                key: "isStarted",
                value: function value() {
                  return !!this.state.started;
                }
              }, {
                key: "getOptions",
                value: function value() {
                  return (0, f.d9)(this.options);
                }
              }, {
                key: "getExpireTime",
                value: function value(e) {
                  var t = this.options.expireEarlySeconds || 0;
                  return e.expiresAt - t;
                }
              }, {
                key: "hasExpired",
                value: function value(e) {
                  return this.getExpireTime(e) <= this.clock.now();
                }
              }, {
                key: "emitExpired",
                value: function value(e, t) {
                  this.emitter.emit(v.$Y, e, t);
                }
              }, {
                key: "emitRenewed",
                value: function value(e, t, n) {
                  this.emitter.emit(v.E, e, t, n);
                }
              }, {
                key: "emitAdded",
                value: function value(e, t) {
                  this.emitter.emit(v.O3, e, t);
                }
              }, {
                key: "emitRemoved",
                value: function value(e, t) {
                  this.emitter.emit(v.FT, e, t);
                }
              }, {
                key: "emitError",
                value: function value(e) {
                  this.emitter.emit(v.$I, e);
                }
              }, {
                key: "clearExpireEventTimeout",
                value: function value(e) {
                  clearTimeout(this.state.expireTimeouts[e]), delete this.state.expireTimeouts[e], this.state.renewPromise = null;
                }
              }, {
                key: "clearExpireEventTimeoutAll",
                value: function value() {
                  var e = this.state.expireTimeouts;
                  for (var t in e) Object.prototype.hasOwnProperty.call(e, t) && this.clearExpireEventTimeout(t);
                }
              }, {
                key: "setExpireEventTimeout",
                value: function value(e, t) {
                  var n = this;
                  if (!(0, y.z9)(t)) {
                    var r = this.getExpireTime(t),
                      o = 1e3 * Math.max(r - this.clock.now(), 0);
                    this.clearExpireEventTimeout(e);
                    var i = setTimeout(function () {
                      n.emitExpired(e, t);
                    }, o);
                    this.state.expireTimeouts[e] = i;
                  }
                }
              }, {
                key: "setExpireEventTimeoutAll",
                value: function value() {
                  var e = this.storage.getStorage();
                  for (var t in e) if (Object.prototype.hasOwnProperty.call(e, t)) {
                    var n = e[t];
                    this.setExpireEventTimeout(t, n);
                  }
                }
              }, {
                key: "resetExpireEventTimeoutAll",
                value: function value() {
                  this.clearExpireEventTimeoutAll(), this.setExpireEventTimeoutAll();
                }
              }, {
                key: "add",
                value: function value(e, t) {
                  var n = this.storage.getStorage();
                  (0, p.R)(t), n[e] = t, this.storage.setStorage(n), this.emitSetStorageEvent(), this.emitAdded(e, t), this.setExpireEventTimeout(e, t);
                }
              }, {
                key: "getSync",
                value: function value(e) {
                  return this.storage.getStorage()[e];
                }
              }, {
                key: "get",
                value: (c = (0, r.Z)(s().mark(function e(t) {
                  return s().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        return e.abrupt("return", this.getSync(t));
                      case 1:
                      case "end":
                        return e.stop();
                    }
                  }, e, this);
                })), function (e) {
                  return c.apply(this, arguments);
                })
              }, {
                key: "getTokensSync",
                value: function value() {
                  var e = {},
                    t = this.storage.getStorage();
                  return Object.keys(t).forEach(function (n) {
                    var r = t[n];
                    (0, y.hv)(r) ? e.accessToken = r : (0, y.sI)(r) ? e.idToken = r : (0, y.z9)(r) && (e.refreshToken = r);
                  }), e;
                }
              }, {
                key: "getTokens",
                value: (n = (0, r.Z)(s().mark(function e() {
                  return s().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        return e.abrupt("return", this.getTokensSync());
                      case 1:
                      case "end":
                        return e.stop();
                    }
                  }, e, this);
                })), function () {
                  return n.apply(this, arguments);
                })
              }, {
                key: "getStorageKeyByType",
                value: function value(e) {
                  var t = this.storage.getStorage();
                  return Object.keys(t).filter(function (n) {
                    var r = t[n];
                    return (0, y.hv)(r) && "accessToken" === e || (0, y.sI)(r) && "idToken" === e || (0, y.z9)(r) && "refreshToken" === e;
                  })[0];
                }
              }, {
                key: "getTokenType",
                value: function value(e) {
                  if ((0, y.hv)(e)) return "accessToken";
                  if ((0, y.sI)(e)) return "idToken";
                  if ((0, y.z9)(e)) return "refreshToken";
                  throw new l.Z("Unknown token type");
                }
              }, {
                key: "emitSetStorageEvent",
                value: function value() {
                  if ((0, h.isIE11OrLess)()) {
                    var e = this.storage.getStorage();
                    this.emitter.emit(v.zr, e);
                  }
                }
              }, {
                key: "getStorage",
                value: function value() {
                  return this.storage;
                }
              }, {
                key: "setTokens",
                value: function value(e, t, n, r) {
                  var o = this,
                    i = function i(e, _i) {
                      var a = o.getTokenType(_i);
                      "accessToken" === a ? t && t(e, _i) : "idToken" === a ? n && n(e, _i) : "refreshToken" === a && r && r(e, _i);
                    },
                    a = function a(e, t) {
                      o.emitAdded(e, t), o.setExpireEventTimeout(e, t), i(e, t);
                    },
                    u = function u(e, t) {
                      o.clearExpireEventTimeout(e), o.emitRemoved(e, t), i(e, t);
                    },
                    c = ["idToken", "accessToken", "refreshToken"],
                    s = this.getTokensSync();
                  c.forEach(function (t) {
                    var n = e[t];
                    n && (0, p.R)(n, t);
                  });
                  var f = c.reduce(function (t, n) {
                    var r = e[n];
                    return r && (t[o.getStorageKeyByType(n) || n] = r), t;
                  }, {});
                  this.storage.setStorage(f), this.emitSetStorageEvent(), c.forEach(function (t) {
                    var n,
                      r,
                      c,
                      f = e[t],
                      l = s[t],
                      p = o.getStorageKeyByType(t) || t;
                    f && l ? (u(p, l), a(p, f), n = p, r = f, c = l, o.emitRenewed(n, r, c), o.clearExpireEventTimeout(n), o.setExpireEventTimeout(n, r), i(n, r)) : f ? a(p, f) : l && u(p, l);
                  });
                }
              }, {
                key: "remove",
                value: function value(e) {
                  this.clearExpireEventTimeout(e);
                  var t = this.storage.getStorage(),
                    n = t[e];
                  delete t[e], this.storage.setStorage(t), this.emitSetStorageEvent(), this.emitRemoved(e, n);
                }
              }, {
                key: "renewToken",
                value: (t = (0, r.Z)(s().mark(function e(t) {
                  var n;
                  return s().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        return e.abrupt("return", null === (n = this.sdk.token) || void 0 === n ? void 0 : n.renew(t));
                      case 1:
                      case "end":
                        return e.stop();
                    }
                  }, e, this);
                })), function (e) {
                  return t.apply(this, arguments);
                })
              }, {
                key: "validateToken",
                value: function value(e) {
                  return (0, p.R)(e);
                }
              }, {
                key: "renew",
                value: function value(e) {
                  var t = this;
                  if (this.state.renewPromise) return this.state.renewPromise;
                  try {
                    var n = this.getSync(e);
                    if (!n) throw new l.Z("The tokenManager has no token for the key: " + e);
                  } catch (e) {
                    return Promise.reject(e);
                  }
                  return this.clearExpireEventTimeout(e), this.state.renewPromise = this.sdk.token.renewTokens().then(function (e) {
                    return t.setTokens(e), e[t.getTokenType(n)];
                  })["catch"](function (n) {
                    throw t.remove(e), n.tokenKey = e, t.emitError(n), n;
                  })["finally"](function () {
                    t.state.renewPromise = null;
                  });
                }
              }, {
                key: "clear",
                value: function value() {
                  var e = this,
                    t = this.getTokensSync();
                  this.clearExpireEventTimeoutAll(), this.storage.clearStorage(), this.emitSetStorageEvent(), Object.keys(t).forEach(function (n) {
                    e.emitRemoved(n, t[n]);
                  });
                }
              }, {
                key: "clearPendingRemoveTokens",
                value: function value() {
                  var e = this,
                    t = this.storage.getStorage(),
                    n = {};
                  Object.keys(t).forEach(function (e) {
                    t[e].pendingRemove && (n[e] = t[e], delete t[e]);
                  }), this.storage.setStorage(t), this.emitSetStorageEvent(), Object.keys(n).forEach(function (t) {
                    e.clearExpireEventTimeout(t), e.emitRemoved(t, n[t]);
                  });
                }
              }, {
                key: "updateRefreshToken",
                value: function value(e) {
                  var t = this.getStorageKeyByType("refreshToken") || g.REFRESH_TOKEN_STORAGE_KEY,
                    n = this.storage.getStorage();
                  (0, p.R)(e), n[t] = e, this.storage.setStorage(n), this.emitSetStorageEvent();
                }
              }, {
                key: "removeRefreshToken",
                value: function value() {
                  var e = this.getStorageKeyByType("refreshToken") || g.REFRESH_TOKEN_STORAGE_KEY;
                  this.remove(e);
                }
              }, {
                key: "addPendingRemoveFlags",
                value: function value() {
                  var e = this.getTokensSync();
                  Object.keys(e).forEach(function (t) {
                    e[t].pendingRemove = !0;
                  }), this.setTokens(e);
                }
              }]), e;
            }();
        },
        1646: function _(e, t, n) {
          "use strict";

          n.d(t, {
            P: function P() {
              return s;
            }
          });
          var r = n(5671),
            o = n(3144),
            i = n(4942),
            a = n(4319),
            u = n(146),
            c = 18e5;
          function s() {
            return function () {
              function e(t) {
                (0, r.Z)(this, e), (0, i.Z)(this, "options", void 0), (0, i.Z)(this, "storageManager", void 0), (0, i.Z)(this, "enableSharedStorage", void 0), (0, i.Z)(this, "saveLastResponse", void 0), this.storageManager = t.storageManager, this.enableSharedStorage = !1 !== t.enableSharedStorage, this.saveLastResponse = !1 !== t.saveLastResponse, this.options = t;
              }
              return (0, o.Z)(e, [{
                key: "clear",
                value: function value() {
                  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                    t = this.storageManager.getTransactionStorage(),
                    n = t.getStorage();
                  if (t.clearStorage(), this.enableSharedStorage && !1 !== e.clearSharedStorage) {
                    var r = e.state || (null == n ? void 0 : n.state);
                    r && function (e, t) {
                      var n = e.getSharedTansactionStorage(),
                        r = n.getStorage();
                      delete r[t], n.setStorage(r);
                    }(this.storageManager, r);
                  }
                }
              }, {
                key: "save",
                value: function value(e) {
                  var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
                    n = this.storageManager.getTransactionStorage(),
                    r = n.getStorage();
                  (0, a.mH)(r) && !t.muteWarning && (0, u.ZK)("a saved auth transaction exists in storage. This may indicate another auth flow is already in progress."), n.setStorage(e), this.enableSharedStorage && e.state && function (e, t, n) {
                    var r = e.getSharedTansactionStorage(),
                      o = r.getStorage();
                    o[t] = {
                      dateCreated: Date.now(),
                      transaction: n
                    }, r.setStorage(o);
                  }(this.storageManager, e.state, e);
                }
              }, {
                key: "exists",
                value: function value() {
                  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  try {
                    return !!this.load(e);
                  } catch (e) {
                    return !1;
                  }
                }
              }, {
                key: "load",
                value: function value() {
                  var e,
                    t,
                    n,
                    r = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                  return this.enableSharedStorage && r.state && (t = this.storageManager.getSharedTansactionStorage(), n = t.getStorage(), Object.keys(n).forEach(function (e) {
                    var t = n[e];
                    Date.now() - t.dateCreated > c && delete n[e];
                  }), t.setStorage(n), e = function (e, t) {
                    var n = e.getSharedTansactionStorage().getStorage()[t];
                    return n && n.transaction && (0, a.mH)(n.transaction) ? n.transaction : null;
                  }(this.storageManager, r.state), (0, a.mH)(e)) ? e : (e = this.storageManager.getTransactionStorage().getStorage(), (0, a.mH)(e) ? e : null);
                }
              }]), e;
            }();
          }
        },
        1237: function _(e, t, n) {
          "use strict";

          n.d(t, {
            T: function T() {
              return i;
            }
          });
          var r = n(9123),
            o = n(7987);
          function i(e) {
            var t,
              n = e.split(".");
            try {
              t = {
                header: JSON.parse((0, o.Wy)(n[0])),
                payload: JSON.parse((0, o.Wy)(n[1])),
                signature: n[2]
              };
            } catch (e) {
              throw new r.Z("Malformed token");
            }
            return t;
          }
        },
        2206: function _(e, t, n) {
          "use strict";

          n.d(t, {
            R: function R() {
              return l;
            },
            _: function _() {
              return f;
            }
          });
          var r = n(4942),
            o = n(4771),
            i = n(3193),
            a = n(6718),
            u = n(9123);
          function c(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function s(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? c(Object(n), !0).forEach(function (t) {
                (0, r.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : c(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          function f(e) {
            if (!e.clientId) throw new u.Z("A clientId must be specified in the OktaAuth constructor to get a token");
            if ((0, o.HD)(e.responseType) && -1 !== e.responseType.indexOf(" ")) throw new u.Z("Multiple OAuth responseTypes must be defined as an array");
            var t = {
              client_id: e.clientId,
              code_challenge: e.codeChallenge,
              code_challenge_method: e.codeChallengeMethod,
              display: e.display,
              idp: e.idp,
              idp_scope: e.idpScope,
              login_hint: e.loginHint,
              max_age: e.maxAge,
              nonce: e.nonce,
              prompt: e.prompt,
              redirect_uri: e.redirectUri,
              response_mode: e.responseMode,
              response_type: e.responseType,
              sessionToken: e.sessionToken,
              state: e.state,
              acr_values: e.acrValues,
              enroll_amr_values: e.enrollAmrValues
            };
            if (t = (0, i.YY)(t), ["idp_scope", "response_type", "enroll_amr_values"].forEach(function (e) {
              Array.isArray(t[e]) && (t[e] = t[e].join(" "));
            }), -1 !== e.responseType.indexOf("id_token") && -1 === e.scopes.indexOf("openid")) throw new u.Z("openid scope must be specified in the scopes argument when requesting an id_token");
            return e.scopes && (t.scope = e.scopes.join(" ")), t;
          }
          function l(e) {
            var t = f(e);
            return (0, a.UK)(s(s({}, t), e.extraParams && s({}, e.extraParams)));
          }
        },
        2642: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Dp: function Dp() {
              return o.D;
            },
            ES: function ES() {
              return i.E;
            },
            R0: function R0() {
              return r.R;
            },
            _6: function _6() {
              return r._;
            },
            km: function km() {
              return i.k;
            },
            ti: function ti() {
              return o.t;
            }
          });
          var r = n(2206),
            o = n(9231),
            i = n(52);
        },
        9231: function _(e, t, n) {
          "use strict";

          n.d(t, {
            D: function D() {
              return s;
            },
            t: function t() {
              return c;
            }
          });
          var r = n(885),
            o = n(9123),
            i = n(3193),
            a = n(6718),
            u = n(5385);
          function c(e, t, n) {
            !function (e) {
              if (!e.clientId) throw new o.Z("A clientId must be specified in the OktaAuth constructor to get a token");
              if (!e.redirectUri) throw new o.Z("The redirectUri passed to /authorize must also be passed to /token");
              if (!e.authorizationCode && !e.interactionCode) throw new o.Z("An authorization code (returned from /authorize) must be passed to /token");
              if (!e.codeVerifier) throw new o.Z('The "codeVerifier" (generated and saved by your app) must be passed to /token');
            }(t);
            var r = function (e, t) {
              var n = (0, i.YY)({
                client_id: t.clientId,
                redirect_uri: t.redirectUri,
                grant_type: t.interactionCode ? "interaction_code" : "authorization_code",
                code_verifier: t.codeVerifier
              });
              t.interactionCode ? n.interaction_code = t.interactionCode : t.authorizationCode && (n.code = t.authorizationCode);
              var r = e.options.clientSecret;
              return r && (n.client_secret = r), (0, a.UK)(n).slice(1);
            }(e, t);
            return (0, u.c3)(e, {
              url: n.tokenUrl,
              method: "POST",
              args: r,
              headers: {
                "Content-Type": "application/x-www-form-urlencoded"
              }
            });
          }
          function s(e, t, n) {
            return (0, u.c3)(e, {
              url: n.tokenUrl,
              method: "POST",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded"
              },
              args: Object.entries({
                client_id: t.clientId,
                grant_type: "refresh_token",
                scope: n.scopes.join(" "),
                refresh_token: n.refreshToken
              }).map(function (e) {
                var t = (0, r.Z)(e, 2),
                  n = t[0],
                  o = t[1];
                return n + "=" + encodeURIComponent(o);
              }).join("&")
            });
          }
        },
        52: function _(e, t, n) {
          "use strict";

          n.d(t, {
            E: function E() {
              return a;
            },
            k: function k() {
              return u;
            }
          });
          var r = n(5385),
            o = n(3193),
            i = n(9123);
          function a(e, t) {
            var n = t || e.options.issuer;
            return (0, r.U2)(e, n + "/.well-known/openid-configuration", {
              cacheResponse: !0
            });
          }
          function u(e, t, n) {
            var u = e.storageManager.getHttpCache(e.options.cookies);
            return a(e, t).then(function (t) {
              var a = t.jwks_uri,
                c = u.getStorage()[a];
              if (c && Date.now() / 1e3 < c.expiresAt) {
                var s = (0, o.sE)(c.response.keys, {
                  kid: n
                });
                if (s) return s;
              }
              return u.clearStorage(a), (0, r.U2)(e, a, {
                cacheResponse: !0
              }).then(function (e) {
                var t = (0, o.sE)(e.keys, {
                  kid: n
                });
                if (t) return t;
                throw new i.Z("The key id, " + n + ", was not found in the server's keys");
              });
            });
          }
        },
        8707: function _(e, t, n) {
          "use strict";

          n.d(t, {
            r: function r() {
              return c;
            }
          });
          var r = n(7599),
            o = n(7756),
            i = n(3193),
            a = n(9231),
            u = n(8676);
          function c(e, t, n) {
            n = n || (0, r.Fc)(e, t);
            var c = t = Object.assign({}, (0, o.D)(e), (0, i.d9)(t)),
              s = c.authorizationCode,
              f = c.interactionCode,
              l = c.codeVerifier,
              p = c.clientId,
              h = c.redirectUri,
              d = c.scopes,
              v = c.ignoreSignature,
              y = c.state,
              g = c.acrValues,
              m = {
                clientId: p,
                redirectUri: h,
                authorizationCode: s,
                interactionCode: f,
                codeVerifier: l
              };
            return (0, a.t)(e, m, n).then(function (t) {
              var r = ["token"];
              -1 !== d.indexOf("openid") && r.push("id_token");
              var o = {
                clientId: p,
                redirectUri: h,
                scopes: d,
                responseType: r,
                ignoreSignature: v,
                acrValues: g
              };
              return (0, u.s)(e, o, t, n).then(function (e) {
                return e.code = s, e.state = y, e;
              });
            })["finally"](function () {
              e.transactionManager.clear();
            });
          }
        },
        5324: function _(e, t, n) {
          "use strict";

          n.d(t, {
            $: function $() {
              return E;
            },
            o: function o() {
              return Z;
            }
          });
          var r = n(3548),
            o = n(1237),
            i = n(8707),
            a = n(6844),
            u = n(7625),
            c = n(9770),
            s = n(6803),
            f = n(5372),
            l = n(2476),
            p = n(6268),
            h = n(781),
            d = n(6466),
            v = n(8113),
            y = n(6898),
            g = n(8221),
            m = n(1260),
            b = n(3193),
            k = n(6757),
            w = n(8080),
            O = n(2206);
          function T(e, t) {
            t = (0, b.d9)(t) || {};
            var n = (0, k.U)(e, t),
              r = (0, w.A)(e, n),
              o = r.urls.authorizeUrl + (0, O.R)(n);
            e.transactionManager.save(r), e.options.setLocation ? e.options.setLocation(o) : window.location.assign(o);
          }
          function Z(e, t) {
            var n = function n(e) {
                return r.b.prototype.push.bind(t, e, null);
              },
              b = n(s.H.bind(null, e)),
              k = n(f.ko.bind(null, e)),
              w = Object.assign(k, {
                _getHistory: function _getHistory() {
                  return window.history;
                },
                _getLocation: function _getLocation() {
                  return window.location;
                },
                _getDocument: function _getDocument() {
                  return window.document;
                }
              }),
              O = {
                prepareTokenParams: y.wu.bind(null, e),
                exchangeCodeForTokens: i.r.bind(null, e),
                getWithoutPrompt: u.y.bind(null, e),
                getWithPopup: c.d.bind(null, e),
                getWithRedirect: b,
                parseFromUrl: w,
                decode: o.T,
                revoke: d.P.bind(null, e),
                renew: l.$.bind(null, e),
                renewTokensWithRefresh: h.R.bind(null, e),
                renewTokens: p.I.bind(null, e),
                getUserInfo: function getUserInfo(t, n) {
                  return (0, a.b)(e, t, n);
                },
                verify: m.W.bind(null, e),
                isLoginRedirect: g.gM.bind(null, e),
                introspect: v.j.bind(null, e)
              };
            return ["getWithoutPrompt", "getWithPopup", "revoke", "renew", "renewTokensWithRefresh", "renewTokens"].forEach(function (e) {
              O[e] = n(O[e]);
            }), O;
          }
          function E(e) {
            return {
              authorize: {
                enrollAuthenticator: T.bind(null, e)
              }
            };
          }
        },
        231: function _(e, t, n) {
          "use strict";

          n.d(t, {
            $V: function $V() {
              return r.$;
            },
            zr: function zr() {
              return s;
            },
            o5: function o5() {
              return r.o;
            }
          });
          var r = n(5324),
            o = n(9893),
            i = n(265),
            a = n(3980),
            u = n(279),
            c = n(2724);
          function s(e, t, n) {
            var r = (0, o.a)(t),
              s = (0, i.H)(r, e),
              f = (0, u.A)(s),
              l = (0, a.Z)(f);
            return (0, c.J)(l, n);
          }
        },
        3253: function _(e, t, n) {
          "use strict";

          n.d(t, {
            L: function L() {
              return s;
            }
          });
          var r = n(7599),
            o = n(4970),
            i = n(9123),
            a = n(6898),
            u = n(2206),
            c = n(8676);
          function s(e, t) {
            if (arguments.length > 2) return Promise.reject(new i.Z('As of version 3.0, "getToken" takes only a single set of options'));
            var n = (t = t || {}).popupWindow;
            return t.popupWindow = void 0, (0, a.wu)(e, t).then(function (a) {
              var s, f;
              switch (t.sessionToken ? Object.assign(a, {
                prompt: "none",
                responseMode: "okta_post_message",
                display: null
              }) : t.idp && Object.assign(a, {
                display: "popup"
              }), f = (0, r.Fc)(e, a), s = (t.codeVerifier ? f.tokenUrl : f.authorizeUrl) + (0, u.R)(a), a.sessionToken || null === a.display ? "IFRAME" : "popup" === a.display ? "POPUP" : "IMPLICIT") {
                case "IFRAME":
                  var l = (0, o.iC)(e, t.timeout, a.state),
                    p = (0, o.Rl)(s);
                  return l.then(function (t) {
                    return (0, c.s)(e, a, t, f);
                  })["finally"](function () {
                    var e;
                    document.body.contains(p) && (null === (e = p.parentElement) || void 0 === e || e.removeChild(p));
                  });
                case "POPUP":
                  var h;
                  if ("okta_post_message" === a.responseMode) {
                    if (!e.features.isPopupPostMessageSupported()) throw new i.Z("This browser doesn't have full postMessage support");
                    h = (0, o.iC)(e, t.timeout, a.state);
                  }
                  return n && n.location.assign(s), new Promise(function (e, t) {
                    var r = setInterval(function () {
                      n && !n.closed || (clearInterval(r), t(new i.Z("Unable to parse OAuth flow response")));
                    }, 100);
                    h.then(function (t) {
                      clearInterval(r), e(t);
                    })["catch"](function (e) {
                      clearInterval(r), t(e);
                    });
                  }).then(function (t) {
                    return (0, c.s)(e, a, t, f);
                  })["finally"](function () {
                    n && !n.closed && n.close();
                  });
                default:
                  throw new i.Z("The full page redirect flow is not supported");
              }
            });
          }
        },
        6844: function _(e, t, n) {
          "use strict";

          n.d(t, {
            b: function b() {
              return l;
            }
          });
          var r = n(5861),
            o = n(4687),
            i = n.n(o),
            a = n(4771),
            u = n(9123),
            c = n(2886),
            s = n(5385),
            f = n(6488);
          function l(e, t, n) {
            return p.apply(this, arguments);
          }
          function p() {
            return (p = (0, r.Z)(i().mark(function e(t, n, r) {
              return i().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if (n) {
                      e.next = 4;
                      break;
                    }
                    return e.next = 3, t.tokenManager.getTokens();
                  case 3:
                    n = e.sent.accessToken;
                  case 4:
                    if (r) {
                      e.next = 8;
                      break;
                    }
                    return e.next = 7, t.tokenManager.getTokens();
                  case 7:
                    r = e.sent.idToken;
                  case 8:
                    if (n && (0, f.hv)(n)) {
                      e.next = 10;
                      break;
                    }
                    return e.abrupt("return", Promise.reject(new u.Z("getUserInfo requires an access token object")));
                  case 10:
                    if (r && (0, f.sI)(r)) {
                      e.next = 12;
                      break;
                    }
                    return e.abrupt("return", Promise.reject(new u.Z("getUserInfo requires an ID token object")));
                  case 12:
                    return e.abrupt("return", (0, s.c3)(t, {
                      url: n.userinfoUrl,
                      method: "GET",
                      accessToken: n.accessToken
                    }).then(function (e) {
                      return e.sub === r.claims.sub ? e : Promise.reject(new u.Z("getUserInfo request was rejected due to token mismatch"));
                    })["catch"](function (e) {
                      var t;
                      if (e.xhr && (401 === e.xhr.status || 403 === e.xhr.status) && (e.xhr.headers && (0, a.mf)(e.xhr.headers.get) && e.xhr.headers.get("WWW-Authenticate") ? t = e.xhr.headers.get("WWW-Authenticate") : (0, a.mf)(e.xhr.getResponseHeader) && (t = e.xhr.getResponseHeader("WWW-Authenticate")), t)) {
                        var n = t.match(/error="(.*?)"/) || [],
                          r = t.match(/error_description="(.*?)"/) || [],
                          o = n[1],
                          i = r[1];
                        o && i && (e = new c.Z(o, i));
                      }
                      throw e;
                    }));
                  case 13:
                  case "end":
                    return e.stop();
                }
              }, e);
            }))).apply(this, arguments);
          }
        },
        9770: function _(e, t, n) {
          "use strict";

          n.d(t, {
            d: function d() {
              return u;
            }
          });
          var r = n(9123),
            o = n(3193),
            i = n(3253),
            a = n(4970);
          function u(e, t) {
            if (arguments.length > 2) return Promise.reject(new r.Z('As of version 3.0, "getWithPopup" takes only a single set of options'));
            var n = (0, a.pU)("/", t);
            return t = (0, o.d9)(t) || {}, Object.assign(t, {
              display: "popup",
              responseMode: "okta_post_message",
              popupWindow: n
            }), (0, i.L)(e, t);
          }
        },
        6803: function _(e, t, n) {
          "use strict";

          n.d(t, {
            H: function H() {
              return l;
            }
          });
          var r = n(5861),
            o = n(4687),
            i = n.n(o),
            a = n(9123),
            u = n(3193),
            c = n(6898),
            s = n(2865),
            f = n(2206);
          function l(e, t) {
            return p.apply(this, arguments);
          }
          function p() {
            return p = (0, r.Z)(i().mark(function e(t, n) {
              var r,
                o,
                l,
                p = arguments;
              return i().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if (!(p.length > 2)) {
                      e.next = 2;
                      break;
                    }
                    return e.abrupt("return", Promise.reject(new a.Z('As of version 3.0, "getWithRedirect" takes only a single set of options')));
                  case 2:
                    return n = (0, u.d9)(n) || {}, e.next = 5, (0, c.wu)(t, n);
                  case 5:
                    r = e.sent, o = (0, s.H)(t, r), l = o.urls.authorizeUrl + (0, f.R)(r), t.transactionManager.save(o), t.options.setLocation ? t.options.setLocation(l) : window.location.assign(l);
                  case 10:
                  case "end":
                    return e.stop();
                }
              }, e);
            })), p.apply(this, arguments);
          }
        },
        7625: function _(e, t, n) {
          "use strict";

          n.d(t, {
            y: function y() {
              return a;
            }
          });
          var r = n(9123),
            o = n(3193),
            i = n(3253);
          function a(e, t) {
            return arguments.length > 2 ? Promise.reject(new r.Z('As of version 3.0, "getWithoutPrompt" takes only a single set of options')) : (t = (0, o.d9)(t) || {}, Object.assign(t, {
              prompt: "none",
              responseMode: "okta_post_message",
              display: null
            }), (0, i.L)(e, t));
          }
        },
        8676: function _(e, t, n) {
          "use strict";

          n.d(t, {
            s: function s() {
              return h;
            }
          });
          var r = n(5861),
            o = n(4687),
            i = n.n(o),
            a = n(3193),
            u = n(7599),
            c = n(2886),
            s = n(9123),
            f = n(1260),
            l = n(7756);
          function p(e, t) {
            if (e.error && e.error_description) throw new c.Z(e.error, e.error_description);
            if (e.state !== t.state) throw new s.Z("OAuth flow response state doesn't match request state");
          }
          function h(e, t, n, r) {
            return d.apply(this, arguments);
          }
          function d() {
            return (d = (0, r.Z)(i().mark(function e(t, n, r, o) {
              var c, h, d, v, y, g, m, b, k, w, O, T, Z, E;
              return i().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if (!1 === t.options.pkce || !r.code && !r.interaction_code) {
                      e.next = 3;
                      break;
                    }
                    return e.abrupt("return", t.token.exchangeCodeForTokens(Object.assign({}, n, {
                      authorizationCode: r.code,
                      interactionCode: r.interaction_code
                    }), o));
                  case 3:
                    if (n = n || (0, l.D)(t), o = o || (0, u.Fc)(t, n), c = n.responseType || [], Array.isArray(c) || "none" === c || (c = [c]), h = r.scope ? r.scope.split(" ") : (0, a.d9)(n.scopes), d = n.clientId || t.options.clientId, p(r, n), v = {}, y = r.expires_in, g = r.token_type, m = r.access_token, b = r.id_token, k = r.refresh_token, w = Math.floor(Date.now() / 1e3), m && (O = t.token.decode(m), v.accessToken = {
                      accessToken: m,
                      claims: O.payload,
                      expiresAt: Number(y) + w,
                      tokenType: g,
                      scopes: h,
                      authorizeUrl: o.authorizeUrl,
                      userinfoUrl: o.userinfoUrl
                    }), k && (v.refreshToken = {
                      refreshToken: k,
                      expiresAt: Number(y) + w,
                      scopes: h,
                      tokenUrl: o.tokenUrl,
                      authorizeUrl: o.authorizeUrl,
                      issuer: o.issuer
                    }), !b) {
                      e.next = 27;
                      break;
                    }
                    return T = t.token.decode(b), Z = {
                      idToken: b,
                      claims: T.payload,
                      expiresAt: T.payload.exp - T.payload.iat + w,
                      scopes: h,
                      authorizeUrl: o.authorizeUrl,
                      issuer: o.issuer,
                      clientId: d
                    }, E = {
                      clientId: d,
                      issuer: o.issuer,
                      nonce: n.nonce,
                      accessToken: m,
                      acrValues: n.acrValues
                    }, void 0 !== n.ignoreSignature && (E.ignoreSignature = n.ignoreSignature), e.next = 26, (0, f.W)(t, Z, E);
                  case 26:
                    v.idToken = Z;
                  case 27:
                    if (-1 === c.indexOf("token") || v.accessToken) {
                      e.next = 29;
                      break;
                    }
                    throw new s.Z('Unable to parse OAuth flow response: response type "token" was requested but "access_token" was not returned.');
                  case 29:
                    if (-1 === c.indexOf("id_token") || v.idToken) {
                      e.next = 31;
                      break;
                    }
                    throw new s.Z('Unable to parse OAuth flow response: response type "id_token" was requested but "id_token" was not returned.');
                  case 31:
                    return e.abrupt("return", {
                      tokens: v,
                      state: r.state,
                      code: r.code,
                      responseType: c
                    });
                  case 32:
                  case "end":
                    return e.stop();
                }
              }, e);
            }))).apply(this, arguments);
          }
        },
        9443: function _(e, t, n) {
          "use strict";

          n.r(t), n.d(t, {
            TokenManager: function TokenManager() {
              return l.M;
            },
            addListener: function addListener() {
              return h.NH;
            },
            addPostMessageListener: function addPostMessageListener() {
              return h.iC;
            },
            assertPKCESupport: function assertPKCESupport() {
              return h.vz;
            },
            buildAuthorizeParams: function buildAuthorizeParams() {
              return a.R0;
            },
            convertTokenParamsToOAuthParams: function convertTokenParamsToOAuthParams() {
              return a._6;
            },
            createEndpoints: function createEndpoints() {
              return r.$V;
            },
            createEnrollAuthenticatorMeta: function createEnrollAuthenticatorMeta() {
              return h.AW;
            },
            createOAuthMeta: function createOAuthMeta() {
              return h.H;
            },
            createOAuthOptionsConstructor: function createOAuthOptionsConstructor() {
              return u.m;
            },
            createOAuthStorageManager: function createOAuthStorageManager() {
              return i.a;
            },
            createOktaAuthOAuth: function createOktaAuthOAuth() {
              return r.zr;
            },
            createTokenAPI: function createTokenAPI() {
              return r.o5;
            },
            createTransactionManager: function createTransactionManager() {
              return p.P;
            },
            decodeToken: function decodeToken() {
              return d.T;
            },
            exchangeCodeForTokens: function exchangeCodeForTokens() {
              return O.r;
            },
            generateNonce: function generateNonce() {
              return h.PY;
            },
            generateState: function generateState() {
              return h.aV;
            },
            getDefaultEnrollAuthenticatorParams: function getDefaultEnrollAuthenticatorParams() {
              return h.cE;
            },
            getDefaultTokenParams: function getDefaultTokenParams() {
              return h.Dx;
            },
            getHashOrSearch: function getHashOrSearch() {
              return h.O2;
            },
            getKey: function getKey() {
              return a.km;
            },
            getOAuthBaseUrl: function getOAuthBaseUrl() {
              return h.zf;
            },
            getOAuthDomain: function getOAuthDomain() {
              return h.Xp;
            },
            getOAuthUrls: function getOAuthUrls() {
              return h.Fc;
            },
            getToken: function getToken() {
              return T.L;
            },
            getUserInfo: function getUserInfo() {
              return k.b;
            },
            getWellKnown: function getWellKnown() {
              return a.ES;
            },
            getWithPopup: function getWithPopup() {
              return E.d;
            },
            getWithRedirect: function getWithRedirect() {
              return S.H;
            },
            getWithoutPrompt: function getWithoutPrompt() {
              return Z.y;
            },
            handleOAuthResponse: function handleOAuthResponse() {
              return w.s;
            },
            hasAuthorizationCode: function hasAuthorizationCode() {
              return h.ZP;
            },
            hasErrorInUrl: function hasErrorInUrl() {
              return h.hg;
            },
            hasInteractionCode: function hasInteractionCode() {
              return h.d_;
            },
            hasTokensInHash: function hasTokensInHash() {
              return h.kU;
            },
            isAuthorizationCodeError: function isAuthorizationCodeError() {
              return h.tC;
            },
            isCodeFlow: function isCodeFlow() {
              return h.Ik;
            },
            isInteractionRequired: function isInteractionRequired() {
              return h.wc;
            },
            isInteractionRequiredError: function isInteractionRequiredError() {
              return h.Cf;
            },
            isLoginRedirect: function isLoginRedirect() {
              return h.gM;
            },
            isRedirectUri: function isRedirectUri() {
              return h.Qs;
            },
            isRefreshTokenError: function isRefreshTokenError() {
              return h.Yo;
            },
            isRefreshTokenInvalidError: function isRefreshTokenInvalidError() {
              return h.$E;
            },
            isSameRefreshToken: function isSameRefreshToken() {
              return h.q0;
            },
            loadFrame: function loadFrame() {
              return h.Rl;
            },
            loadPopup: function loadPopup() {
              return h.pU;
            },
            mixinOAuth: function mixinOAuth() {
              return o.J;
            },
            oidcIntrospect: function oidcIntrospect() {
              return P.j;
            },
            parseFromUrl: function parseFromUrl() {
              return x.ko;
            },
            pkce: function pkce() {
              return h.U5;
            },
            postRefreshToken: function postRefreshToken() {
              return a.Dp;
            },
            postToTokenEndpoint: function postToTokenEndpoint() {
              return a.ti;
            },
            prepareEnrollAuthenticatorParams: function prepareEnrollAuthenticatorParams() {
              return h.Uc;
            },
            preparePKCE: function preparePKCE() {
              return h.mi;
            },
            prepareTokenParams: function prepareTokenParams() {
              return h.wu;
            },
            removeListener: function removeListener() {
              return h.ys;
            },
            renewToken: function renewToken() {
              return y.$;
            },
            renewTokens: function renewTokens() {
              return m.I;
            },
            renewTokensWithRefresh: function renewTokensWithRefresh() {
              return g.R;
            },
            revokeToken: function revokeToken() {
              return v.P;
            },
            urlParamsToObject: function urlParamsToObject() {
              return h.vL;
            },
            validateClaims: function validateClaims() {
              return h.pj;
            },
            validateCodeChallengeMethod: function validateCodeChallengeMethod() {
              return h.br;
            },
            validateToken: function validateToken() {
              return h.Rp;
            },
            verifyToken: function verifyToken() {
              return b.W;
            }
          });
          var r = n(231),
            o = n(2724),
            i = n(2333),
            a = n(2642),
            u = n(3775),
            c = n(8927),
            s = {};
          for (var f in c) ["default", "decodeToken", "revokeToken", "renewToken", "renewTokensWithRefresh", "renewTokens", "verifyToken", "getUserInfo", "handleOAuthResponse", "exchangeCodeForTokens", "getToken", "getWithoutPrompt", "getWithPopup", "getWithRedirect", "parseFromUrl", "oidcIntrospect", "createEndpoints", "createOktaAuthOAuth", "createTokenAPI", "mixinOAuth", "createOAuthStorageManager", "buildAuthorizeParams", "convertTokenParamsToOAuthParams", "getKey", "getWellKnown", "postRefreshToken", "postToTokenEndpoint", "createOAuthOptionsConstructor"].indexOf(f) < 0 && (s[f] = function (e) {
            return c[e];
          }.bind(0, f));
          n.d(t, s);
          var l = n(2427),
            p = n(1646),
            h = n(8785),
            d = n(1237),
            v = n(6466),
            y = n(2476),
            g = n(781),
            m = n(6268),
            b = n(1260),
            k = n(6844),
            w = n(8676),
            O = n(8707),
            T = n(3253),
            Z = n(7625),
            E = n(9770),
            S = n(6803),
            x = n(5372),
            P = n(8113);
        },
        8113: function _(e, t, n) {
          "use strict";

          n.d(t, {
            j: function j() {
              return h;
            }
          });
          var r = n(5861),
            o = n(4687),
            i = n.n(o),
            a = n(9123),
            u = n(52),
            c = n(5385),
            s = n(6718),
            f = n(7594),
            l = n(6488),
            p = {
              accessToken: "access_token",
              idToken: "id_token",
              refreshToken: "refresh_token"
            };
          function h(e, t, n) {
            return d.apply(this, arguments);
          }
          function d() {
            return (d = (0, r.Z)(i().mark(function e(t, n, r) {
              var o, h, d, v, y, g, m, b, k, w, O;
              return i().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if (d = t.options.clientId, v = t.options.clientSecret, r || (r = t.tokenManager.getTokens()[n]), r) {
                      e.next = 5;
                      break;
                    }
                    throw new a.Z("unable to find ".concat(n, " in storage or fn params"));
                  case 5:
                    if (h = n !== l.T6.ACCESS ? null === (y = r) || void 0 === y ? void 0 : y.issuer : null === (g = r) || void 0 === g || null === (m = g.claims) || void 0 === m ? void 0 : m.iss, null !== (o = h) && void 0 !== o || (h = t.options.issuer), d) {
                      e.next = 9;
                      break;
                    }
                    throw new a.Z("A clientId must be specified in the OktaAuth constructor to introspect a token");
                  case 9:
                    if (h) {
                      e.next = 11;
                      break;
                    }
                    throw new a.Z("Unable to find issuer");
                  case 11:
                    return e.next = 13, (0, u.E)(t, h);
                  case 13:
                    return b = e.sent, k = b.introspection_endpoint, w = v ? (0, f.r3)("".concat(d, ":").concat(v)) : (0, f.r3)(d), O = (0, s.UK)({
                      token_type_hint: p[n],
                      token: r[n]
                    }).slice(1), e.abrupt("return", (0, c.v_)(t, k, O, {
                      headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        Authorization: "Basic " + w
                      }
                    }));
                  case 18:
                  case "end":
                    return e.stop();
                }
              }, e);
            }))).apply(this, arguments);
          }
        },
        2724: function _(e, t, n) {
          "use strict";

          n.d(t, {
            J: function J() {
              return P;
            }
          });
          var r = n(4925),
            o = n(5861),
            i = n(5671),
            a = n(3144),
            u = n(7326),
            c = n(1752),
            s = n(136),
            f = n(2963),
            l = n(1120),
            p = n(4942),
            h = n(4687),
            d = n.n(h),
            v = n(5385),
            y = n(3548),
            g = n(9718),
            m = n(3611),
            b = n(5324),
            k = n(2427),
            w = n(8221),
            O = n(7599),
            T = n(1971),
            Z = n(4858);
          var E = ["originalUri"];
          function S(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function x(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? S(Object(n), !0).forEach(function (t) {
                (0, p.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : S(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          function P(e, t) {
            var n,
              h = function (e) {
                (0, s.Z)(o, e);
                var t,
                  n,
                  r = (t = o, n = function () {
                    if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                    if (Reflect.construct.sham) return !1;
                    if ("function" == typeof Proxy) return !0;
                    try {
                      return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                    } catch (e) {
                      return !1;
                    }
                  }(), function () {
                    var e,
                      r = (0, l.Z)(t);
                    if (n) {
                      var o = (0, l.Z)(this).constructor;
                      e = Reflect.construct(r, arguments, o);
                    } else e = r.apply(this, arguments);
                    return (0, f.Z)(this, e);
                  });
                function o() {
                  return (0, i.Z)(this, o), r.apply(this, arguments);
                }
                return (0, a.Z)(o, [{
                  key: "setOriginalUri",
                  value: function value(e, t) {
                    Z.Z.getSessionStorage().setItem(T.REFERRER_PATH_STORAGE_KEY, e), (t = t || this.options.state) && this.storageManager.getOriginalUriStorage().setItem(t, e);
                  }
                }, {
                  key: "getOriginalUri",
                  value: function value(e) {
                    if (e = e || this.options.state) {
                      var t = this.storageManager.getOriginalUriStorage().getItem(e);
                      if (t) return t;
                    }
                    var n = Z.Z.getSessionStorage();
                    return n && n.getItem(T.REFERRER_PATH_STORAGE_KEY) || void 0;
                  }
                }, {
                  key: "removeOriginalUri",
                  value: function value(e) {
                    if (Z.Z.getSessionStorage().removeItem(T.REFERRER_PATH_STORAGE_KEY), e = e || this.options.state) {
                      var t = this.storageManager.getOriginalUriStorage();
                      t.removeItem && t.removeItem(e);
                    }
                  }
                }]), o;
              }(e);
            return n = function (e) {
              (0, s.Z)(C, e);
              var n,
                h,
                g,
                T,
                Z,
                S,
                P,
                A,
                _,
                R,
                j = (_ = C, R = function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                  } catch (e) {
                    return !1;
                  }
                }(), function () {
                  var e,
                    t = (0, l.Z)(_);
                  if (R) {
                    var n = (0, l.Z)(this).constructor;
                    e = Reflect.construct(t, arguments, n);
                  } else e = t.apply(this, arguments);
                  return (0, f.Z)(this, e);
                });
              function C() {
                var e;
                (0, i.Z)(this, C);
                for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) r[o] = arguments[o];
                return e = j.call.apply(j, [this].concat(r)), (0, p.Z)((0, u.Z)(e), "token", void 0), (0, p.Z)((0, u.Z)(e), "tokenManager", void 0), (0, p.Z)((0, u.Z)(e), "transactionManager", void 0), (0, p.Z)((0, u.Z)(e), "pkce", void 0), (0, p.Z)((0, u.Z)(e), "endpoints", void 0), (0, p.Z)((0, u.Z)(e), "_pending", void 0), (0, p.Z)((0, u.Z)(e), "_tokenQueue", void 0), e.transactionManager = new t(Object.assign({
                  storageManager: e.storageManager
                }, e.options.transactionManager)), e.pkce = {
                  DEFAULT_CODE_CHALLENGE_METHOD: m.Z.DEFAULT_CODE_CHALLENGE_METHOD,
                  generateVerifier: m.Z.generateVerifier,
                  computeChallenge: m.Z.computeChallenge
                }, e._pending = {
                  handleLogin: !1
                }, e._tokenQueue = new y.b(), e.token = (0, b.o)((0, u.Z)(e), e._tokenQueue), e.tokenManager = new k.M((0, u.Z)(e), e.options.tokenManager), e.endpoints = (0, b.$)((0, u.Z)(e)), e;
              }
              return (0, a.Z)(C, [{
                key: "clearStorage",
                value: function value() {
                  (0, c.Z)((0, l.Z)(C.prototype), "clearStorage", this).call(this), this.tokenManager.clear();
                }
              }, {
                key: "isAuthenticated",
                value: (A = (0, o.Z)(d().mark(function e() {
                  var t,
                    n,
                    r,
                    o,
                    i,
                    a,
                    u,
                    c,
                    s,
                    f,
                    l = arguments;
                  return d().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        if (t = l.length > 0 && void 0 !== l[0] ? l[0] : {}, n = this.tokenManager.getOptions(), r = n.autoRenew, o = n.autoRemove, i = t.onExpiredToken ? "renew" === t.onExpiredToken : r, a = t.onExpiredToken ? "remove" === t.onExpiredToken : o, u = this.tokenManager.getTokensSync(), !(c = u.accessToken) || !this.tokenManager.hasExpired(c)) {
                          e.next = 19;
                          break;
                        }
                        if (c = void 0, !i) {
                          e.next = 18;
                          break;
                        }
                        return e.prev = 8, e.next = 11, this.tokenManager.renew("accessToken");
                      case 11:
                        c = e.sent, e.next = 16;
                        break;
                      case 14:
                        e.prev = 14, e.t0 = e["catch"](8);
                      case 16:
                        e.next = 19;
                        break;
                      case 18:
                        a && this.tokenManager.remove("accessToken");
                      case 19:
                        if (s = this.tokenManager.getTokensSync(), !(f = s.idToken) || !this.tokenManager.hasExpired(f)) {
                          e.next = 34;
                          break;
                        }
                        if (f = void 0, !i) {
                          e.next = 33;
                          break;
                        }
                        return e.prev = 23, e.next = 26, this.tokenManager.renew("idToken");
                      case 26:
                        f = e.sent, e.next = 31;
                        break;
                      case 29:
                        e.prev = 29, e.t1 = e["catch"](23);
                      case 31:
                        e.next = 34;
                        break;
                      case 33:
                        a && this.tokenManager.remove("idToken");
                      case 34:
                        return e.abrupt("return", !(!c || !f));
                      case 35:
                      case "end":
                        return e.stop();
                    }
                  }, e, this, [[8, 14], [23, 29]]);
                })), function () {
                  return A.apply(this, arguments);
                })
              }, {
                key: "signInWithRedirect",
                value: (P = (0, o.Z)(d().mark(function e() {
                  var t,
                    n,
                    o,
                    i,
                    a = arguments;
                  return d().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        if (n = (t = a.length > 0 && void 0 !== a[0] ? a[0] : {}).originalUri, o = (0, r.Z)(t, E), !this._pending.handleLogin) {
                          e.next = 4;
                          break;
                        }
                        return e.abrupt("return");
                      case 4:
                        return this._pending.handleLogin = !0, e.prev = 5, n && this.setOriginalUri(n), i = Object.assign({
                          scopes: this.options.scopes || ["openid", "email", "profile"]
                        }, o), e.next = 10, this.token.getWithRedirect(i);
                      case 10:
                        return e.prev = 10, this._pending.handleLogin = !1, e.finish(10);
                      case 13:
                      case "end":
                        return e.stop();
                    }
                  }, e, this, [[5,, 10, 13]]);
                })), function () {
                  return P.apply(this, arguments);
                })
              }, {
                key: "getUser",
                value: (S = (0, o.Z)(d().mark(function e() {
                  var t, n, r;
                  return d().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        return t = this.tokenManager.getTokensSync(), n = t.idToken, r = t.accessToken, e.abrupt("return", this.token.getUserInfo(r, n));
                      case 2:
                      case "end":
                        return e.stop();
                    }
                  }, e, this);
                })), function () {
                  return S.apply(this, arguments);
                })
              }, {
                key: "getIdToken",
                value: function value() {
                  var e = this.tokenManager.getTokensSync().idToken;
                  return e ? e.idToken : void 0;
                }
              }, {
                key: "getAccessToken",
                value: function value() {
                  var e = this.tokenManager.getTokensSync().accessToken;
                  return e ? e.accessToken : void 0;
                }
              }, {
                key: "getRefreshToken",
                value: function value() {
                  var e = this.tokenManager.getTokensSync().refreshToken;
                  return e ? e.refreshToken : void 0;
                }
              }, {
                key: "storeTokensFromRedirect",
                value: (Z = (0, o.Z)(d().mark(function e() {
                  var t, n;
                  return d().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        return e.next = 2, this.token.parseFromUrl();
                      case 2:
                        t = e.sent, n = t.tokens, "none" !== t.responseType && this.tokenManager.setTokens(n);
                      case 6:
                      case "end":
                        return e.stop();
                    }
                  }, e, this);
                })), function () {
                  return Z.apply(this, arguments);
                })
              }, {
                key: "isLoginRedirect",
                value: function value() {
                  return (0, w.gM)(this);
                }
              }, {
                key: "isPKCE",
                value: function value() {
                  return !!this.options.pkce;
                }
              }, {
                key: "hasResponseType",
                value: function value(e) {
                  return Array.isArray(this.options.responseType) && this.options.responseType.length ? this.options.responseType.indexOf(e) >= 0 : this.options.responseType === e;
                }
              }, {
                key: "isAuthorizationCodeFlow",
                value: function value() {
                  return this.hasResponseType("code");
                }
              }, {
                key: "invokeApiMethod",
                value: (T = (0, o.Z)(d().mark(function e(t) {
                  var n;
                  return d().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        if (t.accessToken) {
                          e.next = 5;
                          break;
                        }
                        return e.next = 3, this.tokenManager.getTokens();
                      case 3:
                        n = e.sent.accessToken, t.accessToken = null == n ? void 0 : n.accessToken;
                      case 5:
                        return e.abrupt("return", (0, v.c3)(this, t));
                      case 6:
                      case "end":
                        return e.stop();
                    }
                  }, e, this);
                })), function (e) {
                  return T.apply(this, arguments);
                })
              }, {
                key: "revokeAccessToken",
                value: (g = (0, o.Z)(d().mark(function e(t) {
                  var n;
                  return d().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        if (t) {
                          e.next = 6;
                          break;
                        }
                        return e.next = 3, this.tokenManager.getTokens();
                      case 3:
                        t = e.sent.accessToken, n = this.tokenManager.getStorageKeyByType("accessToken"), this.tokenManager.remove(n);
                      case 6:
                        if (t) {
                          e.next = 8;
                          break;
                        }
                        return e.abrupt("return", Promise.resolve(null));
                      case 8:
                        return e.abrupt("return", this.token.revoke(t));
                      case 9:
                      case "end":
                        return e.stop();
                    }
                  }, e, this);
                })), function (e) {
                  return g.apply(this, arguments);
                })
              }, {
                key: "revokeRefreshToken",
                value: (h = (0, o.Z)(d().mark(function e(t) {
                  var n;
                  return d().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        if (t) {
                          e.next = 6;
                          break;
                        }
                        return e.next = 3, this.tokenManager.getTokens();
                      case 3:
                        t = e.sent.refreshToken, n = this.tokenManager.getStorageKeyByType("refreshToken"), this.tokenManager.remove(n);
                      case 6:
                        if (t) {
                          e.next = 8;
                          break;
                        }
                        return e.abrupt("return", Promise.resolve(null));
                      case 8:
                        return e.abrupt("return", this.token.revoke(t));
                      case 9:
                      case "end":
                        return e.stop();
                    }
                  }, e, this);
                })), function (e) {
                  return h.apply(this, arguments);
                })
              }, {
                key: "getSignOutRedirectUrl",
                value: function value() {
                  var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
                    t = e.idToken,
                    n = e.postLogoutRedirectUri,
                    r = e.state;
                  if (t || (t = this.tokenManager.getTokensSync().idToken), !t) return "";
                  void 0 === n && (n = this.options.postLogoutRedirectUri);
                  var o = (0, O.Fc)(this).logoutUrl,
                    i = t.idToken,
                    a = o + "?id_token_hint=" + encodeURIComponent(i);
                  return n && (a += "&post_logout_redirect_uri=" + encodeURIComponent(n)), r && (a += "&state=" + encodeURIComponent(r)), a;
                }
              }, {
                key: "signOut",
                value: (n = (0, o.Z)(d().mark(function e(t) {
                  var n, r, o, i, a, u, c, s, f, l, p, h;
                  return d().wrap(function (e) {
                    for (;;) switch (e.prev = e.next) {
                      case 0:
                        if (t = Object.assign({}, t), r = window.location.origin, o = window.location.href, i = null === t.postLogoutRedirectUri ? null : t.postLogoutRedirectUri || this.options.postLogoutRedirectUri || r, a = null === (n = t) || void 0 === n ? void 0 : n.state, u = t.accessToken, c = t.refreshToken, s = !1 !== t.revokeAccessToken, (f = !1 !== t.revokeRefreshToken) && void 0 === c && (c = this.tokenManager.getTokensSync().refreshToken), s && void 0 === u && (u = this.tokenManager.getTokensSync().accessToken), t.idToken || (t.idToken = this.tokenManager.getTokensSync().idToken), !f || !c) {
                          e.next = 15;
                          break;
                        }
                        return e.next = 15, this.revokeRefreshToken(c);
                      case 15:
                        if (!s || !u) {
                          e.next = 18;
                          break;
                        }
                        return e.next = 18, this.revokeAccessToken(u);
                      case 18:
                        if (l = this.getSignOutRedirectUrl(x(x({}, t), {}, {
                          postLogoutRedirectUri: i
                        }))) {
                          e.next = 29;
                          break;
                        }
                        return e.next = 22, this.closeSession();
                      case 22:
                        return p = e.sent, h = new URL(i || r), a && h.searchParams.append("state", a), i === o ? window.location.href = h.href : window.location.assign(h.href), e.abrupt("return", p);
                      case 29:
                        return t.clearTokensBeforeRedirect ? this.tokenManager.clear() : this.tokenManager.addPendingRemoveFlags(), window.location.assign(l), e.abrupt("return", !0);
                      case 32:
                      case "end":
                        return e.stop();
                    }
                  }, e, this);
                })), function (e) {
                  return n.apply(this, arguments);
                })
              }]), C;
            }(h), (0, p.Z)(n, "crypto", g), n;
          }
        },
        9453: function _(e, t, n) {
          "use strict";

          n.d(t, {
            m: function m() {
              return g;
            }
          });
          var r = n(3144),
            o = n(5671),
            i = n(7326),
            a = n(136),
            u = n(2963),
            c = n(1120),
            s = n(4942),
            f = n(1971),
            l = n(6718),
            p = n(415),
            h = n(8817),
            d = !0,
            v = n(9123);
          function y(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function g() {
            return function (e) {
              (0, a.Z)(g, e);
              var t,
                n,
                h = (t = g, n = function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                  } catch (e) {
                    return !1;
                  }
                }(), function () {
                  var e,
                    r = (0, c.Z)(t);
                  if (n) {
                    var o = (0, c.Z)(this).constructor;
                    e = Reflect.construct(r, arguments, o);
                  } else e = r.apply(this, arguments);
                  return (0, u.Z)(this, e);
                });
              function g(e) {
                var t;
                return (0, o.Z)(this, g), t = h.call(this, e), (0, s.Z)((0, i.Z)(t), "issuer", void 0), (0, s.Z)((0, i.Z)(t), "authorizeUrl", void 0), (0, s.Z)((0, i.Z)(t), "userinfoUrl", void 0), (0, s.Z)((0, i.Z)(t), "tokenUrl", void 0), (0, s.Z)((0, i.Z)(t), "revokeUrl", void 0), (0, s.Z)((0, i.Z)(t), "logoutUrl", void 0), (0, s.Z)((0, i.Z)(t), "pkce", void 0), (0, s.Z)((0, i.Z)(t), "clientId", void 0), (0, s.Z)((0, i.Z)(t), "redirectUri", void 0), (0, s.Z)((0, i.Z)(t), "responseType", void 0), (0, s.Z)((0, i.Z)(t), "responseMode", void 0), (0, s.Z)((0, i.Z)(t), "state", void 0), (0, s.Z)((0, i.Z)(t), "scopes", void 0), (0, s.Z)((0, i.Z)(t), "ignoreSignature", void 0), (0, s.Z)((0, i.Z)(t), "codeChallenge", void 0), (0, s.Z)((0, i.Z)(t), "codeChallengeMethod", void 0), (0, s.Z)((0, i.Z)(t), "acrValues", void 0), (0, s.Z)((0, i.Z)(t), "maxAge", void 0), (0, s.Z)((0, i.Z)(t), "tokenManager", void 0), (0, s.Z)((0, i.Z)(t), "postLogoutRedirectUri", void 0), (0, s.Z)((0, i.Z)(t), "restoreOriginalUri", void 0), (0, s.Z)((0, i.Z)(t), "transactionManager", void 0), (0, s.Z)((0, i.Z)(t), "clientSecret", void 0), (0, s.Z)((0, i.Z)(t), "setLocation", void 0), (0, s.Z)((0, i.Z)(t), "ignoreLifetime", void 0), (0, s.Z)((0, i.Z)(t), "maxClockSkew", void 0), function (e) {
                  var t = (e = e || {}).scopes;
                  if (t && !Array.isArray(t)) throw new v.Z('scopes must be a array of strings. Required usage: new OktaAuth({scopes: ["openid", "email"]})');
                  var n = e.issuer;
                  if (!n) throw new v.Z('No issuer passed to constructor. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
                  if (!new RegExp("^http?s?://.+").test(n)) throw new v.Z('Issuer must be a valid URL. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com/oauth2/{authServerId}"})');
                  if (-1 !== n.indexOf("-admin.")) throw new v.Z('Issuer URL passed to constructor contains "-admin" in subdomain. Required usage: new OktaAuth({issuer: "https://{yourOktaDomain}.com})');
                }(e), t.issuer = (0, l.Qj)(e.issuer), t.tokenUrl = (0, l.Qj)(e.tokenUrl), t.authorizeUrl = (0, l.Qj)(e.authorizeUrl), t.userinfoUrl = (0, l.Qj)(e.userinfoUrl), t.revokeUrl = (0, l.Qj)(e.revokeUrl), t.logoutUrl = (0, l.Qj)(e.logoutUrl), t.pkce = !1 !== e.pkce, t.clientId = e.clientId, t.redirectUri = e.redirectUri, (0, p.isBrowser)() && (t.redirectUri = (0, l.BY)(e.redirectUri, window.location.origin)), t.responseType = e.responseType, t.responseMode = e.responseMode, t.state = e.state, t.scopes = e.scopes, t.ignoreSignature = !!e.ignoreSignature, t.codeChallenge = e.codeChallenge, t.codeChallengeMethod = e.codeChallengeMethod, t.acrValues = e.acrValues, t.maxAge = e.maxAge, t.tokenManager = e.tokenManager, t.postLogoutRedirectUri = e.postLogoutRedirectUri, t.restoreOriginalUri = e.restoreOriginalUri, t.transactionManager = function (e) {
                  for (var t = 1; t < arguments.length; t++) {
                    var n = null != arguments[t] ? arguments[t] : {};
                    t % 2 ? y(Object(n), !0).forEach(function (t) {
                      (0, s.Z)(e, t, n[t]);
                    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : y(Object(n)).forEach(function (t) {
                      Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                    });
                  }
                  return e;
                }({
                  enableSharedStorage: d
                }, e.transactionManager), t.clientSecret = e.clientSecret, t.setLocation = e.setLocation, t.ignoreLifetime = !!e.ignoreLifetime, e.maxClockSkew || 0 === e.maxClockSkew ? t.maxClockSkew = e.maxClockSkew : t.maxClockSkew = f.DEFAULT_MAX_CLOCK_SKEW, t;
              }
              return (0, r.Z)(g);
            }((0, h.Z)());
          }
        },
        3775: function _(e, t, n) {
          "use strict";

          n.d(t, {
            m: function m() {
              return r.m;
            }
          });
          var r = n(9453);
        },
        5372: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Tp: function Tp() {
              return p;
            },
            ko: function ko() {
              return d;
            }
          });
          var r = n(5861),
            o = n(4687),
            i = n.n(o),
            a = n(9123),
            u = n(1969),
            c = n(9912),
            s = n(4771),
            f = n(8676);
          function l(e) {
            var t = e.options.pkce ? "query" : "fragment";
            return e.options.responseMode || t;
          }
          function p(e, t) {
            t = t || {}, (0, s.HD)(t) && (t = {
              url: t
            });
            var n,
              r = t.url,
              o = t.responseMode || l(e),
              i = e.token.parseFromUrl._getLocation();
            if (!(n = "query" === o ? r ? r.substring(r.indexOf("?")) : i.search : r ? r.substring(r.indexOf("#")) : i.hash)) throw new a.Z("Unable to parse a token from the url");
            return (0, u.v)(n);
          }
          function h(e, t) {
            "query" === (t.responseMode || l(e)) ? function (e) {
              var t = e.token.parseFromUrl._getHistory(),
                n = e.token.parseFromUrl._getDocument(),
                r = e.token.parseFromUrl._getLocation();
              t && t.replaceState ? t.replaceState(null, n.title, r.pathname + r.hash) : r.search = "";
            }(e) : function (e) {
              var t = e.token.parseFromUrl._getHistory(),
                n = e.token.parseFromUrl._getDocument(),
                r = e.token.parseFromUrl._getLocation();
              t && t.replaceState ? t.replaceState(null, n.title, r.pathname + r.search) : r.hash = "";
            }(e);
          }
          function d(e, t) {
            return v.apply(this, arguments);
          }
          function v() {
            return (v = (0, r.Z)(i().mark(function e(t, n) {
              var r, o, u, l;
              return i().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if (n = n || {}, (0, s.HD)(n) && (n = {
                      url: n
                    }), r = p(t, n), o = r.state, u = t.transactionManager.load({
                      state: o
                    })) {
                      e.next = 9;
                      break;
                    }
                    if (!t.options.pkce) {
                      e.next = 8;
                      break;
                    }
                    throw new a.Z("Could not load PKCE codeVerifier from storage. This may indicate the auth flow has already completed or multiple auth flows are executing concurrently.", void 0);
                  case 8:
                    throw new a.Z("Unable to retrieve OAuth redirect params from storage");
                  case 9:
                    return l = u.urls, delete u.urls, n.url || h(t, n), e.abrupt("return", (0, f.s)(t, u, r, l)["catch"](function (e) {
                      throw (0, c.Cf)(e) || t.transactionManager.clear({
                        state: o
                      }), e;
                    }).then(function (e) {
                      return t.transactionManager.clear({
                        state: o
                      }), e;
                    }));
                  case 13:
                  case "end":
                    return e.stop();
                }
              }, e);
            }))).apply(this, arguments);
          }
        },
        2476: function _(e, t, n) {
          "use strict";

          n.d(t, {
            $: function $() {
              return p;
            }
          });
          var r = n(5861),
            o = n(4687),
            i = n.n(o),
            a = n(9123),
            u = n(6488),
            c = n(7625),
            s = n(781);
          function f() {
            throw new a.Z("Renew must be passed a token with an array of scopes and an accessToken or idToken");
          }
          function l(e, t) {
            return (0, u.sI)(e) ? t.idToken : (0, u.hv)(e) ? t.accessToken : void f();
          }
          function p(e, t) {
            return h.apply(this, arguments);
          }
          function h() {
            return (h = (0, r.Z)(i().mark(function e(t, n) {
              var r, o, a, p, h, d, v;
              return i().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if ((0, u.sI)(n) || (0, u.hv)(n) || f(), !(r = t.tokenManager.getTokensSync()).refreshToken) {
                      e.next = 7;
                      break;
                    }
                    return e.next = 5, (0, s.R)(t, {
                      scopes: n.scopes
                    }, r.refreshToken);
                  case 5:
                    return r = e.sent, e.abrupt("return", l(n, r));
                  case 7:
                    return o = t.options.pkce ? "code" : (0, u.hv)(n) ? "token" : "id_token", p = (a = n).scopes, h = a.authorizeUrl, d = a.userinfoUrl, v = a.issuer, e.abrupt("return", (0, c.y)(t, {
                      responseType: o,
                      scopes: p,
                      authorizeUrl: h,
                      userinfoUrl: d,
                      issuer: v
                    }).then(function (e) {
                      return l(n, e.tokens);
                    }));
                  case 10:
                  case "end":
                    return e.stop();
                }
              }, e);
            }))).apply(this, arguments);
          }
        },
        6268: function _(e, t, n) {
          "use strict";

          n.d(t, {
            I: function I() {
              return f;
            }
          });
          var r = n(5861),
            o = n(4687),
            i = n.n(o),
            a = n(9123),
            u = n(7625),
            c = n(781),
            s = n(7756);
          function f(e, t) {
            return l.apply(this, arguments);
          }
          function l() {
            return (l = (0, r.Z)(i().mark(function e(t, n) {
              var r, o, f, l, p, h, d, v, y, g, m;
              return i().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if (!(f = null !== (r = null === (o = n) || void 0 === o ? void 0 : o.tokens) && void 0 !== r ? r : t.tokenManager.getTokensSync()).refreshToken) {
                      e.next = 3;
                      break;
                    }
                    return e.abrupt("return", (0, c.R)(t, n || {}, f.refreshToken));
                  case 3:
                    if (f.accessToken || f.idToken) {
                      e.next = 5;
                      break;
                    }
                    throw new a.Z("renewTokens() was called but there is no existing token");
                  case 5:
                    if (l = f.accessToken || {}, p = f.idToken || {}, h = l.scopes || p.scopes) {
                      e.next = 10;
                      break;
                    }
                    throw new a.Z("renewTokens: invalid tokens: could not read scopes");
                  case 10:
                    if (d = l.authorizeUrl || p.authorizeUrl) {
                      e.next = 13;
                      break;
                    }
                    throw new a.Z("renewTokens: invalid tokens: could not read authorizeUrl");
                  case 13:
                    return v = l.userinfoUrl || t.options.userinfoUrl, y = p.issuer || t.options.issuer, n = Object.assign({
                      scopes: h,
                      authorizeUrl: d,
                      userinfoUrl: v,
                      issuer: y
                    }, n), t.options.pkce ? n.responseType = "code" : (g = (0, s.D)(t), m = g.responseType, n.responseType = m), e.abrupt("return", (0, u.y)(t, n).then(function (e) {
                      return e.tokens;
                    }));
                  case 18:
                  case "end":
                    return e.stop();
                }
              }, e);
            }))).apply(this, arguments);
          }
        },
        781: function _(e, t, n) {
          "use strict";

          n.d(t, {
            R: function R() {
              return p;
            }
          });
          var r = n(5861),
            o = n(4687),
            i = n.n(o),
            a = n(9123),
            u = n(7599),
            c = n(6635),
            s = n(8676),
            f = n(9231),
            l = n(9912);
          function p(e, t, n) {
            return h.apply(this, arguments);
          }
          function h() {
            return (h = (0, r.Z)(i().mark(function e(t, n, r) {
              var o, p, h, d, v, y, g;
              return i().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if (o = t.options.clientId) {
                      e.next = 3;
                      break;
                    }
                    throw new a.Z("A clientId must be specified in the OktaAuth constructor to renew tokens");
                  case 3:
                    return e.prev = 3, p = Object.assign({}, n, {
                      clientId: o
                    }), e.next = 7, (0, f.D)(t, p, r);
                  case 7:
                    return h = e.sent, d = (0, u.Fc)(t, n), e.next = 11, (0, s.s)(t, p, h, d);
                  case 11:
                    return v = e.sent, y = v.tokens, (g = y.refreshToken) && !(0, c.q)(g, r) && t.tokenManager.updateRefreshToken(g), e.abrupt("return", y);
                  case 18:
                    throw e.prev = 18, e.t0 = e["catch"](3), (0, l.$E)(e.t0) && t.tokenManager.removeRefreshToken(), e.t0;
                  case 22:
                  case "end":
                    return e.stop();
                }
              }, e, null, [[3, 18]]);
            }))).apply(this, arguments);
          }
        },
        6466: function _(e, t, n) {
          "use strict";

          n.d(t, {
            P: function P() {
              return l;
            }
          });
          var r = n(5861),
            o = n(4687),
            i = n.n(o),
            a = n(5385),
            u = n(6718),
            c = n(7599),
            s = n(7594),
            f = n(9123);
          function l(e, t) {
            return p.apply(this, arguments);
          }
          function p() {
            return (p = (0, r.Z)(i().mark(function e(t, n) {
              var r, o, l, p, h, d, v;
              return i().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if (r = "", o = "", n && (r = n.accessToken, o = n.refreshToken), r || o) {
                      e.next = 5;
                      break;
                    }
                    throw new f.Z("A valid access or refresh token object is required");
                  case 5:
                    if (l = t.options.clientId, p = t.options.clientSecret, l) {
                      e.next = 9;
                      break;
                    }
                    throw new f.Z("A clientId must be specified in the OktaAuth constructor to revoke a token");
                  case 9:
                    return h = (0, c.Fc)(t).revokeUrl, d = (0, u.UK)({
                      token_type_hint: o ? "refresh_token" : "access_token",
                      token: o || r
                    }).slice(1), v = p ? (0, s.r3)("".concat(l, ":").concat(p)) : (0, s.r3)(l), e.abrupt("return", (0, a.v_)(t, h, d, {
                      headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                        Authorization: "Basic " + v
                      }
                    }));
                  case 13:
                  case "end":
                    return e.stop();
                }
              }, e);
            }))).apply(this, arguments);
          }
        },
        2333: function _(e, t, n) {
          "use strict";

          n.d(t, {
            a: function a() {
              return l;
            }
          });
          var r = n(5671),
            o = n(3144),
            i = n(136),
            a = n(2963),
            u = n(1120),
            c = n(5437),
            s = n(5763),
            f = n(1971);
          function l() {
            return function (e) {
              (0, i.Z)(p, e);
              var t,
                n,
                l = (t = p, n = function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                  } catch (e) {
                    return !1;
                  }
                }(), function () {
                  var e,
                    r = (0, u.Z)(t);
                  if (n) {
                    var o = (0, u.Z)(this).constructor;
                    e = Reflect.construct(r, arguments, o);
                  } else e = r.apply(this, arguments);
                  return (0, a.Z)(this, e);
                });
              function p(e, t, n) {
                return (0, r.Z)(this, p), l.call(this, e, t, n);
              }
              return (0, o.Z)(p, [{
                key: "getTransactionStorage",
                value: function value(e) {
                  e = this.getOptionsForSection("transaction", e), (0, c.V)(e);
                  var t = this.getStorage(e),
                    n = e.storageKey || f.TRANSACTION_STORAGE_NAME;
                  return new s._(t, n);
                }
              }, {
                key: "getSharedTansactionStorage",
                value: function value(e) {
                  e = this.getOptionsForSection("shared-transaction", e), (0, c.V)(e);
                  var t = this.getStorage(e),
                    n = e.storageKey || f.SHARED_TRANSACTION_STORAGE_NAME;
                  return new s._(t, n);
                }
              }, {
                key: "getOriginalUriStorage",
                value: function value(e) {
                  e = this.getOptionsForSection("original-uri", e), (0, c.V)(e);
                  var t = this.getStorage(e),
                    n = e.storageKey || f.ORIGINAL_URI_STORAGE_NAME;
                  return new s._(t, n);
                }
              }]), p;
            }(c.W);
          }
        },
        6488: function _(e, t, n) {
          "use strict";

          var r;
          function o(e) {
            return !!(e && (e.accessToken || e.idToken || e.refreshToken) && Array.isArray(e.scopes));
          }
          function i(e) {
            return e && e.accessToken;
          }
          function a(e) {
            return e && e.idToken;
          }
          function u(e) {
            return e && e.refreshToken;
          }
          n.d(t, {
            T6: function T6() {
              return r;
            },
            hD: function hD() {
              return o;
            },
            hv: function hv() {
              return i;
            },
            sI: function sI() {
              return a;
            },
            z9: function z9() {
              return u;
            }
          }), function (e) {
            e.ACCESS = "accessToken", e.ID = "idToken", e.REFRESH = "refreshToken";
          }(r || (r = {}));
        },
        7088: function _(e, t, n) {
          "use strict";

          n.d(t, {
            $I: function $I() {
              return u;
            },
            $Y: function $Y() {
              return r;
            },
            E: function E() {
              return o;
            },
            FT: function FT() {
              return a;
            },
            O3: function O3() {
              return i;
            },
            zr: function zr() {
              return c;
            }
          });
          var r = "expired",
            o = "renewed",
            i = "added",
            a = "removed",
            u = "error",
            c = "set_storage";
        },
        4319: function _(e, t, n) {
          "use strict";

          n.d(t, {
            G5: function G5() {
              return i;
            },
            ZT: function ZT() {
              return a;
            },
            mH: function mH() {
              return s;
            },
            rZ: function rZ() {
              return c;
            },
            sG: function sG() {
              return u;
            }
          });
          var r = n(1002);
          function o(e) {
            return !(!e || "object" !== (0, r.Z)(e) || 0 === Object.values(e).length);
          }
          function i(e) {
            return !(!o(e) || !e.redirectUri && !e.responseType);
          }
          function a(e) {
            return !!i(e) && !!e.codeVerifier;
          }
          function u(e) {
            return !!a(e) && !!e.interactionHandle;
          }
          function c(e) {
            return !!o(e) && void 0 === Object.values(e).find(function (e) {
              return "string" != typeof e;
            });
          }
          function s(e) {
            return !(!i(e) && !c(e));
          }
        },
        7615: function _() {},
        8927: function _(e, t, n) {
          "use strict";

          n.r(t), n.d(t, {
            EVENT_ADDED: function EVENT_ADDED() {
              return u.O3;
            },
            EVENT_ERROR: function EVENT_ERROR() {
              return u.$I;
            },
            EVENT_EXPIRED: function EVENT_EXPIRED() {
              return u.$Y;
            },
            EVENT_REMOVED: function EVENT_REMOVED() {
              return u.FT;
            },
            EVENT_RENEWED: function EVENT_RENEWED() {
              return u.E;
            },
            EVENT_SET_STORAGE: function EVENT_SET_STORAGE() {
              return u.zr;
            },
            TokenKind: function TokenKind() {
              return a.T6;
            },
            isAccessToken: function isAccessToken() {
              return a.hv;
            },
            isCustomAuthTransactionMeta: function isCustomAuthTransactionMeta() {
              return c.rZ;
            },
            isIDToken: function isIDToken() {
              return a.sI;
            },
            isIdxTransactionMeta: function isIdxTransactionMeta() {
              return c.sG;
            },
            isOAuthTransactionMeta: function isOAuthTransactionMeta() {
              return c.G5;
            },
            isPKCETransactionMeta: function isPKCETransactionMeta() {
              return c.ZT;
            },
            isRefreshToken: function isRefreshToken() {
              return a.z9;
            },
            isToken: function isToken() {
              return a.hD;
            },
            isTransactionMeta: function isTransactionMeta() {
              return c.mH;
            }
          });
          var r = n(9263),
            o = {};
          for (var i in r) "default" !== i && (o[i] = function (e) {
            return r[e];
          }.bind(0, i));
          n.d(t, o);
          var a = n(6488),
            u = n(7088),
            c = n(4319),
            s = n(7615);
          for (var i in o = {}, s) ["default", "TokenKind", "isAccessToken", "isIDToken", "isRefreshToken", "isToken", "EVENT_ADDED", "EVENT_ERROR", "EVENT_EXPIRED", "EVENT_REMOVED", "EVENT_RENEWED", "EVENT_SET_STORAGE", "isCustomAuthTransactionMeta", "isIdxTransactionMeta", "isOAuthTransactionMeta", "isPKCETransactionMeta", "isTransactionMeta"].indexOf(i) < 0 && (o[i] = function (e) {
            return s[e];
          }.bind(0, i));
          n.d(t, o);
        },
        9263: function _() {},
        4970: function _(e, t, n) {
          "use strict";

          n.d(t, {
            NH: function NH() {
              return o;
            },
            Rl: function Rl() {
              return a;
            },
            iC: function iC() {
              return c;
            },
            pU: function pU() {
              return u;
            },
            ys: function ys() {
              return i;
            }
          });
          var r = n(9123);
          function o(e, t, n) {
            e.addEventListener ? e.addEventListener(t, n) : e.attachEvent("on" + t, n);
          }
          function i(e, t, n) {
            e.removeEventListener ? e.removeEventListener(t, n) : e.detachEvent("on" + t, n);
          }
          function a(e) {
            var t = document.createElement("iframe");
            return t.style.display = "none", t.src = e, document.body.appendChild(t);
          }
          function u(e, t) {
            var n = t.popupTitle || "External Identity Provider User Authentication";
            return window.open(e, n, "toolbar=no, scrollbars=yes, resizable=yes, top=100, left=500, width=600, height=600");
          }
          function c(e, t, n) {
            var a, u;
            return new Promise(function (i, c) {
              a = function a(t) {
                if (t.data && t.data.state === n) return t.origin !== e.getIssuerOrigin() ? c(new r.Z("The request does not match client configuration")) : void i(t.data);
              }, o(window, "message", a), u = setTimeout(function () {
                c(new r.Z("OAuth flow timed out"));
              }, t || 12e4);
            })["finally"](function () {
              clearTimeout(u), i(window, "message", a);
            });
          }
        },
        5078: function _(e, t, n) {
          "use strict";

          n.d(t, {
            c: function c() {
              return a;
            }
          });
          var r = n(7599),
            o = n(415),
            i = n(3193);
          function a(e) {
            var t = e.options,
              n = t.clientId,
              a = t.redirectUri,
              u = t.responseMode,
              c = t.state,
              s = (0, o.isBrowser)() ? window.location.href : void 0;
            return (0, i.YY)({
              clientId: n,
              redirectUri: a || s,
              responseMode: u,
              state: c || (0, r.aV)(),
              responseType: "none",
              prompt: "enroll_authenticator"
            });
          }
        },
        7756: function _(e, t, n) {
          "use strict";

          n.d(t, {
            D: function D() {
              return a;
            }
          });
          var r = n(7599),
            o = n(415),
            i = n(3193);
          function a(e) {
            var t = e.options,
              n = t.pkce,
              a = t.clientId,
              u = t.redirectUri,
              c = t.responseType,
              s = t.responseMode,
              f = t.scopes,
              l = t.acrValues,
              p = t.maxAge,
              h = t.state,
              d = t.ignoreSignature,
              v = (0, o.isBrowser)() ? window.location.href : void 0;
            return (0, i.YY)({
              pkce: n,
              clientId: a,
              redirectUri: u || v,
              responseType: c || ["token", "id_token"],
              responseMode: s,
              state: h || (0, r.aV)(),
              nonce: (0, r.NH)(),
              scopes: f || ["openid", "email"],
              acrValues: l,
              maxAge: p,
              ignoreSignature: d
            });
          }
        },
        8080: function _(e, t, n) {
          "use strict";

          n.d(t, {
            A: function A() {
              return o;
            }
          });
          var r = n(7599);
          function o(e, t) {
            return {
              issuer: e.options.issuer,
              urls: (0, r.Fc)(e, t),
              clientId: t.clientId,
              redirectUri: t.redirectUri,
              responseType: t.responseType,
              responseMode: t.responseMode,
              state: t.state,
              acrValues: t.acrValues,
              enrollAmrValues: t.enrollAmrValues
            };
          }
        },
        9912: function _(e, t, n) {
          "use strict";

          n.d(t, {
            $E: function $E() {
              return a;
            },
            Cf: function Cf() {
              return o;
            },
            tC: function tC() {
              return i;
            }
          });
          var r = n(5728);
          function o(e) {
            return "OAuthError" === e.name && "interaction_required" === e.errorCode;
          }
          function i(e, t) {
            if ("AuthApiError" !== t.name) return !1;
            var n = t.xhr,
              r = null == n ? void 0 : n.responseJSON;
            return e.options.pkce && "invalid_grant" === (null == r ? void 0 : r.error);
          }
          function a(e) {
            return (0, r.isOAuthError)(e) && "invalid_grant" === e.errorCode && "The refresh token is invalid or expired." === e.errorSummary;
          }
        },
        8785: function _(e, t, n) {
          "use strict";

          n.d(t, {
            $E: function $E() {
              return a.$E;
            },
            AW: function AW() {
              return f.A;
            },
            Cf: function Cf() {
              return a.Cf;
            },
            Dx: function Dx() {
              return o.D;
            },
            Fc: function Fc() {
              return c.Fc;
            },
            H: function H() {
              return s.H;
            },
            Ik: function Ik() {
              return u.Ik;
            },
            NH: function NH() {
              return r.NH;
            },
            O2: function O2() {
              return u.O2;
            },
            PY: function PY() {
              return c.NH;
            },
            Qs: function Qs() {
              return u.Qs;
            },
            Rl: function Rl() {
              return r.Rl;
            },
            Rp: function Rp() {
              return g.R;
            },
            U5: function U5() {
              return l.Z;
            },
            Uc: function Uc() {
              return h.U;
            },
            Xp: function Xp() {
              return c.Xp;
            },
            Yo: function Yo() {
              return d.Y;
            },
            ZP: function ZP() {
              return u.ZP;
            },
            aV: function aV() {
              return c.aV;
            },
            br: function br() {
              return p.br;
            },
            cE: function cE() {
              return i.c;
            },
            d_: function d_() {
              return u.d_;
            },
            gM: function gM() {
              return u.gM;
            },
            hg: function hg() {
              return u.hg;
            },
            iC: function iC() {
              return r.iC;
            },
            kU: function kU() {
              return u.kU;
            },
            mi: function mi() {
              return p.mi;
            },
            pU: function pU() {
              return r.pU;
            },
            pj: function pj() {
              return y.p;
            },
            q0: function q0() {
              return d.q;
            },
            tC: function tC() {
              return a.tC;
            },
            vL: function vL() {
              return v.v;
            },
            vz: function vz() {
              return p.vz;
            },
            wc: function wc() {
              return u.wc;
            },
            wu: function wu() {
              return p.wu;
            },
            ys: function ys() {
              return r.ys;
            },
            zf: function zf() {
              return c.zf;
            }
          });
          var r = n(4970),
            o = n(7756),
            i = n(5078),
            a = n(9912),
            u = n(8221),
            c = n(7599),
            s = n(2865),
            f = n(8080),
            l = n(3611),
            p = n(6898),
            h = n(6757),
            d = n(6635),
            v = n(1969),
            y = n(6003),
            g = n(2482);
        },
        8221: function _(e, t, n) {
          "use strict";

          function r(e) {
            return /((id|access)_token=)/i.test(e);
          }
          function o(e) {
            return /(code=)/i.test(e);
          }
          function i(e) {
            return /(interaction_code=)/i.test(e);
          }
          function a(e) {
            return /(error=)/i.test(e) || /(error_description)/i.test(e);
          }
          function u(e, t) {
            var n = t.options;
            return !(!e || !n.redirectUri) && 0 === e.indexOf(n.redirectUri);
          }
          function c(e) {
            return e.pkce || "code" === e.responseType || "query" === e.responseMode;
          }
          function s(e) {
            return c(e) && "fragment" !== e.responseMode ? window.location.search : window.location.hash;
          }
          function f(e) {
            if (!u(window.location.href, e)) return !1;
            var t = c(e.options),
              n = s(e.options);
            return !!a(n) || (t ? o(n) || i(n) : r(window.location.hash));
          }
          function l(e, t) {
            if (!t) {
              if (!f(e)) return !1;
              t = s(e.options);
            }
            return /(error=interaction_required)/i.test(t);
          }
          n.d(t, {
            Ik: function Ik() {
              return c;
            },
            O2: function O2() {
              return s;
            },
            Qs: function Qs() {
              return u;
            },
            ZP: function ZP() {
              return o;
            },
            d_: function d_() {
              return i;
            },
            gM: function gM() {
              return f;
            },
            hg: function hg() {
              return a;
            },
            kU: function kU() {
              return r;
            },
            wc: function wc() {
              return l;
            }
          });
        },
        7599: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Fc: function Fc() {
              return l;
            },
            NH: function NH() {
              return u;
            },
            Xp: function Xp() {
              return f;
            },
            aV: function aV() {
              return a;
            },
            zf: function zf() {
              return s;
            }
          });
          var r = n(8750),
            o = n(6718),
            i = n(9123);
          function a() {
            return (0, r.uh)(64);
          }
          function u() {
            return (0, r.uh)(64);
          }
          function c(e) {
            var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
            return (0, o.Qj)(t.issuer) || e.options.issuer;
          }
          function s(e) {
            var t = c(e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {});
            return t.indexOf("/oauth2") > 0 ? t : t + "/oauth2";
          }
          function f(e) {
            return c(e, arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}).split("/oauth2")[0];
          }
          function l(e, t) {
            if (arguments.length > 2) throw new i.Z('As of version 3.0, "getOAuthUrls" takes only a single set of options');
            t = t || {};
            var n = (0, o.Qj)(t.authorizeUrl) || e.options.authorizeUrl,
              r = c(e, t),
              a = (0, o.Qj)(t.userinfoUrl) || e.options.userinfoUrl,
              u = (0, o.Qj)(t.tokenUrl) || e.options.tokenUrl,
              f = (0, o.Qj)(t.logoutUrl) || e.options.logoutUrl,
              l = (0, o.Qj)(t.revokeUrl) || e.options.revokeUrl,
              p = s(e, t);
            return {
              issuer: r,
              authorizeUrl: n = n || p + "/v1/authorize",
              userinfoUrl: a = a || p + "/v1/userinfo",
              tokenUrl: u = u || p + "/v1/token",
              revokeUrl: l = l || p + "/v1/revoke",
              logoutUrl: f = f || p + "/v1/logout"
            };
          }
        },
        2865: function _(e, t, n) {
          "use strict";

          n.d(t, {
            H: function H() {
              return u;
            }
          });
          var r = n(4942),
            o = n(7599);
          function i(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function a(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? i(Object(n), !0).forEach(function (t) {
                (0, r.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : i(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          function u(e, t) {
            var n = {
              issuer: e.options.issuer,
              urls: (0, o.Fc)(e, t),
              clientId: t.clientId,
              redirectUri: t.redirectUri,
              responseType: t.responseType,
              responseMode: t.responseMode,
              scopes: t.scopes,
              state: t.state,
              nonce: t.nonce,
              ignoreSignature: t.ignoreSignature,
              acrValues: t.acrValues
            };
            return !1 === t.pkce ? n : a(a({}, n), {}, {
              codeVerifier: t.codeVerifier,
              codeChallengeMethod: t.codeChallengeMethod,
              codeChallenge: t.codeChallenge
            });
          }
        },
        3611: function _(e, t, n) {
          "use strict";

          var r = n(7594),
            o = n(7987),
            i = n(1971);
          function a(e) {
            return ("0" + e.toString(16)).substr(-2);
          }
          t.Z = {
            DEFAULT_CODE_CHALLENGE_METHOD: i.DEFAULT_CODE_CHALLENGE_METHOD,
            generateVerifier: function generateVerifier(e) {
              var t,
                n,
                o = e || "";
              return o.length < i.MIN_VERIFIER_LENGTH && (o += (t = i.MIN_VERIFIER_LENGTH - o.length, n = new Uint8Array(Math.ceil(t / 2)), r.KP.getRandomValues(n), Array.from(n, a).join("").slice(0, t))), encodeURIComponent(o).slice(0, i.MAX_VERIFIER_LENGTH);
            },
            computeChallenge: function computeChallenge(e) {
              var t = new TextEncoder().encode(e);
              return r.KP.subtle.digest("SHA-256", t).then(function (e) {
                var t = String.fromCharCode.apply(null, new Uint8Array(e));
                return (0, o.NL)(t);
              });
            }
          };
        },
        6757: function _(e, t, n) {
          "use strict";

          n.d(t, {
            U: function U() {
              return c;
            }
          });
          var r = n(4942),
            o = n(9123),
            i = n(5078);
          function a(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function u(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? a(Object(n), !0).forEach(function (t) {
                (0, r.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : a(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          function c(e, t) {
            return function (e) {
              if (!(e = u(u({}, e), {}, {
                responseType: "none",
                prompt: "enroll_authenticator",
                maxAge: 0
              })).enrollAmrValues) throw new o.Z("enroll_amr_values must be specified");
              if (!e.acrValues) throw new o.Z("acr_values must be specified");
              return delete e.scopes, delete e.nonce, e;
            }(u(u({}, (0, i.c)(e)), t));
          }
        },
        6898: function _(e, t, n) {
          "use strict";

          n.d(t, {
            br: function br() {
              return v;
            },
            mi: function mi() {
              return g;
            },
            vz: function vz() {
              return d;
            },
            wu: function wu() {
              return b;
            }
          });
          var r = n(4942),
            o = n(5861),
            i = n(4687),
            a = n.n(i),
            u = n(52),
            c = n(9123),
            s = n(7756),
            f = n(1971),
            l = n(3611);
          function p(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function h(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? p(Object(n), !0).forEach(function (t) {
                (0, r.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          function d(e) {
            if (!e.features.isPKCESupported()) {
              var t = "PKCE requires a modern browser with encryption support running in a secure context.";
              throw e.features.isHTTPS() || (t += "\nThe current page is not being served with HTTPS protocol. PKCE requires secure HTTPS protocol."), e.features.hasTextEncoder() || (t += '\n"TextEncoder" is not defined. To use PKCE, you may need to include a polyfill/shim for this browser.'), new c.Z(t);
            }
          }
          function v(e, t) {
            return y.apply(this, arguments);
          }
          function y() {
            return (y = (0, o.Z)(a().mark(function e(t, n) {
              return a().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    return n = n || t.options.codeChallengeMethod || f.DEFAULT_CODE_CHALLENGE_METHOD, e.next = 3, (0, u.E)(t);
                  case 3:
                    if (-1 !== (e.sent.code_challenge_methods_supported || []).indexOf(n)) {
                      e.next = 7;
                      break;
                    }
                    throw new c.Z("Invalid code_challenge_method");
                  case 7:
                    return e.abrupt("return", n);
                  case 8:
                  case "end":
                    return e.stop();
                }
              }, e);
            }))).apply(this, arguments);
          }
          function g(e, t) {
            return m.apply(this, arguments);
          }
          function m() {
            return (m = (0, o.Z)(a().mark(function e(t, n) {
              var r, o, i, u;
              return a().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if (o = (r = n).codeVerifier, i = r.codeChallenge, u = r.codeChallengeMethod, i = i || t.options.codeChallenge) {
                      e.next = 8;
                      break;
                    }
                    return d(t), o = o || l.Z.generateVerifier(), e.next = 7, l.Z.computeChallenge(o);
                  case 7:
                    i = e.sent;
                  case 8:
                    return e.next = 10, v(t, u);
                  case 10:
                    return u = e.sent, n = h(h({}, n), {}, {
                      responseType: "code",
                      codeVerifier: o,
                      codeChallenge: i,
                      codeChallengeMethod: u
                    }), e.abrupt("return", n);
                  case 13:
                  case "end":
                    return e.stop();
                }
              }, e);
            }))).apply(this, arguments);
          }
          function b(e) {
            return k.apply(this, arguments);
          }
          function k() {
            return k = (0, o.Z)(a().mark(function e(t) {
              var n,
                r,
                o = arguments;
              return a().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if (n = o.length > 1 && void 0 !== o[1] ? o[1] : {}, r = (0, s.D)(t), !1 !== (n = h(h({}, r), n)).pkce) {
                      e.next = 5;
                      break;
                    }
                    return e.abrupt("return", n);
                  case 5:
                    return e.abrupt("return", g(t, n));
                  case 6:
                  case "end":
                    return e.stop();
                }
              }, e);
            })), k.apply(this, arguments);
          }
        },
        6635: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Y: function Y() {
              return i;
            },
            q: function q() {
              return o;
            }
          });
          var r = n(5728);
          function o(e, t) {
            return e.refreshToken === t.refreshToken;
          }
          function i(e) {
            return !(!(0, r.isAuthApiError)(e) || !e.xhr || !e.xhr.responseJSON || "invalid_grant" !== e.xhr.responseJSON.error);
          }
        },
        1969: function _(e, t, n) {
          "use strict";

          function r(e) {
            var t = /\+/g,
              n = /([^&=]+)=?([^&]*)/g,
              r = e || "";
            "#" === r.charAt(0) && "/" === r.charAt(1) && (r = r.substring(2)), "#" !== r.charAt(0) && "?" !== r.charAt(0) || (r = r.substring(1));
            for (var o, i = {}; o = n.exec(r);) {
              var a = o[1],
                u = o[2];
              i[a] = "id_token" === a || "access_token" === a || "code" === a ? u : decodeURIComponent(u.replace(t, " "));
            }
            return i;
          }
          n.d(t, {
            v: function v() {
              return r;
            }
          });
        },
        6003: function _(e, t, n) {
          "use strict";

          n.d(t, {
            p: function p() {
              return o;
            }
          });
          var r = n(9123);
          function o(e, t, n) {
            var o = n.clientId,
              i = n.issuer,
              a = n.nonce,
              u = n.acrValues;
            if (!t || !i || !o) throw new r.Z("The jwt, iss, and aud arguments are all required");
            if (a && t.nonce !== a) throw new r.Z("OAuth flow response nonce doesn't match request nonce");
            var c = Math.floor(Date.now() / 1e3);
            if (t.iss !== i) throw new r.Z("The issuer [" + t.iss + "] does not match [" + i + "]");
            if (t.aud !== o) throw new r.Z("The audience [" + t.aud + "] does not match [" + o + "]");
            if (u && t.acr !== u) throw new r.Z("The acr [" + t.acr + "] does not match acr_values [" + u + "]");
            if (t.iat > t.exp) throw new r.Z("The JWT expired before it was issued");
            if (!e.options.ignoreLifetime) {
              if (c - e.options.maxClockSkew > t.exp) throw new r.Z("The JWT expired and is no longer valid");
              if (t.iat > c + e.options.maxClockSkew) throw new r.Z("The JWT was issued in the future");
            }
          }
        },
        2482: function _(e, t, n) {
          "use strict";

          n.d(t, {
            R: function R() {
              return i;
            }
          });
          var r = n(9123),
            o = n(6488);
          function i(e, t) {
            if (!(0, o.sI)(e) && !(0, o.hv)(e) && !(0, o.z9)(e)) throw new r.Z("Token must be an Object with scopes, expiresAt, and one of: an idToken, accessToken, or refreshToken property");
            if ("accessToken" === t && !(0, o.hv)(e)) throw new r.Z("invalid accessToken");
            if ("idToken" === t && !(0, o.sI)(e)) throw new r.Z("invalid idToken");
            if ("refreshToken" === t && !(0, o.z9)(e)) throw new r.Z("invalid refreshToken");
          }
        },
        1260: function _(e, t, n) {
          "use strict";

          n.d(t, {
            W: function W() {
              return p;
            }
          });
          var r = n(5861),
            o = n(4687),
            i = n.n(o),
            a = n(52),
            u = n(6003),
            c = n(9123),
            s = n(1237),
            f = n(3154),
            l = n(5698);
          function p(e, t, n) {
            return h.apply(this, arguments);
          }
          function h() {
            return (h = (0, r.Z)(i().mark(function e(t, n, r) {
              var o, p, h, d, v, y;
              return i().wrap(function (e) {
                for (;;) switch (e.prev = e.next) {
                  case 0:
                    if (n && n.idToken) {
                      e.next = 2;
                      break;
                    }
                    throw new c.Z("Only idTokens may be verified");
                  case 2:
                    return o = (0, s.T)(n.idToken), p = (null == r ? void 0 : r.issuer) || t.options.issuer, e.next = 6, (0, a.E)(t, p);
                  case 6:
                    if (h = e.sent, d = h.issuer, v = Object.assign({
                      clientId: t.options.clientId,
                      ignoreSignature: t.options.ignoreSignature
                    }, r, {
                      issuer: d
                    }), (0, u.p)(t, o.payload, v), 1 != v.ignoreSignature && t.features.isTokenVerifySupported()) {
                      e.next = 12;
                      break;
                    }
                    return e.abrupt("return", n);
                  case 12:
                    return e.next = 14, (0, a.k)(t, n.issuer, o.header.kid);
                  case 14:
                    return y = e.sent, e.next = 17, f.W(n.idToken, y);
                  case 17:
                    if (e.sent) {
                      e.next = 20;
                      break;
                    }
                    throw new c.Z("The token signature is not valid");
                  case 20:
                    if (!(r && r.accessToken && n.claims.at_hash)) {
                      e.next = 26;
                      break;
                    }
                    return e.next = 23, l.X(r.accessToken);
                  case 23:
                    if (e.sent === n.claims.at_hash) {
                      e.next = 26;
                      break;
                    }
                    throw new c.Z("Token hash verification failed");
                  case 26:
                    return e.abrupt("return", n);
                  case 27:
                  case "end":
                    return e.stop();
                }
              }, e);
            }))).apply(this, arguments);
          }
        },
        3719: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Gg: function Gg() {
              return u;
            },
            OT: function OT() {
              return f;
            },
            RJ: function RJ() {
              return c;
            },
            dx: function dx() {
              return s;
            },
            sH: function sH() {
              return a;
            }
          });
          var r = n(3193),
            o = n(6718),
            i = n(5385);
          function a(e) {
            return e.session.get().then(function (e) {
              return "ACTIVE" === e.status;
            })["catch"](function () {
              return !1;
            });
          }
          function u(e) {
            return (0, i.U2)(e, "/api/v1/sessions/me", {
              withCredentials: !0
            }).then(function (t) {
              var n = (0, r.CE)(t, "_links");
              return n.refresh = function () {
                return (0, i.v_)(e, (0, r.Rg)(t, "refresh").href, {}, {
                  withCredentials: !0
                });
              }, n.user = function () {
                return (0, i.U2)(e, (0, r.Rg)(t, "user").href, {
                  withCredentials: !0
                });
              }, n;
            })["catch"](function () {
              return {
                status: "INACTIVE"
              };
            });
          }
          function c(e) {
            return (0, i.c3)(e, {
              url: e.getIssuerOrigin() + "/api/v1/sessions/me",
              method: "DELETE",
              withCredentials: !0
            });
          }
          function s(e) {
            return (0, i.v_)(e, "/api/v1/sessions/me/lifecycle/refresh", {}, {
              withCredentials: !0
            });
          }
          function f(e, t, n) {
            n = n || window.location.href, window.location.assign(e.getIssuerOrigin() + "/login/sessionCookieRedirect" + (0, o.UK)({
              checkAccountSetupComplete: !0,
              token: t,
              redirectUrl: n
            }));
          }
        },
        2815: function _(e, t, n) {
          "use strict";

          n.d(t, {
            M: function M() {
              return o;
            }
          });
          var r = n(3719);
          function o(e) {
            return {
              close: r.RJ.bind(null, e),
              exists: r.sH.bind(null, e),
              get: r.Gg.bind(null, e),
              refresh: r.dx.bind(null, e),
              setCookieAndRedirect: r.OT.bind(null, e)
            };
          }
        },
        8041: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Gg: function Gg() {
              return r.Gg;
            },
            MG: function MG() {
              return o.M;
            },
            OT: function OT() {
              return r.OT;
            },
            RJ: function RJ() {
              return r.RJ;
            },
            Zg: function Zg() {
              return i.Z;
            },
            dx: function dx() {
              return r.dx;
            },
            sH: function sH() {
              return r.sH;
            }
          });
          var r = n(3719),
            o = n(2815),
            i = n(3980);
        },
        3980: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Z: function Z() {
              return d;
            }
          });
          var r = n(5861),
            o = n(5671),
            i = n(3144),
            a = n(7326),
            u = n(136),
            c = n(2963),
            s = n(1120),
            f = n(4942),
            l = n(4687),
            p = n.n(l),
            h = n(2815);
          function d(e) {
            return function (e) {
              (0, u.Z)(d, e);
              var t,
                n,
                l = (t = d, n = function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                  } catch (e) {
                    return !1;
                  }
                }(), function () {
                  var e,
                    r = (0, s.Z)(t);
                  if (n) {
                    var o = (0, s.Z)(this).constructor;
                    e = Reflect.construct(r, arguments, o);
                  } else e = r.apply(this, arguments);
                  return (0, c.Z)(this, e);
                });
              function d() {
                var e;
                (0, o.Z)(this, d);
                for (var t = arguments.length, n = new Array(t), r = 0; r < t; r++) n[r] = arguments[r];
                return e = l.call.apply(l, [this].concat(n)), (0, f.Z)((0, a.Z)(e), "session", void 0), e.session = (0, h.M)((0, a.Z)(e)), e;
              }
              return (0, i.Z)(d, [{
                key: "closeSession",
                value: function value() {
                  var e = this;
                  return this.session.close().then((0, r.Z)(p().mark(function t() {
                    return p().wrap(function (t) {
                      for (;;) switch (t.prev = t.next) {
                        case 0:
                          return e.clearStorage(), t.abrupt("return", !0);
                        case 2:
                        case "end":
                          return t.stop();
                      }
                    }, t);
                  })))["catch"](function (e) {
                    if ("AuthApiError" === e.name && "E0000007" === e.errorCode) return !1;
                    throw e;
                  });
                }
              }]), d;
            }(e);
          }
        },
        5437: function _(e, t, n) {
          "use strict";

          n.d(t, {
            V: function V() {
              return f;
            },
            W: function W() {
              return l;
            }
          });
          var r = n(5671),
            o = n(3144),
            i = n(4942),
            a = n(1971),
            u = n(5763),
            c = n(415),
            s = n(146);
          function f(e) {
            (0, c.isBrowser)() || e.storageProvider || e.storageKey || (0, s.ZK)("Memory storage can only support simple single user use case on server side, please provide custom storageProvider or storageKey if advanced scenarios need to be supported.");
          }
          var l = function () {
            function e(t, n, o) {
              (0, r.Z)(this, e), (0, i.Z)(this, "storageManagerOptions", void 0), (0, i.Z)(this, "cookieOptions", void 0), (0, i.Z)(this, "storageUtil", void 0), this.storageManagerOptions = t, this.cookieOptions = n, this.storageUtil = o;
            }
            return (0, o.Z)(e, [{
              key: "getOptionsForSection",
              value: function value(e, t) {
                return Object.assign({}, this.storageManagerOptions[e], t);
              }
            }, {
              key: "getStorage",
              value: function value(e) {
                if ((e = Object.assign({}, this.cookieOptions, e)).storageProvider) return e.storageProvider;
                var t = e,
                  n = t.storageType,
                  r = t.storageTypes;
                if ("sessionStorage" === n && (e.sessionCookie = !0), n && r) {
                  var o = r.indexOf(n);
                  o >= 0 && (r = r.slice(o), n = void 0);
                }
                return n || (n = this.storageUtil.findStorageType(r)), this.storageUtil.getStorageByType(n, e);
              }
            }, {
              key: "getTokenStorage",
              value: function value(e) {
                f(e = this.getOptionsForSection("token", e));
                var t = this.getStorage(e),
                  n = e.storageKey || a.TOKEN_STORAGE_NAME;
                return new u._(t, n);
              }
            }, {
              key: "getHttpCache",
              value: function value(e) {
                e = this.getOptionsForSection("cache", e);
                var t = this.getStorage(e),
                  n = e.storageKey || a.CACHE_STORAGE_NAME;
                return new u._(t, n);
              }
            }]), e;
          }();
        },
        5763: function _(e, t, n) {
          "use strict";

          n.d(t, {
            _: function _() {
              return u;
            }
          });
          var r = n(5671),
            o = n(3144),
            i = n(4942),
            a = n(9123),
            u = function () {
              function e(t, n) {
                if ((0, r.Z)(this, e), (0, i.Z)(this, "storageProvider", void 0), (0, i.Z)(this, "storageName", void 0), !t) throw new a.Z('"storage" is required');
                if ("string" != typeof n || !n.length) throw new a.Z('"storageName" is required');
                this.storageName = n, this.storageProvider = t;
              }
              return (0, o.Z)(e, [{
                key: "getItem",
                value: function value(e) {
                  return this.getStorage()[e];
                }
              }, {
                key: "setItem",
                value: function value(e, t) {
                  return this.updateStorage(e, t);
                }
              }, {
                key: "removeItem",
                value: function value(e) {
                  return this.clearStorage(e);
                }
              }, {
                key: "getStorage",
                value: function value() {
                  var e = this.storageProvider.getItem(this.storageName);
                  e = e || "{}";
                  try {
                    return JSON.parse(e);
                  } catch (e) {
                    throw new a.Z("Unable to parse storage string: " + this.storageName);
                  }
                }
              }, {
                key: "setStorage",
                value: function value(e) {
                  try {
                    var t = e ? JSON.stringify(e) : "{}";
                    this.storageProvider.setItem(this.storageName, t);
                  } catch (e) {
                    throw new a.Z("Unable to set storage: " + this.storageName);
                  }
                }
              }, {
                key: "clearStorage",
                value: function value(e) {
                  if (e) {
                    var t = this.getStorage();
                    delete t[e], this.setStorage(t);
                  } else this.storageProvider.removeItem ? this.storageProvider.removeItem(this.storageName) : this.setStorage();
                }
              }, {
                key: "updateStorage",
                value: function value(e, t) {
                  var n = this.getStorage();
                  n[e] = t, this.setStorage(n);
                }
              }]), e;
            }();
        },
        9927: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Ho: function Ho() {
              return i.H;
            },
            Tp: function Tp() {
              return r.T;
            },
            Vp: function Vp() {
              return o.V;
            },
            W8: function W8() {
              return o.W;
            },
            _e: function _e() {
              return a._;
            }
          });
          var r = n(3849),
            o = n(5437),
            i = n(265),
            a = n(5763);
        },
        265: function _(e, t, n) {
          "use strict";

          n.d(t, {
            H: function H() {
              return f;
            }
          });
          var r = n(5671),
            o = n(3144),
            i = n(7326),
            a = n(136),
            u = n(2963),
            c = n(1120),
            s = n(4942);
          function f(e, t) {
            return function (e) {
              (0, a.Z)(p, e);
              var n,
                f,
                l = (n = p, f = function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                  } catch (e) {
                    return !1;
                  }
                }(), function () {
                  var e,
                    t = (0, c.Z)(n);
                  if (f) {
                    var r = (0, c.Z)(this).constructor;
                    e = Reflect.construct(t, arguments, r);
                  } else e = t.apply(this, arguments);
                  return (0, u.Z)(this, e);
                });
              function p() {
                var e;
                (0, r.Z)(this, p);
                for (var n = arguments.length, o = new Array(n), a = 0; a < n; a++) o[a] = arguments[a];
                e = l.call.apply(l, [this].concat(o)), (0, s.Z)((0, i.Z)(e), "storageManager", void 0);
                var u = e.options,
                  c = u.storageManager,
                  f = u.cookies,
                  h = u.storageUtil;
                return e.storageManager = new t(c, f, h), e;
              }
              return (0, o.Z)(p, [{
                key: "clearStorage",
                value: function value() {}
              }]), p;
            }(e);
          }
        },
        3849: function _(e, t, n) {
          "use strict";

          n.d(t, {
            T: function T() {
              return g;
            }
          });
          var r = n(3144),
            o = n(5671),
            i = n(7326),
            a = n(136),
            u = n(2963),
            c = n(1120),
            s = n(4942),
            f = n(5093),
            l = n(146),
            p = n(4858),
            h = {
              token: {
                storageTypes: ["localStorage", "sessionStorage", "cookie"]
              },
              cache: {
                storageTypes: ["localStorage", "sessionStorage", "cookie"]
              },
              transaction: {
                storageTypes: ["sessionStorage", "localStorage", "cookie"]
              },
              "shared-transaction": {
                storageTypes: ["localStorage"]
              },
              "original-uri": {
                storageTypes: ["localStorage"]
              }
            },
            d = n(415);
          function v(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
              var r = Object.getOwnPropertySymbols(e);
              t && (r = r.filter(function (t) {
                return Object.getOwnPropertyDescriptor(e, t).enumerable;
              })), n.push.apply(n, r);
            }
            return n;
          }
          function y(e) {
            for (var t = 1; t < arguments.length; t++) {
              var n = null != arguments[t] ? arguments[t] : {};
              t % 2 ? v(Object(n), !0).forEach(function (t) {
                (0, s.Z)(e, t, n[t]);
              }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : v(Object(n)).forEach(function (t) {
                Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
              });
            }
            return e;
          }
          function g() {
            return function (e) {
              (0, a.Z)(v, e);
              var t,
                n,
                f = (t = v, n = function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                  } catch (e) {
                    return !1;
                  }
                }(), function () {
                  var e,
                    r = (0, c.Z)(t);
                  if (n) {
                    var o = (0, c.Z)(this).constructor;
                    e = Reflect.construct(r, arguments, o);
                  } else e = r.apply(this, arguments);
                  return (0, u.Z)(this, e);
                });
              function v(e) {
                var t;
                return (0, o.Z)(this, v), t = f.call(this, e), (0, s.Z)((0, i.Z)(t), "cookies", void 0), (0, s.Z)((0, i.Z)(t), "storageUtil", void 0), (0, s.Z)((0, i.Z)(t), "storageManager", void 0), t.cookies = function () {
                  var e = arguments.length > 1 ? arguments[1] : void 0,
                    t = (arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}).cookies || {};
                  return void 0 === t.secure && (t.secure = e), void 0 === t.sameSite && (t.sameSite = t.secure ? "none" : "lax"), t.secure && !e && ((0, l.ZK)('The current page is not being served with the HTTPS protocol.\nFor security reasons, we strongly recommend using HTTPS.\nIf you cannot use HTTPS, set "cookies.secure" option to false.'), t.secure = !1), "none" !== t.sameSite || t.secure || (t.sameSite = "lax"), t;
                }(e, (0, d.isHTTPS)()), t.storageUtil = e.storageUtil || Object.assign({}, p.Z, {
                  inMemoryStore: {}
                }), t.storageManager = y(y({}, h), e.storageManager), t;
              }
              return (0, r.Z)(v);
            }((0, f.X)());
          }
        },
        3548: function _(e, t, n) {
          "use strict";

          n.d(t, {
            b: function b() {
              return c;
            }
          });
          var r = n(5671),
            o = n(3144),
            i = n(4942),
            a = n(4771),
            u = n(146),
            c = function () {
              function e() {
                var t = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {
                  quiet: !1
                };
                (0, r.Z)(this, e), (0, i.Z)(this, "queue", void 0), (0, i.Z)(this, "running", void 0), (0, i.Z)(this, "options", void 0), this.queue = [], this.running = !1, this.options = t;
              }
              return (0, o.Z)(e, [{
                key: "push",
                value: function value(e, t) {
                  for (var n = this, r = arguments.length, o = new Array(r > 2 ? r - 2 : 0), i = 2; i < r; i++) o[i - 2] = arguments[i];
                  return new Promise(function (r, i) {
                    n.queue.length > 0 && !1 !== n.options.quiet && (0, u.ZK)("Async method is being called but another async method is already running. The new method will be delayed until the previous method completes."), n.queue.push({
                      method: e,
                      thisObject: t,
                      args: o,
                      resolve: r,
                      reject: i
                    }), n.run();
                  });
                }
              }, {
                key: "run",
                value: function value() {
                  var e = this;
                  if (!this.running && 0 !== this.queue.length) {
                    this.running = !0;
                    var t = this.queue.shift(),
                      n = t.method.apply(t.thisObject, t.args);
                    (0, a.tI)(n) ? n.then(t.resolve, t.reject)["finally"](function () {
                      e.running = !1, e.run();
                    }) : (t.resolve(n), this.running = !1, this.run());
                  }
                }
              }]), e;
            }();
        },
        146: function _(e, t, n) {
          "use strict";

          function r() {
            return "undefined" != typeof window ? window.console : "undefined" != typeof console ? console : void 0;
          }
          function o() {
            var e = r();
            return e && e.log ? e : {
              log: function log() {},
              warn: function warn() {},
              group: function group() {},
              groupEnd: function groupEnd() {}
            };
          }
          function i(e) {
            o().warn("[okta-auth-sdk] WARN: " + e);
          }
          function a(e) {
            o().warn("[okta-auth-sdk] DEPRECATION: " + e);
          }
          function u(e, t) {
            return function () {
              return a(e), t.apply(null, arguments);
            };
          }
          n.d(t, {
            Rn: function Rn() {
              return a;
            },
            VA: function VA() {
              return u;
            },
            ZK: function ZK() {
              return i;
            },
            dr: function dr() {
              return o;
            },
            sW: function sW() {
              return r;
            }
          });
        },
        305: function _(e, t, n) {
          "use strict";

          n.d(t, {
            BY: function BY() {
              return c.BY;
            },
            CE: function CE() {
              return i.CE;
            },
            HD: function HD() {
              return u.HD;
            },
            Kn: function Kn() {
              return u.Kn;
            },
            QN: function QN() {
              return c.QN;
            },
            Qj: function Qj() {
              return c.Qj;
            },
            Rg: function Rg() {
              return i.Rg;
            },
            Rn: function Rn() {
              return r.Rn;
            },
            UK: function UK() {
              return c.UK;
            },
            VA: function VA() {
              return r.VA;
            },
            YQ: function YQ() {
              return o.YQ;
            },
            YY: function YY() {
              return i.YY;
            },
            ZK: function ZK() {
              return r.ZK;
            },
            ak: function ak() {
              return i.ak;
            },
            bo: function bo() {
              return a.b;
            },
            d9: function d9() {
              return i.d9;
            },
            dr: function dr() {
              return r.dr;
            },
            gw: function gw() {
              return o.gw;
            },
            hj: function hj() {
              return u.hj;
            },
            l7: function l7() {
              return i.l7;
            },
            mf: function mf() {
              return u.mf;
            },
            ng: function ng() {
              return o.ng;
            },
            sD: function sD() {
              return c.sD;
            },
            sE: function sE() {
              return i.sE;
            },
            sW: function sW() {
              return r.sW;
            },
            tI: function tI() {
              return u.tI;
            },
            uh: function uh() {
              return o.uh;
            }
          });
          var r = n(146),
            o = n(8750),
            i = n(3193),
            a = n(3548),
            u = n(4771),
            c = n(6718);
        },
        8750: function _(e, t, n) {
          "use strict";

          function r(e) {
            var t = e.match(/\d+/g),
              n = Date.UTC(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
            return new Date(n).toUTCString();
          }
          function o(e) {
            for (var t = "", n = 0; n < e; ++n) t += "abcdefghijklnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789"[Math.floor(61 * Math.random())];
            return t;
          }
          function i(e) {
            return new Promise(function (t) {
              setTimeout(t, e);
            });
          }
          function a(e, t) {
            var n = e.split(t);
            return [n[0], n.splice(1, n.length).join(t)];
          }
          n.d(t, {
            YQ: function YQ() {
              return a;
            },
            gw: function gw() {
              return i;
            },
            ng: function ng() {
              return r;
            },
            uh: function uh() {
              return o;
            }
          });
        },
        3193: function _(e, t, n) {
          "use strict";

          function r(e, t) {
            var n = Array.prototype.slice.call(arguments, 2);
            return function () {
              var r = Array.prototype.slice.call(arguments);
              return r = n.concat(r), e.apply(t, r);
            };
          }
          function o() {
            var e = arguments[0];
            return [].slice.call(arguments, 1).forEach(function (t) {
              for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && void 0 !== t[n] && (e[n] = t[n]);
            }), e;
          }
          function i(e) {
            var t = {};
            for (var n in e) if (Object.prototype.hasOwnProperty.call(e, n)) {
              var r = e[n];
              null != r && (t[n] = r);
            }
            return t;
          }
          function a(e) {
            if (e) {
              var t = JSON.stringify(e);
              if (t) return JSON.parse(t);
            }
            return e;
          }
          function u(e) {
            for (var t = {}, n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), o = 1; o < n; o++) r[o - 1] = arguments[o];
            for (var i in e) Object.prototype.hasOwnProperty.call(e, i) && -1 == r.indexOf(i) && (t[i] = e[i]);
            return a(t);
          }
          function c(e, t) {
            for (var n = e.length; n--;) {
              var r = e[n],
                o = !0;
              for (var i in t) if (Object.prototype.hasOwnProperty.call(t, i) && r[i] !== t[i]) {
                o = !1;
                break;
              }
              if (o) return r;
            }
          }
          function s(e, t, n) {
            if (e && e._links) {
              var r = a(e._links[t]);
              return r && r.name && n ? r.name === n ? r : void 0 : r;
            }
          }
          n.d(t, {
            CE: function CE() {
              return u;
            },
            Rg: function Rg() {
              return s;
            },
            YY: function YY() {
              return i;
            },
            ak: function ak() {
              return r;
            },
            d9: function d9() {
              return a;
            },
            l7: function l7() {
              return o;
            },
            sE: function sE() {
              return c;
            }
          });
        },
        4771: function _(e, t, n) {
          "use strict";

          function r(e) {
            return "[object String]" === Object.prototype.toString.call(e);
          }
          function o(e) {
            return "[object Object]" === Object.prototype.toString.call(e);
          }
          function i(e) {
            return "[object Number]" === Object.prototype.toString.call(e);
          }
          function a(e) {
            return !!e && "[object Function]" === {}.toString.call(e);
          }
          function u(e) {
            return e && e["finally"] && "function" == typeof e["finally"];
          }
          n.d(t, {
            HD: function HD() {
              return r;
            },
            Kn: function Kn() {
              return o;
            },
            hj: function hj() {
              return i;
            },
            mf: function mf() {
              return a;
            },
            tI: function tI() {
              return u;
            }
          });
        },
        6718: function _(e, t, n) {
          "use strict";

          function r(e) {
            return /^[a-z][a-z0-9+.-]*:/i.test(e);
          }
          function o() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
              t = arguments.length > 1 ? arguments[1] : void 0;
            return r(e) ? e : (t = u(t), "/" === e[0] ? "".concat(t).concat(e) : "".concat(t, "/").concat(e));
          }
          function i() {
            var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "",
              t = arguments.length > 1 ? arguments[1] : void 0;
            return r(e) && (e = e.substring(t.length)), "/" === e[0] ? e : "/".concat(e);
          }
          function a(e) {
            var t = [];
            if (null !== e) for (var n in e) Object.prototype.hasOwnProperty.call(e, n) && void 0 !== e[n] && null !== e[n] && t.push(n + "=" + encodeURIComponent(e[n]));
            return t.length ? "?" + t.join("&") : "";
          }
          function u(e) {
            if (e) {
              var t = e.replace(/^\s+|\s+$/gm, "");
              return t.replace(/\/+$/, "");
            }
          }
          n.d(t, {
            BY: function BY() {
              return o;
            },
            QN: function QN() {
              return i;
            },
            Qj: function Qj() {
              return u;
            },
            UK: function UK() {
              return a;
            },
            sD: function sD() {
              return r;
            }
          });
        },
        3615: function _(e, t, n) {
          "use strict";

          var r = n(6690),
            o = n(9728),
            i = n(1655),
            a = n(4993),
            u = n(3808);
          function c(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
            return r;
          }
          var s = function (e) {
              i(s, e);
              var t,
                n,
                c = (t = s, n = function () {
                  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                  if (Reflect.construct.sham) return !1;
                  if ("function" == typeof Proxy) return !0;
                  try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
                  } catch (e) {
                    return !1;
                  }
                }(), function () {
                  var e,
                    r = u(t);
                  if (n) {
                    var o = u(this).constructor;
                    e = Reflect.construct(r, arguments, o);
                  } else e = r.apply(this, arguments);
                  return a(this, e);
                });
              function s(e) {
                var t;
                return r(this, s), (t = c.call(this, e || "Promise was canceled")).name = "CancelError", t;
              }
              return o(s, [{
                key: "isCanceled",
                get: function get() {
                  return !0;
                }
              }]), s;
            }(n(3496)(Error)),
            f = function () {
              function e(t) {
                var n = this;
                r(this, e), this._cancelHandlers = [], this._isPending = !0, this._isCanceled = !1, this._rejectOnCancel = !0, this._promise = new Promise(function (e, r) {
                  n._reject = r;
                  var o = function o(e) {
                    if (!n._isPending) throw new Error("The `onCancel` handler was attached after the promise settled.");
                    n._cancelHandlers.push(e);
                  };
                  return Object.defineProperties(o, {
                    shouldReject: {
                      get: function get() {
                        return n._rejectOnCancel;
                      },
                      set: function set(e) {
                        n._rejectOnCancel = e;
                      }
                    }
                  }), t(function (t) {
                    n._isCanceled && o.shouldReject || (n._isPending = !1, e(t));
                  }, function (e) {
                    n._isPending = !1, r(e);
                  }, o);
                });
              }
              return o(e, [{
                key: "then",
                value: function value(e, t) {
                  return this._promise.then(e, t);
                }
              }, {
                key: "catch",
                value: function value(e) {
                  return this._promise["catch"](e);
                }
              }, {
                key: "finally",
                value: function value(e) {
                  return this._promise["finally"](e);
                }
              }, {
                key: "cancel",
                value: function value(e) {
                  if (this._isPending && !this._isCanceled) {
                    if (this._isCanceled = !0, this._cancelHandlers.length > 0) try {
                      var t,
                        n = function (e, t) {
                          var _n11 = "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                          if (!_n11) {
                            if (Array.isArray(e) || (_n11 = function (e, t) {
                              if (e) {
                                if ("string" == typeof e) return c(e, t);
                                var n = Object.prototype.toString.call(e).slice(8, -1);
                                return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? c(e, t) : void 0;
                              }
                            }(e)) || t && e && "number" == typeof e.length) {
                              _n11 && (e = _n11);
                              var r = 0,
                                o = function o() {};
                              return {
                                s: o,
                                n: function n() {
                                  return r >= e.length ? {
                                    done: !0
                                  } : {
                                    done: !1,
                                    value: e[r++]
                                  };
                                },
                                e: function e(_e22) {
                                  throw _e22;
                                },
                                f: o
                              };
                            }
                            throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
                          }
                          var i,
                            a = !0,
                            u = !1;
                          return {
                            s: function s() {
                              _n11 = _n11.call(e);
                            },
                            n: function n() {
                              var e = _n11.next();
                              return a = e.done, e;
                            },
                            e: function e(_e23) {
                              u = !0, i = _e23;
                            },
                            f: function f() {
                              try {
                                a || null == _n11["return"] || _n11["return"]();
                              } finally {
                                if (u) throw i;
                              }
                            }
                          };
                        }(this._cancelHandlers);
                      try {
                        for (n.s(); !(t = n.n()).done;) (0, t.value)();
                      } catch (e) {
                        n.e(e);
                      } finally {
                        n.f();
                      }
                    } catch (e) {
                      return void this._reject(e);
                    }
                    this._rejectOnCancel && this._reject(new s(e));
                  }
                }
              }, {
                key: "isCanceled",
                get: function get() {
                  return this._isCanceled;
                }
              }], [{
                key: "fn",
                value: function value(t) {
                  return function () {
                    for (var n = arguments.length, r = new Array(n), o = 0; o < n; o++) r[o] = arguments[o];
                    return new e(function (e, n, o) {
                      r.push(o), t.apply(void 0, r).then(e, n);
                    });
                  };
                }
              }]), e;
            }();
          Object.setPrototypeOf(f.prototype, Promise.prototype), e.exports = f, e.exports.CancelError = s;
        },
        4098: function _(e, t) {
          var n = "undefined" != typeof self ? self : this,
            r = function () {
              function e() {
                this.fetch = !1, this.DOMException = n.DOMException;
              }
              return e.prototype = n, new e();
            }();
          !function (e) {
            !function (t) {
              var n = {
                searchParams: "URLSearchParams" in e,
                iterable: "Symbol" in e && "iterator" in Symbol,
                blob: "FileReader" in e && "Blob" in e && function () {
                  try {
                    return new Blob(), !0;
                  } catch (e) {
                    return !1;
                  }
                }(),
                formData: "FormData" in e,
                arrayBuffer: "ArrayBuffer" in e
              };
              if (n.arrayBuffer) var r = ["[object Int8Array]", "[object Uint8Array]", "[object Uint8ClampedArray]", "[object Int16Array]", "[object Uint16Array]", "[object Int32Array]", "[object Uint32Array]", "[object Float32Array]", "[object Float64Array]"],
                o = ArrayBuffer.isView || function (e) {
                  return e && r.indexOf(Object.prototype.toString.call(e)) > -1;
                };
              function i(e) {
                if ("string" != typeof e && (e = String(e)), /[^a-z0-9\-#$%&'*+.^_`|~]/i.test(e)) throw new TypeError("Invalid character in header field name");
                return e.toLowerCase();
              }
              function a(e) {
                return "string" != typeof e && (e = String(e)), e;
              }
              function u(e) {
                var t = {
                  next: function next() {
                    var t = e.shift();
                    return {
                      done: void 0 === t,
                      value: t
                    };
                  }
                };
                return n.iterable && (t[Symbol.iterator] = function () {
                  return t;
                }), t;
              }
              function c(e) {
                this.map = {}, e instanceof c ? e.forEach(function (e, t) {
                  this.append(t, e);
                }, this) : Array.isArray(e) ? e.forEach(function (e) {
                  this.append(e[0], e[1]);
                }, this) : e && Object.getOwnPropertyNames(e).forEach(function (t) {
                  this.append(t, e[t]);
                }, this);
              }
              function s(e) {
                if (e.bodyUsed) return Promise.reject(new TypeError("Already read"));
                e.bodyUsed = !0;
              }
              function f(e) {
                return new Promise(function (t, n) {
                  e.onload = function () {
                    t(e.result);
                  }, e.onerror = function () {
                    n(e.error);
                  };
                });
              }
              function l(e) {
                var t = new FileReader(),
                  n = f(t);
                return t.readAsArrayBuffer(e), n;
              }
              function p(e) {
                if (e.slice) return e.slice(0);
                var t = new Uint8Array(e.byteLength);
                return t.set(new Uint8Array(e)), t.buffer;
              }
              function h() {
                return this.bodyUsed = !1, this._initBody = function (e) {
                  var t;
                  this._bodyInit = e, e ? "string" == typeof e ? this._bodyText = e : n.blob && Blob.prototype.isPrototypeOf(e) ? this._bodyBlob = e : n.formData && FormData.prototype.isPrototypeOf(e) ? this._bodyFormData = e : n.searchParams && URLSearchParams.prototype.isPrototypeOf(e) ? this._bodyText = e.toString() : n.arrayBuffer && n.blob && (t = e) && DataView.prototype.isPrototypeOf(t) ? (this._bodyArrayBuffer = p(e.buffer), this._bodyInit = new Blob([this._bodyArrayBuffer])) : n.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(e) || o(e)) ? this._bodyArrayBuffer = p(e) : this._bodyText = e = Object.prototype.toString.call(e) : this._bodyText = "", this.headers.get("content-type") || ("string" == typeof e ? this.headers.set("content-type", "text/plain;charset=UTF-8") : this._bodyBlob && this._bodyBlob.type ? this.headers.set("content-type", this._bodyBlob.type) : n.searchParams && URLSearchParams.prototype.isPrototypeOf(e) && this.headers.set("content-type", "application/x-www-form-urlencoded;charset=UTF-8"));
                }, n.blob && (this.blob = function () {
                  var e = s(this);
                  if (e) return e;
                  if (this._bodyBlob) return Promise.resolve(this._bodyBlob);
                  if (this._bodyArrayBuffer) return Promise.resolve(new Blob([this._bodyArrayBuffer]));
                  if (this._bodyFormData) throw new Error("could not read FormData body as blob");
                  return Promise.resolve(new Blob([this._bodyText]));
                }, this.arrayBuffer = function () {
                  return this._bodyArrayBuffer ? s(this) || Promise.resolve(this._bodyArrayBuffer) : this.blob().then(l);
                }), this.text = function () {
                  var e,
                    t,
                    n,
                    r = s(this);
                  if (r) return r;
                  if (this._bodyBlob) return e = this._bodyBlob, n = f(t = new FileReader()), t.readAsText(e), n;
                  if (this._bodyArrayBuffer) return Promise.resolve(function (e) {
                    for (var t = new Uint8Array(e), n = new Array(t.length), r = 0; r < t.length; r++) n[r] = String.fromCharCode(t[r]);
                    return n.join("");
                  }(this._bodyArrayBuffer));
                  if (this._bodyFormData) throw new Error("could not read FormData body as text");
                  return Promise.resolve(this._bodyText);
                }, n.formData && (this.formData = function () {
                  return this.text().then(y);
                }), this.json = function () {
                  return this.text().then(JSON.parse);
                }, this;
              }
              c.prototype.append = function (e, t) {
                e = i(e), t = a(t);
                var n = this.map[e];
                this.map[e] = n ? n + ", " + t : t;
              }, c.prototype["delete"] = function (e) {
                delete this.map[i(e)];
              }, c.prototype.get = function (e) {
                return e = i(e), this.has(e) ? this.map[e] : null;
              }, c.prototype.has = function (e) {
                return this.map.hasOwnProperty(i(e));
              }, c.prototype.set = function (e, t) {
                this.map[i(e)] = a(t);
              }, c.prototype.forEach = function (e, t) {
                for (var n in this.map) this.map.hasOwnProperty(n) && e.call(t, this.map[n], n, this);
              }, c.prototype.keys = function () {
                var e = [];
                return this.forEach(function (t, n) {
                  e.push(n);
                }), u(e);
              }, c.prototype.values = function () {
                var e = [];
                return this.forEach(function (t) {
                  e.push(t);
                }), u(e);
              }, c.prototype.entries = function () {
                var e = [];
                return this.forEach(function (t, n) {
                  e.push([n, t]);
                }), u(e);
              }, n.iterable && (c.prototype[Symbol.iterator] = c.prototype.entries);
              var d = ["DELETE", "GET", "HEAD", "OPTIONS", "POST", "PUT"];
              function v(e, t) {
                var n,
                  r,
                  o = (t = t || {}).body;
                if (e instanceof v) {
                  if (e.bodyUsed) throw new TypeError("Already read");
                  this.url = e.url, this.credentials = e.credentials, t.headers || (this.headers = new c(e.headers)), this.method = e.method, this.mode = e.mode, this.signal = e.signal, o || null == e._bodyInit || (o = e._bodyInit, e.bodyUsed = !0);
                } else this.url = String(e);
                if (this.credentials = t.credentials || this.credentials || "same-origin", !t.headers && this.headers || (this.headers = new c(t.headers)), this.method = (r = (n = t.method || this.method || "GET").toUpperCase(), d.indexOf(r) > -1 ? r : n), this.mode = t.mode || this.mode || null, this.signal = t.signal || this.signal, this.referrer = null, ("GET" === this.method || "HEAD" === this.method) && o) throw new TypeError("Body not allowed for GET or HEAD requests");
                this._initBody(o);
              }
              function y(e) {
                var t = new FormData();
                return e.trim().split("&").forEach(function (e) {
                  if (e) {
                    var n = e.split("="),
                      r = n.shift().replace(/\+/g, " "),
                      o = n.join("=").replace(/\+/g, " ");
                    t.append(decodeURIComponent(r), decodeURIComponent(o));
                  }
                }), t;
              }
              function g(e, t) {
                t || (t = {}), this.type = "default", this.status = void 0 === t.status ? 200 : t.status, this.ok = this.status >= 200 && this.status < 300, this.statusText = "statusText" in t ? t.statusText : "OK", this.headers = new c(t.headers), this.url = t.url || "", this._initBody(e);
              }
              v.prototype.clone = function () {
                return new v(this, {
                  body: this._bodyInit
                });
              }, h.call(v.prototype), h.call(g.prototype), g.prototype.clone = function () {
                return new g(this._bodyInit, {
                  status: this.status,
                  statusText: this.statusText,
                  headers: new c(this.headers),
                  url: this.url
                });
              }, g.error = function () {
                var e = new g(null, {
                  status: 0,
                  statusText: ""
                });
                return e.type = "error", e;
              };
              var m = [301, 302, 303, 307, 308];
              g.redirect = function (e, t) {
                if (-1 === m.indexOf(t)) throw new RangeError("Invalid status code");
                return new g(null, {
                  status: t,
                  headers: {
                    location: e
                  }
                });
              }, t.DOMException = e.DOMException;
              try {
                new t.DOMException();
              } catch (e) {
                t.DOMException = function (e, t) {
                  this.message = e, this.name = t;
                  var n = Error(e);
                  this.stack = n.stack;
                }, t.DOMException.prototype = Object.create(Error.prototype), t.DOMException.prototype.constructor = t.DOMException;
              }
              function b(e, r) {
                return new Promise(function (o, i) {
                  var a = new v(e, r);
                  if (a.signal && a.signal.aborted) return i(new t.DOMException("Aborted", "AbortError"));
                  var u = new XMLHttpRequest();
                  function s() {
                    u.abort();
                  }
                  u.onload = function () {
                    var e,
                      t,
                      n = {
                        status: u.status,
                        statusText: u.statusText,
                        headers: (e = u.getAllResponseHeaders() || "", t = new c(), e.replace(/\r?\n[\t ]+/g, " ").split(/\r?\n/).forEach(function (e) {
                          var n = e.split(":"),
                            r = n.shift().trim();
                          if (r) {
                            var o = n.join(":").trim();
                            t.append(r, o);
                          }
                        }), t)
                      };
                    n.url = "responseURL" in u ? u.responseURL : n.headers.get("X-Request-URL");
                    var r = "response" in u ? u.response : u.responseText;
                    o(new g(r, n));
                  }, u.onerror = function () {
                    i(new TypeError("Network request failed"));
                  }, u.ontimeout = function () {
                    i(new TypeError("Network request failed"));
                  }, u.onabort = function () {
                    i(new t.DOMException("Aborted", "AbortError"));
                  }, u.open(a.method, a.url, !0), "include" === a.credentials ? u.withCredentials = !0 : "omit" === a.credentials && (u.withCredentials = !1), "responseType" in u && n.blob && (u.responseType = "blob"), a.headers.forEach(function (e, t) {
                    u.setRequestHeader(t, e);
                  }), a.signal && (a.signal.addEventListener("abort", s), u.onreadystatechange = function () {
                    4 === u.readyState && a.signal.removeEventListener("abort", s);
                  }), u.send(void 0 === a._bodyInit ? null : a._bodyInit);
                });
              }
              b.polyfill = !0, e.fetch || (e.fetch = b, e.Headers = c, e.Request = v, e.Response = g), t.Headers = c, t.Request = v, t.Response = g, t.fetch = b, Object.defineProperty(t, "__esModule", {
                value: !0
              });
            }({});
          }(r), r.fetch.ponyfill = !0, delete r.fetch.polyfill;
          var o = r;
          (t = o.fetch)["default"] = o.fetch, t.fetch = o.fetch, t.Headers = o.Headers, t.Request = o.Request, t.Response = o.Response, e.exports = t;
        },
        5643: function _(e) {
          e.exports = !1;
        },
        4279: function _(e) {
          function t() {}
          t.prototype = {
            on: function on(e, t, n) {
              var r = this.e || (this.e = {});
              return (r[e] || (r[e] = [])).push({
                fn: t,
                ctx: n
              }), this;
            },
            once: function once(e, t, n) {
              var r = this;
              function o() {
                r.off(e, o), t.apply(n, arguments);
              }
              return o._ = t, this.on(e, o, n);
            },
            emit: function emit(e) {
              for (var t = [].slice.call(arguments, 1), n = ((this.e || (this.e = {}))[e] || []).slice(), r = 0, o = n.length; r < o; r++) n[r].fn.apply(n[r].ctx, t);
              return this;
            },
            off: function off(e, t) {
              var n = this.e || (this.e = {}),
                r = n[e],
                o = [];
              if (r && t) for (var i = 0, a = r.length; i < a; i++) r[i].fn !== t && r[i].fn._ !== t && o.push(r[i]);
              return o.length ? n[e] = o : delete n[e], this;
            }
          }, e.exports = t;
        },
        199: function _() {},
        6115: function _(e) {
          e.exports = function (e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        6690: function _(e) {
          e.exports = function (e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        3515: function _(e, t, n) {
          var r = n(6015),
            o = n(9617);
          function i(t, n, a) {
            return o() ? (e.exports = i = Reflect.construct.bind(), e.exports.__esModule = !0, e.exports["default"] = e.exports) : (e.exports = i = function i(e, t, n) {
              var o = [null];
              o.push.apply(o, t);
              var i = new (Function.bind.apply(e, o))();
              return n && r(i, n.prototype), i;
            }, e.exports.__esModule = !0, e.exports["default"] = e.exports), i.apply(null, arguments);
          }
          e.exports = i, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        9728: function _(e) {
          function t(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
          }
          e.exports = function (e, n, r) {
            return n && t(e.prototype, n), r && t(e, r), Object.defineProperty(e, "prototype", {
              writable: !1
            }), e;
          }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        3808: function _(e) {
          function t(n) {
            return e.exports = t = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
              return e.__proto__ || Object.getPrototypeOf(e);
            }, e.exports.__esModule = !0, e.exports["default"] = e.exports, t(n);
          }
          e.exports = t, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        1655: function _(e, t, n) {
          var r = n(6015);
          e.exports = function (e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && r(e, t);
          }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        6035: function _(e) {
          e.exports = function (e) {
            return -1 !== Function.toString.call(e).indexOf("[native code]");
          }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        9617: function _(e) {
          e.exports = function () {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
              return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
            } catch (e) {
              return !1;
            }
          }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        4993: function _(e, t, n) {
          var r = n(8698)["default"],
            o = n(6115);
          e.exports = function (e, t) {
            if (t && ("object" === r(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return o(e);
          }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        7061: function _(e, t, n) {
          var r = n(8698)["default"];
          function o() {
            "use strict";

            e.exports = o = function o() {
              return t;
            }, e.exports.__esModule = !0, e.exports["default"] = e.exports;
            var t = {},
              n = Object.prototype,
              i = n.hasOwnProperty,
              a = "function" == typeof Symbol ? Symbol : {},
              u = a.iterator || "@@iterator",
              c = a.asyncIterator || "@@asyncIterator",
              s = a.toStringTag || "@@toStringTag";
            function f(e, t, n) {
              return Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
              }), e[t];
            }
            try {
              f({}, "");
            } catch (e) {
              f = function f(e, t, n) {
                return e[t] = n;
              };
            }
            function l(e, t, n, r) {
              var o = t && t.prototype instanceof d ? t : d,
                i = Object.create(o.prototype),
                a = new S(r || []);
              return i._invoke = function (e, t, n) {
                var r = "suspendedStart";
                return function (o, i) {
                  if ("executing" === r) throw new Error("Generator is already running");
                  if ("completed" === r) {
                    if ("throw" === o) throw i;
                    return {
                      value: void 0,
                      done: !0
                    };
                  }
                  for (n.method = o, n.arg = i;;) {
                    var a = n.delegate;
                    if (a) {
                      var u = T(a, n);
                      if (u) {
                        if (u === h) continue;
                        return u;
                      }
                    }
                    if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
                      if ("suspendedStart" === r) throw r = "completed", n.arg;
                      n.dispatchException(n.arg);
                    } else "return" === n.method && n.abrupt("return", n.arg);
                    r = "executing";
                    var c = p(e, t, n);
                    if ("normal" === c.type) {
                      if (r = n.done ? "completed" : "suspendedYield", c.arg === h) continue;
                      return {
                        value: c.arg,
                        done: n.done
                      };
                    }
                    "throw" === c.type && (r = "completed", n.method = "throw", n.arg = c.arg);
                  }
                };
              }(e, n, a), i;
            }
            function p(e, t, n) {
              try {
                return {
                  type: "normal",
                  arg: e.call(t, n)
                };
              } catch (e) {
                return {
                  type: "throw",
                  arg: e
                };
              }
            }
            t.wrap = l;
            var h = {};
            function d() {}
            function v() {}
            function y() {}
            var g = {};
            f(g, u, function () {
              return this;
            });
            var m = Object.getPrototypeOf,
              b = m && m(m(x([])));
            b && b !== n && i.call(b, u) && (g = b);
            var k = y.prototype = d.prototype = Object.create(g);
            function w(e) {
              ["next", "throw", "return"].forEach(function (t) {
                f(e, t, function (e) {
                  return this._invoke(t, e);
                });
              });
            }
            function O(e, t) {
              function n(o, a, u, c) {
                var s = p(e[o], e, a);
                if ("throw" !== s.type) {
                  var f = s.arg,
                    l = f.value;
                  return l && "object" == r(l) && i.call(l, "__await") ? t.resolve(l.__await).then(function (e) {
                    n("next", e, u, c);
                  }, function (e) {
                    n("throw", e, u, c);
                  }) : t.resolve(l).then(function (e) {
                    f.value = e, u(f);
                  }, function (e) {
                    return n("throw", e, u, c);
                  });
                }
                c(s.arg);
              }
              var o;
              this._invoke = function (e, r) {
                function i() {
                  return new t(function (t, o) {
                    n(e, r, t, o);
                  });
                }
                return o = o ? o.then(i, i) : i();
              };
            }
            function T(e, t) {
              var n = e.iterator[t.method];
              if (void 0 === n) {
                if (t.delegate = null, "throw" === t.method) {
                  if (e.iterator["return"] && (t.method = "return", t.arg = void 0, T(e, t), "throw" === t.method)) return h;
                  t.method = "throw", t.arg = new TypeError("The iterator does not provide a 'throw' method");
                }
                return h;
              }
              var r = p(n, e.iterator, t.arg);
              if ("throw" === r.type) return t.method = "throw", t.arg = r.arg, t.delegate = null, h;
              var o = r.arg;
              return o ? o.done ? (t[e.resultName] = o.value, t.next = e.nextLoc, "return" !== t.method && (t.method = "next", t.arg = void 0), t.delegate = null, h) : o : (t.method = "throw", t.arg = new TypeError("iterator result is not an object"), t.delegate = null, h);
            }
            function Z(e) {
              var t = {
                tryLoc: e[0]
              };
              1 in e && (t.catchLoc = e[1]), 2 in e && (t.finallyLoc = e[2], t.afterLoc = e[3]), this.tryEntries.push(t);
            }
            function E(e) {
              var t = e.completion || {};
              t.type = "normal", delete t.arg, e.completion = t;
            }
            function S(e) {
              this.tryEntries = [{
                tryLoc: "root"
              }], e.forEach(Z, this), this.reset(!0);
            }
            function x(e) {
              if (e) {
                var t = e[u];
                if (t) return t.call(e);
                if ("function" == typeof e.next) return e;
                if (!isNaN(e.length)) {
                  var n = -1,
                    r = function t() {
                      for (; ++n < e.length;) if (i.call(e, n)) return t.value = e[n], t.done = !1, t;
                      return t.value = void 0, t.done = !0, t;
                    };
                  return r.next = r;
                }
              }
              return {
                next: P
              };
            }
            function P() {
              return {
                value: void 0,
                done: !0
              };
            }
            return v.prototype = y, f(k, "constructor", y), f(y, "constructor", v), v.displayName = f(y, s, "GeneratorFunction"), t.isGeneratorFunction = function (e) {
              var t = "function" == typeof e && e.constructor;
              return !!t && (t === v || "GeneratorFunction" === (t.displayName || t.name));
            }, t.mark = function (e) {
              return Object.setPrototypeOf ? Object.setPrototypeOf(e, y) : (e.__proto__ = y, f(e, s, "GeneratorFunction")), e.prototype = Object.create(k), e;
            }, t.awrap = function (e) {
              return {
                __await: e
              };
            }, w(O.prototype), f(O.prototype, c, function () {
              return this;
            }), t.AsyncIterator = O, t.async = function (e, n, r, o, i) {
              void 0 === i && (i = Promise);
              var a = new O(l(e, n, r, o), i);
              return t.isGeneratorFunction(n) ? a : a.next().then(function (e) {
                return e.done ? e.value : a.next();
              });
            }, w(k), f(k, s, "Generator"), f(k, u, function () {
              return this;
            }), f(k, "toString", function () {
              return "[object Generator]";
            }), t.keys = function (e) {
              var t = [];
              for (var n in e) t.push(n);
              return t.reverse(), function n() {
                for (; t.length;) {
                  var r = t.pop();
                  if (r in e) return n.value = r, n.done = !1, n;
                }
                return n.done = !0, n;
              };
            }, t.values = x, S.prototype = {
              constructor: S,
              reset: function reset(e) {
                if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(E), !e) for (var t in this) "t" === t.charAt(0) && i.call(this, t) && !isNaN(+t.slice(1)) && (this[t] = void 0);
              },
              stop: function stop() {
                this.done = !0;
                var e = this.tryEntries[0].completion;
                if ("throw" === e.type) throw e.arg;
                return this.rval;
              },
              dispatchException: function dispatchException(e) {
                if (this.done) throw e;
                var t = this;
                function n(n, r) {
                  return a.type = "throw", a.arg = e, t.next = n, r && (t.method = "next", t.arg = void 0), !!r;
                }
                for (var r = this.tryEntries.length - 1; r >= 0; --r) {
                  var o = this.tryEntries[r],
                    a = o.completion;
                  if ("root" === o.tryLoc) return n("end");
                  if (o.tryLoc <= this.prev) {
                    var u = i.call(o, "catchLoc"),
                      c = i.call(o, "finallyLoc");
                    if (u && c) {
                      if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                      if (this.prev < o.finallyLoc) return n(o.finallyLoc);
                    } else if (u) {
                      if (this.prev < o.catchLoc) return n(o.catchLoc, !0);
                    } else {
                      if (!c) throw new Error("try statement without catch or finally");
                      if (this.prev < o.finallyLoc) return n(o.finallyLoc);
                    }
                  }
                }
              },
              abrupt: function abrupt(e, t) {
                for (var n = this.tryEntries.length - 1; n >= 0; --n) {
                  var r = this.tryEntries[n];
                  if (r.tryLoc <= this.prev && i.call(r, "finallyLoc") && this.prev < r.finallyLoc) {
                    var o = r;
                    break;
                  }
                }
                o && ("break" === e || "continue" === e) && o.tryLoc <= t && t <= o.finallyLoc && (o = null);
                var a = o ? o.completion : {};
                return a.type = e, a.arg = t, o ? (this.method = "next", this.next = o.finallyLoc, h) : this.complete(a);
              },
              complete: function complete(e, t) {
                if ("throw" === e.type) throw e.arg;
                return "break" === e.type || "continue" === e.type ? this.next = e.arg : "return" === e.type ? (this.rval = this.arg = e.arg, this.method = "return", this.next = "end") : "normal" === e.type && t && (this.next = t), h;
              },
              finish: function finish(e) {
                for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                  var n = this.tryEntries[t];
                  if (n.finallyLoc === e) return this.complete(n.completion, n.afterLoc), E(n), h;
                }
              },
              "catch": function _catch(e) {
                for (var t = this.tryEntries.length - 1; t >= 0; --t) {
                  var n = this.tryEntries[t];
                  if (n.tryLoc === e) {
                    var r = n.completion;
                    if ("throw" === r.type) {
                      var o = r.arg;
                      E(n);
                    }
                    return o;
                  }
                }
                throw new Error("illegal catch attempt");
              },
              delegateYield: function delegateYield(e, t, n) {
                return this.delegate = {
                  iterator: x(e),
                  resultName: t,
                  nextLoc: n
                }, "next" === this.method && (this.arg = void 0), h;
              }
            }, t;
          }
          e.exports = o, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        6015: function _(e) {
          function t(n, r) {
            return e.exports = t = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
              return e.__proto__ = t, e;
            }, e.exports.__esModule = !0, e.exports["default"] = e.exports, t(n, r);
          }
          e.exports = t, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        8698: function _(e) {
          function t(n) {
            return e.exports = t = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
              return _typeof(e);
            } : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
            }, e.exports.__esModule = !0, e.exports["default"] = e.exports, t(n);
          }
          e.exports = t, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        3496: function _(e, t, n) {
          var r = n(3808),
            o = n(6015),
            i = n(6035),
            a = n(3515);
          function u(t) {
            var n = "function" == typeof Map ? new Map() : void 0;
            return e.exports = u = function u(e) {
              if (null === e || !i(e)) return e;
              if ("function" != typeof e) throw new TypeError("Super expression must either be null or a function");
              if (void 0 !== n) {
                if (n.has(e)) return n.get(e);
                n.set(e, t);
              }
              function t() {
                return a(e, arguments, r(this).constructor);
              }
              return t.prototype = Object.create(e.prototype, {
                constructor: {
                  value: t,
                  enumerable: !1,
                  writable: !0,
                  configurable: !0
                }
              }), o(t, e);
            }, e.exports.__esModule = !0, e.exports["default"] = e.exports, u(t);
          }
          e.exports = u, e.exports.__esModule = !0, e.exports["default"] = e.exports;
        },
        4687: function _(e, t, n) {
          var r = n(7061)();
          e.exports = r;
          try {
            regeneratorRuntime = r;
          } catch (e) {
            "object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis)) ? globalThis.regeneratorRuntime = r : Function("r", "regeneratorRuntime = r")(r);
          }
        },
        907: function _(e, t, n) {
          "use strict";

          function r(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
            return r;
          }
          n.d(t, {
            Z: function Z() {
              return r;
            }
          });
        },
        7326: function _(e, t, n) {
          "use strict";

          function r(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
          }
          n.d(t, {
            Z: function Z() {
              return r;
            }
          });
        },
        5861: function _(e, t, n) {
          "use strict";

          function r(e, t, n, r, o, i, a) {
            try {
              var u = e[i](a),
                c = u.value;
            } catch (e) {
              return void n(e);
            }
            u.done ? t(c) : Promise.resolve(c).then(r, o);
          }
          function o(e) {
            return function () {
              var t = this,
                n = arguments;
              return new Promise(function (o, i) {
                var a = e.apply(t, n);
                function u(e) {
                  r(a, o, i, u, c, "next", e);
                }
                function c(e) {
                  r(a, o, i, u, c, "throw", e);
                }
                u(void 0);
              });
            };
          }
          n.d(t, {
            Z: function Z() {
              return o;
            }
          });
        },
        5671: function _(e, t, n) {
          "use strict";

          function r(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
          }
          n.d(t, {
            Z: function Z() {
              return r;
            }
          });
        },
        3144: function _(e, t, n) {
          "use strict";

          function r(e, t) {
            for (var n = 0; n < t.length; n++) {
              var r = t[n];
              r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
          }
          function o(e, t, n) {
            return t && r(e.prototype, t), n && r(e, n), Object.defineProperty(e, "prototype", {
              writable: !1
            }), e;
          }
          n.d(t, {
            Z: function Z() {
              return o;
            }
          });
        },
        4942: function _(e, t, n) {
          "use strict";

          function r(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
              value: n,
              enumerable: !0,
              configurable: !0,
              writable: !0
            }) : e[t] = n, e;
          }
          n.d(t, {
            Z: function Z() {
              return r;
            }
          });
        },
        1752: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Z: function Z() {
              return o;
            }
          });
          var r = n(1120);
          function o() {
            return o = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, n) {
              var o = function (e, t) {
                for (; !Object.prototype.hasOwnProperty.call(e, t) && null !== (e = (0, r.Z)(e)););
                return e;
              }(e, t);
              if (o) {
                var i = Object.getOwnPropertyDescriptor(o, t);
                return i.get ? i.get.call(arguments.length < 3 ? e : n) : i.value;
              }
            }, o.apply(this, arguments);
          }
        },
        1120: function _(e, t, n) {
          "use strict";

          function r(e) {
            return r = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (e) {
              return e.__proto__ || Object.getPrototypeOf(e);
            }, r(e);
          }
          n.d(t, {
            Z: function Z() {
              return r;
            }
          });
        },
        136: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Z: function Z() {
              return o;
            }
          });
          var r = n(9611);
          function o(e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
              constructor: {
                value: e,
                writable: !0,
                configurable: !0
              }
            }), Object.defineProperty(e, "prototype", {
              writable: !1
            }), t && (0, r.Z)(e, t);
          }
        },
        4925: function _(e, t, n) {
          "use strict";

          function r(e, t) {
            if (null == e) return {};
            var n,
              r,
              o = function (e, t) {
                if (null == e) return {};
                var n,
                  r,
                  o = {},
                  i = Object.keys(e);
                for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                return o;
              }(e, t);
            if (Object.getOwnPropertySymbols) {
              var i = Object.getOwnPropertySymbols(e);
              for (r = 0; r < i.length; r++) n = i[r], t.indexOf(n) >= 0 || Object.prototype.propertyIsEnumerable.call(e, n) && (o[n] = e[n]);
            }
            return o;
          }
          n.d(t, {
            Z: function Z() {
              return r;
            }
          });
        },
        2963: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Z: function Z() {
              return i;
            }
          });
          var r = n(1002),
            o = n(7326);
          function i(e, t) {
            if (t && ("object" === (0, r.Z)(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return (0, o.Z)(e);
          }
        },
        9611: function _(e, t, n) {
          "use strict";

          function r(e, t) {
            return r = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (e, t) {
              return e.__proto__ = t, e;
            }, r(e, t);
          }
          n.d(t, {
            Z: function Z() {
              return r;
            }
          });
        },
        885: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Z: function Z() {
              return o;
            }
          });
          var r = n(181);
          function o(e, t) {
            return function (e) {
              if (Array.isArray(e)) return e;
            }(e) || function (e, t) {
              var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
              if (null != n) {
                var r,
                  o,
                  i = [],
                  a = !0,
                  u = !1;
                try {
                  for (n = n.call(e); !(a = (r = n.next()).done) && (i.push(r.value), !t || i.length !== t); a = !0);
                } catch (e) {
                  u = !0, o = e;
                } finally {
                  try {
                    a || null == n["return"] || n["return"]();
                  } finally {
                    if (u) throw o;
                  }
                }
                return i;
              }
            }(e, t) || (0, r.Z)(e, t) || function () {
              throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }
        },
        2982: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Z: function Z() {
              return i;
            }
          });
          var r = n(907),
            o = n(181);
          function i(e) {
            return function (e) {
              if (Array.isArray(e)) return (0, r.Z)(e);
            }(e) || function (e) {
              if ("undefined" != typeof Symbol && null != e[Symbol.iterator] || null != e["@@iterator"]) return Array.from(e);
            }(e) || (0, o.Z)(e) || function () {
              throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
            }();
          }
        },
        1002: function _(e, t, n) {
          "use strict";

          function r(e) {
            return r = "function" == typeof Symbol && "symbol" == _typeof(Symbol.iterator) ? function (e) {
              return _typeof(e);
            } : function (e) {
              return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : _typeof(e);
            }, r(e);
          }
          n.d(t, {
            Z: function Z() {
              return r;
            }
          });
        },
        181: function _(e, t, n) {
          "use strict";

          n.d(t, {
            Z: function Z() {
              return o;
            }
          });
          var r = n(907);
          function o(e, t) {
            if (e) {
              if ("string" == typeof e) return (0, r.Z)(e, t);
              var n = Object.prototype.toString.call(e).slice(8, -1);
              return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? (0, r.Z)(e, t) : void 0;
            }
          }
        }
      },
      t = {};
    function n(r) {
      var o = t[r];
      if (void 0 !== o) return o.exports;
      var i = t[r] = {
        exports: {}
      };
      return e[r].call(i.exports, i, i.exports, n), i.exports;
    }
    n.n = function (e) {
      var t = e && e.__esModule ? function () {
        return e["default"];
      } : function () {
        return e;
      };
      return n.d(t, {
        a: t
      }), t;
    }, n.d = function (e, t) {
      for (var r in t) n.o(t, r) && !n.o(e, r) && Object.defineProperty(e, r, {
        enumerable: !0,
        get: t[r]
      });
    }, n.g = function () {
      if ("object" == (typeof globalThis === "undefined" ? "undefined" : _typeof(globalThis))) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == (typeof window === "undefined" ? "undefined" : _typeof(window))) return window;
      }
    }(), n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, n.r = function (e) {
      "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
        value: "Module"
      }), Object.defineProperty(e, "__esModule", {
        value: !0
      });
    };
    var r = {};
    return function () {
      "use strict";

      n.r(r), n.d(r, {
        AuthenticatorKey: function AuthenticatorKey() {
          return y.pc;
        },
        BaseTransaction: function BaseTransaction() {
          return g.mV;
        },
        EmailChallengeTransaction: function EmailChallengeTransaction() {
          return g.nh;
        },
        EmailRole: function EmailRole() {
          return g.aw;
        },
        EmailStatusTransaction: function EmailStatusTransaction() {
          return g.XC;
        },
        EmailTransaction: function EmailTransaction() {
          return g.yB;
        },
        IdxFeature: function IdxFeature() {
          return y.Fw;
        },
        IdxStatus: function IdxStatus() {
          return y.Qd;
        },
        OktaAuth: function OktaAuth() {
          return Z;
        },
        PasswordStatus: function PasswordStatus() {
          return g.Fn;
        },
        PasswordTransaction: function PasswordTransaction() {
          return g.QU;
        },
        PhoneTransaction: function PhoneTransaction() {
          return g.$N;
        },
        ProfileSchemaTransaction: function ProfileSchemaTransaction() {
          return g.XW;
        },
        ProfileTransaction: function ProfileTransaction() {
          return g.Sx;
        },
        Status: function Status() {
          return g.qb;
        },
        addEmail: function addEmail() {
          return g.no;
        },
        addPhone: function addPhone() {
          return g.Z1;
        },
        authenticate: function authenticate() {
          return y.YR;
        },
        canProceed: function canProceed() {
          return y.Ch;
        },
        cancel: function cancel() {
          return y.al;
        },
        clearTransactionMeta: function clearTransactionMeta() {
          return y.Jm;
        },
        createAuthnTransactionAPI: function createAuthnTransactionAPI() {
          return m.b;
        },
        createIdxAPI: function createIdxAPI() {
          return y.F4;
        },
        createIdxOptionsConstructor: function createIdxOptionsConstructor() {
          return y.SL;
        },
        createIdxStorageManager: function createIdxStorageManager() {
          return y.aT;
        },
        createIdxTransactionManager: function createIdxTransactionManager() {
          return y.vK;
        },
        createOktaAuthIdx: function createOktaAuthIdx() {
          return y.Yn;
        },
        createOktaAuthMyAccount: function createOktaAuthMyAccount() {
          return g.Xc;
        },
        createTransactionMeta: function createTransactionMeta() {
          return y.Xc;
        },
        deleteEmail: function deleteEmail() {
          return g.nd;
        },
        deletePassword: function deletePassword() {
          return g.QN;
        },
        deletePhone: function deletePhone() {
          return g.qj;
        },
        enrollPassword: function enrollPassword() {
          return g.xg;
        },
        getEmail: function getEmail() {
          return g.OD;
        },
        getEmailChallenge: function getEmailChallenge() {
          return g.hG;
        },
        getEmails: function getEmails() {
          return g.G5;
        },
        getPassword: function getPassword() {
          return g.Ij;
        },
        getPhone: function getPhone() {
          return g.u_;
        },
        getPhones: function getPhones() {
          return g.Po;
        },
        getProfile: function getProfile() {
          return g.Ai;
        },
        getProfileSchema: function getProfileSchema() {
          return g.aF;
        },
        getSavedTransactionMeta: function getSavedTransactionMeta() {
          return y.uN;
        },
        getTransactionMeta: function getTransactionMeta() {
          return y.Co;
        },
        handleEmailVerifyCallback: function handleEmailVerifyCallback() {
          return y.Jn;
        },
        handleInteractionCodeRedirect: function handleInteractionCodeRedirect() {
          return y.Xx;
        },
        hasSavedInteractionHandle: function hasSavedInteractionHandle() {
          return y.$0;
        },
        interact: function interact() {
          return y.EW;
        },
        introspect: function introspect() {
          return y.L8;
        },
        isAuthenticator: function isAuthenticator() {
          return y.H;
        },
        isEmailVerifyCallback: function isEmailVerifyCallback() {
          return y.GA;
        },
        isEmailVerifyCallbackError: function isEmailVerifyCallbackError() {
          return y.gc;
        },
        isTransactionMetaValid: function isTransactionMetaValid() {
          return y.Wf;
        },
        isTransactionMetaValidForFlow: function isTransactionMetaValidForFlow() {
          return y.bl;
        },
        isTransactionMetaValidForOptions: function isTransactionMetaValidForOptions() {
          return y.UC;
        },
        mixinAuthn: function mixinAuthn() {
          return m.t;
        },
        mixinIdx: function mixinIdx() {
          return y.B_;
        },
        mixinMyAccount: function mixinMyAccount() {
          return g.HT;
        },
        parseEmailVerifyCallback: function parseEmailVerifyCallback() {
          return y.mo;
        },
        poll: function poll() {
          return y.$l;
        },
        proceed: function proceed() {
          return y.xc;
        },
        recoverPassword: function recoverPassword() {
          return y.M4;
        },
        register: function register() {
          return y.z2;
        },
        saveTransactionMeta: function saveTransactionMeta() {
          return y.r0;
        },
        sendEmailChallenge: function sendEmailChallenge() {
          return g.ME;
        },
        sendPhoneChallenge: function sendPhoneChallenge() {
          return g.dv;
        },
        startTransaction: function startTransaction() {
          return y.Yr;
        },
        unlockAccount: function unlockAccount() {
          return y.le;
        },
        updatePassword: function updatePassword() {
          return g.gQ;
        },
        updateProfile: function updateProfile() {
          return g.ck;
        },
        verifyEmailChallenge: function verifyEmailChallenge() {
          return g.T8;
        },
        verifyPhoneChallenge: function verifyPhoneChallenge() {
          return g.Lo;
        }
      });
      var e = n(3144),
        t = n(5671),
        o = n(136),
        i = n(2963),
        a = n(1120),
        u = n(4602),
        c = n(4143),
        s = n(3334),
        f = n(2144),
        l = n(6794),
        p = n(8284),
        h = n(6736),
        d = {};
      for (var v in h) ["default", "OktaAuth"].indexOf(v) < 0 && (d[v] = function (e) {
        return h[e];
      }.bind(0, v));
      n.d(r, d);
      var y = n(683),
        g = n(1132),
        m = n(3398);
      var b = (0, u.S)(),
        k = (0, c.a)(),
        w = (0, s.v)(),
        O = (0, f.Y)(k, b, w),
        T = (0, l.H)(O),
        Z = function (n) {
          (0, o.Z)(s, n);
          var r,
            u,
            c = (r = s, u = function () {
              if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
              if (Reflect.construct.sham) return !1;
              if ("function" == typeof Proxy) return !0;
              try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
              } catch (e) {
                return !1;
              }
            }(), function () {
              var e,
                t = (0, a.Z)(r);
              if (u) {
                var n = (0, a.Z)(this).constructor;
                e = Reflect.construct(t, arguments, n);
              } else e = t.apply(this, arguments);
              return (0, i.Z)(this, e);
            });
          function s(e) {
            return (0, t.Z)(this, s), c.call(this, e);
          }
          return (0, e.Z)(s);
        }((0, p.t)(T));
      r["default"] = Z;
    }(), r;
  }();
});